/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237fb5a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237fb5a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"bdb1cb7c-3766-47a9-abd1-0ccbf6d8936e","title":"プリンタについての確認","link":"finding-information-about-printer-topic.html","desc":"プリンタに関する情報を見つける リソースおよび入手先 検索する場所 入手先 初期設定の手順","descFull":"プリンタに関する情報を見つける リソースおよび入手先 検索する場所 入手先 初期設定の手順 詳細については、プリンタに同梱されているセットアップマニュアルを参照してください。 プリンタソフトウェア 印刷または FAX ドライバ プリンタファームウェア ユーティリティ www.lexmark.com/downloads  にアクセスします。 対話型の ユーザーズガイド https://support.lexmark.com  をご覧ください。 ハウツービデオ https://infoserve.lexmark.com/idv/  をご覧ください。 プリンタソフトウェアの使用に関するヘルプ情報。 Microsoft Windows または Macintosh のオペレーティングシステムのヘルプ—プリンタソフトウェアプログラムまたはアプリケーションを開き、［ ヘルプ ］をクリックします。 をクリックすると、状況に対応した情報が表示されます。 ヘルプシステムはプリンタソフトウェアとともに自動的にインストールされます。 オペレーティングシステムに応じて、プリンタソフトウェアは、プリンタのプログラムフォルダまたはデスクトップにあります。 マニュアル ライブチャットサポート E メールサポート 電話サポート https://support.lexmark.com  をご覧ください。 国または地域を選択してから、製品を選択し、該当するサポートサイトを表示します。 お住まいの国または地域を担当するサポートの連絡先情報については、Web サイトまたはプリンタに同梱されている書面の保証書でご確認ください。 カスタマサポートにお問い合わせの際には、次の情報を手元に用意しておいてください。 ご購入の場所と日付 プリンタタイプとシリアル番号 詳細については、 を参照してください。 安全に関する情報 規制情報 保証情報 環境情報 保証情報は国または地域によって異なります。 米国  — プリンタに同梱されている『限定保証宣言』を参照するか、  https://support.lexmark.com  をご覧ください。 その他の国および地域  — プリンタに同梱されている書面の保証書をご覧ください。 『 製品情報ガイド 』—詳細については、プリンタに同梱されているマニュアルを参照するか、 https://support.lexmark.com  をご覧ください。 Lexmark デジタルパスポートに関する情報 https://csr.lexmark.com/digital-passport.php  をご覧ください。 プリンタ情報を確認する"},{"UUID":"8c1e3a78-a8d9-49d8-bc3c-184485f3c851","title":"プリンタについての確認","link":"finding-printer-serial-number-topic.html","desc":"","descFull":"プリンタのシリアル番号を確認する カセットを開きます。 プリンタの左側にあるシリアル番号を探します。 プリンタのシリアル番号 シリアル番号"},{"UUID":"46d39465-77c0-41d4-8652-571015010a57","title":"プリンタについての確認","link":"printer-configurations-topic.html","desc":"プリンタ構成 プリンタを構成するときに、プリンタの設置面が平らかつ丈夫で、安定していることを確認します。 基本モデル 基本プリンタ機種の部品 1","descFull":"プリンタ構成 プリンタを構成するときに、プリンタの設置面が平らかつ丈夫で、安定していることを確認します。 基本モデル 基本プリンタ機種の部品 1 自動原稿フィーダ（ADF） 2 操作パネル 3 USB ポート 4 多目的フィーダ 5 標準 550 枚トレイ 6 標準排紙トレイ 構成設定済み機種 プリンタまたは MFP に 1 つ以上のオプションを取り付ける場合は、けがを防ぐためにキャスタベース、ファニチャ、または他のフィーチャを使用して安定させる必要があります。サポートされる構成の詳細については、 www.lexmark.com/multifunctionprinters  を参照してください。 プリンタまたは MFP に 1 つ以上のオプションを取り付ける場合は、けがを防ぐためにキャスタベース、ファニチャ、または他のフィーチャを使用して安定させる必要があります。サポートされる構成の詳細については、プリンタの販売店までお問い合わせください。 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 設定済みプリンタモデルの部品 # ハードウェアオプション 代替ハードウェアオプション 1  冊子フィニッシャまたはホチキス、穴パンチフィニッシャと一緒に取り付けることはできません。 2  オプションの 550 枚トレイおよび 2 x 550枚トレイまたは 2000 枚デュアル給紙と必ず一緒に取り付ける必要があります。 3  このオプションは、必ずオプションの 550 枚トレイと一緒に取り付ける必要があります。 4  オプションの 550 枚トレイと以下のいずれかを必ず一緒に取り付ける必要があります。2 x 550 枚トレイ、2,000 枚デュアル給紙、またはキャビネット 1 ホチキスフィニッシャ  1 オフセットスタッカ  1 用紙搬送ユニット 折り畳みオプション付き用紙搬送ユニット 2 1500 枚トレイ  2 なし 3 2000 枚デュアル給紙  3 2 x 550 枚トレイ  3 キャビネット 3 4 オプションの 550 枚トレイ なし 5 冊子フィニッシャ  4 ホチキス、穴パンチフィニッシャ  4 一部のオプションは提供されていない場合があります。詳細については、プリンタの販売店までお問い合わせください。 プリンタ構成"},{"UUID":"d9ac0150-d1b8-4698-83f3-08c8bcd15959","title":"プリンタについての確認","link":"using-control-panel-topic.html","desc":"操作パネルを使用する 操作パネルの項目と機能 操作パネルの項目 機能 1","descFull":"操作パネルを使用する 操作パネルの項目と機能 操作パネルの項目 機能 1 電源ボタン プリンタの電源のオン/オフを切り替えます。 プリンタの電源を切るには、電源ボタンを 5 秒間押し続けます。 プリンタをスリープモードに設定します。 スリープモードまたは休止モードからプリンタを復帰します。 2 表示 プリンタのメッセージと消耗品の状態を表示します。 プリンタを設定して操作します。 3 インジケータランプ プリンタの状態を確認します。 操作パネル 使用 操作パネルを使用する"},{"UUID":"25236296-65d2-4750-92d0-00a40b572597","title":"プリンタについての確認","link":"using-home-screen-topic.html","desc":"ホーム画面のアイコン ホーム画面のカスタマイズ設定、管理者設定、アクティブな内蔵ソリューションによっては、ホーム画面の表示が異なる場合があります。 ホーム画面のアイコンおよび機能 # アイコン名","descFull":"ホーム画面のアイコン ホーム画面のカスタマイズ設定、管理者設定、アクティブな内蔵ソリューションによっては、ホーム画面の表示が異なる場合があります。 ホーム画面のアイコンおよび機能 # アイコン名 機能 1 ユーザー ユーザーがプリンタにログインしているかどうかを表示します。 2 表示する情報 プリンタの IP アドレスや日時など、プリンタ情報をカスタマイズして表示します。 3 消耗品 消耗品の状態を表示します。 4 通知 プリンタで処理を続行するために操作が必要な場合には、必ずプリンタ警告またはエラーメッセージが表示されます。 プリンタの警告またはメッセージの詳細と解決方法を示します。 5 印刷 写真やドキュメントを印刷します。 6 コピー 写真やドキュメントをコピーします。 7 スキャン 原稿をスキャンします。 8 FAX FAX メッセージを送信します。 ホーム画面を使用する ホーム画面のアイコン"},{"UUID":"fcdf0b5f-0325-41b8-bf08-064536e6e156","title":"プリンタについての確認","link":"colors-of-indicator-light-topic.html","desc":"インジケータランプの色 インジケータランプの色と対応するプリンタの状態 インジケータランプの色 プリンタの状況 オフ","descFull":"インジケータランプの色 インジケータランプの色と対応するプリンタの状態 インジケータランプの色 プリンタの状況 オフ プリンタの電源がオフになっています。 青に点灯 プリンタは待機中です。 青で点滅 プリンタは、印刷中かデータの処理中です。 赤で点滅 ユーザーによるプリンタ操作が必要です。 黄色で点灯 プリンタはスリープモードです。 黄色で点滅 プリンタはディープスリープモードまたは休止モードになっています。 インジケータランプ プリンタの状況 プリンタの状態"},{"UUID":"1c84129f-cee1-4add-9b07-252709459633","title":"プリンタについての確認","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"自動原稿フィーダーと原稿台を使用する ADF トレイと原稿台に用紙をセットする 自動原稿フィーダ（ADF） 原稿台ガラス","descFull":"自動原稿フィーダーと原稿台を使用する ADF トレイと原稿台に用紙をセットする 自動原稿フィーダ（ADF） 原稿台ガラス 複数ページの原稿や両面印刷の原稿の場合、ADF を使用します。 スキャンする面を上にして原稿をセットします。複数ページの文書の場合は、セットする前に用紙の先端をそろえてください。 セットする用紙の幅に合わせて ADF ガイドを調整します。 1 ページの文書、本のページ、小さいもの（葉書や写真など）、OHP フィルム、感光紙、薄いもの（雑誌の切り抜きなど）には原稿台を使用します。 原稿を下向きにして、矢印のある隅にセットします。 コピー 自動原稿フィーダ（ADF）の使用 コピー 原稿台ガラスを使用"},{"UUID":"e033fb40-792f-4fbc-941c-3fe2f1b6f555","title":"プリンタについての確認","link":"locating-security-slot-topic.html","desc":"","descFull":"セキュリティスロットの場所 プリンタにはセキュリティロック機能が搭載されています。大半のノート型パソコンと互換性のあるセキュリティロックを図に示した場所に取り付けて、プリンタの盗難を防止できます。 セキュリティスロット 場所 セキュリティスロットの場所"},{"UUID":"2ae2b326-28d6-4ddf-aff0-420c84524418","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"用紙ガイドライン 適切な用紙を使用して、紙詰まりを防ぎ、問題のない印刷を行います。 必ず新しく損傷のない用紙を使用する。 用紙をセットする前に、用紙の推奨印刷可能面を確認する。通常、この情報は用紙のパッケージに記載されています。 手で切った、またはちぎった用紙は使用しないでください。","descFull":"用紙ガイドライン 適切な用紙を使用して、紙詰まりを防ぎ、問題のない印刷を行います。 必ず新しく損傷のない用紙を使用する。 用紙をセットする前に、用紙の推奨印刷可能面を確認する。通常、この情報は用紙のパッケージに記載されています。 手で切った、またはちぎった用紙は使用しないでください。 大きさ、種類、重さが異なる用紙を 1 つのトレイにセットしない。これらを混在させると紙詰まりが発生します。 電子写真印刷用に特に設計されていない限り、コーティングされた用紙を使用しない。 （⇒ 『 用紙および普通紙以外の用紙に関するガイド 』） 用紙 選択 用紙ガイドライン"},{"UUID":"d6215cac-b5f1-40cd-b6f5-11de46de4d3d","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"用紙特性 以下の用紙特性は、印刷の品質と信頼性に影響します。以下の項目を検討してから、用紙に印刷します。 重さ トレイを使用すると、さまざまな重さの用紙を給紙できます。重さが 60","descFull":"用紙特性 以下の用紙特性は、印刷の品質と信頼性に影響します。以下の項目を検討してから、用紙に印刷します。 重さ トレイを使用すると、さまざまな重さの用紙を給紙できます。重さが 60 g/m 2 （16 ポンド）よりも軽い用紙は硬さが足りないため適切に給紙されず、紙詰まりの原因になることがあります。詳細については、「サポートされている用紙の重さ」トピックを参照してください。 カール カールは、用紙の先端が丸まろうとする性質を指します。カールの度合いが大きすぎると、給紙時に問題が生じることがあります。高温になっているプリンタ内部を用紙が通過した後に、カールが発生することがあります。用紙を包装から取り出して高温、多湿、低温、または乾燥した状態で保管していると、印刷前に用紙がカールして、給紙時に問題が生じることがあります。 平滑度 用紙の平滑度は、印刷品質に直接影響します。用紙のきめが粗すぎる場合は、トナーが適切に定着しません。用紙が滑らかすぎる場合は、給紙や印刷品質に問題が生じることがあります。50 シェフィールドポイントの用紙を使用することをお勧めします。 含水率 用紙に含まれる水分の量は、印刷品質とプリンタの給紙機能の両方に影響します。用紙は使用するまで元の包装に入れたままにしてください。用紙は湿度の変化により劣化する可能性があります。 印刷する前に、用紙を元の包装紙で包んで 24 ～ 48 時間保管してください。用紙を保管する環境は、プリンタと同じである必要があります。用紙を保管時や輸送時の環境がプリンタの設置環境と大きく異なる場合は、この調整の時間を数日延長してください。用紙に厚みがある場合も同様に、調整に時間がかかることがあります。 紙目 紙目は、用紙に含まれる繊維の方向を指します。紙目には、用紙の縦方向に伸びる 縦目 と、用紙の横方向に伸びる 横目 があります。推奨される紙目の方向については、「サポートされている用紙の重さ」トピックを参照してください。 繊維含有率 最高品質のゼログラフィ用紙は、100% の化学処理済みパルプ木材から作られています。この繊維により用紙の安定度が高まり、その結果、給紙時の問題が減少し、印刷品質が向上します。コットンなどの繊維を含む用紙は、用紙の処理に悪影響を及ぼすことがあります。 用紙特性"},{"UUID":"f90c50e5-feb2-428d-904f-40a6d16275a0","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"使用できない用紙 次の種類の用紙は、プリンタで使用しないでください。 カーボン紙なしでコピーの作成に使用される化学処理済みの用紙。これらは、ノーカーボン紙、感圧複写紙（CCP）、カーボン不要（NCR）紙とも呼ばれます。 プリンタを汚染する可能性のある化学薬品を使用して事前印刷された用紙。 プリンタフューザーの温度の影響を受ける可能性のある事前印刷用紙。","descFull":"使用できない用紙 次の種類の用紙は、プリンタで使用しないでください。 カーボン紙なしでコピーの作成に使用される化学処理済みの用紙。これらは、ノーカーボン紙、感圧複写紙（CCP）、カーボン不要（NCR）紙とも呼ばれます。 プリンタを汚染する可能性のある化学薬品を使用して事前印刷された用紙。 プリンタフューザーの温度の影響を受ける可能性のある事前印刷用紙。 ±2.3 mm（±0.09 インチ）よりも高い精度で位置合わせする必要がある事前印刷用紙。例えば、光学式文字認識（OCR）フォームなどです。 場合によっては、ソフトウェアアプリで位置合わせを調整することで、このようなフォームにも正常に印刷できます。 コート紙（消去可能ボンド紙）、合成紙、または感熱紙。 縁がぎざぎざな用紙、表面のきめが粗い用紙、ざらつきのある用紙、カールした用紙。 EN12281:2002（欧州）に準拠していない用紙。 重量が 60g/m 2 （16ポンド）未満の用紙。 マルチパートフォームまたはマルチパートドキュメント。 使用できない用紙"},{"UUID":"63c0dd43-d6db-42be-8695-762261f27990","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"用紙の保管 紙詰まりを防いで印刷品質を安定させるため、用紙の保管に関する以下のガイドラインに従ってください。 印刷に使用する 24～48 時間前から、用紙を元の包装のままプリンタと同じ環境に保管して、用紙の状態を調整してください。","descFull":"用紙の保管 紙詰まりを防いで印刷品質を安定させるため、用紙の保管に関する以下のガイドラインに従ってください。 印刷に使用する 24～48 時間前から、用紙を元の包装のままプリンタと同じ環境に保管して、用紙の状態を調整してください。 ただし、用紙を保管または輸送したときの環境がプリンタの設置環境と大きく異なる場合は、この調整の時間を数日伸ばしてください。用紙に厚みがある場合も同様に、調整に時間がかかることがあります。 最良の印刷結果を得るため、温度 21℃（70°F）、相対湿度 40% の場所に用紙を保管してください。 ほとんどのラベルメーカーは、温度が 18 ～ 24℃（65 ～ 75°F）で、相対湿度が 40 ～ 60% で印刷することを推奨しています。 用紙をダンボール箱に入れ、台の上か棚など、床より高い場所で保管してください。 梱包された用紙を平らな場所に保管してください。 梱包された用紙の上には何も置かないでください。 プリンタにセットする準備ができたときにのみ、用紙をダンボール箱または包装から取り出します。ダンボール箱と包装は、用紙を清潔で乾燥した平らな状態にしておくのに役立ちます。 用紙の保管"},{"UUID":"53ac3b25-155b-4c97-8a87-935aee46a9b4","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"プレプリント用紙とレターヘッド紙を選択する 縦目の用紙を使用します。 オフセットリトグラフ印刷または写真版印刷処理を使用して印刷されたフォームおよびレターヘッド紙に限定して使用する。 表面のきめが粗い用紙やざらつきが大きい用紙は避ける。 トナーの樹脂に影響されないインクを使用する。酸性インクや油性インクは通常、この要件を満たしています。ラテックスインクは、この要件を満たしていない可能性があります。","descFull":"プレプリント用紙とレターヘッド紙を選択する 縦目の用紙を使用します。 オフセットリトグラフ印刷または写真版印刷処理を使用して印刷されたフォームおよびレターヘッド紙に限定して使用する。 表面のきめが粗い用紙やざらつきが大きい用紙は避ける。 トナーの樹脂に影響されないインクを使用する。酸性インクや油性インクは通常、この要件を満たしています。ラテックスインクは、この要件を満たしていない可能性があります。 使用する予定のプレプリント紙およびレターヘッド紙を大量に購入する前に、その用紙にサンプルを印刷してください。このアクションにより、事前印刷用紙やレターヘッド紙でインクが印刷品質に影響するかどうかが決まります。 疑わしい場合は、用紙の供給元に問い合わせてください。 レターヘッド紙に印刷する場合は、プリンタに適した向きに用紙をセットします。（⇒ 『 用紙および普通紙以外の用紙に関するガイド 』） レターヘッド紙に印刷する場合は、プリンタに適した向きに用紙をセットします。 用紙 プレプリント用紙 プレプリント用紙 選択 用紙 レターヘッド レターヘッド 選択"},{"UUID":"b2deed0d-f93b-42c7-ae9f-644978397934","title":"サポートされている用紙サイズ","link":"paper-guidelines-topic.html","desc":"基本設定でサポートされている用紙サイズ 基本設定でサポートされている用紙サイズ 用紙サイズ 原稿の向き 標準","descFull":"基本設定でサポートされている用紙サイズ 基本設定でサポートされている用紙サイズ 用紙サイズ 原稿の向き 標準 550 枚トレイ 多目的フィーダ 両面印刷 自動原稿フィーダ 1  一部のプリンタ機種のみ対応。 2  ［ユニバーサル設定］メニューから設定した場合のみサポートされます。 3  95 x 139.7 mm（3.74 x 5.5 インチ）～ 297 x 355.6 mm（11.69 x 14 インチ）の用紙サイズに対応します。 4  バナー紙の場合、ユニバーサル用紙サイズの最大長は 1320.8 mm/52  インチです。バナー紙は一度に 1 枚だけセットします。 5  95 x 139.7 mm（3.74 x 5.5 インチ）～ 320 x 457.2 mm（12.6 x 18 インチ）の用紙サイズに対応します。 6  105 x 139.7 mm（4.13 x 5.5 インチ）～ 320 x 457.2 mm（12.59 x 18 インチ）の用紙サイズに対応します。 7  76.2 x 128 mm（3 x 5.04 インチ）～ 297 x 432 mm（11.69 x 17.01 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード X ✓ X X 長辺フィード X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード ✓ ✓ ✓ ✓ 長辺フィード X X X X 1/3 A4 短辺フィード ✓ ✓ X ✓ 長辺フィード X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ X ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ X ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード X ✓ ✓ 1 ✓ 1 JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ X ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード X ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ X ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ X ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ X ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17インチ） 短辺フィード X ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12.0 x 18.0インチ） 短辺フィード X ✓ ✓ X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X ✓ ✓ X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード ✓ ✓ X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード ✓ ✓ X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード ✓ ✓ X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード ✓ ✓ X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード ✓ ✓ X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード ✓ ✓ X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード ✓ ✓ X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X ✓ 2 X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード ✓ ✓ X X ユニバーサル 規定せず ✓ 3 ✓ 4、5 ✓ 6 ✓ 7 サポートされている用紙サイズ 用紙サイズ サポート"},{"UUID":"bb362eda-59fb-4b30-9953-dbd66d90278c","title":"サポートされている用紙サイズ","link":"paper-guidelines-topic.html","desc":"オプショントレイでサポートされている用紙サイズ 用紙サイズ 原稿の向き オプションの 550","descFull":"オプショントレイでサポートされている用紙サイズ 用紙サイズ 原稿の向き オプションの 550 枚トレイ 2 x 550 枚トレイ 2000 枚デュアル給紙 1500 枚トレイ 1  ［ユニバーサル設定］メニューから設定した場合のみサポートされます。 2  139.7 x 215.9 mm（5.5 x 8.5 インチ）～ 304.8 x 457.2 mm（12 x 18 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード X X X X 長辺フィード X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード ✓ ✓ X X 長辺フィード X X X X 1/3 A4 短辺フィード X X X X 長辺フィード X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ ✓ X X 長辺フィード ✓ ✓ X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ X X JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ X X 長辺フィード ✓ ✓ X ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ X X ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ ✓ X X 長辺フィード X X X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ X X 長辺フィード ✓ ✓ X X レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ X X Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ X X リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ X X Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ X X 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード ✓ ✓ X X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード ✓ ✓ X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード ✓ 1 ✓ 1 X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード ✓ 1 ✓ 1 X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード ✓ ✓ X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード ✓ ✓ X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード ✓ ✓ X X ユニバーサル 規定せず ✓ 2 ✓ 2 ✓ ✓ サポートされている用紙サイズ 用紙サイズ サポート"},{"UUID":"28b03b04-f147-4b71-9acd-0cba3b7d567e","title":"サポートされている用紙サイズ","link":"paper-guidelines-topic.html","desc":"排紙トレイによりサポートされている用紙サイズ 用紙搬送ユニットと、ホチキス、穴パンチフィニッシャ、冊子フィニッシャのいずれかがプリンタに取り付けられている場合。 用紙サイズ 原稿の向き 用紙搬送ユニット","descFull":"排紙トレイによりサポートされている用紙サイズ 用紙搬送ユニットと、ホチキス、穴パンチフィニッシャ、冊子フィニッシャのいずれかがプリンタに取り付けられている場合。 用紙サイズ 原稿の向き 用紙搬送ユニット + ホチキス、穴パンチフィニッシャ 用紙搬送ユニット + 冊子フィニッシャ 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス/パンチ、オフセット排紙トレイ） 排紙トレイ 2（用紙搬送ユニット排紙トレイ） 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス/パンチ、オフセット排紙トレイ） 排紙トレイ 2（フィニッシャ冊子排紙トレイ） 排紙トレイ 3（用紙搬送ユニット排紙トレイ） 1  90 x 148 mm（3.55 x 5.83 インチ）～ 320 x 600 mm（12.59 x 23.62 インチ）の用紙サイズに対応します。 2  90 x 148 mm（3.55 x 5.83 インチ）～ 320 x 1260 mm（12.59 x 49.6 インチ）の用紙サイズに対応します。 3  182 x 257 mm（7.17 x 10.12 インチ）～ 304.8 x 457.2 mm（12 x 18 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード X X X X X X ✓ A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード X X X X X X X 1/3 A4 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード X X X X X X ✓ A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード ✓ ✓ X ✓ ✓ X ✓ 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X ✓ X X X ✓ ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X ✓ X X X ✓ B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X ✓ X X X ✓ ユニバーサル 規定せず ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 折り畳みオプション付き用紙搬送ユニットと、ホチキス、穴パンチフィニッシャ、冊子フィニッシャのいずれかがプリンターに取り付けられている場合。 折り畳みオプション付き用紙搬送ユニット + ホチキス、穴パンチフィニッシャ 折り畳みオプション付き用紙搬送 + 冊子フィニッシャ 用紙サイズ 原稿の向き 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス/パンチ、オフセット排紙トレイ） 排紙トレイ 2（用紙搬送ユニット排紙トレイ） 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス/パンチ、オフセット排紙トレイ） 排紙トレイ 2（フィニッシャ冊子排紙トレイ） 排紙トレイ 3（用紙搬送ユニット排紙トレイ） 1  90 x 148 mm（3.55 x 5.83 インチ）～ 320 x 600 mm（12.59 x 23.62 インチ）の用紙サイズに対応します。 2  90 x 148 mm（3.55 x 5.83 インチ）～ 297 x 1260 mm（11.69 x 49.6 インチ）の用紙サイズに対応します。 3  182 x 257 mm（7.17 x 10.12 インチ）～ 304.8 x 457.2 mm（12 x 18 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード X X X X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード X X X X X X X 1/3 A4 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード X X X X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ ✓ ✓ X ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード ✓ ✓ X ✓ ✓ ✓ X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード ✓ ✓ X ✓ ✓ X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X ✓ X X X ✓ ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X ✓ X X X ✓ B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X ✓ X X X ✓ 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X ✓ X X X ✓ ユニバーサル 規定せず ✓ 1 ✓ 1 ✓ 2 ✓ 1 ✓ 1 ✓ 3 ✓ 2 サポートされている用紙サイズ 用紙サイズ サポート"},{"UUID":"5ed13aa7-3e64-4c8c-810b-7a19eac406d8","title":"サポートされている用紙サイズ","link":"paper-guidelines-topic.html","desc":"ホチキスとパンチジョブでサポートされている用紙サイズ ホチキスフィニッシャでサポートされている用紙サイズ 用紙サイズ 原稿の向き ホチキス","descFull":"ホチキスとパンチジョブでサポートされている用紙サイズ ホチキスフィニッシャでサポートされている用紙サイズ 用紙サイズ 原稿の向き ホチキス 1 カ所 2 カ所 左 2 カ所 4x6 カード 短辺フィード X X X 長辺フィード X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X X 長辺フィード X X X 1/3 A4 短辺フィード X X X 長辺フィード X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X X 長辺フィード X X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ ✓ 長辺フィード ✓ ✓ ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X X 長辺フィード X X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ X X 長辺フィード ✓ ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ X 長辺フィード ✓ ✓ X フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ X Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ X リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X X ホチキス、穴パンチフィニッシャでサポートされている用紙サイズ 用紙サイズ 原稿の向き ホチキス ホールパンチ 1 カ所 2 カ所 左 2 カ所 2 つ穴 3 つ穴 4 つ穴 4x6 カード 短辺フィード X X X X X X 長辺フィード X X X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X X X X X 長辺フィード X X X X X X 1/3 A4 短辺フィード X X X X X X 長辺フィード X X X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X X ✓ X X 長辺フィード X X X ✓ X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ X ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X X ✓ X X 長辺フィード X X X ✓ X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X X X X X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X X X X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X X X X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X X X X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X X X X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X X X X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X X X X X 冊子フィニッシャでサポートされている用紙サイズ 用紙サイズ 原稿の向き ホチキス ホールパンチ 1 カ所 2 カ所 左 2 カ所 2 つ穴 3 つ穴 4 つ穴 4x6 カード 短辺フィード X X X X X X 長辺フィード X X X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X X X X X 長辺フィード X X X X X X 1/3 A4 短辺フィード X X X X X X 長辺フィード X X X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X X ✓ X X 長辺フィード X X X ✓ X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ ✓ X X X 長辺フィード ✓ ✓ ✓ ✓ X X JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ X ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X X ✓ X X 長辺フィード X X X ✓ X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X 長辺フィード ✓ ✓ ✓ ✓ ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ X X Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X X X X X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X X X X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X X X X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X X X X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X X X X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X X X X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X X X X X サポートされている用紙サイズ 用紙サイズ サポート"},{"UUID":"86d90f6b-35a4-444a-bf64-b93bb5083ab2","title":"サポートされている用紙サイズ","link":"paper-guidelines-topic.html","desc":"折り畳みジョブでサポートされている用紙サイズ 折り畳みオプション付き用紙搬送ユニットでサポートされる用紙サイズ 用紙サイズ 原稿の向き 折り畳みオプション付き用紙搬送ユニットのみ","descFull":"折り畳みジョブでサポートされている用紙サイズ 折り畳みオプション付き用紙搬送ユニットでサポートされる用紙サイズ 用紙サイズ 原稿の向き 折り畳みオプション付き用紙搬送ユニットのみ C 折り Z 折り Z 折り半分 V 折り 標準排紙トレイ 標準排紙トレイ 標準排紙トレイ 標準排紙トレイ 4x6 カード 短辺フィード X X X X 長辺フィード X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X X X 長辺フィード X X X X 1/3 A4 短辺フィード X X X X 長辺フィード X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X X X 長辺フィード X X X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ 長辺フィード X X X X A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード X X X X 長辺フィード X X X X JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード X X ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X X X 長辺フィード X X X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード X X X X 長辺フィード X X X X レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ 長辺フィード X X X X フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード X X X X Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X X X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X X X 用紙搬送ユニットと冊子フィニッシャでサポートされる用紙サイズ 用紙サイズ 原稿の向き 用紙搬送ユニット + 冊子フィニッシャ V 折り（複数） V 折り トレイ 2 標準排紙トレイ、排紙トレイ 1、排紙トレイ 2 4x6 カード 短辺フィード X X 長辺フィード X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X 長辺フィード X X 1/3 A4 短辺フィード X X 長辺フィード X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X 長辺フィード X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ 長辺フィード X X A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ 長辺フィード X X JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X 長辺フィード X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード X X 長辺フィード X X レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ 長辺フィード X X フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード ✓ ✓ SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード ✓ ✓ 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X 折り畳みオプション付き用紙搬送ユニットとホチキス、穴パンチフィニッシャでサポートされる用紙サイズ 用紙サイズ 原稿の向き 折り畳みオプション付き用紙搬送ユニット + ホチキス、穴パンチフィニッシャ C 折り Z 折り Z 折り半分 V 折り トレイ 2 トレイ 2 標準排紙トレイ、排紙トレイ 2 標準排紙トレイ、排紙トレイ 2 4x6 カード 短辺フィード X X X X 長辺フィード X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X X X 長辺フィード X X X X 1/3 A4 短辺フィード X X X X 長辺フィード X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X X X 長辺フィード X X X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ 長辺フィード X X X X A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード X X X X 長辺フィード X X X X JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード X X ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X X X 長辺フィード X X X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード X X X X 長辺フィード X X X X レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ 長辺フィード X X X X フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード X X X X Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X X ✓ SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X X ✓ 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X X X 折り畳みオプション付き用紙搬送ユニットと冊子フィニッシャでサポートされる用紙サイズ 用紙サイズ 原稿の向き 折り畳みオプション付き用紙搬送 + 冊子フィニッシャ C 折り Z 折り Z 折り半分 V 折り（複数） V 折り トレイ 3 トレイ 3 標準排紙トレイ、排紙トレイ 1、排紙トレイ 3 トレイ 2 標準排紙トレイ、排紙トレイ 1、排紙トレイ 2、排紙トレイ 3 4x6 カード 短辺フィード X X X X X 長辺フィード X X X X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X X X X 長辺フィード X X X X X 1/3 A4 短辺フィード X X X X X 長辺フィード X X X X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード X X X X X 長辺フィード X X X X X A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ 長辺フィード X X X X X A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード X X X ✓ ✓ 長辺フィード X X X X X JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード X X ✓ ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード X X X X X 長辺フィード X X X X X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード X X X X X 長辺フィード X X X X X レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ 長辺フィード X X X X X フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード X X X ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ ✓ ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X X X ✓ SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X X X ✓ 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X X X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X X X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X X X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X X X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X X X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X X X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X X X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X X X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X X X X サポートされている用紙サイズ 用紙サイズ サポート"},{"UUID":"7e2afc24-75ca-43f9-9c4b-0cb37accbbcd","title":"サポートされている用紙サイズ","link":"paper-guidelines-topic.html","desc":"オフセットスタックジョブでサポートされている用紙サイズ オフセットスタックまたはホチキスフィニッシャでサポートされている用紙サイズ 用紙サイズ 原稿の向き オフセットスタッカ","descFull":"オフセットスタックジョブでサポートされている用紙サイズ オフセットスタックまたはホチキスフィニッシャでサポートされている用紙サイズ 用紙サイズ 原稿の向き オフセットスタッカ ホチキスフィニッシャ 1  90 x 148 mm（3.55 x 5.83 インチ）～ 320 x 600 mm（12.59 x 23.62 インチ）の用紙サイズに対応します。 2  148 x 148 mm（5.83 x 5.83 インチ）～ 297 x 431.8 mm（11.69 x 17 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード X X 長辺フィード X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X 長辺フィード X X 1/3 A4 短辺フィード X X 長辺フィード X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ X 長辺フィード ✓ X エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード X X SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード ✓ X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード ✓ X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード ✓ X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード ✓ X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード ✓ X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード ✓ X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード ✓ X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード ✓ X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード ✓ X ユニバーサル 規定せず ✓ 1 ✓ 2 排紙トレイによりサポートされている用紙サイズ 用紙サイズ 原稿の向き 用紙搬送ユニット + ホチキス、穴パンチフィニッシャ 用紙搬送ユニット + 冊子フィニッシャ トレイ 1 トレイ 1 1  139.7 x 148 mm（5.5 x 5.83 インチ）～ 304.8 x 600 mm（12 x 23.62 インチ）の用紙サイズに対応します。 2  125 x 148 mm（4.93 x 5.83 インチ）～ 304.8 x 457.2 mm（12 x 18 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード X X 長辺フィード X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X 長辺フィード X X 1/3 A4 短辺フィード X X 長辺フィード X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード ✓ ✓ SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X ユニバーサル 規定せず ✓ 1 ✓ 2 折り畳みオプション付き用紙搬送ユニットがある排紙トレイでサポートされる用紙サイズ 用紙サイズ 原稿の向き 折り畳みオプション付き用紙搬送ユニット + ホチキス、穴パンチフィニッシャ 折り畳みオプション付き用紙搬送 + 冊子フィニッシャ トレイ 1 トレイ 1 1  139.7 x 148 mm（5.5 x 5.83 インチ）～ 304.8 x 600 mm（12 x 23.62 インチ）の用紙サイズに対応します。 2  125 x 148 mm（4.93 x 5.83 インチ）～ 304.8 x 457.2 mm（12 x 18 インチ）の用紙サイズに対応します。 4x6 カード 短辺フィード X X 長辺フィード X X A6 105 x 148 mm （4.13 x 5.83 インチ） 短辺フィード X X 長辺フィード X X 1/3 A4 短辺フィード X X 長辺フィード X X A5 148 x 210 mm （5.83 x 8.27 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ A4 210 x 297 mm （8.27 x 11.7 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ A3 297 x 420 mm （11.69 x 16.54 インチ） 短辺フィード ✓ ✓ JIS B5 182 x 257 mm （7.17 x 10.1 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ JIS B4 257 x 364 mm （10.12 x 14.33 インチ） 短辺フィード ✓ ✓ ステートメント 139.7 x 215.9 mm （5.5 x 8.5 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ エグゼクティブ 184.2 x 266.7 mm （7.25 x 10.5 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ レター 215.9 x 279.4 mm （8.5 x 11 インチ） 短辺フィード ✓ ✓ 長辺フィード ✓ ✓ フォリオ 215.9 x 330.2 mm （8.5 x 13 インチ） 短辺フィード ✓ ✓ Oficio（メキシコ） 215.9 x 340.4 mm （8.5 x 13.4 インチ） 短辺フィード ✓ ✓ リーガル 215.9 x 355.6 mm （8.5 x 14 インチ） 短辺フィード ✓ ✓ Ledger 279.4 x 431.8 mm （11 x 17 インチ） 短辺フィード ✓ ✓ 12x18 304.8 x 457.2 mm （12 x 18 インチ） 短辺フィード ✓ ✓ SRA3 320.04 x 449.58 mm （12.6 x 17.7 インチ） 短辺フィード X X 封筒（長型 #3） 120 x 235 mm （4.75 x 9.25 インチ） 短辺フィード X X ハガキ 100 x 148 mm （3.94 x 5.83 インチ） 短辺フィード X X B5 封筒 176 x 250 mm （6.93 x 9.84 インチ） 短辺フィード X X 封筒（商用 #9） 98.4 x 225.4 mm （3.875 x 8.9 インチ） 短辺フィード X X 封筒（商用 #10） 104.8 x 241.3 mm （4.12 x 9.5 インチ） 短辺フィード X X 封筒（モナーク 7‑3/4） 98.4 x 190.5 mm （3.875 x 7.5 インチ） 短辺フィード X X 封筒（DL） 110 x 220 mm （4.33 x 8.66 インチ） 短辺フィード X X 封筒（ISO C4） 229 x 324 mm （9 x 12.8 インチ） 短辺フィード X X 封筒（ISO C5） 162 x 229 mm （6.38 x 9 インチ） 短辺フィード X X ユニバーサル 規定せず ✓ 1 ✓ 2 サポートされている用紙サイズ 用紙サイズ サポート"},{"UUID":"6cdb4e1f-545a-4df7-a7af-223284568724","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"サポートされている用紙の重さ サポートされている用紙の重さ プリンタでサポートされている用紙重量 標準またはオプションの 550","descFull":"サポートされている用紙の重さ サポートされている用紙の重さ プリンタでサポートされている用紙重量 標準またはオプションの 550 枚トレイ、2 x 550 枚トレイ、および 2000 枚デュアル給紙 多目的フィーダ 両面印刷 自動原稿フィーダ 60 ～ 300 g/m 2 （16 ～ 80 lb ボンド紙） 60 ～ 300 g/m 2 （16 ～ 80 lb ボンド紙） 60 ～ 220 g/m 2 （16 ～ 59 lb ボンド紙） 50 ～ 150 g/m 2 （14 ～ 40 lb ボンド紙） サポートされている用紙の重さ 用紙の重量 サポート"},{"UUID":"bcc7d6ac-ad0c-446c-90cf-0505b2415f53","title":"用紙を選択する","link":"paper-guidelines-topic.html","desc":"サポートされている用紙タイプ サポートされている用紙タイプ 基本設定でサポートされている用紙タイプ 用紙サイズ 標準","descFull":"サポートされている用紙タイプ サポートされている用紙タイプ 基本設定でサポートされている用紙タイプ 用紙サイズ 標準 550 枚トレイ 多目的フィーダ 両面印刷 自動原稿フィーダ 普通紙 ✓ ✓ ✓ ✓ 厚紙 ✓ ✓ ✓ X 再生紙 ✓ ✓ ✓ ✓ 光沢紙 ✓ ✓ ✓ X 重い光沢紙 ✓ ✓ ✓ X ラベル ✓ ✓ X X ビニールラベル紙 ✓ ✓ X X ボンド紙 ✓ ✓ ✓ ✓ 封筒 ✓ ✓ X X 粗い封筒 ✓ ✓ X X レターヘッド ✓ ✓ ✓ ✓ 事前印刷用紙 ✓ ✓ ✓ ✓ カラー用紙 ✓ ✓ ✓ ✓ 軽量用紙 ✓ ✓ ✓ ✓ 重い用紙 ✓ ✓ ✓ ✓ ラフ紙/コットン紙 ✓ ✓ ✓ X カスタム紙種 ✓ ✓ ✓ ✓ オプショントレイでサポートされている用紙タイプ 用紙サイズ オプションの 550 枚トレイ 2 x 550 枚トレイ 2000 枚デュアル給紙 1500 枚トレイ 普通紙 ✓ ✓ ✓ ✓ 厚紙 ✓ ✓ ✓ ✓ OHP フィルム X X X X 再生紙 ✓ ✓ ✓ ✓ 光沢紙 ✓ ✓ ✓ ✓ 重い光沢紙 ✓ ✓ ✓ ✓ ラベル ✓ ✓ X X ビニールラベル紙 ✓ ✓ X X ボンド紙 ✓ ✓ ✓ ✓ 封筒 ✓ ✓ X X 粗い封筒 ✓ ✓ X X レターヘッド ✓ ✓ ✓ ✓ 事前印刷用紙 ✓ ✓ ✓ ✓ カラー用紙 ✓ ✓ ✓ ✓ 軽量用紙 ✓ ✓ ✓ ✓ 重い用紙 ✓ ✓ ✓ ✓ ラフ紙/コットン紙 ✓ ✓ ✓ ✓ カスタム紙種 ✓ ✓ ✓ ✓ 排紙トレイによりサポートされている用紙タイプ 用紙サイズ 用紙搬送ユニット + ホチキス、ホールパンチフィニッシャ 用紙搬送ユニット + 冊子フィニッシャ 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス、ホールパンチ、オフセット排紙トレイ） 排紙トレイ 2（用紙搬送ユニット排紙トレイ） 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス、ホールパンチ、オフセット排紙トレイ） 排紙トレイ 2（フィニッシャ冊子排紙トレイ） 排紙トレイ 3（用紙搬送ユニット排紙トレイ） ＊  バナー紙の場合、ユニバーサル用紙サイズの最大長は 1320.8 mm/52 インチです。バナー紙は一度に 1 枚だけセットしてください。 普通紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 厚紙 ✓ ✓ ✓ ✓ ✓ X ✓ 再生紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 光沢紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 重い光沢紙 ✓ ✓ ✓ ✓ ✓ X ✓ ラベル ✓ ✓ ✓ ✓ ✓ X X ビニールラベル紙 ✓ ✓ ✓ ✓ ✓ X X ボンド紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 封筒 X X ✓ X X X ✓ 粗い封筒 X X ✓ X X X ✓ レターヘッド ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 事前印刷用紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ カラー用紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 軽量用紙 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 重い用紙 ✓ ✓ ✓ ✓ ✓ X X ラフ紙/コットン紙 ✓ ✓ ✓ ✓ ✓ X X カスタム紙種 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 折り畳みオプション付き用紙搬送ユニットがある排紙トレイでサポートされる用紙タイプ 用紙サイズ 折り畳みオプション付き用紙搬送ユニット + ホチキス、ホールパンチフィニッシャ 折り畳みオプション付き用紙搬送 + 冊子フィニッシャ 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス/パンチ、オフセット排紙トレイ） 排紙トレイ 2（用紙搬送ユニット排紙トレイ） 標準排紙トレイ（フィニッシャ上部排紙トレイ） 排紙トレイ 1（フィニッシャホチキス/パンチ、オフセット排紙トレイ） 排紙トレイ 2（フィニッシャ冊子排紙トレイ） 排紙トレイ 3（用紙搬送ユニット排紙トレイ） ＊  バナー紙の場合、ユニバーサル用紙サイズの最大長は 1320.8 mm/52 インチです。バナー紙は一度に 1 枚だけセットしてください。 普通紙 ✓ ✓ ✓ ✓ ✓ ✓ ✓ 厚紙 ✓ ✓ ✓ ✓ ✓ X ✓ 再生紙 ✓ ✓ ✓ ✓ ✓ ✓ ✓ 光沢紙 ✓ ✓ ✓ ✓ ✓ ✓ ✓ 重い光沢紙 ✓ ✓ ✓ ✓ ✓ X ✓ ラベル ✓ ✓ ✓ ✓ ✓ X ✓ ビニールラベル紙 ✓ ✓ ✓ ✓ ✓ X ✓ ボンド紙 ✓ ✓ ✓ ✓ ✓ ✓ ✓ 封筒 X X ✓ X X X ✓ 粗い封筒 X X ✓ X X X ✓ レターヘッド ✓ ✓ ✓ ✓ ✓ X ✓ 事前印刷用紙 ✓ ✓ ✓ ✓ ✓ X ✓ カラー用紙 ✓ ✓ ✓ ✓ ✓ ✓ ✓ 軽量用紙 ✓ ✓ ✓ ✓ ✓ ✓ ✓ 重い用紙 ✓ ✓ ✓ ✓ ✓ X X ラフ紙/コットン紙 ✓ ✓ ✓ ✓ ✓ X X カスタム紙種 ✓ ✓ ✓ ✓ ✓ ✓ ＊ ✓ 折り畳みオプション付き用紙搬送ユニット、オフセットスタッカ、ホチキスフィニッシャでサポートされる用紙タイプ 用紙サイズ 折り畳みオプション付き用紙搬送ユニットのみ オフセットスタッカ ホチキスフィニッシャ 普通紙 ✓ ✓ ✓ 厚紙 ✓ ✓ ✓ 再生紙 ✓ ✓ ✓ 光沢紙 ✓ ✓ ✓ 重い光沢紙 ✓ ✓ ✓ ラベル ✓ ✓ ✓ ビニールラベル紙 ✓ ✓ ✓ ボンド紙 ✓ ✓ ✓ 封筒 ✓ ✓ ✓ 粗い封筒 ✓ ✓ ✓ レターヘッド ✓ ✓ ✓ 事前印刷用紙 ✓ ✓ ✓ カラー用紙 ✓ ✓ ✓ 軽量用紙 ✓ ✓ ✓ 重い用紙 ✓ ✓ ✓ ラフ紙/コットン紙 ✓ ✓ ✓ カスタム紙種 ✓ ✓ ✓ ホチキス、ホールパンチフィニッシャ、および冊子フィニッシャでサポートされている用紙タイプ 用紙サイズ フィニッシャ上部排紙トレイ（標準排紙トレイ） フィニッシャホチキス排紙トレイ（排紙トレイ 1） オフセット ホールパンチ ホチキス 中折り オフセット ホールパンチ ホチキス 中折り 普通紙 X ✓ X ✓ ✓ ✓ ✓ ✓ 厚紙 X X X X ✓ X X X 再生紙 X ✓ X ✓ ✓ ✓ ✓ ✓ 光沢紙 X ✓ X ✓ ✓ ✓ ✓ ✓ 重い光沢紙 X X X X ✓ X X X ラベル X X X X ✓ X X X ビニールラベル紙 X X X X ✓ X X X ボンド紙 X ✓ X ✓ ✓ ✓ ✓ ✓ レターヘッド X ✓ X ✓ ✓ ✓ ✓ ✓ 事前印刷用紙 X ✓ X ✓ ✓ ✓ ✓ ✓ カラー用紙 X ✓ X ✓ ✓ ✓ ✓ ✓ 軽量用紙 X ✓ X ✓ ✓ ✓ ✓ ✓ 重い用紙 X X X X ✓ X X X ラフ紙/コットン紙 X ✓ X X ✓ ✓ X X カスタム紙種 X ✓ X ✓ ✓ ✓ ✓ ✓ サポートされている用紙タイプ 用紙タイプ サポート"},{"UUID":"4fb9340e-463b-492e-8e07-eda78c64c543","title":"その他のプリンタ機能とサポート","link":"supported-applications-topic.html","desc":"サポートされているアプリ アプリケーションとそれがサポートされているプリンタ機種 アプリケーション プリンタ機種 スキャンセンター","descFull":"サポートされているアプリ アプリケーションとそれがサポートされているプリンタ機種 アプリケーション プリンタ機種 スキャンセンター CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 ディスプレイのカスタマイズ CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 カスタマサポート XC8355, XC9635, XC9645, XC9655 デバイスクォータ XC8355, XC9635, XC9645, XC9655 プリンタアプリ プリインストールアプリ"},{"UUID":"daa48308-0707-47a1-b408-3cfdde3f9b94","title":"その他のプリンタ機能とサポート","link":"supported-applications-topic.html","desc":"サポートされているフラッシュメモリとファイルタイプ フラッシュメモリ USB 2.0 までをサポートするフラッシュメモリ。","descFull":"サポートされているフラッシュメモリとファイルタイプ フラッシュメモリ USB 2.0 までをサポートするフラッシュメモリ。 New Technology File System（NFTS）または File Allocation Table（FAT32）ファイルシステムをサポートするフラッシュメモリ。 ファイルタイプ サポートされているファイルタイプ ドキュメント 画像 PDF（バージョン 1.7 以前） Microsoft のファイル形式（.doc、.docx、.xls、.xlsx、.ppt、.pptx）＊ .jpeg または jpg .tiff または .tif GIF .bmp .png .pcx .dcx サポートされているフラッシュドライブ サポートされているファイルタイプ"},{"UUID":"171de5e3-f3b4-4075-a168-ff437a527129","title":"その他のプリンタ機能とサポート","link":"supported-applications-topic.html","desc":"使用可能な内蔵オプション ハードディスク ライセンス付与された機能 IPDS バーコード","descFull":"使用可能な内蔵オプション ハードディスク ライセンス付与された機能 IPDS バーコード Lexmark  内蔵ソリューションポート（ISP） RS‑232C シリアルカード MarkNet  N8230 ファイバーイーサネット 100BASE-FX（LC）、1000BASE-SX（LC） 内蔵ソリューションポート（ISP） 内蔵オプション ファームウェアカード ハードディスク"},{"UUID":"45486ef0-f1e1-4822-bd5c-2728aca6494b","title":"設定、設置、構成","link":"selecting-location-printer-topic.html","desc":"プリンタの設置場所を選択する トレイ、カバー、ドアを開くためのスペースを十分確保し、ハードウェアオプションを取り付けます。 プリンタをコンセントの近くにセットします。 火災や感電の危険を避けるため、製品の設置場所の近くにある、アクセスしやすい、正しく接地されていて、適切な定格を持つコンセントに電源コードを接続します。 感電の危険を避けるため、本製品を水に濡れる恐れのある場所に置いたり、そのような場所で使用しないでください。","descFull":"プリンタの設置場所を選択する トレイ、カバー、ドアを開くためのスペースを十分確保し、ハードウェアオプションを取り付けます。 プリンタをコンセントの近くにセットします。 火災や感電の危険を避けるため、製品の設置場所の近くにある、アクセスしやすい、正しく接地されていて、適切な定格を持つコンセントに電源コードを接続します。 感電の危険を避けるため、本製品を水に濡れる恐れのある場所に置いたり、そのような場所で使用しないでください。 室内の空気の流れが最新版の ASHRAE 62 基準または CEN Technical Committee 156 基準を満たしていることを確認します。 設置面が平らかつ丈夫で、安定していることを確認します。 プリンタを以下の状態に保ちます。 清潔で乾燥した、ほこりのない状態にする。 ホチキスや紙クリップを近くに置かない。 エアコン、ヒーター、換気装置の風が直接当たらないようにする。 直射日光、極度の湿気を避ける。 推奨温度を監視し、激しい変動を避けます。 推奨温度 周辺温度 保管温度 適切な通気を保つために、プリンタの周囲に以下のスペースを確保することをお勧めします。 プリンタ周辺の推奨スペース 1 上部 2 背面 3 右側 4 正面 5 左側 プリンタ の設置場所を選択する 設置場所を選択する プリンタの プリンタ 最小スペース プリンタを移動する"},{"UUID":"2434f987-8010-4141-a7f3-b487283ce640","title":"設定、設置、構成","link":"printer-ports-topic.html","desc":"プリンタポート 感電の危険を避けるため、雷雨時には、本製品のセットアップや、電源コード、FAX、電話など、電気的接続またはケーブル接続を行わないでください。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 火災や感電の危険を避けるため、製品に同梱されている電源コード、または製造元の正規の交換品のみを使用してください。 火災発生の恐れがないように、本製品を公共電話回線ネットワークに接続する場合は、26","descFull":"プリンタポート 感電の危険を避けるため、雷雨時には、本製品のセットアップや、電源コード、FAX、電話など、電気的接続またはケーブル接続を行わないでください。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 火災や感電の危険を避けるため、製品に同梱されている電源コード、または製造元の正規の交換品のみを使用してください。 火災発生の恐れがないように、本製品を公共電話回線ネットワークに接続する場合は、26 AWG 以上の太さの電気通信ケーブル（RJ-11）のみを使用してください。オーストラリアのユーザーは、オーストラリア通信メディア庁（Australian Communications and Media Authority）が承認するケーブルを必ず使用してください。 データの損失やプリンタの誤動作の発生を防ぐため、印刷を実行している間は、USB ケーブル、ワイヤレスネットワークアダプタ、またはプリンタの以下のエリアに触れないでください。 プリンタのポートとソケット、およびそれらの機能 プリンタポート 機能 1 フィニッシャまたはオプションポート プリンタをフィニッシャまたはオプションに接続します。 2 USB ポート キーボードまたは互換性のあるオプションを接続します。 3 LINE ポート FAX カードが取り付けられている場合のみ使用できます。 標準壁ジャック（RJ‑11）、DSL フィルタ、または VoIP アダプタ、または FAX を送受信するために電話回線にアクセスできるその他のアダプタ経由で、プリンタをアクティブな電話回線に接続します。 4 EXT ポート FAX カードが取り付けられている場合のみ使用できます。 追加デバイス（電話または留守番電話）をプリンタおよび電話回線に接続します。プリンタ用の専用 FAX 回線がなく、この接続方法が国または地域でサポートされている場合には、このポートを使用します。 5 USB プリンタポート プリンタをコンピュータに接続します。 6 イーサネットポート プリンタをネットワークに接続します。 7 電源コードソケット プリンタを正しく接地されたコンセントに接続します。 プリンタポート USB ポート イーサネットポート 電源コードソケット"},{"UUID":"4a5ef5de-e829-4670-bde5-81ae97fd0b57","title":"アプリとソリューションを設定する","link":"setting-up-scan-center-topic.html","desc":"スキャンセンターを設定する 操作パネルで［ スキャンセンター ］を選択します。 送信先を選択および作成してから、設定を構成します。","descFull":"スキャンセンターを設定する 操作パネルで［ スキャンセンター ］を選択します。 送信先を選択および作成してから、設定を構成します。 内蔵 Web サーバーで作成された送信先だけが保存されます。詳細については、ソリューションに同梱されているマニュアルを参照してください。 ドキュメントをスキャンします。 スキャンセンター 設定する"},{"UUID":"8d8033e2-175c-47cb-aaf5-f3b4b4dfcc19","title":"アプリとソリューションを設定する","link":"setting-up-scan-center-topic.html","desc":"ディスプレイのカスタマイズを使用する ディスプレイのカスタマイズを使用する スクリーンセーバー、スライドショー、壁紙の設定が EWS で有効になっていることを確認します。［","descFull":"ディスプレイのカスタマイズを使用する ディスプレイのカスタマイズを使用する スクリーンセーバー、スライドショー、壁紙の設定が EWS で有効になっていることを確認します。［ アプリ ］ ［ ディスプレイのカスタマイズ ］ ［ 設定 ］の順に移動します。 スクリーンセーバーとスライドショーのイメージを管理する ［スクリーンセーバーとスライドショーのイメージ］セクションで、イメージを追加、編集、または削除します。 最大 10 個のイメージを追加できます。 有効にすると、エラー、注意、またはクラウドベースの通知がある場合のみ、スクリーンセーバーに状態アイコンが表示されます。 変更を適用します。 壁紙のイメージを変更する 操作パネルで［ 壁紙を変更 ］を選択します。 使用するイメージを選択します。 変更を適用します。 フラッシュメモリからスライドショーを実行する フラッシュドライブを USB ポートに挿入します。 操作パネルで［ スライドショー ］を選択します。 スライドショーが開始された後はフラッシュメモリを取り外すことができますが、イメージはプリンタ内に保存されていません。スライドショーが停止した場合は、フラッシュメモリを再度挿入するとイメージが表示されます。 ディスプレイのカスタマイズ 使用する 画面をカスタマイズする 壁紙を変更する スライドショーを実行する スクリーンセーバーを管理する"},{"UUID":"d785b31a-6d07-4abf-95b0-265d235cc3d8","title":"アプリとソリューションを設定する","link":"setting-up-scan-center-topic.html","desc":"ブックマークの設定 ブックマークを作成する Web ブラウザを開き、アドレスフィールドにプリンタの IP","descFull":"ブックマークの設定 ブックマークを作成する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ ブックマーク ］ ［ ブックマークを追加 ］の順にクリックして、ブックマーク名を入力します。 ［ アドレス ］のプロトコルの種類を選択し、以下のいずれかの手順を実行します。 HTTP および HTTPS の場合は、作成するブックマークの URL を入力します。 HTTPS の場合、IP アドレスの代わりにホスト名を使用してください。例えば、「 123.﻿123.123.123/sample.pdf 」の代わりに「 myWebsite.com/sample.pdf 」を入力します。また、ホスト名がサーバー証明書の共通名（CN）の値と一致していることも確認します。サーバー証明書の CN 値の取得の詳細については、Web ブラウザのヘルプ情報を参照してください。 FTP の場合は、FTP アドレスを入力します。例えば、「 myServer/myDirectory 」と入力します。FTP ポート番号を入力します。コマンドを送信する場合は、ポート 21 が初期設定のポートです。 SMB の場合は、ネットワークフォルダのアドレスを入力します。例えば、「 myServer/myShare/myFile.pdf 」と入力します。ネットワークドメイン名を入力します。 必要に応じて、FTP および SMB の［ 認証 ］タイプを選択します。 ブックマークへのアクセスを制限するには、PIN を入力します。 アプリケーションでは、以下のファイルタイプがサポートされています。PDF、JPEG、TIFF。DOCX や XLSX など、その他のファイルタイプは一部のプリンタ機種でサポートされています。 ［ 保存 ］をクリックします。 フォルダを作成する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ ブックマーク ］ ［ フォルダを追加 ］の順にクリックして、フォルダ名を入力します。 フォルダへのアクセスを制限するには、PIN を入力します。 ［ 保存 ］をクリックします。 ブックマーク 作成する ブックマークを作成する"},{"UUID":"8629b64d-c4dc-4e3c-bf7d-081b5665b31f","title":"アプリとソリューションを設定する","link":"setting-up-scan-center-topic.html","desc":"アドレス帳の設定 連絡先を追加する Web ブラウザを開き、アドレスフィールドにプリンタの IP","descFull":"アドレス帳の設定 連絡先を追加する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ アドレス帳 ］をクリックし、［ 連絡先を追加 ］をクリックします。 必要に応じて、アプリケーションアクセスを許可するためにログイン方式を指定します。 ［ 保存 ］をクリックします。 グループを追加する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ アドレス帳 ］をクリックし、［ 連絡先を追加 ］をクリックします。 グループに 1 つまたは複数の連絡先を割り当てることができます。 ［ 保存 ］をクリックします。 連絡先を追加する グループを追加する アドレス帳"},{"UUID":"0dffe880-61fa-48c9-b90a-5bfac1371bec","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"音声ガイダンスを有効にする ホーム画面 1 回の動作で 1","descFull":"音声ガイダンスを有効にする ホーム画面 1 回の動作で 1 本の指を使用して、音声メッセージが聞こえるまで、ディスプレイ上で左にゆっくりとスワイプしてから上にスワイプします。 2 本の指で ［OK］ をタッチします。 ジェスチャが機能しない場合は、さらに力を加えます。 キーボードから 音声メッセージが聞こえるまで  5  キーを長押しします。 Tab  キーを押してフォーカスカーソルを［OK］ボタンに移動し、 Enter  キーを押します。 音声ガイダンスが有効になっている場合は、ディスプレイの任意の項目を選択する際に必ず 2 本の指を使用してください。 音声ガイダンスでは、言語サポートが制限されています。 音声ガイダンス 有効化 音声ガイダンスの有効化"},{"UUID":"1e85725b-0fef-4bfe-afc5-920267d5692c","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"音声ガイダンスを無効にする 1 回の動作で 1 本の指を使用して、音声メッセージが聞こえるまで、ディスプレイ上で左にゆっくりとスワイプしてから上にスワイプします。","descFull":"音声ガイダンスを無効にする 1 回の動作で 1 本の指を使用して、音声メッセージが聞こえるまで、ディスプレイ上で左にゆっくりとスワイプしてから上にスワイプします。 2 本の指を使って、次のいずれかを行います。 ［ 音声ガイダンス ］を選択し、［ OK ］を選択します。 ［ キャンセル ］を選択します。 ジェスチャが機能しない場合は、さらに力を加えます。 電源ボタンを押すか、プリンタをスリープモードまたは休止モードしても、音声ガイダンスは無効になります。 音声ガイダンス 無効化する 音声ガイダンスを無効にする"},{"UUID":"464e72cb-4f95-4eb1-8031-5f23189aacb5","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"ジェスチャを使用して画面を操作する ほとんどのジェスチャは、音声ガイダンスを有効にしている場合にのみ適用できます。 文字の入力と特定の設定の調整を行うには、物理キーボードを使用します。 ジェスチャと機能 ジェスチャ","descFull":"ジェスチャを使用して画面を操作する ほとんどのジェスチャは、音声ガイダンスを有効にしている場合にのみ適用できます。 文字の入力と特定の設定の調整を行うには、物理キーボードを使用します。 ジェスチャと機能 ジェスチャ 機能 1 本の指で左にスワイプしてから上にスワイプする アクセシビリティモードを起動か終了します。 このジェスチャは、プリンタが通常モードの場合にも適用されます。 1 本の指でダブルタップする 画面でオプションまたは項目を選択します。 2 本の指でホームアイコンをダブルタップする アクセシビリティモードを無効にします。 1 本の指でトリプルタップする 文字とイメージを拡大/縮小します。 ズーム機能を使用するには、拡大モードを有効にします。 1 本の指で右にスワイプするか、下にスワイプする 画面で次の項目に移動します。 1 本の指で左にスワイプするか、上にスワイプする 画面で前の項目に移動します。 1 本の指で上にスワイプしてから下にスワイプする 画面上の最初の項目に移動します。 パン 画面の限界を超えて拡大して画像の特定の部分を表示します。 2 本の指で拡大/縮小した画像をドラッグします。 パンジェスチャを使用するには、拡大モードを有効にします。 1 本の指で上にスワイプしてから右にスワイプする ボリュームを上げます。 このジェスチャは、プリンタが通常モードの場合にも適用されます。 1 本の指で下にスワイプしてから右にスワイプする ボリュームを下げます。 このジェスチャは、プリンタが通常モードの場合にも適用されます。 1 本の指で上にスワイプしてから左にスワイプする アプリケーションを終了してホーム画面に戻ります。 1 本の指で下にスワイプしてから左にスワイプする 前の設定に戻ります。 画面の操作 ジェスチャを使用する タッチ画面ジェスチャ 画面ジェスチャ"},{"UUID":"0cfc1872-6f68-486a-a4e7-9f3c2922e952","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"オンスクリーンキーボードを使用する オンスクリーンキーボードが表示されているときに、次の手順を 1 つ以上実行します。 キーをタッチしてアナウンスし、フィールドに文字を入力します。","descFull":"オンスクリーンキーボードを使用する オンスクリーンキーボードが表示されているときに、次の手順を 1 つ以上実行します。 キーをタッチしてアナウンスし、フィールドに文字を入力します。 異なる文字の間で指をドラッグしてアナウンスし、フィールドに文字を入力します。 2 本指でテキストボックスをタッチして、フィールドに文字をアナウンスします。 Backspace  をタッチして、文字を削除します。 オンスクリーンキーボード 使用"},{"UUID":"9b87a356-6e3a-47f6-85f9-a5686140c4dc","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"拡大モードを有効にする 1 回の動作で 1 本の指を使用して、音声メッセージが聞こえるまで、ディスプレイ上で左にゆっくりとスワイプしてから上にスワイプします。","descFull":"拡大モードを有効にする 1 回の動作で 1 本の指を使用して、音声メッセージが聞こえるまで、ディスプレイ上で左にゆっくりとスワイプしてから上にスワイプします。 内蔵スピーカーのないプリンタ機種の場合は、ヘッドフォンを使用してメッセージを聞きます。 2 本の指を使って、次の操作を行います。 ［拡大モード］ をタッチします。 ［OK］ をタッチします。 ジェスチャが機能しない場合は、さらに力を加えます。 拡大した画面を操作する方法の詳細については、 を参照してください。 拡大モード 有効化 拡大モードを有効にする"},{"UUID":"78be8193-3f8e-43d3-8c90-8282f2dfe094","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"音声ガイダンスのスピーチ速度を調整する 操作パネルで、［ 設定 ］ ［","descFull":"音声ガイダンスのスピーチ速度を調整する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ ユーザー補助機能 ］ ［ スピーチ速度］ の順に移動します。 スピーチ速度を選択します。 音声ガイダンス スピーチ速度を調整する スピーチ速度を調整する 音声ガイダンス スピーチ速度を調整する 音声ガイダンス"},{"UUID":"1ceb0b44-c2f6-4c28-be6b-f7c4724e0a34","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"初期設定のヘッドホン音量を調整する 操作パネルで、［ 設定 ］ ［","descFull":"初期設定のヘッドホン音量を調整する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ ユーザー補助機能 ］の順に移動します。 ヘッドホンの音量を調整します。 ユーザーがアクセシビリティモードを終了した後、またはプリンタがスリープモードや休止モードから復帰したときに、ボリュームは初期設定値にリセットされます。 ヘッドホン音量、調整する ヘッドホンの音量を調整する"},{"UUID":"91298673-fde4-4d10-be4b-d08eb375a5cd","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"初期設定の内部スピーカー音量を調整する 操作パネルで、右にスワイプしてコントロールセンターに移動します。 音量を調節します。 静音モードが有効になっている場合、警告音はオフになります。また、この設定を有効にすると、プリンタのパフォーマンスが低下します。 ユーザーがユーザー補助機能モードを終了した後、またはプリンタがスリープモードや休止モードから復帰したときに、ボリュームは初期設定値にリセットされます。","descFull":"初期設定の内部スピーカー音量を調整する 操作パネルで、右にスワイプしてコントロールセンターに移動します。 音量を調節します。 静音モードが有効になっている場合、警告音はオフになります。また、この設定を有効にすると、プリンタのパフォーマンスが低下します。 ユーザーがユーザー補助機能モードを終了した後、またはプリンタがスリープモードや休止モードから復帰したときに、ボリュームは初期設定値にリセットされます。 スピーカー音量 調整 スピーカー音量を調整する"},{"UUID":"f324e493-a4ca-4ba1-8174-069ebcd0c14d","title":"ユーザー補助機能を設定して使用する","link":"activating-voice-guidance-topic.html","desc":"音声のパスワードまたは個人 ID 番号を有効にする 操作パネルから［ 設定","descFull":"音声のパスワードまたは個人 ID 番号を有効にする 操作パネルから［ 設定 ］ ［ デバイス ］ ［ ユーザー補助機能 ］ ［ パスワード/PIN を発声］ の順に移動します。 設定を有効にします。 音声のパスワード 有効にする 個人 ID 番号 有効にする"},{"UUID":"184f7416-5cec-4d20-9a77-64e90e4148ca","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"アナログ FAX を使用した FAX 機能の設定","descFull":"アナログ FAX を使用した FAX 機能の設定 アナログ FAX を使用した FAX 機能の設定 プリンタでアナログ FAX を使用するためには、FAX カードを取り付ける必要があります。 一部の接続方法は、一部の国と地域でのみ利用できます。 FAX 機能が有効になっていても設定が完了していない場合、インジケータランプが赤く点滅することがあります。 TCP/IP 環境がない場合、操作パネルを使用して FAX を設定します。 データの損失やプリンタの誤動作の発生を防ぐため、実際に FAX を送受信している間は、ケーブルや下記に示すプリンタの部分に触らないでください。 操作パネルを使用する 操作パネルで、［ 設定 ］ ［ Fax ］ ［ Fax 設定 ］ ［ 一般 Fax 設定 ］の順に移動します。 設定を行います。 内蔵 Web サーバーを使用する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 操作パネルでプリンタの IP アドレスを確認します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ 一般 FAX 設定 ］をクリックします。 設定を行います。 変更を適用します。 アナログ FAX 設定する アナログ FAX を設定する"},{"UUID":"e09add30-d4b4-46db-976b-a750d76c412b","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"etherFAX を使用した FAX 機能の設定 etherFAX","descFull":"etherFAX を使用した FAX 機能の設定 etherFAX を使用した FAX 機能の設定 プリンタファームウェアを最新バージョンにアップデートする必要があります。詳細については、「ファームウェアを更新する」セクションを参照してください。 適切なライセンスバンドルがプリンタにインストールされている必要があります。詳細については、etherFAX にお問い合わせください。 プリンタが etherFAX ポータルに登録されていることを確認します。詳細については、 https://www.etherfax.net/lexmark  を参照してください。 登録時にはプリンタのシリアル番号が必要です。詳細については、 を参照してください。 Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 操作パネルでプリンタの IP アドレスを確認します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ 一般 FAX 設定 ］をクリックします。 ［ FAX 設定 ］は、［ FAX モード ］が［ FAX ］に設定されている場合にのみ表示されます。 ［FAX 名］フィールドに一意の名前を入力します。 ［FAX 番号］フィールドに、etherFAX から提供される FAX 番号を入力します。 ［ FAX の転送 ］メニューで［ etherFAX ］を選択します。 このメニューは、複数の FAX の転送が使用可能な場合にのみ表示されます。 プリンタに etherFAX のみがインストールされている場合は、自動的に設定されます。 変更を適用します。 etherFAX FAX 機能を設定する FAX 機能を設定する etherFAX を使用する"},{"UUID":"05bf6c81-e04a-44b1-b2de-e92a0734d154","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"FAX サーバーを使用して FAX 機能を設定する この機能を使用すると、E","descFull":"FAX サーバーを使用して FAX 機能を設定する この機能を使用すると、E メール受信をサポートしている FAX サービスプロバイダに FAX メッセージを送信できます。 この機能は、送信 FAX メッセージのみをサポートしています。FAX 受信をサポートするには、プリンタでアナログ FAX、etherFAX、または Fax over IP（FoIP）など、デバイスベースの FAX が設定されていることを確認してください。 Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 操作パネルでプリンタの IP アドレスを確認します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ 設定 ］ ［ FAX ］の順にクリックします。 ［ FAX モード ］メニューから［ FAX サーバー ］を選択し、［ 保存 ］をクリックします。 ［ FAX サーバー設定 ］をクリックします。 ［ 送信先形式 ］フィールドに、「 [#]@myfax.com 」と入力します。ここでの [#]  は FAX 番号、 myfax.com  は FAX プロバイダドメインになります。 必要に応じて、返信アドレス、件名、またはメッセージ フィールドを設定してください。 プリンタで FAX メッセージを受信するには、デバイスベースの FAX 受信設定を有効にしてください。デバイスベースの FAX が設定されていることを確認してください。 ［ 保存 ］をクリックします。 ［ FAX サーバー E メール設定 ］をクリックし、［ E メール SMTP サーバーを使用 ］を有効にします。 これが設定されていない場合、 を参照してください。 変更を適用します。 FAX サーバー、使用 FAX 機能をセットアップする FAX サーバーを使用して FAX 機能を設定する"},{"UUID":"4f9790be-b01b-4965-80c2-c69c9ce6ed49","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"標準電話回線を使用して FAX を設定する 標準電話回線を使用して FAX","descFull":"標準電話回線を使用して FAX を設定する 標準電話回線を使用して FAX を設定する これらの手順は、FAX カードが取り付けられているプリンタにのみ適用されます。 感電の危険を避けるため、雷雨時には、本製品のセットアップや、電源コード、FAX、電話など、電気的接続またはケーブル接続を行わないでください。 雷雨時には、感電の危険を避けるため、FAX 機能を使用しないでください。 火災発生の恐れがないように、本製品を公共電話回線ネットワークに接続する場合は、26 AWG 以上の太さの電気通信ケーブル（RJ-11）のみを使用してください。オーストラリアのユーザーは、オーストラリア通信メディア庁（Australian Communications and Media Authority）が承認するケーブルを必ず使用してください。 セットアップ 1：プリンタが専用 FAX 回線に接続されている場合 電話ケーブルの一方の端をプリンタの LINE ポートに接続します。 ケーブルのもう一方の端を、現在ご使用のアナログ電話のコンセントに接続します。 FAX を自動（［ 自動応答 ］を［ オン ］に設定）または手動（［ 自動応答 ］を［ オフ ］に設定）で受信するようにプリンタを設定できます。 FAX を自動的に受信する場合は、応答するまでの呼び出し回数を設定してください。 セットアップ 2：プリンタが留守番電話機と回線を共有している場合 着信識別サービスに加入している場合は、プリンタに正しい着信音を設定していることを確認します。間違った着信音を設定すると、FAX を自動受信するように設定していたとしてもプリンタは FAX を受信しません。 同じ電話コンセントに接続されている場合 電話ケーブルの一方の端をプリンタの LINE ポートに接続します。 ケーブルのもう一方の端を、アクティブなアナログ電話回線ジャックに接続します。 留守番電話をプリンタの電話ポートに接続します。 別々の電話回線ジャックに接続されている場合 電話ケーブルの一方の端をプリンタの LINE ポートに接続します。 ケーブルのもう一方の端を、アクティブなアナログ電話回線ジャックに接続します。 お使いの電話回線で 1 つの電話番号しか持っていない場合は、FAX を自動で受信するようにプリンタを設定します。 留守番電話が応答してから着信音が 2 回鳴った後でプリンタが応答するように、プリンタを設定します。例えば、留守番電話が着信音 4 回で応答する場合は、プリンタの［ 呼び出し回数 ］設定を  6  回に設定します。 FAX を設定する 標準電話回線接続を使用する FAX 設定 標準電話回線接続を使用する 留守番電話 設定する"},{"UUID":"30a0d7c5-061b-4c51-a3b2-49996fcce013","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"異なる電話のモジュラージャックとプラグを使用する国または地域で FAX を設定する 異なる電話のモジュラージャックとプラグを使用する国または地域で FAX","descFull":"異なる電話のモジュラージャックとプラグを使用する国または地域で FAX を設定する 異なる電話のモジュラージャックとプラグを使用する国または地域で FAX を設定する これらの手順は、FAX カードが取り付けられているプリンタにのみ適用されます。 感電の危険を避けるため、雷雨時には、本製品のセットアップや、電源コード、FAX、電話など、電気的接続またはケーブル接続を行わないでください。 雷雨時には、感電の危険を避けるため、FAX 機能を使用しないでください。 火災発生の恐れがないように、本製品を公共電話回線ネットワークに接続する場合は、26 AWG 以上の太さの電気通信ケーブル（RJ-11）のみを使用してください。オーストラリアのユーザーは、オーストラリア通信メディア庁（Australian Communications and Media Authority）が承認するケーブルを必ず使用してください。 ほとんどの国または地域で標準として採用されているモジュラージャックは、RJ‑11 です。ファシリティ内のモジュラージャックまたは機器がこのタイプの接続に互換性がない場合は、電話アダプタを使用します。お住まいの国または地域のアダプタがプリンタに含まれておらず、別途購入する必要がある場合があります。 プリンタの電話ポートにアダプタプラグが取り付けられている場合があります。シリアルまたはカスケード式電話システムに接続している場合、プリンタの電話ポートからアダプタプラグを取り外さないでください。 アダプタプラグ商品コード 部品名 部品番号 Lexmark アダプタプラグ 40X8519 プリンタを RJ-11 以外のモジュラージャックに接続する 電話ケーブルの一方の端をプリンタの LINE ポートに接続します。 もう一方の端を RJ‑11 アダプタに接続し、アダプタをモジュラージャックに接続します。 RJ‑11 以外のコネクタを使用した別のデバイスを同じモジュラージャックに接続する場合は、直接電話アダプタに接続します。 FAX 設定 FAX を設定する"},{"UUID":"bede82b1-920b-46ab-8aa8-4c3e0e25c50c","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"着信識別サービスへの接続 着信識別サービスを使用すると、1 つの電話回線で複数の電話番号を持つことができます。各電話番号がそれぞれ異なる着信音パターンに割り当てられます。 操作パネルで、［ 設定","descFull":"着信識別サービスへの接続 着信識別サービスを使用すると、1 つの電話回線で複数の電話番号を持つことができます。各電話番号がそれぞれ異なる着信音パターンに割り当てられます。 操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ 管理者用設定 ］ ［ 応答設定 ］の順に移動します。 着信音を選択します。 着信識別サービス 着信識別サービスに接続する プリンタに着信音を割り当てる"},{"UUID":"80b469b3-e67b-485c-b1ff-da18e3a64035","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"FAX の日時を設定する FAX の日時を設定する 操作パネルで、［","descFull":"FAX の日時を設定する FAX の日時を設定する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 基本設定 ］ ［ 日付/時刻 ］ ［ 設定 ］の順に移動します。 設定を行います。 FAX 日付と時刻を設定する 日時 FAX 設定"},{"UUID":"54bd0138-922c-41b7-ae7e-29a1e522d9b6","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"夏時間を設定する 操作パネルで、［ 設定 ］ ［","descFull":"夏時間を設定する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 基本設定 ］ ［ 日付/時刻 ］ ［ 設定 ］の順に移動します。 ［ タイムゾーン ］メニューで、［ （UTC+時差）カスタム ］を選択します。 ［ 設定 ］メニューで［ UTC オフセット ］を設定します。 設定を行います。 夏時間を設定する 夏時間 設定する"},{"UUID":"d33557ad-3f27-4047-826d-dfe9ed4a86d1","title":"プリンタを設定して FAX を送信する","link":"setting-up-printer-to-fax-group.html","desc":"FAX スピーカー設定を行う 操作パネルで、［ 設定 ］","descFull":"FAX スピーカー設定を行う 操作パネルで、［ 設定 ］ ［ Fax ］ ［ Fax 設定 ］ ［ スピーカー設定 ］の順に移動します。 以下の操作を実行します。 ［ スピーカーモード ］を［ 常にオン ］に設定します。 ［ スピーカー音量 ］を［ 大 ］に設定します。 ［ 着信音 ］を有効にします。 設定する FAX スピーカー FAX スピーカー 設定する"},{"UUID":"444e2c8c-fb9e-4229-8d34-b9fceef30b51","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"特殊用紙のサイズとタイプを設定する 特殊用紙のサイズとタイプを設定する 特殊用紙（ラベル、厚紙、封筒など）の場合は次のようにします。 操作パネルから、［ 設定","descFull":"特殊用紙のサイズとタイプを設定する 特殊用紙のサイズとタイプを設定する 特殊用紙（ラベル、厚紙、封筒など）の場合は次のようにします。 操作パネルから、［ 設定 ］ ［ 用紙 ］ ［ トレイ設定 ］ ［ 用紙サイズ/タイプ］ の順に移動します。 給紙トレイを選択し、普通紙以外の用紙のサイズとタイプを設定します。 用紙サイズを設定する 用紙タイプを設定する"},{"UUID":"dc2b05f3-a922-41fb-a994-fea718053cb3","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"ユニバーサル用紙設定を構成する ユニバーサル用紙設定を構成する ［ ユニバーサル設定 ］メニューでは","descFull":"ユニバーサル用紙設定を構成する ユニバーサル用紙設定を構成する ［ ユニバーサル設定 ］メニューでは 、プリンタで予めセットされていない用紙サイズの幅と高さを設定できます。 操作パネルで、［ 設定 ］ ［ 用紙 ］ 用紙構成 ］ ［ ユニバーサル設定 ］の順に移動します。 ［ すべての給紙カセット ］を選択し、カスタマイズする用紙サイズを設定します。 用紙サイズを設定する 用紙サイズをカスタマイズする"},{"UUID":"65cc7937-72f4-41a0-82e6-14f7aeace715","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"550 枚カセットに用紙をセットする 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 カセットを開きます。 紙詰まりを防ぐために、プリンタがビジー状態の間はトレイを開かないでください。","descFull":"550 枚カセットに用紙をセットする 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 カセットを開きます。 紙詰まりを防ぐために、プリンタがビジー状態の間はトレイを開かないでください。 セットする用紙のサイズに合わせてガイドを調整します。 トレイの下部にあるインジケータで、ガイドの位置合わせをします。 穴開き用紙は、標準の 550 枚給紙トレイでのみサポートされています。 A3 サイズの用紙は、オプションの 550 枚給紙トレイでのみサポートされています。 用紙をほぐし、パラパラとめくってから端をそろえ、用紙をセットします。 印刷面を上にして、用紙の束をセットします。 トレイに用紙を滑らせて入れないでください。 側面ガイドが用紙にぴったりと合っていることを確認します。 重ねた用紙の高さが、給紙上限マークを超えないようにします。用紙の枚数が多すぎると、紙詰まりを起こすことがあります。 トレイを挿入します。 必要に応じて、トレイにセットされた用紙に合った用紙サイズとタイプを設定します。 フィニッシャを取り付けると、ページが印刷時に 180°回転します。 レターヘッド紙をセットする場合は、次の操作を実行します。 フィニッシャがない場合 フィニッシャがある場合 片面、長辺印刷 片面、長辺印刷 片面、短辺印刷 片面、短辺印刷 両面、長辺印刷 両面、長辺印刷 両面印刷、短辺印刷 両面印刷、短辺印刷 穴開き用紙をセットする場合は、次の操作を実行します。 オプションのフィニッシャがない場合 オプションのフィニッシャがある場合 片面、長辺印刷 片面、長辺印刷 片面、短辺印刷 片面、短辺印刷 両面、長辺印刷 両面、長辺印刷 両面印刷、短辺印刷 両面印刷、短辺印刷 550 枚トレイ 用紙をセットする 550 枚トレイに用紙をセットする 用紙をトレイにセットする"},{"UUID":"ebc9e954-afe0-4ad0-aa9f-a99154e7b1a2","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"2000 枚デュアル給紙に用紙をセットする 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 カセットを開きます。 紙詰まりを防ぐために、プリンタがビジー状態の間はトレイを引き出さないでください。","descFull":"2000 枚デュアル給紙に用紙をセットする 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 カセットを開きます。 紙詰まりを防ぐために、プリンタがビジー状態の間はトレイを引き出さないでください。 用紙をほぐし、パラパラとめくってから端をそろえ、用紙をセットします。 印刷面を上にして、用紙の束を右トレイの引き出し部にセットします。 トレイに用紙を滑らせて入れないでください。 重ねた用紙の高さが、給紙上限マークを超えないようにします。用紙の枚数が多すぎると、紙詰まりを起こすことがあります。 プリンタに右トレイの引き出し部を挿入します。 印刷面を上にして、用紙の束を左トレイの引き出し部にセットします。 トレイを挿入します。 必要に応じて、トレイにセットされた用紙に合った用紙サイズとタイプを設定します。 フィニッシャを取り付けると、ページが印刷時に 180°回転します。 片面印刷の場合、レターヘッド紙は、ヘッダーがトレイの正面を向くように上向きにセットします。 両面印刷の場合、レターヘッド紙は、ヘッダーがトレイの後方を向くように下向きにセットします。 2000 枚デュアル給紙 用紙をセットする 2000 枚デュアル給紙に用紙をセットする 用紙をトレイにセットする"},{"UUID":"bd616269-9789-42a4-9b1e-a5a430f837f7","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"1500 枚カセットに用紙をセットする 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 ドア K","descFull":"1500 枚カセットに用紙をセットする 本機が不安定にならないように、用紙トレイは個別にセットします。その他のすべてのトレイは必要になるまで閉じた状態にします。 ドア K を開きます。 紙詰まりを防ぐために、プリンタがビジー状態の間はトレイを開かないでください。 用紙をほぐし、パラパラとめくってから端をそろえ、用紙をセットします。 印刷面を下にして、用紙の束をセットします。 トレイに用紙を滑らせて入れないでください。 重ねた用紙の高さが、給紙上限マークを超えないようにします。用紙の枚数が多すぎると、紙詰まりを起こすことがあります。 ドア K を閉じます。 必要に応じて、トレイにセットされた用紙に合った用紙サイズとタイプを設定します。 方面印刷の場合、レターヘッド紙は、ヘッダーがプリンタの後方を向くように下向きにセットします。 両面印刷の場合、レターヘッド紙は、ヘッダーがプリンタの後方を向くように上向きにセットします。 異なる用紙サイズをセットする場合は、必ずガイドを調整してください。以下の操作を実行します。 マイナスドライバを使用して用紙ガイドのねじを外します。 用紙ガイドを取り外します。 セットする用紙のサイズに合わせて用紙ガイドを調整します。 ネジを用紙ガイドに取り付けます。 1500 枚トレイ 用紙をセットする 用紙をトレイにセットする"},{"UUID":"5cbf9453-f97f-4c3a-845c-be82ede0463d","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"多目的フィーダに用紙をセットする 多目的フィーダを開きます。 セットする用紙のサイズに合わせて側面ガイドを調整します。 用紙をほぐし、パラパラとめくってから端をそろえ、用紙をセットします。 用紙をセットします。","descFull":"多目的フィーダに用紙をセットする 多目的フィーダを開きます。 セットする用紙のサイズに合わせて側面ガイドを調整します。 用紙をほぐし、パラパラとめくってから端をそろえ、用紙をセットします。 用紙をセットします。 側面ガイドが用紙にぴったりと合っていることを確認します。 レターヘッド紙をセットする場合は、次のいずれかを実行します。 フィニッシャがない場合 フィニッシャがある場合 片面、長辺印刷 片面、長辺印刷 両面、長辺印刷 両面、長辺印刷 穴開き用紙をセットする場合は、次のいずれかを実行します。 フィニッシャがない場合 フィニッシャがある場合 片面、長辺印刷 片面、長辺印刷 両面、長辺印刷 両面、長辺印刷 封筒の場合 封筒の蓋を閉じる側を上にして、プリンタ後方に向けてセットします。ヨーロッパサイズの封筒は、蓋を閉じる側を上にして最初に多目的フィーダに入るようにセットします。 フィニッシャを取り付けると、プリンタではページが 180°回転します。 用紙をセットする 多目的フィーダ レターヘッド紙をセットする 穴あき用紙をセットする"},{"UUID":"eca56130-fcad-4165-8ff9-3c8724ff8f61","title":"用紙と普通紙以外の用紙をセットする","link":"loading-trays-group.html","desc":"トレイのリンク Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。","descFull":"トレイのリンク Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［設定 ］ ［ 用紙 ］ ［ トレイ設定 ］をクリックします。 リンクしているトレイと同じ用紙サイズと用紙タイプを設定します。 リンクしているトレイは、必ず同じ用紙方向にセットしてください。 設定を保存します。 ［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 設定メニュー ］ ［ トレイ設定 ］をクリックします。 同一用紙サイズの［ トレイのリンク ］を［ 自動 ］に設定します。 設定を保存します。 トレイとのリンクを解除するには、同じ用紙サイズと用紙タイプの設定を持つトレイが他にないことを確認してください。 フューザーの温度は、指定した用紙タイプによって異なります。印刷の問題を回避するには、プリンタの用紙タイプの設定をトレイにセットした用紙に合わせます。 トレイのリンクを解除する トレイのリンク カセットのリンク カセットのリンクの解除"},{"UUID":"c7bdb945-5961-4270-9517-1fcb55e57dd2","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う","link":"installing-printer-software-topic.html","desc":"プリンタソフトウェアをインストールする プリンタドライバはソフトウェアインストーラパッケージに含まれています。 macOS バージョン 10.7","descFull":"プリンタソフトウェアをインストールする プリンタドライバはソフトウェアインストーラパッケージに含まれています。 macOS バージョン 10.7 以降が搭載されている Macintosh コンピュータの場合は、ドライバをインストールせずに AirPrint 対応プリンタで印刷できます。カスタム印刷機能が必要な場合は、プリンタドライバをダウンロードします。 ソフトウェアインストーラパッケージのコピーを取得します。 プリンタに付属のソフトウェア CD から www.lexmark.com/downloads  にアクセスします。 www.dell.com/support/printers  にアクセスします。 Web サイトまたはプリンタの販売店から インストーラを実行して、コンピュータの画面の手順に従います。 プリンタソフトウェアをインストールする プリンタソフトウェア 設置 プリントドライバをインストールする プリントドライバ 設置"},{"UUID":"ea85141f-ddda-4e4d-9908-3c0cd5f417a7","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う","link":"installing-printer-software-topic.html","desc":"FAX ドライバをインストールする www.lexmark.com/downloads  にアクセスし、プリンタ機種を検索して、適切なインストーラパッケージをダウンロードします。","descFull":"FAX ドライバをインストールする www.lexmark.com/downloads  にアクセスし、プリンタ機種を検索して、適切なインストーラパッケージをダウンロードします。 弊社の Web サイトまたはプリンタを購入した場所にアクセスし、インストーラパッケージを入手します。 www.dell.com/support  にアクセスし、適切なインストーラパッケージをダウンロードします。 コンピュータで、 ［プリンタのプロパティ］ をクリックし、 ［設定］ タブに移動します。 インストーラを実行して、コンピュータの画面の手順に従います。 ［FAX］ を選択してから ［適用］ をクリックします。 FAX ドライバ 設置 FAX ドライバをインストールする"},{"UUID":"2bd77c26-b150-416e-a35e-a368ac830d99","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う","link":"installing-printer-software-topic.html","desc":"コンピュータにプリンタを追加する 開始する前に、次のいずれかを実行します。 プリンタとコンピュータを同じネットワークに接続します。プリンタをネットワークに接続する方法については、 を参照してください。 コンピュータをプリンタに接続します。詳細については、","descFull":"コンピュータにプリンタを追加する 開始する前に、次のいずれかを実行します。 プリンタとコンピュータを同じネットワークに接続します。プリンタをネットワークに接続する方法については、 を参照してください。 コンピュータをプリンタに接続します。詳細については、 を参照してください。 USB ケーブルを使用してプリンタをコンピュータに接続します。詳細については、 を参照してください。 USB ケーブルは付属していません。 Windows の場合 コンピュータに印刷ドライバをインストールします。 詳細については、 を参照してください。 ［ プリンタとスキャナ ］を開き、［ プリンタまたはスキャナを追加 ］をクリックします。 プリンタ接続に応じて、次のいずれかを実行します。 一覧からプリンタを選択し、［ デバイスの追加 ］をクリックします。 ［ Wi-Fi ダイレクトプリンタを表示する ］をクリックし、プリンタを選択して、［ デバイスの追加 ］をクリックします。 ［ プリンタが一覧にない場合 ］をクリックして、［ プリンタを追加 ］ウィンドウで次の手順を実行します。 ［ IP アドレスまたはホスト名を使ってプリンタを追加する ］を選択し、［ 次へ ］をクリックします。 ［デバイスの種類］フィールドで、［ TCP/IP デバイス ］を選択します。 ［ホスト名または IP アドレス］フィールドにプリンタの IP アドレスを入力し、［ 次へ ］をクリックします。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 プリンタドライバ選択してから、［ 次へ ］をクリックします。 ［ 現在インストールされているドライバーを使う（推奨） ］を選択し、［ 次へ ］をクリックします。 プリンタ名を入力し、［ 次へ ］をクリックします。 ［ 終了 ］をクリックします。 Macintosh の場合 ［ プリンタとスキャナ ］を開きます。 ［ プリンタ、スキャナ、またはファクスを追加 ］をクリックし、プリンタを選択します。 ［ プリンタを追加 ］メニューからプリントドライバを選択します。 Macintosh のプリントドライバを使用するには、［ AirPrint ］または［ Secure AirPrint ］のいずれかを選択します。 カスタム印刷機能を使用する場合は、Lexmark のプリントドライバを選択します。ドライバをインストールするには、 を参照してください。 カスタム印刷機能が必要な場合は、製造元のプリントドライバを選択します。ドライバをインストールするには、 を参照してください。 プリンタを追加します。 コンピュータにプリンタを追加する"},{"UUID":"780416e9-43f2-4f44-8b70-ffdc8a35f9d1","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う","link":"installing-printer-software-topic.html","desc":"設定ファイルをエクスポートする Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。","descFull":"設定ファイルをエクスポートする Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 EWS で、［ 構成をエクスポート ］をクリックします。 エクスポートする設定ファイルを選択します。 選択した設定ファイルに応じて、ファイルは ZIP または CSV 形式でエクスポートされます。 設定ファイルのエクスポート 設定ファイル エクスポート"},{"UUID":"7d481335-d80c-43f1-bae1-39d416f2da49","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う","link":"installing-printer-software-topic.html","desc":"設定ファイルをインポートする Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。","descFull":"設定ファイルをインポートする Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 EWS で、［ 構成をインポート ］をクリックします。 ファイルを保存する場所を参照します。 ファイルは ZIP または CSV 形式で保存されます。 ［ インポート ］をクリックします。 設定ファイルをインポートする 設定ファイル インポート"},{"UUID":"87d65a8c-f632-4877-9d22-b8c527a45689","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う","link":"installing-printer-software-topic.html","desc":"プリンタドライバの使用可能なオプションを追加する Windows の場合 プリンタフォルダを開きます。 更新するプリンタを選択して、次のいずれかを実行します。","descFull":"プリンタドライバの使用可能なオプションを追加する Windows の場合 プリンタフォルダを開きます。 更新するプリンタを選択して、次のいずれかを実行します。 Windows 7 以降の場合は、［ プリンタのプロパティ ］を選択します。 それ以前のバージョンの場合は、［ プロパティ ］を選択します。 ［ 設定 ］タブに移動して、［ 今すぐ更新 - プリンタに照会 ］を選択します。 変更を適用します。 Macintosh の場合 ［ プリンタとスキャナ ］を開きます。 ［ プリンタ、スキャナ、またはファクスを追加 ］をクリックし、プリンタを選択します。 プリンタドライバを選択します。 変更を適用します。 ハードウェアオプションを追加する プリントドライバ プリントドライバ ハードウェアオプションを追加する"},{"UUID":"195dd477-8597-48a7-b4cb-26d4dd3adc73","title":"ファームウェアを更新する","link":"installing-printer-software-topic.html","desc":"操作パネルを使用してファームウェアを更新する 通知センターを使用する この方法は、一部のプリンタ機種のみを対象としています。 操作パネルから、通知センターに移動し、[ ファームウェア更新が利用可能","descFull":"操作パネルを使用してファームウェアを更新する 通知センターを使用する この方法は、一部のプリンタ機種のみを対象としています。 操作パネルから、通知センターに移動し、[ ファームウェア更新が利用可能 ]を選択します。 [ 今すぐインストール ]を選択します。 更新後、プリンタは自動的に再起動します。 ［設定］メニューを使用する 操作パネルから、［ 設定 ］ ［ デバイス ］ ［ ファームウェアを更新 ］の順に移動します。 お使いのプリンタモデルに応じて、［ 更新を確認 ］または［ 今すぐ更新を確認 ］を選択します。 新しい更新が利用可能な場合は、[ 今すぐインストール ]を選択します。 更新後、プリンタは自動的に再起動します。 ファームウェアを更新する 操作パネルを使用する ファームウェア、更新する 操作パネルを使用する"},{"UUID":"d4b880c1-21dd-4d03-ad7d-04a7066dface","title":"ファームウェアを更新する","link":"installing-printer-software-topic.html","desc":"EWS を使用してファームウェアを更新する 開始する前に、次の点を確認してください。 https://support.lexmark.com ","descFull":"EWS を使用してファームウェアを更新する 開始する前に、次の点を確認してください。 https://support.lexmark.com  からダウンロードされた最新のプリンタファームウェアが、フラッシュドライブまたはコンピュータに保存されています。 プリンタのファームウェアを展開するには、ZIP パッケージから FLS ファームウェアのファイルを解凍します。 ダウンロードされた最新のプリンタファームウェアが、フラッシュドライブまたはコンピュータに保存されています。詳細については、プリンタの購入先に問い合わせてください。 ダウンロードされた最新のプリンタファームウェアが、フラッシュドライブまたはコンピュータに保存されています。詳細については、営業担当者に問い合わせてください。 この機能を利用できなくなることを避けるために、プリンタで特別なコードを使用しているわけではありません。 ファームウェアを更新中に、ファームウェアを更新するすべてのプリンタの電源がオンになっていることを確認します。ファームウェアの更新中にプリンタの電源をオフにすると、プリンタが深刻な損傷を受ける恐れあります。 更新を確認するときにプリンタがネットワークに接続されている場合は、ファームウェアをダウンロードする必要はありません。 Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 [ デバイス ]をクリックします。 下方向にスクロールし、［ ファームウェアを更新 ］をクリックします。 お使いのプリンタモデルに応じて、［ 更新を確認 ］または［ 今すぐ更新を確認 ］をクリックします。 新しい更新が利用可能な場合は、［ 同意します。更新を開始します ］をクリックします。 更新後、プリンタは自動的に再起動します。 ファームウェアを更新する 内蔵 Web サーバーを使用する ファームウェア、更新する 内蔵 Web サーバーを使用する"},{"UUID":"a5340618-be72-4d3f-bf37-8d464e53f4aa","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"オプションの 550 枚トレイを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。","descFull":"オプションの 550 枚トレイを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 オプションの 550 枚トレイを梱包から取り出します。 トレイの破損を防ぐため、トレイを持ち上げる際は必ず前面と背面を持ってください。 右トレイのカバーを取り付けます。 550 枚トレイの引き出し部を引き出します。 上部のトレイカバーを取り外します。 ねじを外します。 下部のトレイカバーを取り付けます。 ネジを取り付けます。 上部のトレイカバーを取り付けます。 550 枚トレイの引き出し部を挿入します。 プリンタの左下のカバーを取り外します。 プリンタを 550 枚トレイに合わせ、所定の位置まで下げます。 プリンタの重さが 20 kg（44 lb）以上ある場合、安全に持ち上げるために 2 名以上の人が必要になることがあります。 標準トレイの引き出し部を引き出します。 550 枚トレイにプリンタを固定します。 標準トレイの引き出し部を挿入します。 550 枚トレイの後部をプリンタに固定します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 プリントドライバにトレイを追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 550 枚トレイを取り付ける 550 枚トレイ インストール ハードウェアオプション 550 枚トレイ"},{"UUID":"f8bb5c3b-ded3-4350-aa29-7ef9cca4c007","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"2 x 550 枚トレイの取り付け 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。","descFull":"2 x 550 枚トレイの取り付け 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションは、オプションの 550 枚トレイと一緒に取り付ける必要があります。このオプションは、構成の一番下に設置します。 550 枚トレイがすでに取り付けられている場合は、このトレイを取り外し、トレイサイドカバーを取り外し、下部のトレイカバーを取り外し、このオプションの上に 550 枚トレイを取り付けます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 2 x 550 枚トレイを梱包から取り出し、梱包材をすべて取り除きます。 キャスタをロックし、2 x 550 枚トレイを固定します。 550 枚トレイを 2 x 550 枚トレイに合わせ、所定の位置まで下げます。 トレイの破損を防ぐため、トレイを持ち上げる際は必ず前面と背面を持ってください。 550 枚トレイの引き出し部を引き出します。 550 枚トレイを 2 x 550 枚トレイに固定します。 550 枚トレイの引き出し部を挿入します。 550 枚トレイの後部を 2 x 550 枚トレイに固定します。 プリンタの左下のカバーを取り外します。 プリンタをデュアル給紙に合わせ、所定の位置まで下げます。 プリンタの重さが 20 kg（44 ポンド）以上ある場合、安全に持ち上げるために 2 名以上の人が必要になることがあります。 標準トレイの引き出し部を引き出します。 550 枚トレイにプリンタを固定します。 標準トレイの引き出し部を挿入します。 550 枚トレイの後部をプリンタに固定します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 プリントドライバにトレイを追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 2 x 550 枚トレイ 取り付ける ハードウェアオプション 2 x 550 枚トレイ 2 x 550 枚トレイを取り付ける"},{"UUID":"34b2f49c-9a67-4700-a5ec-5320967dccac","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"2000 枚デュアル給紙を取り付ける 2000 枚デュアル給紙を取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。","descFull":"2000 枚デュアル給紙を取り付ける 2000 枚デュアル給紙を取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションは、オプションの 550 枚トレイと一緒に取り付ける必要があります。このオプションは、構成の一番下に設置します。 550 枚トレイがすでに取り付けられている場合は、このトレイを取り外し、トレイサイドカバーを取り外し、下部のトレイカバーを取り外し、このオプションの上に 550 枚トレイを取り付けます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 デュアル給紙を梱包から取り出し、梱包材をすべて取り除きます。 キャスタをロックし、デュアル給紙を固定します。 D 550 枚トレイをデュアル給紙に合わせ、所定の位置まで下げます。 トレイの破損を防ぐため、トレイを持ち上げる際は必ず前面と背面を持ってください。 550 枚トレイの引き出し部を引き出します。 550 枚トレイをデュアル給紙に固定します。 トレイの引き出し部を挿入します。 550 枚トレイの後部をデュアル給紙に固定します。 プリンタの左下のカバーを取り外します。 プリンタをデュアル給紙に合わせ、所定の位置まで下げます。 プリンタの重さが 20 kg（44 ポンド）以上ある場合、安全に持ち上げるために 2 名以上の人が必要になることがあります。 標準トレイを引き出します。 550 枚トレイにプリンタを固定します。 トレイを挿入します。 550 枚トレイの後部をプリンタに固定します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 プリントドライバにトレイを追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 2000 枚デュアル給紙 取り付ける ハードウェアオプション 2000 枚デュアル給紙 2000 枚デュアル給紙を取り付ける"},{"UUID":"3aadf2d0-446c-48b1-8c84-8cfdf09dcd54","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"キャビネットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションは、550 枚トレイと一緒に取り付ける必要があります。このオプションは、構成の一番下に設置します。 550","descFull":"キャビネットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションは、550 枚トレイと一緒に取り付ける必要があります。このオプションは、構成の一番下に設置します。 550 枚トレイがすでに取り付けられている場合は、このトレイを取り外し、下部のトレイカバーを取り外し、このオプションの上に 550 枚トレイを取り付けます。 この作業には、マイナスドライバが必要です。 梱包から取り出し、キャビネット組み立てます。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 キャスタをロックし、キャビネットを固定します。 550 枚トレイのサイドカバーを取り付けます。 トレイをキャビネットに合わせ、所定の位置まで下げます。 トレイの破損を防ぐため、トレイを持ち上げる際は必ず前面と背面を持ってください。 トレイの引き出し部を引き出します。 キャビネットにトレイを固定します。 トレイの引き出し部を挿入します。 トレイの後部をキャビネットに固定します。 プリンタの左下のカバーを取り外します。 プリンタをキャビネットとトレイに合わせ、所定の位置まで下げます。 プリンタの重さが 20 kg（44 ポンド）以上ある場合、安全に持ち上げるために 2 名以上の人が必要になることがあります。 標準トレイの引き出し部を引き出します。 550 枚トレイにプリンタを固定します。 標準トレイの引き出し部を挿入します。 550 枚トレイの後部をプリンタに固定します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 キャビネット 取り付ける ハードウェアオプション キャビネット キャビネットを取り付ける"},{"UUID":"5a19b4ca-9728-40e0-9ac5-676f9c776c95","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"1500 枚トレイを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションを取り付ける前に、オプションの 550","descFull":"1500 枚トレイを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションを取り付ける前に、オプションの 550 枚トレイと 2 x 500 枚トレイまたは 2000 枚トレイのいずれかがすでに取り付けられていることを確認してください。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 接続カバーを取り外します。 カバーを捨てないでください。 ポートカバーを取り外します。 カバーを捨てないでください。 プリンタからネジ蓋を取り外します。 ネジ蓋は捨てないでください。 1500 枚トレイを梱包から取り出し、梱包材をすべて取り除きます。 ネジを取り付けブラケットに取り付けます。 プリンタに取り付けブラケットを取り付けます。 1500 枚トレイに付属の取り付けブラケットとネジを使用します。 残りのネジを取り付けます。 1500 枚トレイを取り付けます。 トレイケーブルをプリンタに接続します。 トレイのケーブルカバーを取り付けます。 1500 枚トレイをプリンタに向かってスライドします。 プリンタの電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 プリントドライバにトレイを追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 1500 枚トレイを取り付ける 1500 枚トレイ 取り付ける ハードウェアオプション 1500 枚トレイ"},{"UUID":"d9313354-43b8-45ad-8614-206d8badbcf9","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"ホチキスフィニッシャを取り付ける ホチキスフィニッシャを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。","descFull":"ホチキスフィニッシャを取り付ける ホチキスフィニッシャを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 ホチキスフィニッシャを梱包から取り出し、梱包材をすべて取り除きます。 フィードガイドを取り付けます。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 このオプションを取り外したら、排紙トレイフラグを開位置にします。 バックアップローラーを取り外します。 ローラーを捨てないでください。 ホチキスフィニッシャに付属しているフィードローラーを挿入し、 カチッ と音がすることを確認します。 金属バネが給紙ローラーの前面にあることを確認してください。 ローラーカバーを取り付けるときは、 カチッ と音がすることを確認します。 前面ドアを開いてから、プリンタの左側にあるカバーを取り外します。 ネジとカバーを捨てないでください。 左の背面カバーを取り外します。 ネジとカバーを捨てないでください。 内部排紙トレイのカバーを取り外します。 カバーを捨てないでください。 位置を合わせてから、ホチキスフィニッシャに付属する内部排紙トレイカバーを挿入します。 ネジを内部排紙トレイカバーに取り付けます。 ホチキスフィニッシャのスライドバーを取り付けます。 ホチキスフィニッシャを挿入します。 取り付けブラケットを取り付けて、フィニッシャをプリンタに固定します。 フィニッシャに付属のネジを使用します。 左側の背面カバーを取り付けて、ホチキスフィニッシャを左にスライドします。 フィニッシャに付属する左上のトリムカバーを取り付けます。 ホチキスカートリッジを挿入し、 カチッ と音がすることを確認します。 前面ドアを閉じて、プリンタに向かってフィニッシャをスライドします。 オプションケーブルをプリンタに接続します。 プリンタの電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 必要に応じて、プリントドライバにフィニッシャを追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 ホチキスフィニッシャを取り付ける ホチキスフィニッシャ 取り付ける ハードウェアオプション ホチキスフィニッシャ"},{"UUID":"b54d3678-7cbf-4afb-9192-46f4b3edf3f4","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"オフセットスタッカを取り付ける オフセットスタッカを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。","descFull":"オフセットスタッカを取り付ける オフセットスタッカを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 オフセットスタッカを梱包から取り出し、梱包材をすべて取り除きます。 内部の背面カバーをオフセットスタッカに取り付けます。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 用紙搬送ユニットのコネクタカバーを取り外します。 カバーを捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 位置を合わせ、オフセットスタッカをプリンタに取り付けます。 部品がプリンタの正しい位置にしっかりと接続されていることを確認します。 オフセットスタッカの保護ストリップをプリンタに取り付けます。 排紙トレイのフラグを開位置にします。 排紙トレイフラグカバーを取り付け、 カチッ と音がすることを確認します。 プリンタの電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 プリントドライバにオフセットスタッカを追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 オフセットスタッカ 取り付ける オフセットスタッカを取り付ける ハードウェアオプション 取り付ける"},{"UUID":"6113b14c-1214-487f-93ae-074091200711","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"折り畳みオプション付きの用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションは、ホチキス、穴パンチフィニッシャー、冊子フィニッシャと一緒に取り付けることもできます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。","descFull":"折り畳みオプション付きの用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 このオプションは、ホチキス、穴パンチフィニッシャー、冊子フィニッシャと一緒に取り付けることもできます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 折り畳みオプション付きの用紙搬送ユニットを梱包から取り出し、梱包材をすべて取り除きます。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 このオプションを取り外したら、排紙トレイフラグを開位置にします。 バックアップローラーを取り外します。 ローラーを捨てないでください。 オプションに付属しているフィードローラーを挿入し、 カチッ と音がすることを確認します。 金属バネが給紙ローラーの前面にあることを確認してください。 ローラーカバーを取り付けるときは、 カチッ と音がすることを確認します。 前面ドアを開いてから、プリンタの左側にあるカバーを取り外します。 ネジとカバーを捨てないでください。 前面ドアを閉じます。 用紙搬送ユニットのコネクタカバーを取り外します。 カバーを捨てないでください。 左の背面カバーを取り外します。 ネジとカバーを捨てないでください。 内部排紙トレイのカバーを取り外します。 ネジとカバーを捨てないでください。 位置を合わせてから、オプションに付属する内部排紙トレイカバーを挿入します。 ネジを内部排紙トレイカバーに取り付けます。 フォームテープの一部をオプションに取り付けます。 ドア F を開き、ねじを締めます。 ドア F を閉じます。 オプションに金属のブラケットを取り付けます。 オプションを挿入します。 金属のブラケットがプリンタの前面にあることを確認してください。 ドア F を開いてから、オプションに付属するドライバでネジを取り付けます。 ドア F を閉じます。 ネジをオプションに取り付けます。 左の背面カバーを取り付けます。 前面ドアを開いてから、カバーをプリンタの左側に取り付けます。 前面ドアを閉じます。 排紙トレイのフラップを上げ、位置を合わせてオプションの排紙トレイに取り付けます。 ネジをオプションの排紙トレイに取り付けます。 トリムカバーを取り付けます。 オプションケーブルをプリンタに接続します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 ハードウェアオプション 折り畳みオプション付き用紙搬送ユニット 折り畳みオプション付き用紙搬送ユニット 取り付ける"},{"UUID":"6f2e9c78-38a7-476c-a8d2-4475e82c2341","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"ホチキス、ホールパンチフィニッシャと用紙搬送オプションを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。","descFull":"ホチキス、ホールパンチフィニッシャと用紙搬送オプションを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 用紙搬送ユニットを梱包を取り出します。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 このオプションを取り外したら、排紙トレイフラグを開位置にします。 バックアップローラーを取り外します。 ローラーを捨てないでください。 用紙搬送ユニットに付属しているフィードローラーを挿入し、 カチッ と音がすることを確認します。 金属バネが給紙ローラーの前面にあることを確認してください。 カバーを取り付けて、 カチッ と音がすることを確認します。 前面ドアを開いてから、プリンタの左側にあるカバーを取り外します。 ネジとカバーを捨てないでください。 前面ドアを閉じます。 用紙搬送ユニットのコネクタカバーを取り外します。 カバーを捨てないでください。 カバーを取り外します。 カバーを捨てないでください。 金属のブラケットを取り付けます。 用紙搬送ユニットを挿入します。 ハンドル G を開いてから、ネジを用紙搬送ユニットの前面に取り付けます。 ハンドル G を閉じます。 用紙搬送ユニットの背面にねじを取り付けます。 前面ドアを開け、用紙搬送ユニットに付属のカバーをプリンタの左側に取り付けます。 前面ドアを閉じます。 ホチキス、ホールパンチフィニッシャを取り出します。 固定用器具を取り付けます。 フィニッシャ周辺のテープ片を取り除きます。 フィニッシャにブラケットを取り付けます。 フォームテープをフィニッシャに取り付けます。 フィードガイドをフィニッシャに取り付けます。 排紙トレイをフィニッシャに取り付けます。 フィニッシャのドアを開いてから、穴パンチボックスを挿入します。 フィニッシャ排紙トレイに排紙トレイ拡張装置をセットします。 排紙トレイ拡張装置は、A3 サイズ以上の用紙や湿度の高い環境で用紙を束ねるのに役立ちます。 排紙トレイ拡張装置を使用すると、排紙トレイの容量が減少します。 フィニッシャのドアを閉じます。 プリンタに取り付けブラケットを取り付けます。 ネジが取り付けブラケットのマーカーと合っていることを確認してください。 用紙搬送ユニットに付属の金属のブラケットをプリンタに取り付けます。 フィニッシャのドアを開け、ネジを外し、フィニッシャのロックを引き出します。 フィニッシャをプリンタに取り付けます。 フィニッシャをプリンタに固定し、ネジを取り付けます。 フィニッシャケーブルをプリンタに接続します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 ハードウェアオプション 用紙搬送ユニット ハードウェアオプション ホチキス、ホールパンチフィニッシャ 用紙搬送ユニット 取り付ける ホチキス、ホールパンチフィニッシャ 取り付ける"},{"UUID":"34da84e2-2365-43c8-9e1a-5a4a56832af1","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"ホチキス、ホールパンチフィニッシャと折り畳みオプション付き用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。","descFull":"ホチキス、ホールパンチフィニッシャと折り畳みオプション付き用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 折り畳みオプション付きの用紙搬送ユニットを梱包から取り出し、梱包材をすべて取り除きます。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 このオプションを取り外したら、排紙トレイフラグを開位置にします。 バックアップローラーを取り外します。 ローラーを捨てないでください。 オプションに付属しているフィードローラーを挿入し、 カチッ と音がすることを確認します。 金属バネが給紙ローラーの前面にあることを確認してください。 カバーを取り付けて、 カチッ と音がすることを確認します。 前面ドアを開いてから、プリンタの左側にあるカバーを取り外します。 ネジとカバーを捨てないでください。 前面ドアを閉じます。 用紙搬送ユニットのコネクタカバーを取り外します。 カバーを捨てないでください。 左の背面カバーを取り外します。 ネジとカバーを捨てないでください。 内部排紙トレイのカバーを取り外します。 ネジとカバーを捨てないでください。 位置を合わせてから、折り畳みオプション付き用紙搬送ユニットに付属する内部排紙トレイカバーを挿入します。 ネジを内部排紙トレイカバーに取り付けます。 フォームテープの一部をオプションに取り付けます。 ドア F を開き、ねじを締めます。 ドア F を閉じます。 オプションにブラケットを取り付けます。 オプションを挿入します。 金属のブラケットがプリンタの前面にあることを確認してください。 ドア F を開いてから、オプションに付属するドライバでネジを取り付けます。 ドア F を閉じます。 ネジをオプションに取り付けます。 左の背面カバーを取り付けます。 ホチキス、ホールパンチフィニッシャを取り出します。 固定用器具を取り付けます。 フィニッシャ周辺のテープ片を取り除きます。 フィニッシャにブラケットを取り付けます。 フォームテープをフィニッシャに取り付けます。 フィニッシャの右側にある小さな発泡スチロールを取り除きます。 フィードガイドをフィニッシャに取り付けます。 排紙トレイをフィニッシャに取り付けます。 フィニッシャのドアを開いてから、穴パンチボックスを挿入します。 フィニッシャ排紙トレイに排紙トレイ拡張装置をセットします。 排紙トレイ拡張装置は、A3 サイズ以上の用紙や湿度の高い環境で用紙を束ねるのに役立ちます。 排紙トレイ拡張装置を使用すると、排紙トレイの容量が減少します。 フィニッシャのドアを閉じます。 排紙トレイのフラップを上げ、カバーの位置を合わせてオプションに取り付けます。 ネジを取り付けます。 前面ドアを開けてから、オプションに付属のトリムカバーを取り付けます。 プリンタに取り付けブラケットを取り付けます。 ネジが取り付けブラケットのマーカーと合っていることを確認してください。 フィニッシャのドアを開け、ネジを外し、フィニッシャのロックを引き出します。 オプションケーブルをプリンタに接続します。 フィニッシャケーブルをオプションに接続します。 フィニッシャをプリンタに取り付けます。 フィニッシャをプリンタに固定し、ネジを取り付けます。 フィニッシャのドアを閉じます。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 ハードウェアオプション 折り畳みオプション付き用紙搬送ユニット ハードウェアオプション ホチキス、ホールパンチフィニッシャ 折り畳みオプション付き用紙搬送ユニット 取り付ける ホチキス、ホールパンチフィニッシャ 取り付ける"},{"UUID":"5e4081df-8800-432a-8fd1-a84e7f870179","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"冊子フィニッシャと用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。","descFull":"冊子フィニッシャと用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 用紙搬送ユニットを梱包を取り出します。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 このオプションを取り外したら、排紙トレイフラグを開位置にします。 バックアップローラーを取り外します。 ローラーを捨てないでください。 用紙搬送ユニットに付属しているフィードローラーを挿入し、 カチッ と音がすることを確認します。 金属バネが給紙ローラーの前面にあることを確認してください。 ローラーカバーを取り付けるときは、 カチッ と音がすることを確認します。 前面ドアを開いてから、プリンタの左側にあるカバーを取り外します。 ネジとカバーを捨てないでください。 前面ドアを閉じます。 用紙搬送ユニットのコネクタカバーを取り外します。 カバーを捨てないでください。 カバーを取り外します。 カバーを捨てないでください。 金属のブラケットを取り付けます。 用紙搬送ユニットを挿入します。 ハンドル G を開いてから、ネジを用紙搬送ユニットの前面に取り付けます。 ハンドル G を閉じます。 用紙搬送ユニットの背面にねじを取り付けます。 前面ドアを開け、用紙搬送ユニットに付属のカバーをプリンタの左側に取り付けます。 前面ドアを閉じます。 冊子フィニッシャを梱包から取り出し、梱包材をすべて取り除きます。 フィニッシャにブラケットを取り付けます。 フォームテープをフィニッシャに取り付けます。 フィードガイドをフィニッシャに取り付けます。 上部排紙トレイをフィニッシャに取り付けます。 排紙トレイのフラップを上げ、下部排紙トレイをフィニッシャに取り付けます。 フィニッシャのドアを開きます。 穴パンチボックスから梱包材を取り除いてから、フィニッシャに挿入します。 フィニッシャ排紙トレイに排紙トレイ拡張装置をセットします。 排紙トレイ拡張装置は、A3 サイズ以上の用紙や湿度の高い環境で用紙を束ねるのに役立ちます。 排紙トレイ拡張装置を使用すると、排紙トレイの容量が減少します。 フィニッシャの背面にバスケットを添付します。 フィニッシャのドアを閉じます。 プリンタに取り付けブラケットを取り付けます。 ネジが取り付けブラケットのマーカーと合っていることを確認してください。 用紙搬送ユニットに付属のブラケットをプリンタに取り付けます。 フィニッシャのドアを開け、ネジを外し、フィニッシャのロックを引き出します。 フィニッシャをプリンタに取り付けます。 フィニッシャをプリンタに固定し、ネジを取り付けます。 フィニッシャのドアを閉じます。 フィニッシャケーブルをプリンタに接続します。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 用紙搬送ユニットを取り付ける 取り付ける 用紙搬送ユニット ブックレットフィニッシャを取り付ける 取り付ける 冊子フィニッシャ"},{"UUID":"29ed4727-cf0c-439e-ba9c-5e4a435c5206","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"冊子フィニッシャと折り畳みオプション付き用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。","descFull":"冊子フィニッシャと折り畳みオプション付き用紙搬送ユニットを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 折り畳みオプション付きの用紙搬送ユニットを梱包から取り出します。 標準排紙トレイを取り外します。 排紙トレイは捨てないでください。 このオプションを取り付ける前に、排紙トレイフラグを閉位置にします。 このオプションを取り外したら、排紙トレイフラグを開位置にします。 バックアップローラーを取り外します。 ローラーを捨てないでください。 オプションに付属しているフィードローラーを挿入し、 カチッ と音がすることを確認します。 金属バネが給紙ローラーの前面にあることを確認してください。 ローラーカバーを取り付けるときは、 カチッ と音がすることを確認します。 前面ドアを開いてから、プリンタの左側にあるカバーを取り外します。 ネジとカバーを捨てないでください。 前面ドアを閉じます。 用紙搬送ユニットのコネクタカバーを取り外します。 カバーを捨てないでください。 左の背面カバーを取り外します。 ネジとカバーを捨てないでください。 内部排紙トレイのカバーを取り外します。 ネジとカバーを捨てないでください。 位置を合わせてから、オプションに付属する内部排紙トレイカバーを挿入します。 ネジを内部排紙トレイカバーに取り付けます。 フォームテープの一部をオプションに取り付けます。 ドア F を開き、ねじを締めます。 ドア F を閉じます。 オプションにブラケットを取り付けます。 オプションを挿入します。 金属のブラケットがプリンタの前面にあることを確認してください。 ドア F を開いてから、オプションに付属するドライバでネジを取り付けます。 ドア F を閉じます。 ネジをオプションに取り付けます。 左の背面カバーを取り付けます。 冊子フィニッシャを梱包から取り出し、梱包材をすべて取り除きます。 フィニッシャにブラケットを取り付けます。 フォームテープをフィニッシャに取り付けます。 フィードガイドをフィニッシャに取り付けます。 上部排紙トレイをフィニッシャに取り付けます。 排紙トレイのフラップを上げ、下部排紙トレイをフィニッシャに取り付けます。 フィニッシャのドアを開きます。 穴パンチボックスから梱包材を取り除いてから、フィニッシャに挿入します。 フィニッシャ排紙トレイに排紙トレイ拡張装置をセットします。 排紙トレイ拡張装置は、A3 サイズ以上の用紙や湿度の高い環境で用紙を束ねるのに役立ちます。 排紙トレイ拡張装置を使用すると、排紙トレイの容量が減少します。 フィニッシャの背面にバスケットを添付します。 フィニッシャのドアを閉じます。 排紙トレイのフラップを上げ、カバーの位置を合わせてオプションに取り付けます。 ネジを取り付けます。 前面ドアを開けてから、オプションに付属のトリムカバーを取り付けます。 プリンタに取り付けブラケットを取り付けます。 ネジが取り付けブラケットのマーカーと合っていることを確認してください。 フィニッシャのドアを開け、ネジを外し、フィニッシャのロックを引き出します。 オプションケーブルをプリンタに接続します。 フィニッシャケーブルをオプションに接続します。 フィニッシャをプリンタに取り付けます。 フィニッシャをプリンタに固定し、ネジを取り付けます。 フィニッシャのドアを閉じます。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 ハードウェアオプション 折り畳みオプション付き用紙搬送ユニット ハードウェアオプション 冊子フィニッシャ 折り畳みオプション付き用紙搬送ユニット 取り付ける 冊子フィニッシャ 取り付ける"},{"UUID":"671a20dd-fe97-4f60-a9b3-a7b9e37755bf","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"キーボードシェルフを取り付ける プリンタの電源を切ります。 ドア B を開きます。","descFull":"キーボードシェルフを取り付ける プリンタの電源を切ります。 ドア B を開きます。 前面カバーを外して、ドア B を閉じます。 キーボードシェルフを梱包から取り出します。 キーボードケーブルをシェルフに差し込みます。 シェルフの内側にケーブルを通します。 接着カバーを取り外します。 位置を合わせて、キーボードをベースに接続します。 シェルフの位置を合わせ、キーボードケーブルをプリンタに接続し、シェルフを挿入してからプリンタに取り付けます。 プリンタの電源を入れます。 ハードウェアオプション キーボードシェルフ キーボードシェルフ 取り付ける キーボードシェルフを取り付ける"},{"UUID":"d737bfd1-ecbb-49db-8843-cb7c0f65a8bb","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"FAX カードを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。","descFull":"FAX カードを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 コントローラボードのアクセスカバーを開きます。 コントローラボードの電気コンポーネントは、静電気により簡単に損傷します。コントローラボードの電気コンポーネントまたはコネクタに触れる前に、プリンタの金属面を触ります。 FAX ポートカバーを取り外します。 ネジとカバーを捨てないでください。 FAX カードを開梱します。 FAX ケーブルをコントローラボードに接続します。 位置を合わせ、FAX カードをプリンタに取り付けます。 コントローラボードのアクセスカバーを閉じ、 カチッ と音がすることを確認してから、ねじを取り付けます。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 FAX カード 取り付ける 内部オプションを取り付ける FAX カード"},{"UUID":"6997463c-8fe3-447e-8366-7cb212b76bff","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"カードリーダーを取り付る 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 プリンタの電源を切ります。 ドア B","descFull":"カードリーダーを取り付る 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 プリンタの電源を切ります。 ドア B を開きます。 前面の USB ポートカバーを開きます。 下部の USB ポートカバーを取り外します。 お使いのプリンタにこの部品がない場合は、次の手順に進みます。 カードリーダーから保護カバーを取り外します。 カードリーダーを挿入します。 下部のポートカバーを取り付け、 カチッ と音がすることを確認します。 ラベルガイドを取り付けます。 前面の USB ポートカバーを取り付け、 カチッ と音がすることを確認します。 ドア B を閉じて、 カチッ という音がすることを確認します。 プリンタの電源を入れます。 カードリーダー インストール 内蔵オプション カードリーダー"},{"UUID":"10f50182-b593-4066-bcc9-d6c6fff65885","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"内蔵ソリューションポートを取り付ける 内蔵ソリューションポートを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。","descFull":"内蔵ソリューションポートを取り付ける 内蔵ソリューションポートを取り付ける 感電を避けるため、プリンタのセットアップ後にコントローラボードにアクセスする際や、オプションのハードウェアまたはメモリデバイスを取り付ける際には、作業を進める前にプリンタの電源を切り、電源コードを抜きます。他のデバイスがプリンタに接続されている場合は、他のデバイスの電源も切り、プリンタに接続しているケーブルを抜きます。 この作業には、マイナスドライバが必要です。 プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 コントローラボードのアクセスカバーを開きます。 コントローラボードの電気コンポーネントは、静電気により簡単に損傷します。コントローラボードの電気コンポーネントまたはコネクタに触れる前に、プリンタの金属面を触ります。 内蔵ソリューションポート（ISP）をパッケージから取り出します。 ネジとカバーを捨てないでください。 ISP キットを開梱します。 ISP キットの内容 1 年 ISP 2 年 ISP 延長ケーブル 3 年 取り付けブラケット 4 年 つまみネジ 取り付けブラケットをコントローラボードに取り付けて、 カチッ と音がすることを確認します。 ISP を取り付けブラケットに取り付け、ISP 延長ケーブルをコントローラボードのコネクタに接続します。 プリンタに ISP を固定します。 コントローラボードのアクセスカバーを閉じます。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 内蔵ソリューションポート インストール オプションを取り付ける 内蔵ソリューションポート"},{"UUID":"ec66c195-2e12-46bf-9d20-be6ef5bb8653","title":"ハードウェアオプションを取り付ける","link":"installing-optional-550-sheet-tray-topic.html","desc":"内蔵ソリューションポートを取り付けた後でプリンタのポート設定を変更する 静的な IP アドレスがプリンタに割り当てられている場合は、設定を変更しないでください。 IP","descFull":"内蔵ソリューションポートを取り付けた後でプリンタのポート設定を変更する 静的な IP アドレスがプリンタに割り当てられている場合は、設定を変更しないでください。 IP アドレスの代わりにネットワーク名を使用するようにコンピュータが設定されている場合は、設定を変更しないでください。 以前はイーサネット接続用に設定されていたプリンタにワイヤレス内蔵ソリューションポート（ISP）を追加する場合は、プリンタをイーサネットネットワークから切り離します。 Windows の場合 プリンタフォルダを開きます。 新しい ISP を追加したプリンタのショートカットメニューから、プリンタのプロパティを開きます。 リストからポートを設定します。 IP アドレスを更新します。 変更を適用します。 Macintosh の場合 アップルメニューの「システム環境設定」から、プリンタの一覧に移動して、「 + IP」 の順に選択します。 アドレスフィールドに IP アドレスを入力します。 変更を適用します。 プリンタポート設定 変更 ISP の取り付け後にプリンタポート設定を変更する"},{"UUID":"43b5a25c-07c2-4d0f-8ace-278f3c9a5a18","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"プリンタを Wi-Fi ネットワークに接続する 開始する前に、次の点を確認してください。 ［","descFull":"プリンタを Wi-Fi ネットワークに接続する 開始する前に、次の点を確認してください。 ［ アクティブアダプタ ］が［ 自動 ］に設定されている。操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ネットワークの概要 ］ ［ アクティブアダプタ ］の順に移動します。 プリンタにイーサネットケーブルが接続されていません。 操作パネルを使用する 操作パネルで、[ 設定 ] [ ネットワーク/ポート ] [ ワイヤレス ] [ プリンタパネルで設定 ] [ ネットワークを選択 ]の順に移動します。 Wi-Fi ネットワークを選択して、ネットワークパスワードを入力します。 Wi-Fi ネットワーク機能を内蔵しているプリンタでは、初期セットアップ中に Wi-Fi ネットワークの設定を求めるメッセージが表示されます。 プリンタを Wi-Fi に接続する プリンタをワイヤレスネットワークに接続する ワイヤレスネットワーク"},{"UUID":"c417f528-ed9b-43bb-abf3-984827bc2170","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"WPS（Wi-Fi Protected Setup）を使用してワイヤレスネットワークにプリンタを接続する 開始する前に、次の点を確認してください。 アクセスポイント（ワイヤレスルーター）が","descFull":"WPS（Wi-Fi Protected Setup）を使用してワイヤレスネットワークにプリンタを接続する 開始する前に、次の点を確認してください。 アクセスポイント（ワイヤレスルーター）が WPS（Wi-Fi Protected Setup）認定または互換である。詳細については、アクセスポイントに同梱されているマニュアルを参照してください。 ワイヤレスネットワークアダプタがプリンタに取り付けられている。詳細については、アダプタに付属の説明書を参照してください。 ［ アクティブアダプタ ］が［ 自動 ］に設定されている。操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ネットワークの概要 ］ ［ アクティブアダプタ ］の順に移動します。 プッシュボタン方式を使用する場合 操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ワイヤレス ］ ［ Wi‑Fi Protected 設定 ］ ［ プッシュボタン方式を開始 ］の順に移動します。 ディスプレイに表示される手順に従います。 個人 ID 番号（PIN）方式を使用する場合 操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ワイヤレス ］ ［ Wi‑Fi Protected 設定 ］ ［ 暗証番号方式を開始 ］の順に移動します。 8 桁の WPS 暗証番号をコピーします。 Web ブラウザを開き、アドレスフィールドにアクセスポイントの IP アドレスを入力します。 IP アドレスを調べるには、アクセスポイントに同梱されているマニュアルを参照してください。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 WPS 設定にアクセスします。詳細については、アクセスポイントに同梱されているマニュアルを参照してください。 8 桁の PIN を入力して、変更を保存します。 Wi‑Fi Protected 設定 ワイヤレスネットワーク ワイヤレスネットワーク Wi‑Fi Protected 設定 ワイヤレスネットワークに接続する PIN 方式を使用する ワイヤレスネットワークに接続する プッシュボタン方式を使用する"},{"UUID":"c42d71dd-6be6-40ed-9d75-4952f77da65e","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi-Fi ダイレクトを設定する Wi-Fi ダイレクト を使用すると、アクセスポイント（ワイヤレスルーター）を使用せずに、Wi-Fi","descFull":"Wi-Fi ダイレクトを設定する Wi-Fi ダイレクト を使用すると、アクセスポイント（ワイヤレスルーター）を使用せずに、Wi-Fi デバイス同士を直接接続できます。 操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ Wi-Fi ダイレクト ］の順に移動します。 設定を行います。 ［ Wi-Fi ダイレクトを有効化 ］ — プリンタが独自の Wi-Fi ダイレクトネットワークにブロードキャストできるようにします。 ［ Wi-Fi ダイレクト名 ］ — Wi-Fi ダイレクトネットワークに名前を割り当てます。 ［ Wi‑Fi ダイレクトのパスワード ］ — ピアツーピア接続を使用しているときにワイヤレスセキュリティをネゴシエートするためのパスワードを割り当てます。 ［ 設定ページにパスワードを表示 ］ — ネットワーク設定ページにパスワードを表示します。 ［ 優先チャネル番号 ］ — Wi-Fi ダイレクトネットワークの優先チャネルを割り当てます。 ［ グループオーナー IP アドレス ］ — グループオーナーの IP アドレスを割り当てます。 ［ 自動受け付けプッシュボタン要求 ］ — プリンタに接続要求を自動的に受け付けさせます。 プッシュボタン要求の自動承諾はセキュリティ保護されません。 初期設定では、Wi-Fi ダイレクトのネットワークパスワードはプリンタのディスプレイに表示されません。パスワードを表示するには、パスワードピークアイコンを有効にします。操作パネルから［ 設定 ］ ［ セキュリティ ］ ［ その他 ］ ［ パスワード/PIN 表示を有効化］ の順に移動します。 Wi‑Fi ダイレクトネットワークのパスワードをプリンタのディスプレイに表示せずに確認するには、［ ネットワーク設定ページ ］を印刷します。操作パネルで、［ 設定 ］ ［ レポート ］ ［ ネットワーク ］ ［ ネットワーク設定ページ ］の順に移動します。 Wi‑Fi ダイレクト 設定 Wi-Fi ダイレクトを設定する"},{"UUID":"99c49afb-6c2f-4d89-bada-301c74ef23c2","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"プリンタにモバイルデバイスを接続する モバイルデバイスを接続する前に、Wi‑Fi Directが設定されていることを確認してください。詳細については、 を参照してください。 Wi‑Fi","descFull":"プリンタにモバイルデバイスを接続する モバイルデバイスを接続する前に、Wi‑Fi Directが設定されていることを確認してください。詳細については、 を参照してください。 Wi‑Fi ダイレクトを使用する これらの説明は、 Android  プラットフォームで動作するモバイルデバイスにのみ適用されます。 モバイルデバイスから、［ 設定 ］メニューに移動します。 Wi-Fi  を有効にして、 ［Wi‑Fi ダイレクト ］をタップします。 プリンタの Wi‑Fi Direct名を選択します。 プリンタ操作パネルの接続を確認します。 Wi‑Fi を使用する モバイルデバイスから、［ 設定 ］メニューに移動します。 ［ Wi-Fi ］をタップし、プリンタの Wi‑Fi ダイレクト名を選択します。 文字列 DIRECT-xy（x と y は 2 つのランダムな文字）が Wi‑Fi Direct名の前に追加されます。 Wi‑Fi ダイレクトのパスワードを入力します。 モバイルデバイスを接続する プリンタに プリンタに接続する Wi‑Fi ダイレクトを使用する"},{"UUID":"68308653-d5c8-432e-af19-74e2b3d13788","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi‑Fi Direct コンピュータをプリンタに接続する コンピュータを接続する前に、Wi‑Fi Direct","descFull":"Wi‑Fi Direct コンピュータをプリンタに接続する コンピュータを接続する前に、Wi‑Fi Direct が設定されていることを確認してください。詳細については、 を参照してください。 Windows の場合 ［ プリンタとスキャナ ］を開き、［ プリンタまたはスキャナを追加 ］をクリックします。 ［ Wi‑Fi Direct プリンタを表示する ］をクリックし、プリンタの Wi‑Fi Direct 名を選択します。 プリンタのディスプレイから、プリンタの 8 桁の PIN をメモします。 コンピュータに PIN を入力します。 プリンタドライバがまだインストールされていない場合は、Windows によって適切なドライバがダウンロードされます。 Macintosh の場合 ワイヤレスアイコンをクリックし、プリンタの Wi‑Fi Direct 名を選択します。 文字列 DIRECT-xy（x と y は 2 つのランダムな文字）が Wi‑Fi Direct 名の前に追加されます。 Wi‑Fi Direct のパスワードを入力します。 Wi‑Fi Direct のネットワークから切断した後で、コンピュータを以前のネットワークに戻します。 コンピュータをプリンタに接続する"},{"UUID":"de0e2459-3de2-4e8e-b879-2c1fe401fb41","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wi-Fi ネットワークを無効にする 操作パネルで、［ 設定 ］","descFull":"Wi-Fi ネットワークを無効にする 操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ネットワークの概要］ ［アクティブアダプタ ］ ［ 標準ネットワーク ］の順に移動します。 お使いのプリンタを再起動するには、［ はい ］を選択します。 Wi-Fi ネットワーク、無効にする Wi-Fi ネットワークを無効にする"},{"UUID":"738282cb-18e1-4c8f-9397-689a6ef45c95","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"プリンタの接続を確認する プリンタの接続を確認する 操作パネルで、［ 設定 ］","descFull":"プリンタの接続を確認する プリンタの接続を確認する 操作パネルで、［ 設定 ］ ［ レポート ］ ［ ネットワーク ］ ［ ネットワーク設定ページ ］の順に移動します。 ページの最初のセクションを確認し、状態が［接続済み］であることを確認します。 状態が［未接続］の場合、LAN 破棄が有効ではないか、ネットワークケーブルが正常に動作していない可能性があります。サポートが必要な場合は、管理者に問い合わせてください。 ネットワーク接続を確認する ネットワークへのプリンタ接続 確認する"},{"UUID":"b3b8266f-7e1c-47f4-a10d-932903c3d7fe","title":"ネットワーク","link":"connecting-printer-to-wireless-network-topic.html","desc":"シリアル印刷を設定する（Windows のみ） プリンタでパラメータを設定します。 コントロールパネルから、ポート設定のメニューを選択します。 シリアルポート設定のメニューを選択し、必要に応じて、設定を調整します。","descFull":"シリアル印刷を設定する（Windows のみ） プリンタでパラメータを設定します。 コントロールパネルから、ポート設定のメニューを選択します。 シリアルポート設定のメニューを選択し、必要に応じて、設定を調整します。 変更を適用します。 コンピュータでプリンタフォルダを開き、プリンタを選択します。 ［プリンタプロパティ］を開き、リストから［COM ポート］を選びます。 ［デバイスマネージャ］で COM ポートのパラメータを設定します。 シリアル印刷では印刷速度が遅くなります。 プリンタのシリアルポートにシリアルケーブルが接続されていることを確認します。 シリアル印刷を設定する シリアル印刷 セットアップ"},{"UUID":"1c8c6ecc-73e0-4673-85ed-c667df41e98f","title":"プリンタを保護する","link":"erasing-printer-memory-topic.html","desc":"プリンタメモリを消去する 揮発性メモリまたはバッファされているデータを消去するには、プリンタの電源をオフにします。 不揮発性メモリ、デバイスおよびネットワークの設定、セキュリティ設定、組込みソリューションを消去するには、以下を行います。 操作パネルで、［ 設定","descFull":"プリンタメモリを消去する 揮発性メモリまたはバッファされているデータを消去するには、プリンタの電源をオフにします。 不揮発性メモリ、デバイスおよびネットワークの設定、セキュリティ設定、組込みソリューションを消去するには、以下を行います。 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 未使用時の消去 ］の順に移動します。 ［ 不揮発性メモリにあるすべての情報を消去 ］を選択し、［ 消去 ］を選択します。 ［ 初期設定ウィザードを起動する ］または［ プリンタをオフラインのままにする ］を選択し、［ 次へ ］を選択します。 処理を開始します。 また、このプロセスでは、ユーザーデータの保護に使用される暗号化キーも破棄されます。暗号化キーを破棄すると、データは復元不可能になります。 揮発性メモリ 消去する 不揮発性メモリ 消去する プリンタメモリ 消去する 消去する プリンタメモリ 消去する 揮発性メモリ 消去する 不揮発性メモリ"},{"UUID":"a8ce5c7f-54bb-4a47-acd8-929e03887dc0","title":"プリンタを保護する","link":"erasing-printer-storage-drive-topic.html","desc":"プリンタストレージドライブを消去する プリンタストレージドライブを消去する 操作パネルで、［ 設定 ］","descFull":"プリンタストレージドライブを消去する プリンタストレージドライブを消去する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 未使用時の消去 ］の順に移動します。 プリンタに取り付けられているストレージドライブに応じて、次のいずれかを実行します。 ハードディスクの場合は、［ ハードディスク上のすべての情報を消去 ］を選択し、［ 消去 ］を選択してから、データを消去する方法を選択します。 ハードディスクを消去するプロセスには、数分から 1 時間以上かかります。この間は、プリンタを他の処理に使用できません。 インテリジェントストレージドライブの場合は、［ ISD のすべてのユーザーデータを暗号化消去 ］を選択し、［ 消去 ］を選択します。 ストレージドライブ 消去する ハードディスク 消去する インテリジェントストレージドライブ 消去する 消去する ストレージドライブ 消去する ハードディスク 消去する インテリジェントストレージドライブ"},{"UUID":"d435b0f9-ef02-49f8-a6cc-3506f523cfcb","title":"プリンタを保護する","link":"restoring-factory-default-settings-topic.html","desc":"出荷時初期設定に復元する 操作パネルで、［ 設定 ］ ［","descFull":"出荷時初期設定に復元する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 工場出荷状態に戻す ］の順に選択します。 ［ 設定を復元 ］を選択します。 元に戻すする設定を選択して、［ 復元 ］を選択します。 出荷時初期設定 元に戻す プリンタ設定 工場出荷時設定に戻す"},{"UUID":"3e19ec19-402a-4438-b1e4-3abc50213769","title":"プリンタを保護する","link":"statement-of-volatility-topic.html","desc":"揮発性に関する記述 揮発性に関する記述 メモリのタイプと説明 メモリのタイプ 説明","descFull":"揮発性に関する記述 揮発性に関する記述 メモリのタイプと説明 メモリのタイプ 説明 揮発性メモリ 本機では、単純な印刷ジョブやコピージョブ時にユーザーデータを一時的にバッファに格納するために標準的なランダムアクセスメモリ（RAM）を使用します。 不揮発性メモリ このプリンタでは、EEPROM および NAND（フラッシュメモリ）の 2 つの形態の不揮発性メモリが使用されています。どちらのタイプにも、オペレーティングシステム、プリンタ設定、ネットワーク情報が保存されます。また、スキャナやブックマークの設定、組込みソリューションも保存されます。 ハードディスクストレージドライブ 一部のプリンタには、ハードディスクドライブが搭載されている場合があります。プリンタのハードディスクは、各プリンタ固有の機能に対応するように設計されています。ハードディスクがあることにより、複雑な印刷ジョブでバッファに保存されたユーザーデータ、用紙データ、フォントデータをプリンタが保持できます。 インテリジェントストレージドライブ（ISD） 一部のプリンタには、ISD が搭載されている場合があります。ISD は、不揮発性フラッシュメモリを使用して、複雑な印刷ジョブのユーザーデータ、用紙データ、フォントデータを保存します。 次の状況では、取り付けられたプリンタメモリの内容を消去してください。 プリンタを廃棄する プリンタのハードディスクまたは ISD を交換する。 プリンタを別の部門または場所に移動する 外部の業者がプリンタを修理する プリンタが修理のために社外に搬送される プリンタが別の会社に売却される ストレージドライブを廃棄するには、組織のポリシーと手順に従います。 揮発性に関する記述 揮発性メモリ 不揮発性メモリ ハードディスクストレージドライブ インテリジェントストレージドライブ プリンタメモリを消去する プリンタのデータを保護する"},{"UUID":"1a4009e9-7b1d-4420-9e4d-666cf856a688","title":"印刷","link":"printing-from-computer-topic.html","desc":"コンピュータから印刷する Windows の場合 ドキュメントを開いている状態で、［ ファイル","descFull":"コンピュータから印刷する Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 必要に応じて、設定を調整します。 ［ OK ］、［ 印刷 ］の順にクリックします。 Macintosh の場合 ドキュメントが開いている状態で、［ ファイル ］ ［ 印刷 ］の順に選択します。 プリンタを選択し、［ プリセット ］から設定を選択します。 必要に応じて、設定を調整します。 ［ 印刷 ］をクリックします。 印刷 コンピュータから ドキュメント、印刷する コンピュータから"},{"UUID":"1dbe7c83-62b0-49ac-b561-47e8d9a18a17","title":"モバイルデバイスから印刷する","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Lexmark プリントを使用してモバイルデバイスから印刷する Lexmark  プリントは、","descFull":"Lexmark プリントを使用してモバイルデバイスから印刷する Lexmark  プリントは、 Android  プラットフォームバージョン 6.0 以降が実行されているモバイルデバイス用のモバイル印刷ソリューションです。ネットワークに接続されたプリンタや印刷管理サーバーにドキュメントやイメージを送信できます。 必ず、 Google Play  ストアから Lexmark プリントアプリをダウンロードし、モバイルデバイスで有効にしてください。 プリンタとモバイルデバイスが同じネットワークに接続していることを確認します。 モバイルデバイスで、ファイルマネージャからドキュメントを選択します。 ドキュメントを Lexmark 印刷に送信するか、ドキュメントを共有します。 サードパーティアプリの中には、送信機能または共有機能をサポートしていないものもあります。詳細については、アプリに付属のマニュアルを参照してください。 プリンタを選択します。 必要に応じて、設定を調整します。 ドキュメントを印刷します。 Lexmark プリント 使用する ドキュメントを印刷する モバイルデバイスから モバイルデバイス 印刷する"},{"UUID":"4bee28c2-b821-4577-9e6f-a8dbea2f458e","title":"モバイルデバイスから印刷する","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Mopria™ プリントサービスを使用してモバイルデバイスから印刷する Mopria プリントサービスは、 Android","descFull":"Mopria™ プリントサービスを使用してモバイルデバイスから印刷する Mopria プリントサービスは、 Android  バージョン 5.0 以降が実行されているモバイルデバイス用の、モバイル印刷ソリューションです。お好きな Mopria™ 認定プリンタへ直接印刷できます。 必ず、 Google Play  ストアから Mopria プリントサービスダウンロードし、モバイルデバイスで有効にしてください。 モバイルデバイスで対応アプリを起動するか、ファイルマネージャでドキュメントを選択します。 ［ 印刷 ］をタップします。 プリンタを選択し、必要に応じて設定を調整します。 をタップします。 Mopria プリントサービス 印刷 モバイルデバイスから モバイルデバイス 印刷する 印刷 Mopria プリントサービスを使用する"},{"UUID":"fdfe5cae-e63c-408c-9a10-b743498adb40","title":"モバイルデバイスから印刷する","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"AirPrint を使用してモバイルデバイスから印刷する AirPrint ソフトウェア機能は、Apple デバイスから","descFull":"AirPrint を使用してモバイルデバイスから印刷する AirPrint ソフトウェア機能は、Apple デバイスから AirPrint 認定プリンタへ直接印刷することができる、モバイル印刷ソリューションです。 Apple デバイスとプリンタが同じネットワークに接続していることを確認します。ネットワークが複数のワイヤレスハブに接続している場合、両方のデバイスが同じサブネットに接続されていることを確認します。 このアプリケーションは、一部の Apple デバイスのみでサポートされています。 モバイルデバイスで、ファイルマネージャからドキュメントを選択するか、互換性のあるアプリケーションを起動します。 ［ 印刷 ］をタップします。 プリンタを選択し、必要に応じて設定を調整します。 ドキュメントを印刷します。 AirPrint を使用する 印刷 モバイルデバイスから モバイルデバイス 印刷する"},{"UUID":"fe81a851-646a-4483-a1b9-951c27ec6bb4","title":"モバイルデバイスから印刷する","link":"printing-from-mobile-device-using-lexmark-print-app-topic.html","desc":"Wi‑Fi Direct® を使用してモバイルデバイスから印刷する wifi ダイレクト","descFull":"Wi‑Fi Direct® を使用してモバイルデバイスから印刷する wifi ダイレクト  は、お好きな wifi ダイレクト対応のプリンタへ印刷することができる、印刷サービスです。 モバイルデバイスがプリンタのワイヤレスネットワークに接続されていることを確認してください。詳細については、  を参照してください。 モバイルデバイスで対応アプリケーションを起動するか、ファイルマネージャでドキュメントを選択します。 モバイルデバイスに応じて、次の手順のいずれかを実行します。 ［印刷］ をタップします。 ［印刷］ をタップします。 ［印刷］ をタップします。 プリンタを選択し、必要に応じて設定を調整します。 ドキュメントを印刷します。 wifi ダイレクト モバイルデバイスから印刷する 印刷 モバイルデバイスから モバイルデバイス 印刷 印刷 wifi ダイレクトを使用する"},{"UUID":"844ff21b-5a2c-4845-b240-c729b7c0e3ef","title":"印刷","link":"printing-from-flash-drive-topic.html","desc":"フラッシュメモリから印刷する フラッシュメモリをセットします。 対応するフラッシュメモリの詳細については、 を参照してください。 エラーメッセージが表示されているときにフラッシュメモリを挿入しても、フラッシュメモリはプリンタで認識されません。","descFull":"フラッシュメモリから印刷する フラッシュメモリをセットします。 対応するフラッシュメモリの詳細については、 を参照してください。 エラーメッセージが表示されているときにフラッシュメモリを挿入しても、フラッシュメモリはプリンタで認識されません。 フラッシュメモリを挿入したときに、プリンタで他の印刷ジョブが処理されていた場合には、画面に［ ビジー ］が表示されます。 操作パネルで［ 印刷 ］を選択します。 ［ USB ドライブ ］を選択して、印刷するドキュメントのファイル名を選択します。 必要に応じて、設定を構成します。 ドキュメントを印刷します。 データの損失やプリンタの誤動作を防ぐため、メモリデバイスからの印刷やデータ読み書きの最中は、フラッシュメモリや、プリンタの図で示した範囲に手を触れないでください。 印刷 フラッシュメモリから フラッシュメモリ、印刷元"},{"UUID":"a1495c5b-aa01-4af8-bcca-c5f86d74d2d2","title":"印刷","link":"configuring-confidential-jobs-topic.html","desc":"コンフィデンシャルジョブを設定する 操作パネルで、［ 設定 ］ ［","descFull":"コンフィデンシャルジョブを設定する 操作パネルで、［ 設定 ］ ［ セキュリティ ］ ［ コンフィデンシャル印刷設定 ］の順に移動します。 設定を行います。 ［ コンフィデンシャル印刷設定 ］のメニュー項目と説明 設定 説明 無効 PIN の許容回数 無効な PIN の入力に関する制限を設定します。 制限回数に達すると、そのユーザー名に対する印刷ジョブが削除されます。 コンフィデンシャルジョブ期限切れ 各保留ジョブがプリンタメモリ、ハードディスク、インテリジェントストレージドライブから自動的に削除されるまでの個別の有効期限を設定します。 保留ジョブは、［ コンフィデンシャル ］、［ 繰り返し ］、［ 予約 ］、または［ 確認 ］です。 期限切れジョブの繰り返し 繰り返す印刷ジョブの有効期限を設定します。 期限切れジョブの確認 ジョブのコピーを印刷するにあたって有効期限を設定し、残りのコピーを印刷する前に品質を確認します。 期限切れジョブの予約 後で印刷するために、プリンタに保存するジョブの有効期限を設定します。 すべてのジョブを保留にする すべての印刷ジョブを保留にするようにプリンタを設定します。 重複ドキュメントを維持 同じファイル名を持つすべてのドキュメントを保持するようにプリンタを設定します。 コンフィデンシャル印刷ジョブ 設定 保留ジョブ 設定 印刷ジョブの保存 印刷ジョブの保留"},{"UUID":"afd10144-abca-49e6-8a13-8735fb640abc","title":"印刷","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"コンフィデンシャルジョブおよびその他の保留中のジョブを印刷する Windows の場合 ドキュメントを開いている状態で、［ ファイル","descFull":"コンフィデンシャルジョブおよびその他の保留中のジョブを印刷する Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 印刷後保持 ］をクリックします。 ［ ［印刷して保持］を使用 ］をクリックして、ユーザー名を割り当てます。 以下の印刷ジョブの種類から選択します。 コンフィデンシャル印刷  — ジョブを印刷する前に、個人 ID 番号を入力するように求めます。 このジョブの種類を選択した場合は、4 桁の個人 ID 番号（PIN）を入力します。 確認印刷  — 1 部だけが印刷され、ドライバから要求された残りの部数はプリンタのメモリに保持されます。 予約印刷  — ユーザが後で印刷できるよう、ジョブはメモリに保存されます。 繰り返し印刷  — 要求したすべての部数が印刷され、さらに、追加の部数を後で印刷できるようにジョブがメモリに保存されます。 ［ OK ］をクリックします。 ［ 印刷 ］をクリックします。 プリンタの操作パネルから印刷ジョブをリリースします。 ［ 印刷 ］を選択します。 ［ 保留ジョブ ］選択し、ユーザー名を選択します。 コンフィデンシャル印刷ジョブの場合は、［ コンフィデンシャル ］を選択し、PIN を入力して、［ OK ］を選択します。 印刷ジョブを選択し、［ 印刷 ］を選択します。 Macintosh の場合 ドキュメントが開いている状態で、［ ファイル ］ ［ 印刷 ］の順に選択します。 プリンタを選択します。 ［ 印刷ジョブのセキュリティ ］ドロップダウンメニューで、［ PIN で印刷 ］を有効にし、4 桁の PIN を入力します。 ［ 印刷 ］をクリックします。 プリンタの操作パネルから印刷ジョブをリリースします。 ［ 保留ジョブ ］選択し、コンピュータ名を選択します。 ［ コンフィデンシャル ］を選択して、PIN を入力します。 印刷ジョブを選択し、［ 印刷 ］を選択します。 印刷 保留ジョブ 印刷 コンフィデンシャル印刷ジョブ コンフィデンシャル印刷ジョブ 印刷 保留ジョブ 印刷"},{"UUID":"e363af91-c335-4f65-8659-5c6a3f09e2c3","title":"印刷","link":"printing-font-sample-list-topic.html","desc":"フォントサンプルリストを印刷する 操作パネルで、［ 設定 ］ ［","descFull":"フォントサンプルリストを印刷する 操作パネルで、［ 設定 ］ ［ レポート ］ ［ 印刷 ］ ［ フォントを印刷 ］の順に移動します。 フォントの種類を選択します。 印刷 フォントサンプルリスト フォントサンプルリスト 印刷"},{"UUID":"90ab9679-d5cc-4eae-a6f0-d6e5450fac56","title":"印刷","link":"printing-directory-list-topic.html","desc":"ディレクトリ一覧を印刷する 操作パネルで、［ 設定 ］ ［","descFull":"ディレクトリ一覧を印刷する 操作パネルで、［ 設定 ］ ［ レポート ］ ［ 印刷 ］の順に移動します。 ［ ディレクトリ印刷 ］を選択します。 印刷 ディレクトリリスト ディレクトリリスト 印刷"},{"UUID":"feb09d70-c54d-4e68-80f9-462696b33458","title":"印刷","link":"placing-separator-sheets-in-print-jobs-topic.html","desc":"印刷ジョブにセパレータ紙を配置する ドキュメントを開いている状態で、［ ファイル ］ ［","descFull":"印刷ジョブにセパレータ紙を配置する ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 用紙/フィニッシャ ］をクリックします。 ［ セパレータ紙 ］メニューから、設定を選択します。 ［ OK ］、［ 印刷 ］の順にクリックします。 セパレータ紙 挿入する 挿入紙を入れる"},{"UUID":"6e603f74-ea17-43e5-880d-b75aa43f471b","title":"印刷","link":"canceling-print-job-topic.html","desc":"印刷ジョブをキャンセルする 操作パネルで［ ジョブのキュー ］を選択します。 ［","descFull":"印刷ジョブをキャンセルする 操作パネルで［ ジョブのキュー ］を選択します。 ［ 印刷 ］を選択して、キャンセルするジョブを選択します。 文書がすでに印刷されている場合は、ディスプレイの右下隅にある［ ジョブをキャンセル ］を選択して、印刷を中止します。 印刷ジョブ キャンセルする 印刷ジョブを中止する"},{"UUID":"f02d4785-985c-4c23-9e92-e95c23b0d864","title":"印刷","link":"adjusting-toner-darkness-topic.html","desc":"トナーの濃さを調整する 操作パネルで、［ 設定 ］ ［","descFull":"トナーの濃さを調整する 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］の順に移動します。 ［ トナーの濃さ ］の設定を調整します。 トナーの濃さ 調整 トナーの濃さを調整する"},{"UUID":"fbba6ed4-ce9e-490f-aed9-d821b026010d","title":"コピー","link":"making-copies-topic.html","desc":"コピーを作成する 原稿を ADF トレイまたは原稿台にセットします。 画面が途切れることを防止するには、原稿と印刷物の用紙サイズが同じであることを確認してください。","descFull":"コピーを作成する 原稿を ADF トレイまたは原稿台にセットします。 画面が途切れることを防止するには、原稿と印刷物の用紙サイズが同じであることを確認してください。 操作パネルから［ コピー ］を選択して、コピー部数を指定します。 必要に応じて、コピー設定を調整します。 ドキュメントをコピーします。 コピーを作成する コピーする ドキュメント コピーする ADF を使用する コピーする 原稿台を使用する"},{"UUID":"64290247-d3f4-4082-a5d5-1fc2493b3ca5","title":"コピー","link":"copying-photos-topic.html","desc":"写真をコピーする 写真をコピーする 写真を原稿台にセットします。 操作パネルで、［ コピー","descFull":"写真をコピーする 写真をコピーする 写真を原稿台にセットします。 操作パネルで、［ コピー ］ ［ その他の設定 ］ ［ コンテンツ ］の ［ コンテンツタイプ ］ ［ 写真 ］順に移動します。 ［ コンテンツソース ］を選択して、元の写真に最適な設定を選択します。 写真をコピーします。 コピーする 写真 写真、コピーする"},{"UUID":"848281c0-bb25-44ba-bcd9-b510d2e9b50d","title":"コピー","link":"copying-on-letterhead-topic.html","desc":"レターヘッド紙にコピーする レターヘッド紙にコピーする 原稿を ADF トレイまたは原稿台にセットします。","descFull":"レターヘッド紙にコピーする レターヘッド紙にコピーする 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ コピー ］ ［ コピー元 ］の順に移動します。 原稿のサイズを選択します。 ［ コピー先 ］を選択してから、レターヘッド紙をセットした給紙トレイを選択します。 レターヘッド紙を多目的フィーダにセットした場合は、［ 多目的フィーダ ］を選択し、用紙サイズを選択して、［ レターヘッド ］を選択します。 ドキュメントをコピーします。 コピーする レターヘッド レターヘッド コピー"},{"UUID":"abd25750-46d3-4b59-aef2-b9fdad74cb42","title":"コピー","link":"copying-on-both-sides-of-paper-topic.html","desc":"用紙の両面にコピーする 用紙の両面にコピーする 原稿を ADF トレイまたは原稿台にセットします。","descFull":"用紙の両面にコピーする 用紙の両面にコピーする 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ コピー ］ ［ その他の設定 ］ ［ 印刷面 ］の順に移動します。 設定を選択します。 ドキュメントをコピーします。 コピーする 用紙の両面 両面コピー 両面コピー"},{"UUID":"7da9aba1-ad11-4e18-8d37-ada839f6a583","title":"コピー","link":"reducing-or-enlarging-copies-topic.html","desc":"コピーを縮小または拡大する コピーを縮小または拡大する 原稿を ADF トレイまたは原稿台にセットします。","descFull":"コピーを縮小または拡大する コピーを縮小または拡大する 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ コピー ］ ［ その他の設定 ］ ［ 倍率 ］の順に移動します。 設定を選択します。 ［ 倍率 ］を設定してから、原稿または出力のサイズを変更すると、拡大縮小の値は［ 自動 ］に戻ります。 ドキュメントをコピーします。 コピーサイズを縮小する コピーサイズを拡大する コピーサイズ 調整する"},{"UUID":"389d9368-77f0-468e-a353-0b2bfb0764d9","title":"コピー","link":"collating-copies-topic.html","desc":"部単位でコピーする 部単位でコピーする 原稿を ADF トレイまたは原稿台にセットします。","descFull":"部単位でコピーする 部単位でコピーする 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ コピー ］ ［ その他の設定 ］ ［ 部単位 ］ ［ オン［1,2,1,2,1,2］ ］の順に移動します。 ドキュメントをコピーします。 部単位でコピーする 複数部をソートする"},{"UUID":"9bbbcaff-c9bc-498f-bdb5-31eda0ac4bcd","title":"コピー","link":"placing-separator-sheets-between-copies-topic.html","desc":"コピーの区切りとしてセパレータ紙を挿入する コピーの区切りとしてセパレータ紙を挿入する 原稿を ADF トレイまたは原稿台にセットします。","descFull":"コピーの区切りとしてセパレータ紙を挿入する コピーの区切りとしてセパレータ紙を挿入する 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ コピー ］ ［ その他の設定 ］ ［ 挿入紙 ］の順に移動します。 このメニューを有効にして、設定を選択します。 ドキュメントをコピーします。 セパレータ紙 追加する 挿入紙を入れる"},{"UUID":"a4edc841-021c-4cb5-8bdd-f54113c18cd5","title":"コピー","link":"copying-multiple-pages-onto-single-sheet-topic.html","desc":"1 枚の用紙に複数ページをコピーする 1 枚の用紙に複数ページをコピーする 原稿を","descFull":"1 枚の用紙に複数ページをコピーする 1 枚の用紙に複数ページをコピーする 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ コピー ］ ［ その他の設定 ］ ［ 割り付けるページ数 ］の順に移動します。 このメニューを有効にして、設定を選択します。 ドキュメントをコピーします。 複数のページをコピーする 1 枚の用紙に 用紙を節約する"},{"UUID":"125378d7-e797-48ac-a223-5eaa905a4139","title":"コピー","link":"copying-cards-topic.html","desc":"カードをコピーする カードをコピーする カードを原稿台にセットします。 操作パネルで、［ コピー","descFull":"カードをコピーする カードをコピーする カードを原稿台にセットします。 操作パネルで、［ コピー ］ ［ コピー元 ］ ［ ID カード ］の順に移動します。 カードをコピーします。 コピーする カード カード、コピーする"},{"UUID":"2114d24b-56a5-47b1-aed6-97158ca71460","title":"コピー","link":"creating-copy-shortcut-topic.html","desc":"ショートカットコピーを作成する ショートカットコピーを作成する 操作パネルで［ コピー ］を選択します。","descFull":"ショートカットコピーを作成する ショートカットコピーを作成する 操作パネルで［ コピー ］を選択します。 設定を行い、 を選択します。 ショートカットを作成します。 ショートカットを作成する コピー ショートカットを追加する コピー"},{"UUID":"e2aca848-dc13-4045-8799-44875cf12c57","title":"E メール","link":"configuring-smtp-settings-topic.html","desc":"SMTP 設定を構成する SMTP 設定を構成する スキャンしたドキュメントを","descFull":"SMTP 設定を構成する SMTP 設定を構成する スキャンしたドキュメントを E メールで送信するように、簡易メール転送プロトコル（SMTP）設定を構成します。設定は、E メールサービスプロバイダによって異なります。 開始する前に、プリンタがネットワークに接続されていること、ネットワークがインターネットに接続されていることを確認してください。 操作パネルを使用する 操作パネルで、［ 設定 ］ ［ E メール ］ ［ E メール設定 ］の順に移動します。 設定を行います。 内蔵 Web サーバーを使用する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ 設定 ］ ［ E メール ］の順にクリックします。 ［ E メール設定 ］メニューで、設定を行います。 ［ 保存 ］をクリックします。 E メールサービスプロバイダ AOL メール Comcast メール Gmail iCloud メール Mail.com NetEase メール（mail.126.com） NetEase メール（mail.163.com） NetEase メール（mail.yeah.net） Outlook Live または Microsoft 365 QQ メール Sina メール Sohu メール Yahoo!メール Zoho メール 指定された設定を使用してエラーが発生した場合は、サービスプロバイダにお問い合わせください。 お使いのサービスプロバイダがリストに表示されていない場合は、お使いのプロバイダにお問い合わせください。 AOL メール AOL メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.aol.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アプリのパスワード アプリのパスワードを作成するには、 AOL アカウントのセキュリティ ページにアクセスしてアカウントにログインし、［ アプリパスワードの生成と管理 ］をクリックします。 Comcast メール Comcast メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.comcast.net プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アカウントパスワード アカウントで［サードパーティアクセスセキュリティ］設定が有効になっていることを確認します。詳細については、 Comcast Xfinity Connect のヘルプページ を参照してください。 Gmail アカウントで 2 段階認証が有効になっていることを確認します。2 段階認証を有効にするには、 Google アカウントのセキュリティ ページにアクセスしてアカウントにログインし、［ Googleにサインインする方法 ］セクションで［ 2 段階認証 ］をクリックします。 Gmail の SMTP 設定 設定 値 プライマリ SMTP ゲートウェイ smtp.gmail.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アプリのパスワード アプリのパスワードを作成するには、 Google アカウントセキュリティ ページにアクセスして、［ Googleにサインインする方法 ］セクションで［ 2 段階認証 ］ ［ アプリパスワード ］をクリックします。 ［ アプリパスワード ］は、2 段階認証が有効になっている場合にのみ表示されます。 iCloud メール アカウントで 2 段階認証が有効になっていることを確認します。 iCloud メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.mail.me.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アプリのパスワード アプリのパスワードを作成するには、 iCloud アカウント管理 ページにアクセスしてアカウントにログインし、［ サインインとセキュリティ ］セクションで［ アプリ用パスワード ］ ［ アプリ用パスワードを作成 ］をクリックします。 Mail.com Mail.com の設定 設定 値 プライマリ SMTP ゲートウェイ smtp.mail.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アカウントパスワード NetEase メール（mail.126.com） アカウントで SMTP サービスが有効になっていることを確認します。サービスを有効にするには、NetEase メールのホームページで、［ 設定 ］ ［ POP3/SMTP/IMAP ］をクリックし、［ IMAP/SMTP ］サービスまたは［ POP3/SMTP ］サービスのいずれかを有効にします。 NetEase メールの設定（mail.126.com） 設定 値 プライマリ SMTP ゲートウェイ smtp.126.com プライマリ SMTP ゲートウェイポート 465 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード 認証パスワード 認証パスワードは、［ IMAP/SMTP サービス ］または［ POP3/SMTP サービス ］が有効になっている場合に提供されます。 NetEase メール（mail.163.com） アカウントで SMTP サービスが有効になっていることを確認します。サービスを有効にするには、NetEase メールのホームページで、［ 設定 ］ ［ POP3/SMTP/IMAP ］をクリックし、［ IMAP/SMTP ］サービスまたは［ POP3/SMTP ］サービスのいずれかを有効にします。 NetEase メールの設定（mail.163.com） 設定 値 プライマリ SMTP ゲートウェイ smtp.163.com プライマリ SMTP ゲートウェイポート 465 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード 認証パスワード 認証パスワードは、［ IMAP/SMTP サービス ］または［ POP3/SMTP サービス ］が有効になっている場合に提供されます。 NetEase メール（mail.yeah.net） アカウントで SMTP サービスが有効になっていることを確認します。サービスを有効にするには、NetEase メールのホームページで、［ 設定 ］ ［ POP3/SMTP/IMAP ］をクリックし、［ IMAP/SMTP ］サービスまたは［ POP3/SMTP ］サービスのいずれかを有効にします。 NetEase メールの設定（mail.yeah.net） 設定 値 プライマリ SMTP ゲートウェイ smtp.yeah.net プライマリ SMTP ゲートウェイポート 465 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード 認証パスワード 認証パスワードは、［ IMAP/SMTP サービス ］または［ POP3/SMTP サービス ］が有効になっている場合に提供されます。 Outlook Live または Microsoft 365 これらの設定は、outlook.com および hotmail.com の E メールドメイン、そして Microsoft 365 のアカウントに適用されます。 Outlook Live または Microsoft 365 の設定 設定 値 プライマリ SMTP ゲートウェイ smtp.office365.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アカウントパスワードまたはアプリのパスワード 2 段階認証が無効なアカウントの場合は、アカウントパスワードを使用します。 2 段階認証が有効になっている outlook.com または hotmail.com アカウントの場合、アプリのパスワードを使用します。アプリのパスワードを作成するには、 Outlook Live アカウントの管理 ページにアクセスしてアカウントにログインし、［ 新しいアプリ パスワードの作成 ］をクリックします。 Microsoft 365 を使用するビジネスのその他の設定オプションについては、 Microsoft 365 のヘルプページ を参照してください。 QQ メール アカウントで SMTP サービスが有効になっていることを確認します。サービスを有効にするには、QQ メールのホームページから［ 設定 ］ ［ アカウント ］の順にクリックします。［ POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service ］セクションで、［ POP3/SMTP サービス ］または［ IMAP/SMTP サービス ］のいずれかを有効にします。 QQ メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.qq.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード 認証コード 認証コードを生成するには、QQ メールのホームページから［ 設定 ］ ［ アカウント ］をクリックし、［ POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV サービス ］セクションで［ 認証コードの生成 ］をクリックします。 Sina メール アカウントで POP3/SMTP サービスが有効になっていることを確認します。サービスを有効にするには、Sina メールのホームページで、［ 設定 ］ ［ その他の設定 ］ ［ ユーザーエンド POP/IMAP/SMTP ］の順にクリックし、 POP3/SMTP サービス を有効にします。 Sina メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.sina.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード 認証コード 認証コードを作成するには、E メールのホームページで、［ 設定 ］ ［ その他の設定 ］ ［ ユーザーエンド POP/IMAP/SMTP ］の順にクリックし、［ 認証コードの状態 ］を有効にします。 Sohu メール アカウントで SMTP サービスが有効になっていることを確認します。サービスを有効にするには、SOHU メールのホームページで、［ オプション ］ ［ 設定 ］ ［ POP3/SMTP/IMAP ］をクリックし、［ IMAP/SMTP サービス ］または［ POP3/SMTP サービス ］のいずれかを有効にします。 Sohu メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.sohu.com プライマリ SMTP ゲートウェイポート 465 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード 独立したパスワード 独立したパスワードは、［ IMAP/SMTP サービス ］または［ POP3/SMTP サービス ］が有効になっている場合に提供されます。 Yahoo! メール Yahoo! メールメール 設定 値 プライマリ SMTP ゲートウェイ smtp.mail.yahoo.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アプリのパスワード アプリのパスワードを作成するには、 Yahoo アカウントセキュリティ ページにアクセスしてアカウントにログインし、［ アプリのパスワード ］セクションで［ アプリパスワードの生成 ］をクリックします。 Zoho メール Zoho メールの設定 設定 値 プライマリ SMTP ゲートウェイ smtp.zoho.com プライマリ SMTP ゲートウェイポート 587 年 SSL/TLS を使用 必須 信頼済み証明書を要求 無効 返信アドレス お客様の E メールアドレス SMTP サーバー認証 ログイン/プレーンテキスト デバイスから送信される E メール デバイスの SMTP 証明書を使用 デバイスのユーザー ID お客様の E メールアドレス デバイスのパスワード アカウントパスワードまたはアプリのパスワード 2 段階認証が無効なアカウントの場合は、アカウントパスワードを使用します。 2 段階認証が有効になっているアカウントの場合は、アプリのパスワードを使用します。アプリのパスワードを作成するには、 Zoho メールのアカウントセキュリティ ページにアクセスしてアカウントにログインし、［ アプリケーション固有のパスワード ］セクションで［ 新しいパスワードの生成 ］をクリックします。 E メールサービスプロバイダ 設定 E メールサーバー設定 SMTP の設定 設定 E メール機能 設定する E メールサーバー設定 設定"},{"UUID":"c36c996e-b09c-4d53-aab8-34589ea0ffc7","title":"E メール","link":"sending-email-topic.html","desc":"E メールを送信する 開始する前に、SMTP 設定が構成されていることを確認します。詳細については、 を参照してください。","descFull":"E メールを送信する 開始する前に、SMTP 設定が構成されていることを確認します。詳細については、 を参照してください。 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ スキャン ］ ［ E メール ］の順に移動します。 情報を入力して、［ 次へ ］を選択します。 必要に応じて、設定を構成します。 ［ スキャン ］を選択し、E メールを送信します。 E メール 送信する E メールを送信する"},{"UUID":"1caae046-95ab-4201-89eb-d8a6d9962aab","title":"E メール","link":"creating-email-shortcut-topic.html","desc":"E メールショートカットを作成する 操作パネルを使用する 操作パネルで、［ スキャン","descFull":"E メールショートカットを作成する 操作パネルを使用する 操作パネルで、［ スキャン ］ ［ E メール ］の順に移動します。 情報を入力して、 を選択します。 ショートカットを作成します。 内蔵 Web サーバーを使用する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ ショートカット ］ ［ ショートカットを追加 ］の順にクリックします。 設定を行います。 ［ 保存 ］をクリックします。 ショートカットを作成する E メール ショートカットを追加する E メール E メールショートカット 作成する"},{"UUID":"7e077feb-e3ed-4816-9ecf-118c567a2c24","title":"FAX","link":"sending-fax-topic.html","desc":"FAX を送信する FAX を送信する 操作パネルを使用する","descFull":"FAX を送信する FAX を送信する 操作パネルを使用する 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで［ FAX ］を選択します。 ［ 送信先の追加 ］または［ アドレス帳 ］を選択します。 必要に応じて、設定を調整します。 FAX を送信します。 コンピュータを使用する 開始する前に、FAX ドライバがインストールされていることを確認してください。詳細については、 を参照してください。 Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ FAX ］ ［ ［FAX を有効化 ］ ［FAX 送信前に FAX 設定を常に表示 ］をクリックして、受信者番号を入力します。 必要に応じて、設定を構成します。 FAX を送信します。 Macintosh の場合 ドキュメントが開いている状態で、［ ファイル ］ ［ 印刷 ］の順に選択します。 名前の後に「 ‑ Fax 」が追加されているプリンタを選択します。 ［宛先］フィールドに送信先番号を入力します。 必要に応じて、設定を構成します。 FAX を送信します。 FAX を送信する FAX、送信"},{"UUID":"6a6e2181-ecf8-40c7-8280-7cba3fb7a693","title":"FAX","link":"scheduling-fax-topic.html","desc":"FAX をスケジュール設定する FAX をスケジュール設定する 原稿を","descFull":"FAX をスケジュール設定する FAX をスケジュール設定する 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで［ FAX ］を選択します。 ［ 送信先の追加 ］または［ アドレス帳 ］を選択し、必要な情報を入力します。 ［ 送信時刻 ］を選択して日時を設定し、［ 完了 ］を選択します。 必要に応じて、その他の FAX 設定を変更します。 FAX を送信します。 スケジュールした FAX FAX、スケジュール設定する"},{"UUID":"8ee6a332-cc33-4d5d-87bd-dea12b372c5d","title":"FAX","link":"creating-fax-destination-shortcut-topic.html","desc":"FAX 宛先のショートカットを作成する FAX 宛先のショートカットを作成する 操作パネルで［","descFull":"FAX 宛先のショートカットを作成する FAX 宛先のショートカットを作成する 操作パネルで［ FAX ］を選択します。 ［ 送信先の追加 ］または［ アドレス帳 ］を選択し、必要な情報を入力します。 必要に応じて、設定を調整します。 を選択します。 ショートカットを作成します。 ショートカットを作成する FAX 宛先 FAX 宛先 ショートカットを作成する ショートカットを追加する FAX 宛先 ショートカット、作成する FAX 宛先"},{"UUID":"94af6f3b-9ce1-4a33-92f2-2d2fabd38987","title":"FAX","link":"changing-fax-resolution-topic.html","desc":"FAX の解像度変更 FAX の解像度変更 原稿を","descFull":"FAX の解像度変更 FAX の解像度変更 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで［ FAX ］を選択します。 ［ 送信先の追加 ］または［ アドレス帳 ］を選択し、必要な情報を入力します。 ［ 解像度 ］を選択して、設定を選択します。 FAX を送信します。 FAX の解像度 変更する FAX の解像度を変更する"},{"UUID":"c6b023fa-c63a-4dfd-8f4a-582f47c3efd7","title":"FAX","link":"adjusting-fax-darkness-topic.html","desc":"FAX の濃度を調整する FAX の濃度を調整する 原稿を","descFull":"FAX の濃度を調整する FAX の濃度を調整する 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで［ FAX ］を選択します。 ［ 送信先の追加 ］または［ アドレス帳 ］を選択し、必要な情報を入力します。 ［ その他の設定 ］ ［ 濃度 ］を選択して、設定を調整します。 FAX を送信します。 FAX の濃度を調整する FAX の濃度 調整"},{"UUID":"e253972e-0a95-476a-ae6e-d0ba5ea13007","title":"FAX","link":"printing-fax-log-topic.html","desc":"FAX ログを印刷する FAX ログを印刷する 操作パネルで、［","descFull":"FAX ログを印刷する FAX ログを印刷する 操作パネルで、［ 設定 ］ ［ レポート ］ ［ FAX ］の順に移動します。 FAX ログを選択します。 FAX ログ 印刷 FAX ログを印刷する"},{"UUID":"dda5dcbf-239a-452c-9535-39c8e336645e","title":"FAX","link":"blocking-junk-faxes-topic.html","desc":"迷惑 FAX をブロックする 操作パネルで、［ 設定","descFull":"迷惑 FAX をブロックする 操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ 管理者用設定 ］の順に移動します。 ［ 無記名の FAX をブロック ］メニューを有効にします。 迷惑 FAX ブロック 迷惑 FAX をブロックする"},{"UUID":"828fdad9-4b44-42dd-8291-eaa65f141455","title":"FAX","link":"holding-faxes-topic.html","desc":"FAX の保留 FAX の保留 操作パネルで、［","descFull":"FAX の保留 FAX の保留 操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ FAX の保留 ］の順に移動します。 設定を選択します。 FAX の保留 受信した FAX 保留 FAX 保留"},{"UUID":"35eab685-553d-4e4a-89cf-16c5ab28ab0b","title":"FAX","link":"forwarding-fax-topic.html","desc":"FAX の転送 FAX の転送 操作パネルで、［","descFull":"FAX の転送 FAX の転送 操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ 管理者用設定 ］の順に移動します。 ［ FAX 転送 ］を選択し、［ 印刷して転送 ］または［ 転送 ］を選択します。 ［ 転送先 ］メニューで、転送先のタイプを選択し、設定を行います。 FAX を転送 FAX 転送"},{"UUID":"5e933725-4014-453f-9e67-14b43f4ce868","title":"スキャン","link":"scanning-to-computer-topic.html","desc":"コンピュータへのスキャン 開始する前に、コンピュータとプリンタが同じネットワークに接続されていることを確認してください。 Windows の場合 Lexmark","descFull":"コンピュータへのスキャン 開始する前に、コンピュータとプリンタが同じネットワークに接続されていることを確認してください。 Windows の場合 Lexmark ScanBack ユーティリティを使用する コンピュータから  Lexmark ScanBack ユーティリティ を実行し、［ プロファイルを作成します ］をクリックします。 ユーティリティをダウンロードするには、 www.lexmark.com/downloads  にアクセスします。 既存のスキャンプロファイルを使用する場合は、［ 既存のプロファイル ］をクリックします。 ［ 設定 ］をクリックし、プリンタの IP アドレスを追加します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 ［ OK ］をクリックし、［ 閉じる ］をクリックします。 スキャンする原稿の形式とサイズを指定します ファイル形式とスキャン解像度を選択し、［ 次へ ］をクリックします。 一意のスキャンプロファイル名を入力します。 スキャンした原稿を保存する場所を参照し、ファイル名を付けて保存します。 スキャンプロファイルを再利用するには、［ ショートカットを作成 ］を有効にして、一意のショートカット名を作成します。 ［ 終了 ］をクリックします。 原稿を、自動原稿フィーダの中、または原稿台の上にセットします。 操作パネルで［ スキャンプロファイル ］ ［ コンピュータにスキャン ］に移動して、スキャンプロファイルを選択します。 コンピュータ上で［ スキャン完了 ］をクリックします。 Windows の場合 ［Windows FAX とスキャン］を使用する プリンタがコンピュータに追加されていることを確認します。詳細については、 を参照してください。 原稿を、自動原稿フィーダの中、または原稿台の上にセットします。 コンピュータで、［ Windows FAX とスキャン ］を開きます。 ［ 新規のスキャン ］をクリックし、タイプを選択します。 必要に応じて、スキャン設定を変更します。 ドキュメントをスキャンします。 ［ 名前を付けて保存 ］をクリックして、ファイル名を入力し、［ 保存 ］をクリックします。 Macintosh の場合 プリンタがコンピュータに追加されていることを確認します。詳細については、 を参照してください。 原稿を、自動原稿フィーダの中、または原稿台の上にセットします。 コンピュータから以下のいずれかの手順を実行します。 ［ イメージキャプチャ ］を開きます。 ［ プリンタとスキャナ ］を開き、プリンタを選択します。［ スキャン ］ ［ スキャナを開く ］をクリックします。 ［スキャナ］ウィンドウで、次の手順の内 1 つ以上を実施します。 スキャンしたドキュメントを保存する場所を選択します。 原稿のサイズを選択します。 ADF からスキャンするには、［ スキャンメニュー ］から［ 原稿フィーダ ］を選択するか、［ 原稿フィーダの使用 ］を有効化します。 必要に応じて、スキャン設定を構成します。 ［ スキャン ］をクリックします。 コンピュータへのスキャン コンピュータ、スキャン先 Lexmark ScanBack ユーティリティ"},{"UUID":"a6dbe50d-469c-4f03-acb3-ea6829bfb45d","title":"スキャン","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"スキャンして FTP サーバーに送信する スキャンして FTP","descFull":"スキャンして FTP サーバーに送信する スキャンして FTP サーバーに送信する 開始する前に、プリンタが FTP サーバーに接続されていることを確認します。 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ スキャン ］ ［ FTP ］の順に移動します。 情報を入力して、［ 次へ ］を選択します。 必要に応じて、FTP 設定を変更します。 ドキュメントをスキャンします。 FTP サーバー スキャン スキャン FTP サーバーへ"},{"UUID":"b8de9f59-45bc-4b46-80a7-90452c74ee49","title":"スキャン","link":"creating-FTP-shortcut-topic.html","desc":"FTP ショートカットを作成する FTP ショートカットを作成する 操作パネルで、［","descFull":"FTP ショートカットを作成する FTP ショートカットを作成する 操作パネルで、［ スキャン ］ ［ FTP ］を選順に択します。 FTP サーバーアドレスを入力して、 をタッチします。 ショートカットを作成します。 ショートカットを作成する FTP アドレス ショートカットを追加する FTP アドレス"},{"UUID":"e21e476b-41e6-48a1-aa45-64c8792a7706","title":"スキャン","link":"scanning-to-network-folder-topic.html","desc":"スキャンしてネットワークフォルダに送信する スキャンを開始する前に、ドキュメントをスキャンして保存するネットワークフォルダがすでに設定されていることを確認してください。 原稿を ADF トレイまたは原稿台にセットします。","descFull":"スキャンしてネットワークフォルダに送信する スキャンを開始する前に、ドキュメントをスキャンして保存するネットワークフォルダがすでに設定されていることを確認してください。 原稿を ADF トレイまたは原稿台にセットします。 操作パネルで、［ スキャンセンター ］ ［ ネットワークフォルダ ］の順に移動します。 保存するネットワークフォルダを選択します。 ネットワークフォルダを追加するには、 を参照してください。 ドキュメントをスキャンします。 スキャン ネットワークフォルダ ネットワークフォルダ スキャン"},{"UUID":"e7d5b03b-d20e-40cf-8c26-d41fd507b66a","title":"スキャン","link":"configuring-network-folder-destination-topic.html","desc":"保存先のネットワークフォルダを設定する 保存先のネットワークフォルダを設定する 操作パネルで、［ スキャンセンター ］","descFull":"保存先のネットワークフォルダを設定する 保存先のネットワークフォルダを設定する 操作パネルで、［ スキャンセンター ］ ［ ネットワークフォルダ ］ ［ ネットワークフォルダを作成 ］の順に移動します。 必要な設定を行います。 ネットワークにログインし、［ 次へ ］を選択します。 ネットワークフォルダの設定を行い、［ 終了 ］を選択します。 スキャンしたドキュメントをネットワークフォルダに保存するには、 を参照してください。 ネットワークフォルダの送信先 設定 ネットワークフォルダを作成する"},{"UUID":"ec8abaa3-4111-42bd-ae37-b559986fc82e","title":"スキャン","link":"creating-network-folder-shortcut-topic.html","desc":"ネットワークフォルダのショートカットを作成する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。","descFull":"ネットワークフォルダのショートカットを作成する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ ショートカット ］ ［ ショートカットを追加 ］の順にクリックします。 ［ ショートカットタイプ ］メニューで［ ネットワークフォルダ ］を選択して設定します。 変更を適用します。 ネットワークフォルダショートカット ショートカットを作成する"},{"UUID":"2054c936-e904-4649-803e-77f454c80d4f","title":"スキャン","link":"scanning-to-flash-drive-topic.html","desc":"フラッシュメモリにスキャンする フラッシュメモリにスキャンする 原稿を ADF トレイまたは原稿台にセットします。","descFull":"フラッシュメモリにスキャンする フラッシュメモリにスキャンする 原稿を ADF トレイまたは原稿台にセットします。 フラッシュメモリをセットします。 操作パネルで、［ スキャン ］を選択し、［ USB ドライブ ］を選択します。 ファイルを保存する場所を選択し、ファイル名を作成し、［ 次へ ］を選択します。 スキャンの設定を行います。 ドキュメントをスキャンします。 データの損失やプリンタの誤動作を防ぐため、メモリデバイスからの印刷やデータ読み書きの最中は、フラッシュメモリや、プリンタの図で示した範囲に手を触れないでください。 スキャン フラッシュメモリへ フラッシュドライブ スキャン"},{"UUID":"930098fd-3793-43a4-b674-d4091c0930c8","title":"プリンタメニュー","link":"menu-map-topic.html","desc":"メニューマップ 1  フィニッシャが取り付けられている場合にのみ表示されます。 2","descFull":"メニューマップ 1  フィニッシャが取り付けられている場合にのみ表示されます。 2  ストレージドライブが取り付けられている場合にのみ表示されます。 デバイス 基本設定 エコモード 遠隔操作パネル 通知 電源管理 Lexmark とデータを共有する ユーザー補助機能 工場出荷時設定に戻す メンテナンス ファームウェアを更新する このプリンタについて デバイス 基本設定 エコモード 遠隔操作パネル 通知 電源管理 ユーザー補助機能 工場出荷時設定に戻す メンテナンス ファームウェアを更新する このプリンタについて 印刷 レイアウト 仕上げ 1 セットアップ 品質 ジョブアカウント PDF PostScript PCL 画像 用紙 トレイ設定 用紙構成 排紙トレイ構成設定 1 コピー コピー初期設定 Fax FAX 初期設定 E メール E メール設定 E メール初期設定 Web リンク設定 FTP FTP 初期値設定 USB ドライブ フラッシュメモリスキャン フラッシュメモリ印刷 ネットワーク/ポート ネットワークの概要 ワイヤレス Wi‑Fi ダイレクト モバイルサービスの管理 イーサネット TCP/IP SNMP IPSec 802.1x LPD 設定 HTTP/FTP の設定 ThinPrint USB 外部ネットワークへのアクセスを制限する セキュリティ ログイン方式 USB デバイスのスケジュール セキュリティ監査ログ ログイン制限 コンフィデンシャル印刷設定 暗号化 一時データファイルの消去 ソリューション LDAP 設定 その他 クラウドサービス クラウドサービス登録 レポート メニュー設定ページ デバイス 印刷 ショートカット Fax ネットワーク トラブルシューティング 印刷品質テストページ スキャナを清掃する Forms Merge 2 Forms Merge メニューマップ プリンタメニュー"},{"UUID":"38ad6319-c0bb-4f0b-85c0-6543e09da317","title":"デバイス","link":"preferences-topic.html","desc":"基本設定 ［基本設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"基本設定 ［基本設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 表示言語 規定せず ［言語の一覧］ ディスプレイに表示されるテキストの言語を設定します。 国／地域 規定せず ［国や地域の一覧］ プリンタを運用する国または地域を指定します。 初期セットアップの実行 規定せず オフ ＊ オン セットアップウィザードを実行します。 キーボード キーボードタイプ ［言語の一覧］ キーボードタイプとして言語を選択します。 ［ キーボードタイプ ］の値がすべて表示されない場合や、表示するには特殊なハードウェアの取り付けが必要になる場合があります。 日付/時刻 設定 現在の日付/時刻 日付/時刻を手動設定 日付形式  （ MM-DD-YYYY ＊） 時刻形式 （ 12 時間表示 AM/PM ＊） 時間帯 DST（GMT）オフセット DST 開始 DST 終了 DST 時差 プリンタの日付/時刻およびネットワークタイムプロトコルを設定します。 米国の場合、工場出荷時は［ MM‑DD‑YYYY ］に設定されています。それ以外の国の場合、工場出荷時は［ DD‑MM‑YYYY ］に設定されています。 ［ UTC（GMT）時差 ］、［ DST 開始 ］、［ DST 終了 ］、［ DST 時差 ］は、［ 時間帯 ］が［ （UTC+時差）カスタム ］に設定されている場合にのみ表示されます。 ［ キー ID ］および［ パスワード ］は、［ 認証を有効化 ］が［ MD5 キー ］に設定されている場合にのみ表示されます。 ネットワークタイムプロトコル NTP の有効化 （ オン ＊） NTP サーバー 認証を有効化 （ なし *） キー ID パスワード 用紙サイズ 規定せず 米国 ＊ ミリ 用紙サイズの測定方法を指定します。 用紙サイズの初期設定は、初期設定ウィザードで選択した国や地域によって決まります。 画面の明るさ 規定せず 20 ～ 100% （100＊） ディスプレイの明るさを調整します。 フラッシュメモリアクセス 規定せず 無効 有効 * プリンタのフラッシュメモリ機能へのアクセスを有効にします。 下地調整を許可 規定せず オフ オン * 下地調整を許可するかどうかを指定します。 カスタムジョブスキャンを許可 規定せず オフ オン * コピー、スキャン、FAX で［ カスタムジョブスキャン ］設定を表示するかどうかを指定します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 1 ページ原稿台スキャン 規定せず オフ ＊ オン 原稿台を使用して、あらゆる種類のジョブを単一のページとしてスキャンするようにプリンタを設定します。 プリンタは、原稿台で1回のスキャンを実行した後に、指示を表示する代わりにホーム画面に戻ります。 デバイスの音声 すべてのサウンドをミュート オフ ＊ オン プリンタのサウンド設定を行います。 ボタンのフィードバック オフ オン * ボリューム 0 ～ 10 （5＊） ADF セットビープ オフ オン * アラーム音設定 オフ 1 回 * 連続 カートリッジ警報 オフ 1 回 * 連続 スピーカーモード 常にオフ ＊ 常にオン 接続されるまでオン 着信音量 オフ ＊ オン 画面タイムアウト 規定せず 5 ～ 300 秒 （60＊） ディスプレイにホーム画面が表示されるまでのアイドル時間、またはユーザーアカウントが自動的にログアウトされるまでのアイドル時間を秒単位で設定します。 メニュー 基本設定"},{"UUID":"e847f00a-3b20-461d-8794-fe5a3cdc2597","title":"デバイス","link":"preferences-topic.html","desc":"エコモード [エコモード]のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"エコモード [エコモード]のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 印刷 印刷面 片面 両面 ＊ 用紙の片面に印刷するか両面に印刷するかを指定します。 割り付けるページ数 オフ ＊ 2 ページ/面 3 ページ/面 4 ページ/面 6 ページ/面 9 ページ/面 12 ページ/面 16 ページ/面 1 枚の用紙の片面に印刷するページ数を指定します。 トナーの濃さ 1 ～ 5 （4＊） 文字画像の明るさや濃度を指定します。 カラートナー節約 オフ ＊ オン プリンタでグラフィックスや画像を印刷するときにトナーを低減するように設定します。 コピー 印刷面 片面->片面 ＊ 片面->両面 両面->片面 両面->両面 原稿に応じてスキャン動作を指定します。 割り付けるページ数 オフ ＊ 縦 2 in 1 縦 4 in 1 横 2 in 1 横 4 in 1 1 枚の用紙の片面にコピーするページ数を指定します。 濃度 1 ～ 9 （5＊） スキャンした文字画像の濃度を指定します。 メニュー エコモード"},{"UUID":"89d81968-f5e0-4c36-a8c2-aab54d05709f","title":"デバイス","link":"preferences-topic.html","desc":"遠隔操作パネル 遠隔操作パネルメニュー項目と説明 メニュー項目 設定 説明","descFull":"遠隔操作パネル 遠隔操作パネルメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 外部 VNC 接続 許可しない ＊ 許可する 外部の Virtual Network Computing（VNC）クライアントをリモート操作パネルに接続します。 認証タイプ なし * 標準認証 VNC クライアントサーバーにアクセスする際の認証タイプを設定します。 VNCパスワード この設定はユーザーが定義します。 VNC クライアントサーバーに接続するためのパスワードを指定します。 このメニュー項目は、［ 認証タイプ ］が［ 標準認証 ］に設定されている場合にのみ表示されます。 メニュー 遠隔操作パネル"},{"UUID":"2393ad27-e297-4f3f-99ef-fc0786cfe230","title":"デバイス","link":"preferences-topic.html","desc":"通知 ［通知］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"通知 ［通知］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ADF セットビープ 規定せず オフ オン * 原稿が ADF にセットされたときに、プリンタがカスタムビープ音を鳴らすかどうかを指定します。 アラーム音設定 規定せず オフ 1 回 * 連続 プリンタでユーザーの操作が必要なときに、アラームを鳴らす回数を設定します。 消耗品 消耗品の寿命を表示 寿命を表示 ＊ 寿命を表示しない 消耗品の寿命を表示します。 カートリッジ警報 オフ 1 回 * 連続 トナーカートリッジの残量が少ないときに、アラームを鳴らす回数を設定します。 ホチキス警報 オフ ＊ 1 回 連続 ホチキスカートリッジが空になったときに、アラームを鳴らす回数を設定します。 このメニュー項目はホチキスフィニッシャがある場合にのみ表示されます。 ホールパンチ警報 オフ ＊ 1 回 連続 ホールパンチコンテナが満杯または見つからないときに、アラームを鳴らす回数を設定します。 このメニュー項目は、ホチキス、ホールパンチフィニッシャが取り付けられている場合のみ表示されます。 E メールアラートを設定 プライマリ SMTP ゲートウェイ この設定はユーザーが定義します。 プライマリ SMTP サーバーの IP アドレスまたはホスト名を入力します。 プライマリ SMTP ゲートウェイポート 1 ～ 65535 （25＊） プライマリ SMTP サーバーのポート番号を入力します。 セカンダリ SMTP ゲートウェイ この設定はユーザーが定義します。 セカンダリ SMTP サーバーの IP アドレスまたはホスト名を入力します。 セカンダリ SMTP ゲートウェイポート 1 ～ 65535 （25＊） セカンダリ SMTP サーバーのサーバーポート番号を入力します。 SMTP タイムアウト 5 ～ 30 秒 （30＊） SMTP サーバーが E メールの送信を停止するまでの待機時間を指定します。 返信アドレス この設定はユーザーが定義します。 E メールの返信アドレスを指定します。 SMTP の初期設定返信アドレスを常に使用 オン オフ ＊ SMTP サーバーの初期設定返信アドレスを常に使用します。 SSL/TLS を使用 無効 ＊ ネゴシエーション 必須 暗号化されたリンクを使用して E メールを送信します。 信頼済み証明書を要求 オン * オフ SMTP サーバーにアクセスする際に、信頼済み証明書が必要となります。 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 E メール警報の設定 SMTP サーバー認証 認証不要 ＊ ログイン/プレーンテキスト NTLM CRAM-MD5 Digest-MD5 Kerberos 5 SMTP サーバーの認証タイプを設定します。 デバイスから送信される E メール なし * デバイスの SMTP 証明書を使用 デバイスから送信される E メールに認証情報が必要かどうかを設定します。 ユーザーから送信される E メール なし * デバイスの SMTP 証明書を使用 セッションユーザー ID およびパスワードを使用 セッション E メールアドレスとパスワードを使用 ユーザーに確認 ユーザーから送信される E メールに認証情報が必要かどうかを設定します。 Active Directory デバイス資格証明書を使用 オン オフ ＊ SMTP サーバーに接続するために、ユーザー資格情報とグループ指定を有効にします。 デバイスのユーザー ID この設定はユーザーが定義します。 SMTP サーバーにログインするためのユーザー ID を指定します。 デバイスのパスワード この設定はユーザーが定義します。 SMTP サーバーにログインするためのパスワードを指定します。 Kerberos 5 レルム この設定はユーザーが定義します。 Kerberos 5 認証プロトコルのレルムを指定します。 NTLM ドメイン この設定はユーザーが定義します。 NTLM セキュリティプロトコルのドメイン名を指定します。 ［SMTP サーバーが設定されていません］のエラーを無効にする オン オフ ＊ SMTP サーバーの設定に関するエラーメッセージを無効にします。 E メールリストとアラートをセットアップ この設定はユーザーが定義します。 E メールアドレスを指定し、E メールアラートを有効にします。 このメニュー項目は、EWS でのみ表示されます。 エラー防止 ADF 重送センサー オフ オン * ADF で 1 度に複数枚の用紙が給紙されたことをプリンタが検出するように設定します。 自動継続 オフ オン * 特定の操作が必要な状態が解消されたら、プリンタがジョブの処理や印刷を自動的に続行するようにします。 ［ オン ］に設定した場合、初期設定は 5 秒です。 自動再起動 アイドル時に再起動 常に再起動 ＊ 再起動しない エラー発生時にプリンタを再起動するように設定します。 最大自動再起動回数 1 ～ 20 （2＊） プリンタが実行可能な自動再起動回数を指定します。 自動再起動までの時間 1 ～ 525600 （720＊） プリンタが自動的に再起動するまでの秒数を設定します。 自動再起動カウンタ この設定は読み取り専用の情報です。 プリンタが実行した自動再起動回数を表示します。 「用紙が短すぎます」エラーを表示 オン 自動クリア ＊ 「用紙が短すぎます」エラーが発生した場合に、プリンタにメッセージを表示するかどうかを設定します。 セットされている用紙のサイズが短いことを示します。 ページ保護 オフ ＊ オン 印刷の前に、ページ全体をメモリで処理するように設定します。 紙詰まりしたページの再印刷 紙づまり回復 オフ オン 自動 ＊ 紙詰まりが発生したページを再印刷するかどうかを設定します。 スキャナの紙詰り後の処理 ジョブレベル ページレベル ＊ 紙詰まりの解決後にスキャンジョブを再開する方法を指定します。 メニュー 通知"},{"UUID":"09d2072d-85af-433a-a851-328687dca734","title":"デバイス","link":"preferences-topic.html","desc":"電源管理 ［電源管理］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"電源管理 ［電源管理］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 スリープモードプロファイル スリープモードから印刷 印刷後も起動状態を維持する 印刷後にスリープモードにする ＊ 印刷後にプリンタを起動状態に維持するか、 スリープモード にするかを設定します。 タッチしてディープスリープから復帰 オフ オン * ディープスリープモード からプリンタを復帰します。 タイムアウト スリープモード 1 ～ 114 分 （15＊） プリンタが スリープモード になるまでのアイドル時間を指定します。 休止時間 無効 1 時間 2 時間 3 時間 6 時間 1 日 2 日 3 日 ＊ 1 週間 2 週間 1 か月 プリンタの電源が切れるまでの時間を設定します。 ネットワーク接続時の休止時間 休止モードにする 休止モードにしない ＊ アクティブなイーサネット接続が存在するときにプリンタの電源を切るため、［ 休止時間 ］を設定します。 電力モードの定期実行 スケジュール 新しいスケジュールを追加 プリンタの スリープモード または 休止モード をスケジュールします。 メニュー 電源管理"},{"UUID":"da3e0067-07dc-41e7-86b9-22322a7e0fa1","title":"デバイス","link":"preferences-topic.html","desc":"Lexmark とデータを共有する ［Lexmark とデータを共有する］のメニュー項目と説明 メニュー項目","descFull":"Lexmark とデータを共有する ［Lexmark とデータを共有する］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 Lexmark とデータを共有する はい いいえ * プリンタ使用方法およびパフォーマンスに関する情報を Lexmark へ送信します。 データ送信時間を共有 開始時間 停止時刻 データを収集および送信する期間を選択します。 ［ データ送信時間を共有 ］は、［ Lexmark とデータを共有する ］で［ はい ］を選択した場合にのみ表示されます。 メニュー Lexmark とデータを共有する"},{"UUID":"53e163f4-a0a5-4809-9f34-d611a9e37f33","title":"デバイス","link":"preferences-topic.html","desc":"ユーザー補助機能 ［ユーザー補助機能］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"ユーザー補助機能 ［ユーザー補助機能］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 重複したキー操作の間隔 0.00 ～ 5.00 （0.00＊） 接続したキーボードで連続で押されたキーをプリンタに無視させる間隔を秒単位で設定します。 キーリピートまでの待ち時間 0.25 ～ 5.00 （1.00＊） 反復キーが繰り返しを開始するまでの遅延の初期時間を秒単位で設定します。 キーリピートの間隔 0.5 ～ 30.0 （30.0＊） 反復キーを 1 秒間に押す回数を設定します。 画面タイムアウトの延期 オフ ＊ オン 期限が切れても、ユーザーはホーム画面に戻らずに同じ場所に留まり、［ 画面タイムアウト ］のタイマーをリセットできます。 ヘッドホンの音量 1 ～ 10 （5＊） ヘッドホンの音量を調整します。 ヘッドホン接続時に音声ガイダンスを有効化 オフ ＊ オン ヘッドホンがヘッドホンジャックに接続されている場合に、音声ガイダンスを有効にします。 パスワード/PIN を発声 オフ ＊ オン 発声されたパスワードまたは個人 ID 番号を認識するようにプリンタを設定します。 スピーチ速度 とても遅い 遅い 標準 ＊ 速い より速い 非常に速い 高速 非常に高速 最も高速 音声ガイダンスのスピーチ速度を設定します。 メニュー ユーザー補助機能"},{"UUID":"a1080734-41a8-4024-9b05-29b89ce2decd","title":"デバイス","link":"preferences-topic.html","desc":"工場出荷時設定に戻す ［工場出荷状態に戻す］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"工場出荷時設定に戻す ［工場出荷状態に戻す］のメニュー項目と説明 メニュー項目 設定 説明 設定を復元 すべての設定を復元 プリンタ設定を復元 ネットワーク設定を復元 FAX 設定を復元 アプリ設定を復元 プリンタの初期状態のデフォルト設定を復元します。 メニュー 工場出荷時設定に戻す"},{"UUID":"3035abbc-8c85-41e7-abda-6a1da088dde7","title":"メンテナンス","link":"preferences-topic.html","desc":"設定メニュー ［設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"設定メニュー ［設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 USB 設定 USB PnP 1 ＊ 2 プリンタの USB ドライバモードを変更して、PC との互換性を向上させます。 ローカルに USB スキャン オン * オフ USB デバイスドライバを USB シンプルデバイス（単一インターフェイス）として表示するのか、USB 複合デバイス（複数インターフェイス）として表示するのかを設定します。 USB 速度 フル 自動 ＊ USB ポートが最高速で動作するように設定し、USB ポートの高速機能を無効化します。 トレイ設定 サイズ検知 トレイ  [x]  検知 （ オン ＊） トレイにセットされている用紙サイズを自動的に感知するように設定します。 トレイのリンク 自動 ＊ オフ 同じ用紙タイプと用紙サイズが設定されているトレイをリンクするように、プリンタを設定します。 トレイ挿入時のメッセージ表示 オフ 不明サイズのみ ＊ 常に トレイを挿入した後で、用紙サイズと用紙タイプの設定を変更できるメッセージが表示されます。 用紙の給紙トレイ 自動 ＊ 多目的フィーダ 手差し用紙 用紙をセットするよう要求されたときに、ユーザーがセットする給紙トレイを設定します。 ［ 多目的フィーダ ］を表示するには［ 用紙 ］メニューで ［MP を構成する］ を［ トレイ ］に設定します。 封筒の給紙トレイ 自動 ＊ 多目的フィーダ 手差し封筒 封筒をセットするよう要求されたときに、ユーザーがセットする給紙トレイを設定します。 ［ 多目的フィーダ ］を表示するには［ 用紙 ］メニューで ［MP を構成する］ を［ トレイ ］に設定します。 用紙変更時のアクション ユーザーに確認 ＊ 続行 セットされている用紙を使用 用紙または封筒関連の変更を求めるプロンプトを解決するようにプリンタを設定します。 複数のユニバーサルサイズ オフ ＊ オン 複数のユニバーサル用紙サイズに対応するようにトレイを設定します。 レポート 規定せず メニュー設定ページ イベントログ イベントログサマリ プリンタメニュー設定、状態、イベントログに関するレポートを印刷します。 消耗品使用量とカウンタ 消耗品使用履歴をクリア 開始 消耗品の使用履歴を出荷時のレベルにリセットします。 ITM のリセット 開始 新しい消耗品またはメンテナンスキットを取り付けたら、カウンタをリセットします。 ブラックカートリッジのカウンタをリセット 開始 シアンカートリッジのカウンタをリセット 開始 マゼンタカートリッジのカウンタをリセット 開始 イエローカートリッジのカウンタをリセット 開始 ブラックイメージングユニットのカウンタをリセット 開始 カラーイメージングキットのカウンタをリセット 開始 MPF ローラーキットカウンタをリセット 開始 1500 枚ローラーキットカウンタをリセット 開始 ローラーキットカウンタをリセット 開始 段階的トナー使用率の範囲 段階的トナー使用率指標 （ 表示 ＊） ［デバイス統計］レポートで段階的トナー使用率の課金セクションを表示します。 段階的トナー使用率の範囲 大容量メディアの調整 オフ ＊ オン 大きい用紙または厚い用紙の印刷時に調整できるようにします。 プリンタエミュレーション PPDS エミュレーション オフ ＊ オン PPDS データストリームを認識して使用するようにプリンタを設定します。 PS エミュレーション オフ オン * PS データストリームを認識して使用するようにプリンタを設定します。 Formsmerge の有効化 オフ ＊ オン Forms Merge を有効にします。 Forms Merge ライセンスがインストールされている必要があります。 ユーザーフラッシュメモリを取り付ける必要があります。 Prescribe の有効化 オフ ＊ オン PRESCRIBE プリンタ言語を有効にします。 Prescribe ライセンスがインストールされている必要があります。 エミュレータセキュリティ ページタイムアウト （60＊） エミュレーション中のページタイムアウトを設定します。 ジョブ後にエミュレータをリセット （ オフ ＊） 印刷ジョブ後にエミュレータをリセットします。 プリンタメッセージアクセスの無効化 （ オン ＊） エミュレータがプリンタの初期設定にアクセスできるかどうかを決定します。 FAX 設定 FAX 節電サポート スリープの無効化 スリープする 自動 ＊ プリンタの FAX 機能が節電をサポートするか決定します。 FAX 保存場所 ハードディスク ＊ NAND すべての FAX の保存場所を指定します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 印刷設定 モノクロモード オフ ＊ オン 非コピージョブをグレースケールで印刷します。 カラートラッピング オフ 1 2 ＊ 3 4 5 出力を修正して、プリンタの見当ずれを補正します。 フォントのシャープ度 0 ～ 150 （24＊） フォントデータの印刷時に高周波数スクリーンを使用する場合の、テキストポイントサイズの最高値を設定します。 例えば、値を 24 に設定すると、フォントが 24 ポイント以下の場合は常に高周波数スクリーンが使用されます。 ネイティブ ISD フォントを使用 オン * オフ インテリジェントストレージドライブ（ISD）にあるフリーフォントを使用するかどうかを選択できます。 このメニュー項目は、ISD が取り付けられている場合にのみ表示されます。 デバイスの操作 静音モード オフ ＊ オン プリンタから発生する騒音の大きさを調整します。 この設定を有効にすると、プリンタ全体のパフォーマンスが低下します。 バーストモードを有効化 オン * オフ 1 ページ目、場合によっては複数ページのジョブの 1 ページ目をすばやく処理するようにプリンタを設定し、ジョブをより速く完了させます。 このメニュー項目は、一部のプリンタ機種にのみ表示されます。 セーフモード オフ ＊ オン 既知の問題が発生しても、プリンタを特別なモードで動作させ、できるだけ多くの機能の提供するように設定します。 例えばこれを［ オン ］に設定しておくと、両面モーターが機能していない場合、両面印刷ジョブであっても片面印刷が実行されます。 この設定を有効にすると、マルチパーパスフィーダからのみ印刷が可能になります。 最小コピーメモリ 20 MB 30 MB 50 MB 80 MB ＊ 100 MB コピージョブを保存するために、最小限のメモリ割り当てを設定します。 カスタムメッセージをクリア 開始 初期設定 のカスタムメッセージ、または 代替 のカスタムメッセージから、ユーザーが定義した文字列が消去されます。 クラウドからのメッセージをすべて消去 開始 リモートからインストールされたメッセージが消去されます。 エラー画面の自動表示 オフ オン * 一定の時間にわたってホーム画面のままプリンタを使用しない状態が続くと、ディスプレイに既存のエラーメッセージが表示されます。 高速コピー時に向きの設定を使用 オフ ＊ オン クイックコピージョブを送信する場合に、プリンタで［ コピー ］メニューの［用紙の向き］設定を使用できるようにします。 サービス不揮発性メモリ 暗号化ステータス インテリジェントストレージドライブの暗号化のステータスを表示します。 暗号化サービス不揮発性メモリ ミラー暗号化を手動で有効します。 トナーパッチセンサーの設定 調整頻度設定 無効 カラー調整を最少にする カラー調整を少なくする 標準 ＊ カラー精度を良好にする カラー精度を最良にする カラーの一貫性を維持するため、トナーを正しい量に調整するかどうかを設定します。 完全調整 開始 カラーの完全調整を実行します。 TPS 情報ページを印刷 開始 トナーパッチセンサー調整の情報を含む診断ページを印刷します。 アプリ設定 LES アプリケーション オフ オン * Lexmark Embedded Solutions（LES）アプリケーションを有効にします。 スキャナ設定 スキャナ手動登録 印刷簡易テスト 正面 ADF 登録 背面 ADF 登録 フラットベッド登録 ADF、スキャナガラス、またはコントローラボードを交換した後、簡易テストのターゲットページを印刷するか、フラットベッドと自動原稿フィーダ（ADF）を手動で登録します。 簡易テストのターゲットページを印刷して、余白の幅が全周で均等になっていることを確認します。均等になっていない場合は、プリンタの余白をリセットする必要があります。 メンテナンスカウンタをリセット ADF メンテナンスカウンタをリセット （ 開始 ） ADF メンテナンスキットの交換後、カウンタをリセットします。 フチ消去 フラットベッドフチ消去 （3＊） ADF フチ 消去（3＊） ADF またはフラットベッドスキャンジョブの周囲にある非印刷領域のサイズをミリ単位で設定します。 ADF デスキュー ADF 電子的傾き （ オン ＊） ADF からスキャンされたドキュメントの傾きを抑制します。 スキャナを無効化 いいえ * はい ADF のみ スキャナが正常に動作しない場合に、スキャナを無効にします。 TIFF バイトオーダー CPU エンディアン リトルエンディアン ビッグエンディアン TIFF 形式のスキャン出力のバイトオーダーを設定します。 正確な Tiff:rows-per-strip オン * オフ TIFF 形式のスキャン出力の RowsPerStrip タグ値を設定します。 原稿台クリーニングのしきい値 1000 ～ 30000 （10000＊） スキャン回数を設定して原稿台クリーニングを促すメッセージを受け取るようにします。 メニュー 設定メニュー"},{"UUID":"4eae9641-f1fb-42e2-81a7-742593f3c7c5","title":"メンテナンス","link":"preferences-topic.html","desc":"未使用時の消去 ［未使用時の消去］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"未使用時の消去 ［未使用時の消去］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 未使用時の消去 前回のプリンタメモリ消去 この設定は読み取り専用の情報です。 プリンタのメモリの前回の消去された日時を示します。 前回消去したハードディスク この設定は読み取り専用の情報です。 ハードディスクが最後に消去された日時を表示します。 このメニュー項目はハードディスクがある場合にのみ表示されます。 最後に消去された ISD この設定は読み取り専用の情報です。 インテリジェントストレージドライブ（ISD）が最後に消去された日時を表示します。 このメニュー項目は、ISD が取り付けられている場合にのみ表示されます。 不揮発性メモリにあるすべての情報を消去 すべてのプリンタおよびネットワーク設定を消去 すべてのアプリとアプリ設定を消去 すべてのショートカットとショートカット設定を消去 不揮発性メモリにあるすべての情報を消去します。 ハードディスクのすべての情報を消去 ダウンロードを消去（すべてのマクロ、フォント、PFO などを消去） バッファリングされたジョブを消去 保留ジョブを消去 ハードディスクのすべての情報を消去します。 このメニュー項目はハードディスクがある場合にのみ表示されます。 インテリジェントストレージドライブを削除する 消去する ISD にあるすべての情報を消去します。 このメニュー項目は、ISD が取り付けられている場合にのみ表示されます。 メニュー 未使用時の消去"},{"UUID":"36a32bf2-a865-4d83-9026-a90fa212fafb","title":"デバイス","link":"preferences-topic.html","desc":"ファームウェアを更新 ［ファームウェアを更新］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"ファームウェアを更新 ［ファームウェアを更新］のメニュー項目と説明 メニュー項目 設定 説明 現在のバージョン この設定は読み取り専用の情報です。 プリンタにインストールされているファームウェアの現在のバージョンを示します。 今すぐ更新を確認 今すぐインストール 後でインストール ファームウェアの更新を確認します。 更新を自動で確認 オン オフ ＊ ファームウェアの更新があるかどうか自動的に確認するように設定します。 メニュー ファームウェアを更新"},{"UUID":"81342abf-b480-4eed-b41e-3d3e0c6cdaeb","title":"デバイス","link":"preferences-topic.html","desc":"このプリンタについて ［このプリンタについて］のメニュー項目と説明 メニュー項目 説明 アセットタグ","descFull":"このプリンタについて ［このプリンタについて］のメニュー項目と説明 メニュー項目 説明 アセットタグ プリンタの ID を指定します。 プリンタの設置場所 プリンタの設置場所を指定します。 担当者 プリンタの連絡先情報を指定します。 ファームウェアバージョン プリンタにインストールされているファームウェアのバージョンを示します。 エンジン プリンタのエンジン番号を示します。 シリアル番号 プリンタのシリアル番号を示します。 設定ファイルを USB にエクスポート 設定ファイルをフラッシュメモリにエクスポートします。 圧縮ログを USB にエクスポート 圧縮ログファイルをフラッシュメモリにエクスポートします。 ログの送信 プリンタのログ情報を Lexmark に送信します。 メニュー このプリンタについて"},{"UUID":"624668ce-c64d-48a8-8c58-f2ee69d9d5f1","title":"印刷","link":"layout-topic.html","desc":"レイアウト ［レイアウト］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"レイアウト ［レイアウト］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 印刷面 片面 両面 ＊ 用紙の片面に印刷するか両面に印刷するかを指定します。 反転スタイル 長辺 ＊ 短辺 両面印刷を実行する場合は、用紙のどちらの辺を綴じるかを決定します。 空白ページ 印刷 印刷しない ＊ 印刷ジョブに含まれる空白ページを印刷します。 部単位 オフ（1,1,1,2,2,2） オン（1,2,1,2,1,2） ＊ 特にジョブを複数部印刷する場合は、各印刷ジョブのページ順が維持されるように積み重ねます。 挿入紙 なし * 各コピー部数の間 各ジョブの間 各ページの間 印刷時に空白の挿入紙を挿入します。 挿入紙のトレイ指定 トレイ  [x]（1＊） 多目的フィーダ 挿入紙のトレイを指定します。 割り付けるページ数 オフ ＊ 2 ページ/面 3 ページ/面 4 ページ/面 6 ページ/面 9 ページ/面 12 ページ/面 16 ページ/面 複数のページ画像を 1 枚の用紙の片面に印刷します。 集約順 横方向（左から） ＊ 横方向（右から） 縦方向（左から） 縦方向（右から） ［ ページ集約 ］メニューを使用するときに、複数ページの画像の位置を指定します。 原稿セット方向 自動 ＊ 横 縦 ［ ページ集約 ］メニューを使用するときに、複数ページの画像の向きを指定します。 ページ枠 なし * 実線 ［ ページ集約 ］メニューを使用するときに、各ページの画像に枠線を印刷します。 部数 1 ～ 9999 （1＊） 各印刷ジョブの部数を指定します。 印刷領域 標準 ＊ ページに合わせる ページ全体 1 枚の用紙の印刷領域を設定します。 メニュー レイアウト"},{"UUID":"fa06d0d0-ba78-449b-93cd-2f11bc940969","title":"印刷","link":"layout-topic.html","desc":"仕上げ ［仕上げ］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"仕上げ ［仕上げ］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ホチキス付きジョブ オフ ＊ 1 ホチキス、左上隅 2 ホチキス、左 1 ホチキス、右上隅 2 ホチキス、上 1 ホチキス、左下隅 2 ホチキス、下 1 ホチキス、右下隅 2 ホチキス、右 すべての印刷ジョブのホチキスの位置を指定します。 このメニュー項目はホチキスフィニッシャがある場合にのみ表示されます。 ホチキスのテスト 開始 ホチキスフィニッシャが正常に機能しているかどうかを確認します。 このメニュー項目はホチキスフィニッシャがある場合にのみ表示されます。 ホールパンチ オフ ＊ オン 出力紙の端にホールパンチを行います。 このメニュー項目は、ホチキス、ホールパンチフィニッシャが取り付けられている場合のみ表示されます。 ホールパンチモード 2 穴 3 穴 4 穴 出力紙のホールパンチモードを設定します。 米国向けの出荷時の標準設定は［ 3 穴 ］です。米国以外の出荷時の初期設定は［ 4 穴 ］です。 このメニュー項目は、ホチキス、ホールパンチまたは冊子フィニッシャが取り付けられている場合のみ表示されます。 オフセットページ なし * 各コピー部数の間 各ジョブの間 各印刷ジョブまたは印刷ジョブの各コピーの出力をオフセットします。 ［ 各コピー部数の間 ］では、［ 部単位 ］が［ オン［1,2,1,2,1,2］ ］に設定されている場合に、印刷ジョブのコピーごとにずらして排紙します。［ 部単位 ］が［ オフ[1,1,1,2,2,2] ］に設定されている場合は、1 に指定されている全ページまたは 2 に指定されている全ページなど、印刷ページの各セットがオフセットされます。 印刷する部数に関係なく、［ 各ジョブの間 ］は、印刷ジョブ全体で、同じオフセット位置です。 メニュー 仕上げ"},{"UUID":"3c57ecd0-d065-44c8-a221-3e2268d25831","title":"印刷","link":"layout-topic.html","desc":"セットアップ ［設定］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"セットアップ ［設定］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 プリンタ言語 PCL エミュレーション PS エミュレーション ＊ プリンタ言語を設定します。 プリンタで設定した標準言語にかかわらず、ソフトウェアから他の言語の印刷データを送信できます。 待機中のジョブ オフ ＊ オン 消耗品を必要とする印刷ジョブを保持し、不足している消耗品を必要としないジョブが印刷できるようにします。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ジョブ保留タイムアウト 0 ～ 255 （30＊） プリンタがリソースを利用できないために印刷できないジョブがある場合、そのジョブを保留する前にユーザーの操作を待つ時間を秒単位で指定します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ダウンロード先 RAM ＊ フラッシュ ディスク プリンタにダウンロードされたすべての常駐リソースを保存する場所を指定します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 プリンタ使用方法 最高速度 印刷可能枚数を最大にする ＊ 印刷時に、リトラクションハードウェアをカラー現像体ユニットから外すか取り付けるかを決定します。 ［ 印刷可能枚数を最大にする ］に設定すると、プリンタがアイドル状態の時に、ハードウェアはカラー現像体ユニットに接続されたままになります。 ［ 最高速度 ］に設定すると、ジョブがモノクロかカラーかに関係なく、このハードウェアはカラー現像体ユニットと接続されたままになります。 低速プリンタの使用方法 印刷可能枚数を最大にする ＊ 最高速度 プリンタが低速で動作しているときに、大容量印刷（モノクロモード）と高速印刷（カラーモード）を切り替えます。 この設定は、印刷エンジンが 1 分あたり 25 ページの処理速度で動作している場合にのみ、プリンタの動作を変更します。印刷エンジンが高速の処理速度で動作している場合、この設定の効果はありません。 リソース保存 オフ ＊ オン 利用可能なメモリよりも多くの領域を必要とするジョブを受信した場合に、ダウンロードされたリソースをプリンタでどのように処理するかを指定します。 ［ オフ ］に設定すると、メモリが必要になるまで、ダウンロードされたリソースは保持されます。使用していないプリンタ言語に関連するリソースは削除されます。 ［ オン ］に設定すると、プリンタはすべての言語スイッチでダウンロード済みの常駐リソースをすべて保持します。必要に応じて、プリンタは常駐リソースを削除するのではなく、メモリ不足のメッセージを表示します。 ［全て印刷］の順序 アルファベット順 ＊ 新しい順 古い順 すべての保留ジョブとコンフィデンシャルジョブの印刷を選択するときに順序を指定します。 一時停止された印刷ジョブの自動削除 オフ ＊ オン 紙詰まりや消耗品不足などのエラーによって一時停止されキューにある印刷ジョブを、自動的にキャンセルするように設定します。 メニュー セットアップ"},{"UUID":"57f76081-a02a-415a-998b-b753f8809c38","title":"印刷","link":"layout-topic.html","desc":"品質 ［品質］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"品質 ［品質］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 印刷モード 規定せず モノクロ カラー ＊ プリンタによるカラー内容の生成方法を設定します。 印刷解像度 規定せず 4800 CQ ＊ 1200 dpi 印刷出力の解像度を設定します。 ［ 4800 CQ ］では高品質な出力が最高速度で行われます。 トナーの濃さ 規定せず 1 ～ 5 （4＊） 文字画像の明るさや濃度を指定します。 ハーフトーン 規定せず 標準 ＊ 詳細 印刷出力を向上して鋭いエッジの滑らかな線にします。 カラートナー節約 規定せず オフ ＊ オン グラフィックスやイメージの印刷に使用するトナーの量を減らします。 ［ オン ］に設定すると、この設定は［ トナーの濃さ ］の設定の値を上書きします。 RGB 明るさ 規定せず ‑6 ～ 6 （0＊） ページ上のすべての RGB およびグレーオブジェクトの明るさを調整します。 この設定は、CMYK カラー仕様を使用しているファイルには影響しません。 RGB コントラスト 規定せず 0 ～ 5 （0＊） ページ上のすべての RGB およびグレーオブジェクトのコントラストを調整します。 この設定は、CMYK カラー仕様を使用しているファイルには影響しません。 RGB 彩度 規定せず 0 ～ 5 （0＊） ページ上のすべてのオブジェクトのカラー値を調整しながら、白黒 2 値を保持します。 この設定は、CMYK カラー仕様を使用しているファイルには影響しません。 イメージ詳細設定 カラーバランス シアン （0＊） マゼンタ （0＊） イエロー （0＊） ブラック （0＊） 各カラーのトナー使用量を調整します。 標準設定に戻す すべてのカラー設定を初期設定値にリセットします。 カラー補正 オフ 自動 ＊ 手動 ドキュメントの印刷に使用するカラー設定を変更します。 ［ オフ ］に設定すると、プリンタはソフトウェアからカラー補正を受信します。 ［ 自動 ］に設定すると、プリンタは印刷されるページの各オブジェクトに異なるカラープロファイルを適用します。 ［ 手動 ］に設定すると、印刷されるページの各オブジェクトに RGB または CMYK のカラー変換をカスタマイズできます。 カラーサンプル カラーサンプルの印刷 プリンタで使用されている RGB/CMYK の各種色変換テーブルのサンプルページを印刷します。 カラー調整 カラー調整 プリンタを調節して、印刷出力でカラーバリエーションを調整します。 スポット色交換 カスタム CMYK の設定 指定した CMYK 値を、20 個の名前付きスポットカラーに割り当てます。 メニュー 印刷品質"},{"UUID":"a1234de1-16d4-45ed-aeaa-3ac222aad483","title":"印刷","link":"layout-topic.html","desc":"ジョブアカウント ［ジョブアカウント］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"ジョブアカウント ［ジョブアカウント］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ジョブアカウント オフ ＊ オン プリンタで受信した印刷ジョブのログを作成するかどうかを設定します。 ジョブアカウントのログ回数 毎日 毎週 毎月 ＊ プリンタでログファイルを作成する頻度を指定します。 最後に行うログ操作 なし * 現在のログを E メールで送信 現在のログを E メールで送信して削除 現在のログをポスト 現在のログを送信して削除 頻度のしきい値を経過したときに、プリンタが行う処理を指定します。 このメニュー項目の動作をいつ実行させるかは、［ ジョブアカウントのログ回数 ］で指定します。 ニアフルの状態をログ オン ＊（5MB） オフ プリンタが ニアフル時のログ操作 を実行する前に、ログファイルの最大サイズを指定します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ニアフル時のログ操作 なし * 現在のログを E メールで送信 現在のログを E メールで送信して削除 最も古いログを E メール送信して削除 現在のログをポスト 現在のログを送信して削除 最も古いログを送信して削除 現在のログを削除 最も古いログを削除 現在のログ以外すべて削除 すべてのログを削除 ストレージドライブがほぼ満杯になったときのプリンタの動作を指定します。 このメニュー項目の動作をいつ実行させるかは、［ ニアフルの状態をログ ］で指定します。 フル時のログ操作 なし * 現在のログを E メールで送信して削除 最も古いログを E メール送信して削除 現在のログを送信して削除 最も古いログを送信して削除 現在のログを削除 最も古いログを削除 現在のログ以外すべて削除 すべてのログを削除 ストレージドライブの使用領域が上限 (100MB) に達したときに、プリンタが行う処理を指定します。 ログ記録用 URL この設定はユーザーが定義します。 プリンタによるジョブアカウント情報のログの記録先を指定します。 ログを送信するための E メールアドレス この設定はユーザーが定義します。 ジョブアカウントのログを送信する E メールアドレスを指定します。 ログファイルのプレフィックス この設定はユーザーが定義します。 ログファイルに使用するプレフィックスを指定します。 ［TCP/IP ］メニューで現在設定されているホスト名が、ログファイルの初期設定のプレフィックスとして使用されます。 メニュー ジョブアカウント"},{"UUID":"0c6005c2-8d45-4015-b075-c67f5dadee8a","title":"印刷","link":"layout-topic.html","desc":"PDF ［PDF］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"PDF ［PDF］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 用紙に合わせて印刷 オフ ＊ オン 選択した用紙サイズに合わせてページの内容を拡大/縮小します。 注釈 印刷 印刷しない ＊ PDF 内の注釈を印刷するかどうかを指定します。 PDF エラーを印刷 オフ オン * PDF エラーの印刷を有効にします。 メニュー PDF"},{"UUID":"fd59a038-a46c-4b52-84a2-7140bd9ec003","title":"印刷","link":"layout-topic.html","desc":"PostScript PostScript ［PostScript］のメニュー項目と説明 メニュー項目 設定","descFull":"PostScript PostScript ［PostScript］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 PS エラーを印刷 オフ ＊ オン PostScript® エミュレーションエラーを説明するページを印刷します。 エラーが発生した場合、ジョブの処理が停止され、プリンタによりエラーメッセージが印刷されて、残りの印刷ジョブがキャンセルされます。 最小線幅 1 ～ 30 （2＊） 最小線幅を設定します。 1200 dpi で印刷されるジョブでは、この値がそのまま使用されます。 PS スタートアップモードをロック オフ オン * SysStart ファイルを無効化します。 SysStart ファイルを有効化すると、プリンタやネットワークがセキュリティリスクにさらされます。 イメージ平滑化 オフ ＊ オン 解像度が低いイメージのコントラストやシャープネスを強調します。 この設定は、解像度が 300 dpi 以上のイメージには効果ありません。 フォント優先順位 常駐 ＊ フラッシュメモリ/ハードディスク フォントの検索順序を指定します。 ［ 常駐 ］に設定すると、要求されたフォントがプリンタメモリで検索されてから、ストレージドライブで検索されます。 ［ フラッシュメモリ/ハードディスク ］に設定すると、要求されたフォントがストレージドライブで検索されてから、プリンタメモリで検索されます。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 データ待ちタイムアウト オフ オン * 印刷ジョブを中止する前に、プリンタが残りのデータを待つようにします。 ［ オン ］に設定した場合、工場出荷時設定は 40 秒になっています。 メニュー PostScript"},{"UUID":"08188fc5-c158-4992-9abe-b3ad115cc64f","title":"印刷","link":"layout-topic.html","desc":"PCL ［PCL］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"PCL ［PCL］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 フォントソース 常駐 ＊ ディスク ダウンロード フラッシュ フォントカード すべて 標準設定のフォント選択を含むソースを選択します。 ［ ディスク ］は、フォントが含まれ、欠陥のない、読み取り/書き込み保護されていないハードディスクがインストールされている場合にのみ表示されます。 ［ ダウンロード ］は、ダウンロードしたフォントがプリンタメモリに存在する場合にのみ表示されます。 ［ フラッシュ ］は、フォントが含まれ、欠陥のない、読み取り/書き込み保護されていないフラッシュメモリが取り付けられている場合にのみ表示されます。 ［ フォントカード ］は、有効なフォントカードが取り付けられているか、インテリジェントストレージドライブが設定されている場合にのみ表示されます。 フォント名 ［利用可能なフォントの一覧］（ Courier ＊） 指定したフォントソースからフォントを選択します。 シンボルセット ［利用可能なシンボルセットの一覧］（ 10U PC-8 ＊） 各フォント名のシンボルセットを指定します。 シンボルセットは英数字、句読点、および特殊記号の組み合わせです。シンボルセットは、科学的な文章内の数学記号など、異なる言語またはプログラムをサポートします。 ピッチ 0.08 ～ 100.00 （10.00＊） 幅が固定の等幅フォントのピッチを指定します。 このメニュー項目は、横方向 1 インチあたりの固定スペース文字の数を示します。 原稿の向き 縦 ＊ 横 縦の反転 横の反転 ページに印刷される文字や画像の向きを指定します。 １ ページ当りの行数 1 ～ 255 PCL® データストリームで各ページに印刷されるテキストの行数を指定します。 このメニュー項目によって、ページの初期設定の余白間に選択した行数を印刷するための、縦方向の送りを有効にします。 米国向けの工場出荷時設定は［60］になっています。64 が米国以外の出荷時初期設定です。 PCL5 の最小線幅 1 ～ 30 （2＊） 利用可能なエミュレータを介して 1200 dpi で印刷されるすべてのジョブの初期の最小線幅の値を設定します。 PCLXL の最小線幅 1 ～ 30 （2＊） A4 サイズの幅 198 mm ＊ 203 mm A4 サイズ用紙の論理ページ幅を設定します。 論理ページとは、データが印刷される用紙上の物理的なスペースのことです。 LF 後に CR を自動実行 オン オフ ＊ 改行制御コマンドの後にキャリッジリターンを実行するよう設定します。 キャリッジリターンは、同じ線上の最初の位置にカーソルを移動するようにプリンタに命令するメカニズムです。 CR 後に LF を自動実行 オン オフ ＊ キャリッジリターン制御コマンドの後に改行を実行するよう設定します。 トレイ番号変更 多目的フィーダ割り当て トレイ [x] 割り当て 手差し用紙を割り当て 手差し封筒を割り当て 給紙トレイの割り当てが異なる別の印刷ドライバやカスタムアプリケーションで動作するようにプリンタを設定し、特定の給紙トレイを使用するようにします。 以下のオプションから選択します。 ［ オフ ］＊ - 出荷時初期設定のトレイ指定を使用します。 ［ なし ］ - トレイ指定で用紙フィーダ選択コマンドが無視されます。 ［ 0 ～199 ］ - 数値を選択して、トレイ指定にユーザー定義値を割り当てます。 出荷時初期設定の表示 各給紙トレイに割り当てられている出荷時初期設定値を表示します。 標準設定に戻す トレイ番号変更の値を工場出荷状態に復元します。 印刷タイムアウト オフ オン ＊（90） 指定した時間アイドル状態が続いた場合に印刷ジョブを完了するようにプリンタを設定します。 メニュー PCL"},{"UUID":"57f69291-9c5c-41d5-ba3d-78f1ea1fe336","title":"印刷","link":"layout-topic.html","desc":"画像 ［画像］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"画像 ［画像］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 自動調整 オン オフ ＊ イメージで利用可能な最適な用紙サイズと向きの設定を選択します。 ［ オン ］に設定した場合、このメニュー項目では、イメージの拡大縮小と向きの設定は上書きされます。 反転 オフ ＊ オン モノクロ 2 階調のイメージを反転します。 このメニュー項目は、GIF または JPEG イメージ形式には適用されません。 倍率変更 自動調整 ＊ 左上隅に固定 中央に固定 高さ/幅に合わせる 高さに合わせる 幅に合わせる 印刷領域に合わせてイメージを調整します。 ［ 自動調整 ］を［ オン ］に設定すると、［ 倍率変更 ］は自動的に［ 自動調整 ］に設定されます。 原稿の向き 縦 ＊ 横 縦の反転 横の反転 ページに印刷される文字や画像の向きを指定します。 メニュー 画像"},{"UUID":"9c7dfa10-b951-4a4a-a1d2-5a71d90556de","title":"用紙","link":"tray-configuration-topic.html","desc":"トレイ設定 ［トレイ設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"トレイ設定 ［トレイ設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 標準設定給紙源 規定せず トレイ  [x]（1＊） 多目的フィーダ 手差し用紙 手差し封筒 すべての印刷ジョブの標準設定の給紙トレイを設定します。 用紙サイズ/タイプ トレイ  [x] 多目的フィーダ 手差し用紙 手差し封筒 サイズ タイプ 各給紙トレイにセットされている用紙サイズまたは用紙タイプを指定します。 代替サイズ 規定せず オフ ステートメント/A5 レター/A4 11 x 17/A3 上記のすべて ＊ 要求したサイズの用紙が給紙トレイにセットされていない場合に、指定のサイズの用紙を代替で使用するかどうかを設定します。 ［ オフ ］に設定すると、必要なサイズの用紙をセットするように画面に指示が表示されます。 ［ 上記のすべて ］に設定すると、使用可能なすべての代替サイズを使用できます。 MP を構成する 規定せず トレイ ＊ 手動 優先 多目的フィーダの動作を決定します。 ［ トレイ ］を選択すると、多目的フィーダが自動給紙トレイとして設定されます。 ［ 手差し ］を選択すると、多目的フィーダが手差しフィーダによる印刷ジョブ専用に設定されます。 ［ 優先 ］を選択すると、多目的フィーダが優先給紙トレイとして設定されます。 メニュー トレイ設定"},{"UUID":"10b7f37a-ea32-420c-9de8-402fa10b92ed","title":"用紙","link":"tray-configuration-topic.html","desc":"用紙構成 ［用紙構成］のメニュー項目とその説明 メニュー項目 サブメニュー項目 設定","descFull":"用紙構成 ［用紙構成］のメニュー項目とその説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 測定単位 規定せず インチ ミリメートル ユニバーサル用紙の長さの単位を指定します。 米国向けの工場出荷時設定は［ インチ ］になっています。［ ミリメートル ］がその他の国の出荷時初期設定です。 ユニバーサル設定 すべての給紙カセット 縦長の横の長さ ユニバーサル用紙の縦長の幅を設定します。 縦長の縦の長さ ユニバーサル用紙の縦長の高さを設定します。 用紙取込み方向 （短辺 *） プリンタで、短辺または長辺方向で用紙を選択するかどうかを設定します。 ［ 長辺 ］は、サポートされる最大幅よりも最大幅が短い場合にのみ表示されます。 カスタムスキャンサイズ スキャンサイズ名 この設定はユーザーが定義します。 カスタムスキャンに名前を割り当てます。 幅 1.–8.5 インチ （8.5*） 25–215.9 mm （215.9*） 原稿の幅を指定します。 高さ 1–25 インチ （11*） 25–635 mm （279.4*） 原稿の高さを指定します。 原稿の向き 縦 ＊ 横 原稿の内容の向きを指定します。 2 スキャン/面 オフ ＊ オン プリンタの各側の初期設定のスキャン数を設定します。 用紙のタイプ設定 ［用紙タイプのリスト］ 表面の粗さ 重さ 用紙のセット方向 トレイへ送信 用紙の表面の粗さ、重さ、向きを指定します。 メニュー 用紙構成"},{"UUID":"3c6e7d74-73d6-4fec-96c7-2f0417231973","title":"用紙","link":"tray-configuration-topic.html","desc":"排紙トレイ構成設定 ［排紙トレイ構成設定］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"排紙トレイ構成設定 ［排紙トレイ構成設定］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 排紙トレイ 標準排紙トレイ ＊ 排紙トレイ  [x] プリンタジョブの排紙トレイを指定します。 排紙トレイの設定 メールボックス * リンク リンクオプション タイプ割り当て 排紙トレイの動作モードを設定します。 ［ メールボックス ］に設定すると、標準排紙トレイとオプションの排紙トレイを個別に選択できます。 ［ リンク ］に設定すると、すべての排紙トレイを 1 つの大きな排紙トレイのようにリンクできます。 ［ リンクオプション ］に設定すると、すべてのオプションの排紙トレイを 1 つの大きな出力排紙トレイとして扱います。 ［ タイプ割り当て ］に設定すると、各用紙タイプを排紙トレイまたはリンクされた排紙トレイセットに割り当てます。 カスタム排紙トレイ名 標準排紙トレイ 排紙トレイ  [x] 各排紙トレイに名前を割り当てます。 メニュー 排紙トレイ構成設定"},{"UUID":"91b5ea2f-5f7d-4a0e-83ae-875147b601b0","title":"コピー","link":"copy-defaults-topic.html","desc":"コピー初期設定 ［コピー初期設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"コピー初期設定 ［コピー初期設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 コンテンツタイプ 規定せず テキスト テキスト/写真 ＊ 写真 グラフィックス 原稿の種類に基づいて、出力結果を向上させます。 コンテンツソース 規定せず モノクロレーザー カラーレーザー ＊ インクジェット 写真/フィルム 雑誌 新聞 出版物 その他 原稿の種類に基づいて、出力結果を向上させます。 印刷面 規定せず 片面->片面 ＊ 片面->両面 両面->片面 両面->両面 原稿に応じてスキャン動作を指定します。 挿入紙 規定せず なし * 各コピー部数の間 各ジョブの間 各ページの間 印刷時に空白の区切り紙を入れるかどうかを指定します。 挿入紙のトレイ指定 規定せず トレイ  [x]（1＊） 多目的フィーダ 挿入紙のトレイを指定します。 カラー 規定せず オフ オン * 自動 スキャンジョブからカラー出力を生成するようプリンタを設定します。 割り付けるページ数 規定せず オフ ＊ 縦 2 in 1 縦 4 in 1 横 2 in 1 横 4 in 1 1 枚の用紙の片面に印刷するページ数を指定します。 ページ枠を印刷 規定せず オフ ＊ オン 単一のページに複数のページを印刷する場合に、各イメージの周囲に枠線を配置します。 部単位 規定せず オフ［1,1,1,2,2,2］ オン［1,2,1,2,1,2］ ＊ 順番を維持して複数部を印刷します。 オフセットページ 規定せず なし * 各コピー部数の間 各ジョブの間 各印刷ジョブまたは印刷ジョブの各コピーの出力をオフセットします。 ［ 各コピー部数の間 ］では、［ 部単位 ］が［ オン［1,2,1,2,1,2］ ］に設定されている場合に、印刷ジョブのコピーごとにずらして排紙します。［ 部単位 ］が［ オフ「1,1,1,2,2,2」 ］に設定されている場合は、すべての 1 ページやすべての 2 ページなど、印刷ページセットがずらして排紙されます。 印刷する部数に関係なく、［ 各ジョブの間 ］は、印刷ジョブ全体で、同じオフセット位置です。 このメニュー項目は、オフセットスタッカ、ホチキス、穴パンチフィニッシャーが取り付けられている場合のみ表示されます。 ホチキス 規定せず オフ ＊ 1 ホチキス、左上隅 2 ホチキス、左 1 ホチキス、右上隅 2 ホチキス、上 1 ホチキス、左下隅 2 ホチキス、下 1 ホチキス、右下隅 2 ホチキス、右 ホチキス 4 個 すべての印刷ジョブのホチキスの位置を指定します。 このメニュー項目はホチキスフィニッシャーがある場合にのみ表示されます。 パンチ 規定せず オフ ＊ 2 穴 3 穴 4 穴 印刷出力のパンチ穴。 このメニュー項目は、ホチキス、穴パンチまたは冊子フィニッシャが取り付けられている場合のみ表示されます。 ［コピー元］のサイズ ［用紙サイズのリスト］ 原稿の用紙サイズを設定します。 米国向けの工場出荷時設定は［ レター ］になっています。その他の国の工場出荷時設定は［ A4 ］になっています。 ［コピー先］の給紙源 規定せず トレイ  [x]（1＊） 多目的フィーダ 自動サイズ調整 コピージョブの給紙源を指定します。 温度 規定せず ‑4 ～ 4 （0＊） 寒色の強い出力を生成するか暖色の強い出力を生成するかを指定します。 濃度 規定せず 1 ～ 9 （5＊） スキャンした画像の濃度を調整します。 コピー部数 規定せず 1 ～ 9999 （1＊） コピー部数を指定します。 ヘッダー/フッター 規定せず ヘッダー（左） ヘッダー（中央） ヘッダー（右） フッター（左） フッター（中央） フッター（右） スキャン画像のヘッダー/フッターの情報を指定します。 オーバーレイ 規定せず コンフィデンシャル コピー ドラフト ドラフト カスタム オフ ＊ コピージョブの各ページにオーバーレイ印刷する文字を指定します。 カスタムオーバーレイ 規定せず この設定はユーザーが定義します。 ［ オーバーレイ ］メニューで［ カスタム ］テキストを入力します。 イメージ詳細設定 カラーバランス シアン - 赤 （0＊） マゼンタ - 緑 （0＊） イエロー - 青 （0＊） シアン、マゼンタ、イエローのカラー濃度を調整します。 カラー削除 カラー削除 （ なし ＊） 赤色 初期しきい値 （128＊） 緑色 初期しきい値 （128＊） 青色 初期しきい値 （128＊） スキャン中にドロップアウトさせるカラーを指定し、そのカラーのドロップアウト設定を調整します。 自動カラー検出 カラー感度 （5＊） 判別範囲 （5＊） 自動カラー検出の設定を行います。 コントラスト 原稿内容に最適な設定 ＊ 0 ～ 5 スキャンした画像のコントラストを指定します。 下地調整 下地の検出 （ 自動 ＊） レベル （0＊） 原稿から背景色や画像ノイズを削除します。 ［ 自動 ］では、原稿から背景色を削除します。 ［ 固定 ］では、写真から画像ノイズを削除します。 ［ 自動中央揃え ］ オフ ＊ オン 原稿をページの中央に合わせます。 左右反転 オフ ＊ オン 原稿を左右反転した画像を作成します。 ネガイメージ オフ ＊ オン 原稿のネガイメージを作成します。 シャドウ描写 ‑4 ～ 4 （0＊） 原稿のシャドウ調整を行います。 端までスキャン オフ ＊ オン 原稿をすこし小さめ（全面）でスキャンします。 シャープネス 1 ～ 5 （3＊） スキャン画像のシャープネスを調整します。 管理者用設定 カラーコピーを許可 オフ オン * コピーをカラーで印刷します。 優先コピーを許可 オフ オン * 印刷ジョブに割り込んでコピーを行います。 カスタムジョブスキャン オフ ＊ オン プリンタで最初の原稿のセットをスキャンするための設定を指定して、同じ設定または異なる設定で次の原稿のセットのスキャンを行うようにします。 ショートカットとして保存を許可 オフ オン * コピー設定をショートカットとして保存します。 サンプルコピー オフ ＊ オン 残りのコピーを印刷する前に、品質を確認するためのサンプルコピーを印刷します。 メニュー コピー初期設定"},{"UUID":"c384d769-bd7a-413f-bec1-9e73c0099da9","title":"FAX 初期設定","link":"fax-defaults-subgroup.html","desc":"FAX モード ［ FAX モード","descFull":"FAX モード ［ FAX モード ］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 FAX モード Fax ＊ FAX サーバー 無効 FAX モードを選択します。 メニュー FAX モード"},{"UUID":"c4897de3-ebc9-4613-ad49-b7b90354e1f1","title":"FAX 初期設定","link":"fax-defaults-subgroup.html","desc":"FAX 設定 ［全般的な FAX 設定］のメニュー項目と説明","descFull":"FAX 設定 ［全般的な FAX 設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 全般的な FAX 設定 FAX 名 この設定はユーザーが定義します。 FAX ID を指定します。 FAX 番号 この設定はユーザーが定義します。 送信者の FAX 番号を指定します。 Fax ID FAX 名 FAX 番号 ＊ FAX ネゴシエーション中に使用する FAX ID を設定します。 手動 FAX を有効化 オフ ＊ オン プリンタの手動 FAX 機能をオンにします。 このメニュー項目には、電話回線スプリッタと電話の受話器が必要となります。 FAX 着信への応答、および FAX 番号のダイヤルは、通常の電話回線で行います。 手動 FAX 機能に直接移動するには、キーパッドで  #  と  0  をタッチします。 メモリ使用 すべて受信 ほとんど受信 均等 * ほとんど送信 すべて送信 FAX 送受信用に割り当てられる内蔵プリンタメモリの容量を設定します。 このメニュー項目により、メモリバッファー状態や FAX の失敗を防ぎます。 FAX のキャンセル 許可する ＊ 許可しない 送信 FAX または受信 FAX をキャンセルします。 FAX 番号のマスキング オフ ＊ 左から 右から 送信 FAX 番号をマスキングする形式を指定します。 全般的な FAX 設定 マスキングする桁数 0 ～ 58 （0＊） 送信 FAX 番号をマスキングする桁数を指定します。 回線接続状況の検出を有効化 オフ オン * 電話回線がプリンタに接続されているかどうかを確認します。 イベントはすぐに検出されます。 間違ったジャックの回線の検出を有効化 オフ オン * 電話回線がプリンタの正しいポートに接続されているかどうかを確認します。 イベントはすぐに検出されます。 使用されている内線番号のサポートを有効化 オフ オン * 同じ電話回線が別の電話など他のデバイスで使用されているかどうかを確認します。 イベントはすぐに検出されます。 FAX 適合性を最適化 この設定はユーザーが定義します。 他の FAX 機との互換性を最適化するために、プリンタの FAX 機能を設定します。 FAX 転送 T.38 アナログ G.711 etherFAX FAX の転送方式を設定します。 このメニュー項目は、etherFAX または Fax over IP（FoIP）ライセンスバンドルがプリンタにインストールされている場合にのみ表示されます。 HTTPS FAX 設定 このメニューは、［ FAX 転送 ］が［ etherFAX ］に設定されている場合にのみ表示されます。 HTTPS サービス URL この設定はユーザーが定義します。 etherFAX サービス URL を指定します。 HTTPS プロキシ この設定はユーザーが定義します。 プロキシサーバーの URL を指定します。 HTTPS プロキシユーザー この設定はユーザーが定義します。 プロキシサーバーのユーザー名とパスワードを指定します。 HTTPS プロキシパスワード FAX 送信の暗号化 無効 有効 * 必須 送信 FAX メッセージの暗号化を有効にします。 FAX 受信の暗号化 無効 有効 * 必須 受信 FAX メッセージの暗号化を有効にします。 HTTPS FAX 状態 この設定は読み取り専用の情報です。 etherFAX の通信状況を表示します。 FAX 送信設定 解像度 標準 ＊ ファイン スーパーファイン ウルトラファイン スキャンした画像の解像度を設定します。 解像度を高くするほど FAX 送信にかかる時間が長くなり、多くのメモリが必要になります。 原稿サイズ ［用紙サイズのリスト］（ 大きさ混在 ＊） 原稿のサイズを指定します。 原稿の向き 縦 ＊ 横 原稿の向きを指定します。 印刷面 オフ ＊ 短辺 長辺 原稿の両面をスキャンする場合に、原稿の向きを指定します。 コンテンツタイプ 文字 ＊ テキスト/写真 写真 グラフィックス 原稿の種類に基づいて、出力結果を向上させます。 コンテンツソース モノクロレーザー カラーレーザー ＊ インクジェット 写真/フィルム 雑誌 新聞 出版物 その他 原稿の種類に基づいて、出力結果を向上させます。 濃度 1 ～ 9 （5＊） スキャンした画像の濃度を調整します。 PABX 経由 オン オフ ＊ プリンタで、ダイヤルトーンを待機することなく FAX 番号をダイヤルするかどうかを設定します。 構内自動交換機（PABX）は、単一のアクセス番号で外部発信者に複数の回線を提供できる電話網です。 ダイヤルモード トーン ＊ パルス 送信 FAX または受信 FAX のダイヤルモードを指定します。 イメージ詳細設定 カラーバランス シアン - 赤 （0＊） マゼンタ - 緑 （0＊） イエロー - 青 （0＊） スキャン中のカラーの彩度を調整します。 カラー削除 原稿内容に最適な設定 ＊ 0 1 2 3 4 5 出力のコントラストを設定します。 左右反転 オフ ＊ オン 原稿を左右反転した画像を作成します。 シャドウ描写 ‑4 ～ 4 （0＊） スキャン画像におけるシャドウ部の濃さを調節します。 端までスキャン オフ オン * 原稿を端から端までスキャンします。 シャープネス 1 ～ 5 （3＊） スキャン画像のシャープネスを調整します。 温度 ‑4 ～ 4 （0＊） 寒色の強い出力を生成するか暖色の強い出力を生成するかを指定します。 管理者用設定 自動リダイヤル 0 ～ 9 （5＊） プリンタが指定した宛先への FAX 送信をキャンセルするまでにリダイヤルする試行回数を指定します。 リダイヤル間隔 1 ～ 200  分（3＊） FAX が正常に送信される確率を高めるために、リダイヤル再試行までの間隔を長くします。 ECM を有効化 オン * オフ FAX ジョブのエラー修正モード（ECM）を有効にします。 FAX 送信処理において、電話回線ノイズや信号強度劣化により発生したエラーを ECM が検出して修正します。 FAX スキャンを有効化 オン * オフ プリンタスキャナを使用して FAX を作成します。 ドライバによる FAX オン * オフ プリンタドライバによる FAX 送信を許可します。 ショートカットとして保存を許可 オン * オフ FAX 番号をショートカットとしてプリンタに保存します。 最高速度 33600 ＊ 14400 9600 4800 2400 FAX 送信の最大速度を設定します。 カスタムジョブスキャン オフ ＊ オン 初期設定でカスタムジョブのスキャンをオンにします。 スキャンプレビュー オフ ＊ オン ディスプレイにスキャンのプレビューを表示します。 ADF の傾きを調整 オフ オン * スキャンした画像の傾きを微調整します。 カラー FAX スキャンを有効化 初期設定でオフ ＊ 初期設定でオン 使用しない 常に使用 FAX のカラースキャンを有効にします。 カラー FAX からモノクロ FAX への自動変換 オン * オフ カラーの送信 FAX をすべて白黒に変換します。 FAX 番号を確認 オフ ＊ オン ユーザーに FAX 番号の確認を求めます。 ダイヤルプレフィックス この設定はユーザーが定義します。 ダイヤルプレフィックスを設定します。 外線発信番号ルール この設定はユーザーが定義します。 外線発信番号ルールを設定します。 FAX 受信設定 待機中の FAX ジョブ なし * トナー トナーと消耗品 利用できない特定のリソースを要求する FAX ジョブを印刷キューから削除します。 呼び出し回数 1 ～ 25 （3＊） プリンタが着信に応答するまでに必要な着信音の回数を設定します。 自動縮小 オン * オフ ページに合わせて受信 FAX を縮小します。 給紙源 トレイ  [x] 自動 ＊ 受信 FAX を印刷する際の給紙源を設定します。 印刷面 オン オフ ＊ 用紙の両面に印刷します。 挿入紙 なし * ジョブ前 ジョブ後 印刷時に空白の区切り紙を入れるかどうかを指定します。 挿入紙のトレイ指定 トレイ  [x]（1＊） 挿入紙のトレイを指定します。 排紙トレイ 標準排紙トレイ 受信 FAX の排紙トレイを指定します。 FAX フッター オン オフ ＊ 受信 FAX の各ページの下に、送信情報を印刷します。 FAX フッタータイムスタンプ 受信 ＊ 印刷 受信 FAX の各ページの下に、タイムスタンプを印刷します。 FAX の保留 FAX 保留モード （オフ＊） 受信 FAX がリリースされるまで印刷を保留します。 FAX の保留スケジュール FAX を保留するスケジュールを割り当てます。 このメニュー項目は、［ FAX 保留モード ］が［ 予約 ］に設定されている場合にのみ表示されます。 管理者用設定 FAX 受信を有効化 オン * オフ FAX を受信するようにプリンタを設定します。 カラー FAX 受信を有効化 オン * オフ FAX をカラーで受信するようにプリンタを設定します。 発信者 ID 表示を有効化 オン オフ ＊ プリンタのディスプレイに着信の発信者 ID 情報を表示します。 無記名の FAX をブロック オン オフ ＊ FAX ID のない着信 FAX をブロックします。 禁止された FAX 一覧 禁止された FAX を追加 ブロックする電話番号を指定します。 応答設定 すべて ＊ 着信音 1 回のみ 着信音 2 回のみ 着信音 3 回のみ 着信音 1 回または 2 回のみ 着信音 1 回または 3 回のみ 着信音 2 回または 3 回のみ 受信 FAX 専用の着信音パターンを設定します。 自動応答 オン * オフ FAX を自動で受信するようにプリンタを設定します。 手動応答コード 0 ～ 9 （9＊） 電話番号パッドでコードを手動で入力して、FAX 受信を開始します。 このメニュー項目は、プリンタと電話が同じ回線を共有している場合にのみ表示されます。 このメニュー項目は、FAX を手動で受信するようにプリンタを設定している場合にのみ表示されます。 FAX 転送 印刷 ＊ 印刷して転送 転送 受信 FAX を転送するかどうかを指定します。 転送先 宛先 1 宛先 2 受信 FAX の転送先を指定します。 このメニュー項目は、［ FAX 転送 ］が［ 印刷して転送 ］または［ 転送 ］に設定されている場合にのみ表示されます。 最高速度 33600 ＊ 14400 9600 4800 2400 FAX を送信する最大速度を設定します。 FAX 送付状ページ FAX 送付状ページ 初期設定でオフ ＊ 初期設定でオン 使用しない 常に使用 FAX 送付状ページの設定を構成します。 宛先を含める オフ ＊ オン 送信者を含める オフ ＊ オン 送信元 この設定はユーザーが定義します。 本文を含める オフ ＊ オン 本文： この設定はユーザーが定義します。 ロゴを含む オフ ＊ オン フッターを含める［x］ オフ ＊ オン フッター［x］ この設定はユーザーが定義します。 FAX ログ設定 送信ログ頻度 常に ＊ 作成しない エラー時のみ プリンタで送信ログを作成する頻度を指定します。 送信ログ操作 印刷 （ オン ＊） E メール （ オフ ＊） FAX の正常送信や送信エラーのログを印刷するか、または E メールで送信します。 受信エラーログ 印刷しない ＊ エラー時に印刷 FAX 受信障害のログを印刷します。 ログの自動印刷 オン * オフ すべての FAX アクティビティを印刷します。 ログの給紙源 トレイ  [x]（1＊） ログを印刷する際の給紙源を指定します。 ログ表示 リモート FAX 名 ＊ ダイヤルした番号 リモート FAX 名または FAX 番号で送信者を特定します。 ジョブログを有効化 オン * オフ すべての FAX ジョブの概要を表示します。 通信ログを有効化 オン * オフ FAX 通信の履歴の概要を表示します。 ログ排出トレイ 標準排紙トレイ ＊ 排紙トレイ  [x] 印刷したログの排紙トレイを指定します。 スピーカー設定 スピーカーモード 常にオフ ＊ 常にオン 接続されるまでオン FAX のスピーカーモードを設定します。 スピーカー音量 小 ＊ 大 FAX のスピーカー音量を調整します。 着信音量 オフ ＊ オン 着信音量を有効にします。 VoIP 設定 VoIP プロトコル SIP ＊ H.323 Voice over Internet Protocol（VoIP）プロトコルを設定します。 STUN サーバー この設定はユーザーが定義します。 ファイアウォールを通過する STUN サーバーを指定します。 強制 FAX モード オフ オン * FAX 通信の開始時に VoIP ゲートウェイをアナログから T.38 に切り替えます。 FAX モードの遅延を強制 0 ～ 15 （7＊） ［ 強制 FAX モード ］の別の招待を送信するときの遅延時間を秒単位で設定します。 SIP 設定 プロキシ この設定はユーザーが定義します。 電話番号を FAX 送信先の IP アドレスに変換するシステムの IP アドレスを指定します。 登録 この設定はユーザーが定義します。 Session Initiation Protocol（SIP）クライアントの登録を処理するシステムの名前または IP アドレスを指定します。 ユーザー この設定はユーザーが定義します。 SIP のユーザー名を指定します。 パスワード この設定はユーザーが定義します。 SIP レジストラへの登録に使用するパスワードを指定します。 認証 ID この設定はユーザーが定義します。 登録時に使用されるユーザー名。 Auth ID  設定が設定されていない場合は、代わりに［ユーザー］フィールドのユーザー名が使用されます。 登録の転送 UDP ＊ TCP 登録の SIP 転送タイプを設定します。 着信の転送 UDP ＊ TCP UDP と TCP 着信の SIP 転送タイプを設定します。 発信の転送 UDP ＊ TCP 発信の SIP 転送タイプを設定します。 外部プロキシ この設定はユーザーが定義します。 すべての SIP 通信を転送する外部プロキシを指定します。 担当者 この設定はユーザーが定義します。 SIP の担当者名を指定します。 レルム この設定はユーザーが定義します。 SIP のレルム名を指定します。 レルム設定が設定されていない場合は、代わりに［ 担当者 ］の名前が使用されます。 SIP 登録状況 この設定は読み取り専用の情報です。 SIP 登録の状態を示します。 H.323 設定 ゲートウェイ この設定はユーザーが定義します。 H.323 ゲートウェイの IP アドレスを指定します。 ゲートキーパー この設定はユーザーが定義します。 H.323 ゲートキーパーを指定します。 ユーザー この設定はユーザーが定義します。 H.323 ゲートウェイで使用するユーザー名を指定します。 パスワード この設定はユーザーが定義します。 H.323 ゲートウェイのパスワードを指定します。 Fast Start を有効化 オフ ＊ オン Fast Start を有効化します。 H.245 トンネリングを無効化 オフ ＊ オン H.323 トンネリングを無効化します。 ゲートキーパー検出を無効化 オフ オン * H.323 ゲートキーパー検出を無効化します。 T.38 設定 インジケータの冗長性 0 ～ 5 （3＊） T.38 通信で FAX インジケータが再送される回数を設定します。 低速の冗長性 0 ～ 5 （3＊） T.38 通信で低速データが再送される回数を設定します。 高速の冗長性 0 ～ 5 （1＊） T.38 通信で高速データが再送される回数を設定します。 メニュー FAX 設定"},{"UUID":"d93f30cc-231a-40bf-b831-638f4ba0abac","title":"FAX 初期設定","link":"fax-defaults-subgroup.html","desc":"FAX サーバー設定 全般的な FAX 設定","descFull":"FAX サーバー設定 全般的な FAX 設定 ［全般的な FAX 設定］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 送信先形式 規定せず FAX 送信先を指定します。 FAX 番号を使用する場合は、番号の前にシャープ（#）を入力します。 返信アドレス 規定せず FAX を送信するための返信アドレスを指定します。 件名 規定せず FAX の件名とメッセージを指定します。 メッセージ 規定せず アナログ受信を有効化 オフ ＊ オン アナログ FAX を受信するようにプリンタを設定します。 FAX サーバー E メール設定 ［ FAX サーバー E メール設定 ］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 E メール SMTP サーバーを使用 オン オフ ＊ FAX の送受信では、E メールの簡易メール転送プロトコル（SMTP）を使用します。 ［ オン ］に設定すると、［ FAX サーバー E メール設定 ］メニューの他の設定は表示されません。 プライマリ SMTP ゲートウェイ 規定せず プライマリ SMTP サーバーの IP アドレスまたはホスト名を入力します。 プライマリ SMTP ゲートウェイポート 1 ～ 65535（25＊） プライマリ SMTP サーバーのポート番号を入力します。 セカンダリ SMTP ゲートウェイ 規定せず セカンダリまたはバックアップ SMTP サーバーのサーバー IP アドレスまたはホスト名を入力します。 セカンダリ SMTP ゲートウェイポート 1 ～ 65535（25＊） セカンダリまたはバックアップ SMTP サーバーのサーバーポート番号を入力します。 SMTP タイムアウト 5 ～ 30（30＊） SMTP サーバーが応答しない場合にプリンタがタイムアウトするまでの時間を指定します。 返信アドレス 規定せず FAX を送信するための返信アドレスを指定します。 SSL/TLS を使用 無効 ＊ ネゴシエーション 必須 暗号化されたリンクを使用して aFAX を送信するかどうかを指定します。 信頼済み証明書を要求 オフ オン * SMTP サーバーにアクセスする際の信頼済み証明書を指定します。 SMTP サーバー認証 認証不要 ＊ ログイン/プレーンテキスト NTLM CRAM‑MD5 Digest-MD5 Kerberos 5 SMTP サーバーの認証タイプを設定します。 デバイスから送信される E メール なし * デバイスの SMTP 証明書を使用 デバイスから送信される E メールに資格情報が必要かどうかを指定します。 ユーザーから送信される E メール なし * デバイスの SMTP 証明書を使用 ログインしているユーザー ID とパスワードを使用 セッション E メールアドレスとパスワードを使用 ユーザーに確認 ユーザーから送信される E メールに資格情報が必要かどうかを指定します。 Active Directory デバイス資格証明書を使用 オフ ＊ オン SMTP サーバーに接続するために、ユーザー資格情報とグループ送信先を有効にします。 デバイスのユーザー ID 規定せず SMTP サーバーに接続する際のユーザー ID とパスワードを指定します。 デバイスのパスワード 規定せず Kerberos 5 レルム 規定せず Kerberos 5 認証プロトコルのレルムを指定します。 NTLM ドメイン 規定せず NTLM セキュリティプロトコルのドメイン名を指定します。 ［SMTP サーバーが設定されていません］のエラーを無効にする オフ ＊ オン ［SMTP サーバーが設定されていません］エラーメッセージを非表示にします。 FAX サーバースキャン設定 ［ FAX サーバースキャン設定 ］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 イメージ形式 TIFF（.tif） PDF（.pdf） ＊ XPS（.xps） TXT（.txt） RTF（.rtf） DOCX（.docx） XLSX（.xlsx） CSV（.csv） スキャン画像のファイル形式を指定します。 コンテンツタイプ 文字 ＊ テキスト/写真 写真 グラフィックス 原稿の種類に基づいて、出力結果を向上させます。 コンテンツソース モノクロレーザー カラーレーザー ＊ インクジェット 写真/フィルム 雑誌 新聞 出版物 その他 原稿の種類に基づいて、出力結果を向上させます。 FAX 解像度 標準 ＊ ファイン スーパーファイン ウルトラファイン FAX の解像度を設定します。 印刷面 オフ ＊ 短辺 長辺 原稿の両面をスキャンする場合に、原稿の向きを指定します。 濃度 1 ～ 9（5＊） 出力の濃さを設定します。 原稿の向き 縦 ＊ 横 ページに印刷される文字や画像の向きを指定します。 原稿サイズ ［用紙サイズのリスト］ 原稿の用紙サイズを設定します。 米国の出荷時初期設定は［ 大きさ混在 ］です。その他の国の工場出荷時設定は［ A4 ］になっています。 この設定は、お使いのプリンタ機種によって異なります。 複数ページ TIFF を使用 オフ オン * 単一ページ TIFF ファイルと複数ページ TIFF ファイルのどちらを使用するかを選択します。 メニュー FAX サーバー設定"},{"UUID":"c83618e1-2708-440c-9afa-7896ee522def","title":"E メール","link":"email-setup-topic.html","desc":"E メール設定 ［E メール設定］のメニュー項目と説明 メニュー項目","descFull":"E メール設定 ［E メール設定］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 プライマリ SMTP ゲートウェイ この設定はユーザーが定義します。 E メール送信に使用するプライマリ SMTP サーバーの IP アドレスまたはホスト名を入力します。 プライマリ SMTP ゲートウェイポート 1 ～ 65535 （25＊） プライマリ SMTP サーバーのポート番号を入力します。 セカンダリ SMTP ゲートウェイ この設定はユーザーが定義します。 セカンダリまたはバックアップ SMTP サーバーのサーバー IP アドレスまたはホスト名を入力します。 セカンダリ SMTP ゲートウェイポート 1 ～ 65535 （25＊） セカンダリまたはバックアップ SMTP サーバーのサーバーポート番号を入力します。 SMTP タイムアウト 5 ～ 30 秒 （30＊） SMTP サーバーが応答しない場合にプリンタがタイムアウトするまでの時間を指定します。 返信アドレス この設定はユーザーが定義します。 E メールの返信アドレスを指定します。 SMTP の初期設定返信アドレスを常に使用 オン オフ ＊ SMTP サーバーの初期設定返信アドレスを常に使用します。 SSL/TLS を使用 無効 ＊ ネゴシエーション 必須 暗号化されたリンクを使用して E メール送信するかどうかを指定します。 信頼済み証明書を要求 オフ オン * SMTP サーバーにアクセスする際に、信頼済み証明書が必要となります。 SMTP サーバー認証 認証不要 ＊ ログイン/プレーンテキスト NTLM CRAM‑MD5 Digest-MD5 Kerberos 5 SMTP サーバーの認証タイプを設定します。 デバイスから送信される E メール なし * なし * デバイスの SMTP 証明書を使用 デバイスから送信される E メールに資格情報が必要かどうかを指定します。 ユーザーから送信される E メール なし * デバイスの SMTP 証明書を使用 ログインしているユーザー ID とパスワードを使用 セッション E メールアドレスとパスワードを使用 ユーザーに確認 ユーザーから送信される E メールに資格情報が必要かどうかを指定します。 Active Directory デバイス資格証明書を使用 オフ ＊ オン ユーザーから送信される E メールに資格情報が必要かどうかを指定します。 デバイスのユーザー ID この設定はユーザーが定義します。 SMTP サーバーに接続する際のユーザー ID とパスワードを指定します。 デバイスのパスワード この設定はユーザーが定義します。 Kerberos 5 レルム この設定はユーザーが定義します。 Kerberos 5 認証プロトコルのレルムを指定します。 NTLM ドメイン この設定はユーザーが定義します。 NTLM セキュリティプロトコルのドメイン名を指定します。 ［SMTP サーバーが設定されていません］のエラーを無効にする オフ ＊ オン ［SMTP サーバーが設定されていません］エラーメッセージを非表示にします。 メニュー E メール設定"},{"UUID":"f6ec3cda-2b3b-4e37-a352-e72717338c42","title":"E メール","link":"email-setup-topic.html","desc":"E メール初期設定 ［E メール初期設定］のメニュー項目と説明 メニュー項目","descFull":"E メール初期設定 ［E メール初期設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 件名： 規定せず この設定はユーザーが定義します。 E メールの件名とメッセージを指定します。 本文： 規定せず この設定はユーザーが定義します。 ファイル名 規定せず この設定はユーザーが定義します。 スキャンしたドキュメントのファイル名を指定します。 形式 規定せず JPEG（.jpg） PDF（.pdf） ＊ TIFF（.tif） XPS（.xps） TXT（.txt） RTF（.rtf） DOCX（.docx） CSV（.csv） スキャンしたドキュメントのファイル形式を指定します。 メニュー項目は、お使いのプリンタ機種によって異なります。 グローバル OCR 設定 認識済み言語 ［言語の一覧］ 光学式文字認識（OCR）の設定を行います。 このメニュー項目は、OCR ソリューションを購入してインストールしている場合にのみ表示されます。 自動回転 オフ ＊ オン しみ除去 オフ ＊ オン 自動コントラスト補正 オフ ＊ オン PDF 設定 PDF バージョン 1.3 1.4 1.5 ＊ 1.6 1.7 スキャン画像の PDF 設定を行います。 ［ PDF バージョン ］が 1.4 または 1.7 に設定されている場合にのみ、［ アーカイブバージョン ］および［ アーカイブ（PDF/A） ］がサポートされます。 ［ 高圧縮 ］は、ストレージドライブが取り付けられている場合にのみ表示されます。 ［ 保護 ］は、 ［ PDF バージョン ］が 1.4 以降に設定されている場合にのみサポートされます。 アーカイブ（PDF/A） オフ ＊ オン アーカイブバージョン A‑1a ＊ A-1b A‑2u 高圧縮 オフ ＊ オン セキュア オフ ＊ オン 検索可能 オフ ＊ オン ジョブをページで分割 0 ＊ コンテンツタイプ 規定せず テキスト テキスト/写真 ＊ 写真 グラフィックス 原稿の内容を指定します。 コンテンツソース 規定せず モノクロレーザー ＊ カラーレーザー インクジェット 写真/フィルム 雑誌 新聞 出版物 その他 原稿の場所を指定します。 カラー 規定せず モノクロ グレー カラー ＊ 自動 原稿の取り込み方法を指定します。 解像度 規定せず 75 dpi 150 dpi ＊ 200 dpi 300 dpi 400 dpi 600 dpi スキャンした画像の解像度を設定します。 濃度 規定せず 1 ～ 9 （5＊） スキャンした画像の濃度を調整します。 原稿の向き 規定せず 縦 ＊ 横 原稿の向きを指定します。 原稿サイズ 規定せず 大きさ混在 原稿の用紙サイズを設定します。 印刷面 規定せず オフ ＊ 短辺 長辺 原稿の両面をスキャンする場合に、原稿の向きを指定します。 イメージ詳細設定 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 カラーバランス シアン マゼンタ イエロー ‑4 ～ 4 （0＊） ‑4 ～ 4 （0＊） ‑4 ～ 4 （0＊） シアン、マゼンタ、イエローのカラー濃度を調整します。 カラー削除 カラー削除 なし * 赤 緑 青 スキャン中にドロップアウトさせるカラーを指定し、そのカラーのドロップアウト設定を調整します。 赤色 標準しきい値 0 ～ 255 （128＊） 緑色 標準しきい値 0 ～ 255 （128＊） 青色 標準しきい値 0 ～ 255 （128＊） 自動カラー検出 カラー感度 1 ～ 9 （5＊） 自動カラー検出の設定を行います。 判別範囲 1 ～ 9 （5＊） E メールビット深度 1 ビット ＊ 8 ビット 最小スキャン解像度 75 dpi 150 dpi 200 dpi 300 dpi ＊ JPEG 品質 規定せず 原稿内容に最適な設定 ＊ 5 ～ 95 スキャンした画像の JPEG 品質を設定します。 コントラスト 規定せず 原稿内容に最適な設定 ＊ 0 ～ 5 スキャンした画像のコントラストを指定します。 下地調整 下地の検出 自動 ＊ 固定 レベル  ‑4 ～ 4 （0＊） 原稿から背景色や画像ノイズを削除します。 左右反転 規定せず オフ ＊ オン 原稿を左右反転した画像を作成します。 ネガイメージ 規定せず オフ ＊ オン 原稿のネガイメージを作成します。 シャドウ描写 規定せず ‑4 ～ 4 （0＊） スキャンした画像のシャドウ調整を行います。 端までスキャン 規定せず オフ ＊ オン 原稿をすこし小さめ（全面）でスキャンします。 シャープネス 規定せず 1 ～ 5 （3＊） スキャンした画像のシャープネスを調整します。 温度 規定せず ‑4 ～ 4 （0＊） 原稿から青みの強い出力または赤みの強い出力を生成します。 空白ページ 空白ページの削除 削除しない ＊ 削除 空白ページを原稿から削除します。 空白ページの感度 1 ～ 9 （5＊） 原稿の空白ページに対するスキャンの相対感度を設定します。 管理者用設定 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 E メールの最大サイズ 0 ～ 65535 （0＊） 各 E メールのファイルサイズの上限を設定します。 サイズのエラーメッセージ この設定はユーザーが定義します。 E メールがファイルサイズの上限を超えた場合にプリンタから送信されるエラーメッセージを指定します。 1,024 文字以下で入力します。 送信先を制限 この設定はユーザーが定義します。 指定されたリストにあるドメイン名にのみ E メールを送信できるように制限します。 カンマを使用して、各ドメインを区切ります。 自分にコピーを送信 表示しない ＊ 初期設定でオン 初期設定でオフ 常にオン 自分自身に E メールのコピーを送信します。 自分の E メールのみを許可 オフ ＊ オン 自分にのみ E メールを送信するようにプリンタを設定します。 cc:/bcc: を使用 オフ ＊ オン E メールの CC および BCC を有効にします。 複数ページ TIFF を使用 オフ ＊ オン 複数の TIFF 画像 から 1 つの TIFF ファイルへのスキャンを有効にします。 TIFF 圧縮 JPEG LZW ＊ TIFF ファイルの圧縮タイプを指定します。 文字の画質設定 5 ～ 95 （75＊） スキャンする原稿の文字品質を設定します。 文字/写真標準設定 5 ～ 95 （75＊） スキャンする原稿の文字と写真の品質を設定します。 写真の画質設定 5 ～ 95 （50＊） スキャンする原稿の写真の品質を設定します。 ADF の傾きを調整 オフ ＊ オン ADF からドキュメントをスキャンして傾いた画像を調整するようにプリンタを設定します。 送信ログ ログを印刷 ＊ ログを印刷しない エラー時のみ印刷 E メールスキャンの送信ログを印刷します。 ログの給紙源 トレイ  [x]（1＊） 多目的フィーダ ログを印刷する際の給紙源を指定します。 カスタムジョブスキャン オフ ＊ オン プリンタで最初の原稿のセットをスキャンするための設定を指定して、同じ設定または異なる設定で次の原稿のセットのスキャンを行うようにします。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 スキャンプレビュー オフ オン * 原稿のスキャンのプレビューを表示します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ショートカットとして保存を許可 オフ オン * E メールアドレスをショートカットとして保存します。 E メールによる画像送信方法 添付ファイル ＊ Web リンク E メールに含まれる画像の送信方法を指定します。 送信後に E メール情報をリセットする オフ オン * E メールを送信した後に、［宛先］、［件名］、［メッセージ］、［ファイル名］フィールドを初期値にリセットします。 メニュー E メール初期設定"},{"UUID":"9333f1e6-8e0f-4587-9424-975943a65eb6","title":"E メール","link":"email-setup-topic.html","desc":"Web リンク設定 ［Web リンク設定］のメニュー項目と説明 メニュー項目","descFull":"Web リンク設定 ［Web リンク設定］のメニュー項目と説明 メニュー項目 設定 説明 サーバー この設定はユーザーが定義します。 E メールに含まれる画像をホストしているサーバーの資格情報を指定します。 ログイン この設定はユーザーが定義します。 パスワード この設定はユーザーが定義します。 パス この設定はユーザーが定義します。 ファイル名 この設定はユーザーが定義します。 Web リンク この設定はユーザーが定義します。 メニュー Web リンク設定"},{"UUID":"a99848de-842b-4dbd-a8f7-0db628eb4412","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP 初期値設定 ［FTP 初期値設定］のメニュー項目と説明 メニュー項目","descFull":"FTP 初期値設定 ［FTP 初期値設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 形式 規定せず JPEG（.jpg） PDF（.pdf） ＊ TIFF（.tif） XPS（.xps） TXT（.txt） RTF（.rtf） DOCX（.docx） CSV（.csv） スキャン画像のファイル形式を指定します。 グローバル OCR 設定 認識済み言語 ［言語の一覧］ 光学式文字認識（OCR）の設定を行います。 このメニューは、OCR ソリューションを購入してインストールしている場合のみ表示されます。 自動回転 オフ ＊ オン しみ除去 オフ ＊ オン 自動コントラスト補正 オフ ＊ オン PDF 設定 PDF バージョン 1.3 1.4 1.5 ＊ 1.6 1.7 スキャン画像の PDF 設定を行います。 ［ PDF バージョン ］が 1.4 または 1.7 に設定されている場合にのみ、［ アーカイブバージョン ］および［ アーカイブ（PDF/A） ］がサポートされます。 ［ 高圧縮 ］は、ストレージドライブが取り付けられている場合にのみ表示されます。 ［ 保護 ］は、 ［ PDF バージョン ］が 1.4 以降に設定されている場合にのみサポートされます。 アーカイブ（PDF/A） オフ ＊ オン アーカイブバージョン A‑1a ＊ A-1b A‑2u 高圧縮 オフ ＊ オン セキュア オフ ＊ オン 検索可能 オフ ＊ オン ジョブをページで分割 0 ＊ コンテンツタイプ 規定せず テキスト テキスト/写真 ＊ グラフィックス 写真 原稿の種類に基づいて、出力結果を向上させます。 コンテンツソース 規定せず モノクロレーザー カラーレーザー ＊ インクジェット 写真/フィルム 雑誌 新聞 出版物 その他 原稿の種類に基づいて、出力結果を向上させます。 カラー 規定せず モノクロ グレー カラー ＊ 自動 原稿をカラーまたはモノクロでキャプチャするようにプリンタを設定します。 解像度 規定せず 75 dpi 150 dpi ＊ 200 dpi 300 dpi 400 dpi 600 dpi スキャンした画像の解像度を設定します。 濃度 規定せず 1 ～ 9 （5＊） スキャンした画像の濃度を調整します。 原稿の向き 規定せず 縦 ＊ 横 原稿の向きを指定します。 原稿サイズ 規定せず 大きさ混在 ＊ 原稿の用紙サイズを設定します。 印刷面 規定せず オフ ＊ 長辺 短辺 原稿の両面をスキャンするときに、原稿の向きを指定します。 ファイル名 規定せず この設定はユーザーが定義します。 スキャン画像のファイル名を指定します。 イメージ詳細設定 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 カラーバランス シアン マゼンタ イエロー ‑4 ～ 4 （0＊） ‑4 ～ 4 （0＊） ‑4 ～ 4 （0＊） シアン、マゼンタ、イエローのカラー濃度を調整します。 カラー削除 カラー削除 なし * 赤 緑 青 スキャン中にドロップアウトさせるカラーを指定し、そのカラーのドロップアウト設定を調整します。 赤色 標準しきい値 0 ～ 255 （128＊） 緑色 標準しきい値 0 ～ 255 （128＊） 青色 標準しきい値 0 ～ 255 （128＊） 自動カラー検出 カラー感度 1 ～ 9 （5＊） 自動カラー検出の設定を行います。 判別範囲 1 ～ 9 （5＊） E メールビット深度 1 ビット ＊ 8 ビット 最小スキャン解像度 75 dpi 150 dpi 200 dpi 300 dpi ＊ JPEG 品質 規定せず 原稿内容に最適な設定 ＊ 5 ～ 95 スキャンした画像の JPEG 品質を設定します。 コントラスト 規定せず 原稿内容に最適な設定 ＊ 0 ～ 5 スキャンした画像のコントラストを指定します。 下地調整 下地の検出 自動 ＊ 固定 レベル  ‑4 ～ 4 （0＊） 原稿から背景色や画像ノイズを削除します。 左右反転 規定せず オフ ＊ オン 原稿を左右反転した画像を作成します。 ネガイメージ 規定せず オフ ＊ オン 原稿のネガイメージを作成します。 シャドウ描写 規定せず ‑4 ～ 4 （0＊） スキャンした画像のシャドウ調整を行います。 端までスキャン 規定せず オフ ＊ オン 原稿をすこし小さめ（全面）でスキャンします。 シャープネス 規定せず 1 ～ 5 （3＊） スキャンした画像のシャープネスを調整します。 温度 規定せず ‑4 ～ 4 （0＊） 原稿から青みの強い出力または赤みの強い出力を生成します。 空白ページ 空白ページの削除 削除しない ＊ 削除 空白ページを原稿から削除します。 空白ページの感度 1 ～ 9 （5＊） 原稿の空白ページに対するスキャンの相対感度を設定します。 管理者用設定 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 文字の画質設定 5 ～ 95 （75＊） スキャンした画像の文字の品質を設定します。 文字/写真標準設定 5 ～ 95 （75＊） スキャンした画像の文字と写真の品質を設定します。 写真の画質設定 5 ～ 95 （50＊） スキャン画像の写真の品質を設定します。 複数ページ TIFF を使用 オン * オフ 複数の TIFF 画像 から 1 つの TIFF ファイルへのスキャンを有効にします。 TIFF 圧縮 LZW ＊ JPEG TIFF ファイルの圧縮タイプを指定します。 送信ログ ログを印刷 ＊ ログを印刷しない エラー時のみ印刷 FTP スキャンの送信ログを印刷します。 ログの給紙源 トレイ  [x]（1＊） 多目的フィーダ FTP ログを印刷する際の給紙トレイを指定します。 カスタムジョブスキャン オフ ＊ オン プリンタで最初の原稿のセットをスキャンするための設定を指定して、同じ設定または異なる設定で次の原稿のセットのスキャンを行うようにします。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 スキャンプレビュー オフ オン * 原稿のプレビューを表示します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ショートカットとして保存を許可 オフ オン * FTP アドレスをショートカットとして保存します。 メニュー FTP 初期値設定"},{"UUID":"94355bfa-c0fa-4d9a-bbda-0d035715cd29","title":"USB ドライブ","link":"flash-drive-scan-topic.html","desc":"フラッシュメモリスキャン ［フラッシュメモリスキャン］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"フラッシュメモリスキャン ［フラッシュメモリスキャン］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 形式 規定せず JPEG（.jpg） PDF（.pdf） ＊ TIFF（.tif） XPS（.xps） TXT（.txt） RTF（.rtf）* DOCX（.doc） XLSX（.xlsx） CSV（.csv） スキャン画像のファイル形式を指定します。 TXT（.txt） 、 RTF（.rtf） 、 DOCX（.docx） 、 XLSX（.xlsx） 、 CSV（.csv） は、 光学文字認識（OCR）ソリューションを購入してインストールしている場合のみ表示されます。 グローバル OCR 設定 認識済み言語 ［言語の一覧］ OCR を設定します。 このメニューは、OCR ソリューションを購入してインストールしている場合のみ表示されます。 自動回転 オフ ＊ オン しみ除去 オフ ＊ オン 自動コントラスト補正 オフ ＊ オン PDF 設定 PDF バージョン 1.3 1.4 1.5 ＊ 1.6 1.7 スキャン画像の PDF 設定を行います。 ［ PDF バージョン ］が 1.4 または 1.7 に設定されている場合にのみ、［ アーカイブ（PDF/A） ］と［ アーカイブバージョン ］とがサポートされます。 ［ 高圧縮 ］は、ハードディスクが取り付けられている場合にのみ表示されます。 ［ 保護 ］は、 ［ PDF バージョン ］が 1.4 以降に設定されている場合にのみサポートされます。 アーカイブ（PDF/A） オフ ＊ オン アーカイブバージョン A‑1a ＊ A-1b A‑2u 高圧縮 オフ ＊ オン セキュア オフ ＊ オン 検索可能 オフ ＊ オン コンテンツタイプ 規定せず テキスト テキスト/写真 ＊ 写真 グラフィックス 原稿の種類に基づいて、出力結果を向上させます。 コンテンツソース 規定せず モノクロレーザー カラーレーザー ＊ インクジェット 写真/フィルム 雑誌 新聞 出版物 その他 原稿の種類に基づいて、出力結果を向上させます。 カラー 規定せず モノクロ グレー カラー ＊ 自動 原稿をカラーまたはモノクロでキャプチャするようにプリンタを設定します。 解像度 規定せず 75 dpi 150 dpi ＊ 200 dpi 300 dpi 400 dpi 600 dpi スキャンした画像の解像度を設定します。 濃度 規定せず 1 ～ 9 （5＊） スキャンした画像の濃度を調整します。 原稿の向き 規定せず 縦 ＊ 横 原稿の向きを指定します。 原稿サイズ 規定せず 大きさ混在 ＊ 原稿の用紙サイズを設定します。 印刷面 規定せず オフ ＊ 短辺 長辺 原稿の両面をスキャンする場合に、原稿の向きを指定します。 ファイル名 規定せず この設定はユーザーが定義します。 スキャン画像のファイル名を指定します。 イメージ詳細設定 カラーバランス シアン （0＊） マゼンタ （0＊） イエロー （0＊） シアン、マゼンタ、イエローのカラー濃度を調整します。 カラー削除 カラー削除 （ なし ＊） 赤色 初期しきい値 （128＊） 緑色 初期しきい値 （128＊） 青色 初期しきい値 （128＊） スキャン中にドロップアウトさせるカラーを指定し、そのカラーのドロップアウト設定を調整します。 自動カラー検出 カラー感度 （5＊） 判別範囲 （5＊） スキャンビット深度 （1 ビット＊） 最小スキャン解像度 （300 dpi＊） 自動カラー検出の設定を行います。 JPEG 品質 原稿内容に最適な設定 ＊ 5 ～ 95 スキャンした画像の JPEG 品質を設定します。 コントラスト 原稿内容に最適な設定 ＊ 0 ～ 5 スキャンした画像のコントラストを指定します。 下地調整 下地の検出 （ 自動 ＊） レベル （0＊） 原稿から背景色や画像ノイズを削除します。 左右反転 オフ ＊ オン 原稿を左右反転した画像を作成します。 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 イメージ詳細設定 ネガイメージ オフ ＊ オン 原稿のネガイメージを作成します。 シャドウ描写 ‑4 ～ 4 （0＊） スキャンした画像のシャドウ調整を行います。 端までスキャン オフ ＊ オン 原稿をすこし小さめ（全面）でスキャンします。 シャープネス 1 ～ 5 （3＊） スキャンした画像のシャープネスを調整します。 温度 ‑4 ～ 4 （0＊） 原稿から青みの強い出力または赤みの強い出力を生成します。 空白ページ 空白ページの削除 （ 削除しない ＊） 空白ページの感度 （5＊） 原稿の空白ページに対するスキャンの相対感度を設定します。 管理者用設定 文字の画質設定 5 ～ 95 （75＊） スキャンした画像の文字の品質を設定します。 文字/写真標準設定 5 ～ 95 （75＊） スキャンした画像の文字と写真の品質を設定します。 写真の画質設定 5 ～ 95 （50＊） スキャンした画像の写真の品質を設定します。 複数ページ TIFF を使用 オフ オン * 複数の TIFF 画像 から 1 つの TIFF ファイルへのスキャンを有効にします。 TIFF 圧縮 JPEG LZW ＊ TIFF ファイルの圧縮タイプを指定します。 カスタムジョブスキャン オフ ＊ オン プリンタで最初の原稿のセットをスキャンするための設定を指定して、同じ設定または異なる設定で次の原稿のセットのスキャンを行うようにします。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 スキャンプレビュー オフ ＊ オン 原稿のスキャンのプレビューを表示します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ADF の傾きを調整 オフ オン * 自動原稿フィーダからドキュメントをスキャンして傾いた画像を調整するようにプリンタを設定します。 メニュー フラッシュメモリスキャン"},{"UUID":"be6caed1-2d04-4101-9b28-8ae2718a9f07","title":"USB ドライブ","link":"flash-drive-scan-topic.html","desc":"フラッシュメモリ印刷 ［フラッシュメモリ印刷］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"フラッシュメモリ印刷 ［フラッシュメモリ印刷］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 コピー部数 1 ～ 9999 （1＊） 印刷ジョブの部数を設定します。 給紙源 トレイ  [x]（1＊） 多目的フィーダ 手差し用紙 手差し封筒 印刷ジョブの給紙源を設定します。 カラー オフ オン * フラッシュメモリをカラーで印刷します。 部単位 オフ［1,1,1,2,2,2］ オン［1,2,1,2,1,2］ ＊ 特にジョブを複数部印刷する場合は、各印刷ジョブのページ順が維持されるように積み重ねます。 印刷面 片面 ＊ 両面 用紙の片面に印刷するか両面に印刷するかを指定します。 ホチキス オフ ＊ 1 ホチキス、左上隅 2 ホチキス、左 1 ホチキス、右上隅 2 ホチキス、上 1 ホチキス、左下隅 2 ホチキス、下 1 ホチキス、右下隅 2 ホチキス、右 すべての印刷ジョブのホチキスの位置を指定します。 このメニュー項目はホチキスフィニッシャーがある場合にのみ表示されます。 穴パンチ オフ ＊ 2 穴 3 穴 4 穴 すべての印刷ジョブのパンチモードを設定します。 このメニュー項目は、ホチキス、穴パンチまたは冊子フィニッシャが取り付けられている場合のみ表示されます。 オフセットページ なし * 各コピー部数の間 各ジョブの間 各印刷ジョブまたは印刷ジョブの各コピーの出力をオフセットします。 ［ 各コピー部数の間 ］では、［ 部単位 ］が［ オン［1,2,1,2,1,2］ ］に設定されている場合に、印刷ジョブのコピーごとにずらして排紙します。［ 部単位 ］が［ オフ[1,1,1,2,2,2] ］に設定されている場合は、1 に指定されている全ページまたは 2 に指定されている全ページなど、印刷ページの各セットがオフセットされます。 印刷する部数に関係なく、［ 各ジョブの間 ］は、印刷ジョブ全体で、同じオフセット位置です。 反転スタイル 長辺 ＊ 短辺 両面印刷を実行する場合は、用紙のどちらの辺を綴じるかを決定します。 割り付けるページ数 オフ ＊ 2 ページ/面 3 ページ/面 4 ページ/面 6 ページ/面 9 ページ/面 12 ページ/面 16 ページ/面 複数のページ画像を 1 枚の用紙の片面に印刷します。 集約順 横方向（左から） ＊ 横方向（右から） 縦方向（右から） 縦方向（左から） ［ ページ集約 ］メニューを使用するときに、複数ページの画像の位置を指定します。 原稿セット方向 自動 ＊ 横 縦 ［ ページ集約 ］メニューを使用するときに、複数ページの画像の向きを指定します。 ページ枠 なし * 実線 ［ ページ集約 ］メニューを使用するときに、各ページの画像に枠線を印刷します。 挿入紙 オフ ＊ 各コピー部数の間 各ジョブの間 各ページの間 印刷時に空白の挿入紙を挿入します。 挿入紙のトレイ指定 トレイ  [x]（1＊） 多目的フィーダ 挿入紙のトレイを指定します。 空白ページ 印刷しない ＊ 印刷 印刷ジョブで白紙ページを印刷します。 メニュー フラッシュメモリ印刷"},{"UUID":"6879fdfd-7476-419d-9a8a-e9cf69e3243d","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"ネットワークの概要 ［ネットワークの概要］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"ネットワークの概要 ［ネットワークの概要］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 アクティブアダプタ 自動 ＊ 標準ネットワーク ワイヤレス ネットワーク接続のタイプを指定します。 ［ ワイヤレス ］は、ワイヤレスネットワークに接続されているプリンタでのみ使用できます。 ネットワーク状況 この設定は読み取り専用の情報です。 プリンタのネットワークの接続状況を表示します。 プリンタにネットワークの状態を表示 オフ オン * ディスプレイにネットワーク状態を表示します。 速度、通信モード この設定は読み取り専用の情報です。 現在有効になっているネットワークカードの速度を示します。 IPv4 この設定は読み取り専用の情報です。 IPv4 アドレスを表示します。 すべての IPv6 アドレス この設定は読み取り専用の情報です。 すべての IPv6 アドレスを表示します。 プリントサーバーをリセット 開始 プリンタへの有効なネットワーク接続すべてをリセットします。 この設定により、すべてのネットワーク設定が削除されます。 ネットワークジョブのタイムアウト オフ オン ＊（90 秒） ネットワークの印刷ジョブが中止されるまでの時間を設定します。 バナーページ オフ オン * バナーページを印刷します。 ポートの範囲 この設定はユーザーが定義します。 ポートをブロックするファイアウォールの先にあるプリンタに対して、有効なポート範囲を指定します。 ネットワーク接続を有効化 オフ オン * プリンタのネットワーク接続を有効にします。 LLDP を有効化 オフ ＊ オン ネットワークの状態をホーム画面に表示します。 メニュー ネットワークの概要"},{"UUID":"ac2dd3d7-969a-4a37-805a-1c5de859ed7a","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"ワイヤレス このメニューは、Wi-Fi ネットワークに接続されているプリンタ、またはワイヤレスネットワークアダプタが内蔵されているプリンタでのみ表示されます。 ［ワイヤレス］のメニュー項目と説明 メニュー項目","descFull":"ワイヤレス このメニューは、Wi-Fi ネットワークに接続されているプリンタ、またはワイヤレスネットワークアダプタが内蔵されているプリンタでのみ表示されます。 ［ワイヤレス］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 プリンタパネルで設定 ネットワークを選択 ［使用可能なワイヤレスネットワークのリスト］ プリンタが接続するワイヤレスネットワークを指定します。 Wi-Fi ネットワークを追加 ネットワーク名 ネットワークモード （ インフラストラクチャモード ＊） ワイヤレスセキュリティモード （ 無効 ＊） ネットワーク名とネットワークタイプを手動で入力します。 Wi‑Fi Protected 設定 規定せず プッシュボタン方式を開始 PIN 方式を開始 Wi-Fi ネットワークを確立して、ネットワークセキュリティを有効にします。 ［ プッシュボタン方式を開始 ］を選択した場合、プリンタとアクセスポイント（ワイヤレスルーター）の両方のボタンを一定時間内に押すと、プリンタが Wi-Fi ネットワークに接続されます。 ［ 暗証番号方式を開始 ］では、プリンタの暗証番号（PIN）がアクセスポイントのワイヤレス設定に入力されると、プリンタが Wi-Fi ネットワークに接続されます。 ネットワークモード 規定せず BSS タイプ インフラストラクチャ ＊ ネットワークモードを指定します。 互換性 規定せず 802.11b/g/n（2.4GHz） ＊ 802.11a/b/g/n/ac（2.4GHz/5GHz） 802.11a/n/ac（5GHz） Wi-Fi ネットワークの規格を指定します。 ［ 802.11a/b/g/n/ac（2.4GHz/5GHz） ］および ［ 802.11a/n/ac（5GHz） ］は、Wi-Fi オプションがインストールされている場合にのみ表示されます。 ワイヤレスセキュリティモード 規定せず 無効 ＊ WPA2/WPA-Personal WPA2-Personal WPA3/WPA-Personal WPA3-Personal 802.1x - RADIUS プリンタを Wi-Fi デバイスに接続する際のセキュリティモードを設定します。 WPA2/WPA - Personal 規定せず AES WPA（Wi-Fi Protected Access）を使用した Wi-Fi セキュリティを有効化します。 このメニュー項目は、［ ワイヤレスセキュリティモード ］が［ WPA2/WPA - Personal ］に設定されている場合にのみ表示されます。 PSK の設定 規定せず この設定はユーザーが定義します。 安全な Wi-Fi 接続のためのパスワードを指定します。 WPA2-Personal 規定せず AES WPA2 を使用した Wi-Fi セキュリティを有効化します。 このメニュー項目は、［ ワイヤレスセキュリティモード ］が［ WPA2 - Personal ］に設定されている場合にのみ表示されます。 802.1x 暗号化モード 規定せず WPA+ WPA2 ＊ この802.1x 規格を使用した Wi-Fi セキュリティを有効化します。 このメニュー項目は、［ ワイヤレスセキュリティモード ］が［ 802.1x - RADIUS ］に設定されている場合にのみ表示されます。 ［ 802.1x - RADIUS ］は、Embedded Web Server からのみ設定できます。 IPv4 DHCP を有効化 オン * オフ プリンタの IPv4 設定を有効化して設定します。 静的 IP アドレスを設定 IP アドレス ネットマスク ゲートウェイ IPv6 IPv6 を有効化 オン * オフ プリンタの IPv6 設定を有効化して設定します。 DHCPv6 を有効化 オン オフ ＊ ステートレスアドレスの自動設定 オン * オフ DNS サーバーアドレス この設定はユーザーが定義します。 IPv6 アドレスの手動割り当て この設定はユーザーが定義します。 IPv6 ルーターの手動割り当て この設定はユーザーが定義します。 アドレスプレフィックス この設定はユーザーが定義します。 すべての IPv6 アドレス この設定はユーザーが定義します。 すべての IPv6 ルーターアドレス この設定はユーザーが定義します。 ネットワークアドレス 規定せず UAA LAA ネットワークアドレスを表示します。 PCL SmartSwitch 規定せず オフ オン * 印刷ジョブで必要な場合、デフォルトのプリンタ言語に関係なく、自動的に PCL エミュレーションに切り替えるようにプリンタを設定します。 ［ PCL SmartSwitch ］が［ オフ ］に設定される場合、プリンタは受信データを確認せず、［ 設定 ］メニューで指定された初期設定のプリンタ言語が使用されます。 PS SmartSwitch 規定せず オフ オン * 印刷ジョブで必要な場合、デフォルトのプリンタ言語に関係なく、自動的に PS エミュレーションに切り替えるようにプリンタを設定します。 ［ PS SmartSwitch ］が［ オフ ］に設定される場合、プリンタは受信データを確認せず、［ 設定 ］メニューで指定された初期設定のプリンタ言語が使用されます。 ジョブバッファリング 規定せず オン オフ ＊ 印刷前に印刷ジョブをストレージドライブに一時的に保存します。 このメニュー項目は、ストレージデバイスが取り付けられている場合にのみ表示されます。 Mac バイナリ PS 規定せず 自動 ＊ オン オフ Macintosh のバイナリ PostScript エミュレーション印刷ジョブを処理するように設定します。 ［ オン ］を選択すると、Raw バイナリ PostScript エミュレーション印刷ジョブが処理されます。 ［ オフ ］を選択すると、標準プロトコルによって印刷ジョブがフィルタリングされます。 メニュー ワイヤレス"},{"UUID":"1740b04e-c8c1-43cc-b196-55448ba5899b","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"Wi‑Fi ダイレクト ［Wi-Fi ダイレクト］のメニュー項目と説明 メニュー項目","descFull":"Wi‑Fi ダイレクト ［Wi-Fi ダイレクト］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 Wi‑Fi ダイレクトを有効化 オン オフ ＊ Wi-Fi デバイスに直接接続するように、プリンタを設定します。 Wi-Fi ダイレクト名 この設定はユーザーが定義します。 Wi‑Fi Directネットワークの名前を指定します。 Wi-Fiダイレクトのパスワード この設定はユーザーが定義します。 Wi-Fi 接続時にユーザーを認証および検証するためのパスワードを設定します。 設定ページにパスワードを表示 オフ オン * ［ ネットワーク設定ページ ］に［ Wi‑Fi ダイレクトのパスワード ］を表示します。 優先チャネル番号 1 ～ 11 自動 ＊ Wi-Fi ネットワークの優先チャネルを設定します。 グループオーナー IP アドレス この設定はユーザーが定義します。 グループオーナーの IP アドレスを指定します。 自動受け付けプッシュボタン要求 オフ ＊ オン ネットワークに自動的に接続する要求を承諾します。 クライアントの自動承諾はセキュリティ保護されません。 メニュー Wi‑Fi ダイレクト"},{"UUID":"6890aac3-a51a-4bac-ad4c-6326a46d1fe7","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"モバイルサービスの管理 ［モバイルサービスの管理］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"モバイルサービスの管理 ［モバイルサービスの管理］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 IPP 印刷を有効にする オン * オフ ネットワークプリンタがインターネットプリンティングプロトコル（IPP）を使用してジョブを印刷できるようにします。 IPP FAX を有効にする オン * オフ USB プリンタが IPP を使用して FAX ジョブを送信できるようにします。 USB 経由の IPP を有効にする オン * オフ USB プリンタが IPP を使用してジョブを印刷できるようにします。 IPP は通常、ネットワークプリンタ用に設計されています。 スキャンを有効にする オン * オフ ネットワークプリンタが eSCL プロトコルを使用してジョブを印刷できるようにします。 Mopria ディスカバリを有効にする オン * オフ モバイルデバイスが Mopria™ 認定プリンタを検出できるようにします。 メニュー モバイルサービスの管理"},{"UUID":"ba0591e6-5639-4795-90b7-a9ba7eab272f","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"イーサネット ［イーサネット］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"イーサネット ［イーサネット］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ネットワーク速度 規定せず この設定は読み取り専用の情報です。 アクティブなネットワークアダプタの速度を表示します。 IPv4 DHCP を有効化 オン * オフ IPv4 設定を行います。 この設定はユーザーが定義します。 静的 IP アドレスを設定 IP アドレス ネットマスク ゲートウェイ IPv6 IPv6 を有効化 オン * オフ IPv6 設定を行います。 DHCPv6 を有効化 オフ ＊ オン ステートレスアドレスの自動設定 オン * オフ DNS サーバーアドレス この設定はユーザーが定義します。 IPv6 アドレスの手動割り当て この設定はユーザーが定義します。 IPv6 ルーターの手動割り当て この設定はユーザーが定義します。 アドレスプレフィックス（64＊） 0 ～ 128 （64＊） すべての IPv6 アドレス この設定は読み取り専用の情報です。 すべての IPv6 ルーターアドレス この設定は読み取り専用の情報です。 ネットワークアドレス 規定せず UAA LAA ネットワークアドレスを指定します。 PCL SmartSwitch 規定せず オフ オン * 印刷ジョブで必要な場合、デフォルトのプリンタ言語に関係なく、自動的に PCL エミュレーションに切り替えるようにプリンタを設定します。 この設定が無効な場合、プリンタは受信データを確認せず、［ 設定 ］メニューで指定された初期設定のプリンタ言語が使用されます。 PS SmartSwitch 規定せず オフ オン * 印刷ジョブで必要な場合、初期設定のプリンタ言語に関係なく、自動的に PostScript エミュレーションに切り替えるようにプリンタを設定します。 この設定が無効な場合、プリンタは受信データを確認せず、［ 設定 ］メニューで指定された初期設定のプリンタ言語が使用されます。 ジョブバッファリング 規定せず オフ ＊ オン 印刷前にジョブをストレージドライブに一時的に保存します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 Mac バイナリ PS 規定せず 自動 ＊ オフ オン Macintosh のバイナリ PostScript エミュレーション印刷ジョブを処理するように設定します。 ［ 自動 ］を選択すると、Windows または Macintosh オペレーティングシステムを使用するコンピュータからの印刷ジョブを処理します。 ［ オフ ］を選択すると、標準プロトコルによって PostScript エミュレーション印刷ジョブがフィルタリングされます。 省電力型イーサネット 規定せず オン オフ 自動 ＊ プリンタがイーサネットネットワークからデータを受信していないときに、電力消費を節約します。 メニュー イーサネット"},{"UUID":"0ce6a1c9-c32e-4f93-bc9d-0b1ca229ad1e","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"TCP/IP このメニューは、ネットワークプリンタ、またはプリントサーバーに接続されているプリンタでのみ表示されます。 ［TCP/IP］のメニュー項目と説明 メニュー項目 設定","descFull":"TCP/IP このメニューは、ネットワークプリンタ、またはプリントサーバーに接続されているプリンタでのみ表示されます。 ［TCP/IP］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ホスト名を設定 この設定はユーザーが定義します。 現在の TCP/IP ホスト名を設定します。 ドメイン名 この設定はユーザーが定義します。 ドメイン名を設定します。 DHCP/BOOTP による NTP サーバーの更新を許可 オン * オフ DHCP（動的ホスト構成プロトコル）およびブートストラッププロトコル（BOOTP）クライアントによる、プリンタの NTP 設定の更新を許可します。 ゼロコンフィグレーション名 この設定はユーザーが定義します。 ゼロ構成ネットワークのサービス名を指定します。 自動 IP を有効化 オフ オン * IP アドレスを自動的に割り当てます。 DNS サーバーアドレス この設定はユーザーが定義します。 現在のドメイン名システム（DNS）サーバーアドレスを指定します。 バックアップ DNS サーバーアドレス この設定はユーザーが定義します。 バックアップ DNS サーバーアドレスを指定します。 バックアップ DNS サーバーアドレス 2 バックアップ DNS サーバーアドレス 3 ドメイン検索順序 この設定はユーザーが定義します。 ドメイン名のリストを指定して、ネットワーク上の異なるドメインに存在するプリンタとそのリソースを確認します。 DDNS を有効化 オフ ＊ オン 動的 DNS 設定を更新します。 DDNS TTL この設定はユーザーが定義します。 現在の DDNS 設定を指定します。 初期設定 TTL DDNS 更新時間 mDNS を有効化 オフ オン * マルチキャスト DNS 設定を更新します。 WINS サーバーアドレス この設定はユーザーが定義します。 Windows インターネットネームサービス（WINS）のサーバーアドレスを指定します。 BOOTP を有効化 オフ ＊ オン BOOTP によるプリンタの IP アドレスの割り当てを許可します。 制限サーバーリスト この設定はユーザーが定義します。 TCP/IP 経由でプリンタとの通信を許可する IP アドレスを指定します。 各 IP アドレスはカンマで区切ります。 最大 50 件の IP アドレスを追加できます。 制限サーバーリストのオプション すべてのポートをブロック ＊ 印刷のみをブロック 印刷および HTTP のみをブロック リストにない IP アドレスのアクセスオプションを指定します。 MTU 256 ～ 1500 イーサネット （1500＊） TCP 接続のための最大伝送単位（MTU）パラメータを指定します。 RAW 印刷ポート 1 ～ 65535 （9100＊） ネットワーク上で接続されるプリンタの RAW ポート番号を指定します。 アウトバウンドトラフィックの最高速度 オフ ＊ オン プリンタの最大転送速度を設定します。 有効にすると、この設定のオプションは 100 ～ 1000000 キロビット/秒になります。 TLS サポート TLSv1.0 を有効化 （ オフ ＊） TLSv1.1 を有効化 （ オフ ＊） TLSv1.2 を有効化 （ オン ＊） トランスポート層セキュリティプロトコルを有効にします。 SSL 暗号リスト この設定はユーザーが定義します。 SSL 接続または TLS 接続に使用する暗号アルゴリズムを指定します。 TLSv1.3 SSL 暗号リスト メニュー TCP/IP"},{"UUID":"b2067a9a-31f2-488d-b21f-ba1cd6694f74","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"SNMP このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［SNMP］のメニュー項目と説明 メニュー項目 サブメニュー項目","descFull":"SNMP このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［SNMP］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 SNMP バージョン 1 および 2c 有効 オフ オン * 簡易ネットワーク管理プロトコル（SNMP）のバージョン 1 および 2c を設定して、プリンタドライバとアプリケーションをインストールします。 SNMP の設定を許可 オフ オン * PPM MIB を有効化 オフ オン * SNMP コミュニティ この設定はユーザーが定義します。 SNMP バージョン 3 有効 オフ オン * SNMP バージョン 3 を有効にして、プリンタセキュリティをインストールおよび更新します。 コンテキスト名 この設定はユーザーが定義します。 コンテキスト名を入力します。 読み取り/書き込み認証資格情報の設定 ユーザー名 認証パスワード プライバシーパスワード SNMP バージョン 3 の読み取り/書き込みの認証資格情報を入力します。 読み取り専用認証資格情報の設定 ユーザー名 認証パスワード プライバシーパスワード SNMP バージョン 3 の読み取り専用の認証資格情報を入力します。 ハッシュ値認証 MD5 SHA1 ＊ 適用する認証ハッシュ値を設定します。 最小認証レベル 認証なし、暗号化なし 認証あり、暗号化なし 認証あり、暗号化あり ＊ 適用する最小認証レベルを設定します。 暗号化アルゴリズム DES AES‑128 ＊ 適用するプライバシーアルゴリズムを設定します。 メニュー SNMP"},{"UUID":"135c40bc-4d1c-45b8-b34e-a3eab0bc0e9d","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"IPSec このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［IPSec］のメニュー項目と説明 メニュー項目 設定","descFull":"IPSec このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［IPSec］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 IPSec を有効化 オフ ＊ オン IPSec（Internet Protocol Security）を有効にします。 基本構成 初期設定 ＊ 互換性 セキュア IPSec の基本構成を設定します。 このメニュー項目は、［ IPSec を有効化 ］が［ オン ］に設定されている場合にのみ表示されます。 DH（Diffie-Hellman）グループ提案 modp2048（14） * modp3072（15） modp4096（16） modp6144（17） IPSec の基本構成を設定します。 このメニュー項目は、［ 基本構成 ］が［ 互換性 ］に設定されている場合にのみ表示されます。 提案された暗号化方式 3DES AES ＊ 暗号化方式を設定します。 このメニュー項目は、［ 基本構成 ］が［ 互換性 ］に設定されている場合にのみ表示されます。 提案された認証方式 SHA1 SHA256 ＊ SHA512 認証方法を設定します。 このメニュー項目は、［ 基本構成 ］が［ 互換性 ］に設定されている場合にのみ表示されます。 IKE SA の寿命（時間） 1 2 4 8 24 ＊ IKE SA の有効期間を指定します。 このメニュー項目は、［ 基本構成 ］が［ セキュア ］に設定されている場合にのみ表示されます。 IPsec SA の寿命（時間） 1 2 4 8 24 ＊ IPSec SA の有効期間を指定します。 このメニュー項目は、［ 基本構成 ］が［ セキュア ］に設定されている場合にのみ表示されます。 IPSec デバイス証明書 初期設定 ＊ IPSec 証明書を指定します。 このメニュー項目は、［ IPSec を有効化 ］が［ オン ］に設定されている場合にのみ表示されます。 事前共有鍵認証済み接続 ホスト  [x] プリンタの認証済みの接続を設定します。 これらのメニュー項目は、［ IPSec を有効化 ］が［ オン ］に設定されている場合のみ表示されます。 証明書認証接続 ホスト  [x]  アドレス[/サブネット] メニュー IPSec"},{"UUID":"90d0bb8d-8a67-4d48-9da8-06ee719e50ae","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"802.1x 802.1x このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［802.1x］のメニュー項目と説明 メニュー項目","descFull":"802.1x 802.1x このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［802.1x］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 有効 規定せず オフ ＊ オン アクセスを許可する前に認証を要求するネットワークにプリンタが参加できるようにします。 802.1x 認証 デバイスのログイン名 この設定はユーザーが定義します。 固有のログイン名を指定します。 デバイスのログインパスワード この設定はユーザーが定義します。 固有のパスワードを指定します。 サーバ証明書を確認 オン * オフ 認証サーバーのセキュリティ証明書を検証するように要求するには、このオプションを有効にします。 イベントログを有効化 オン オフ ＊ プリンタによる接続ログの記録を有効にします。 802.1x デバイス証明書 初期設定 ＊ 使用するデジタル証明書を選択します。 証明書が 1 つしかインストールされていない場合、表示されるオプションは 初期設定 のみになります。 認証方式 EAP MD5 オン * オフ EAP（Extensible Authentication Protocol）MD5 フレームワークを有効にします。 EAP - MSCHAPv2 オン * オフ EAP Microsoft Challenge Handshake Authentication Protocol（MSCHAP）バージョン 2 の認証方法を有効にします。 LEAP オン * オフ MSCHAP の改良版であるLEAP（Lightweight Extensible Authentication Protocol）を有効します。 PEAP オン * オフ 802.11 WLAN にさらに安全な認証を提供する方法である PEAP（Protected Extensible Authentication Protocol）を有効にします。PEAP は 802.1x ポートアクセス制御をサポートします。 EAP - TLS オン * オフ クライアントとサーバーがデジタル証明書を使用して相互に認証するプロトコルである EAP トランスポート層セキュリティ（TLS）を有効にします。 EAP - TTLS オン * オフ EAP トンネルトランスポート層セキュリティプロトコル（TLS）を有効にします。このプロトコルは EAP_TLS と似ていますが、サーバーだけに最初にクライアントに対して自身を認証する証明書が関連付けられます。 TTLS 認証方式 CHAP MSCHAP MSCHAPv2 ＊ PAP デバイスで使用する EAP TTLS 方式を選択します。 メニュー 802.1x"},{"UUID":"98029ada-eef5-47ab-b5d8-ee9e482bac58","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"LPD 設定 このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［LPD 設定］のメニュー項目と説明","descFull":"LPD 設定 このメニューは、ネットワークプリンタまたはプリントサーバーに接続したプリンタでのみ表示されます。 ［LPD 設定］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 LPD タイムアウト 0 ～ 65535 秒 （90＊） タイムアウト値を設定して、Line Printer Daemon（LPD）サーバーが停止または無効な印刷ジョブのために無制限に待機しないようにします。 LPD バナーページ オフ ＊ オン すべての LPD 印刷ジョブのバナーページを印刷します。 バナーページは、印刷ジョブの最初のページで、印刷ジョブの区切りとして使用され、印刷ジョブ要求の送信元を識別します。 LPD トレーラページ オフ ＊ オン すべての LPD 印刷ジョブのトレーラページを印刷します。 トレーラページは、印刷ジョブの最後のページです。 LPD キャリッジリターン変換 オフ ＊ オン キャリッジリターン変換を有効にします。 キャリッジリターンは、同じ線上の最初の位置にカーソルを移動するようにプリンタに命令するメカニズムです。 メニュー LPD 設定"},{"UUID":"84ec507e-03e9-4b23-ad69-78288c1fb766","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"HTTP/FTP の設定 ［HTTP/FTP の設定］のメニュー項目と説明 メニュー項目","descFull":"HTTP/FTP の設定 ［HTTP/FTP の設定］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 プロキシ HTPP プロキシ IP アドレス この設定はユーザーが定義します。 HTTP サーバーを設定します。 HTTP 標準 IP ポート この設定はユーザーが定義します。 HTTP の標準 IP ポートアドレスを設定します。 工場出荷時の HTTP の標準ポートは 80 です。 FTP プロキシ IP アドレス この設定はユーザーが定義します。 FTP 設定を設定します。 FTP 標準 IP ポート この設定はユーザーが定義します。 FTP の標準 IP ポートアドレスを設定します。 工場出荷時の HTTP の標準ポートは 21 です。 認証 なし 自動 ＊ 基本 ダイジェスト NTLM 認証情報を指定します。 ユーザー名 この設定はユーザーが定義します。 固有のユーザー名を指定します。 パスワード この設定はユーザーが定義します。 固有のパスワードを指定します。 ローカルドメイン この設定はユーザーが定義します。 HTTP および FTP サーバーのドメイン名を指定します。 その他の設定 HTTP サーバーを有効化 オン * オフ EWS にアクセスして、プリンタの監視および管理を行います。 HTPPS を有効化 オン * オフ ハイパーテキスト転送プロトコルセキュア（HTTPS）を有効にして、プリントサーバーとの間で転送されるデータを暗号化します。 強制 HTTPS 接続 オン オフ ＊ 強制的にプリンタが HTTPS で接続するようにします。 FTP/TFTP を有効化 オン * オフ FTP/TFTP を使用して、ファイルを送信します。 HTTPS デバイス証明書 初期設定 ＊ プリンタで使用されている HTTP デバイス証明書を表示します。 HTTP/FTP 要求のタイムアウト 1 ～ 299 秒 （30＊） サーバー接続が停止するまでの時間を指定します。 HTTP/FTP 要求の再試行回数 1 ～ 299 秒 （3＊） HTTP/FTP サーバーへの接続を再試行する回数を設定します。 メニュー HTTP/FTP の設定"},{"UUID":"f3c96c3a-2001-4653-9fa5-bc3838cb62c8","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"ThinPrint ［ThinPrint］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"ThinPrint ［ThinPrint］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ThinPrint を有効化 オフ ＊ オン ThinPrint を使用して印刷します。 ポート番号 4000 ～ 4999 （4000＊） ThinPrint サーバーのポート番号を設定します。 帯域幅（ビット/秒） 100 ～ 1000000 （0＊） ThinPrint 環境でデータを転送する速度を設定します。 パケットサイズ（KB） 0 ～ 64000 （0＊） データ転送のパケットサイズを設定します。 メニュー ThinPrint"},{"UUID":"31c6ef49-c2f8-4512-8464-2346bb38404b","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"USB ［USB］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"USB ［USB］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 PCL SmartSwitch オフ オン * USB ポート経由で受信された印刷ジョブで PCL エミュレーションが必要とされる場合に、初期設定のプリンタ言語に関係なく、PCL エミュレーションに切り替えるようにプリンタを設定します。 この設定が無効な場合、プリンタは受信データを確認せず、［ 設定 ］メニューで指定された初期設定のプリンタ言語が使用されます。 PS SmartSwitch オフ オン * USB ポート経由で受信された印刷ジョブで必要な場合、初期設定のプリンタ言語に関係なく、PostScript エミュレーションに切り替えるようにプリンタを設定します。 この設定が無効な場合、プリンタは受信データを確認せず、［ 設定 ］メニューで指定された初期設定のプリンタ言語が使用されます。 ジョブバッファリング オフ ＊ オン 印刷前にジョブをストレージドライブに一時的に保存します。 このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 Mac バイナリ PS 自動 ＊ オン オフ Macintosh のバイナリ PostScript エミュレーション印刷ジョブを処理するように設定します。 ［ 自動 ］を選択すると、Windows または Macintosh オペレーティングシステムを使用するコンピュータからの印刷ジョブを処理します。 ［ オフ ］を選択すると、標準プロトコルによって PostScript エミュレーション印刷ジョブがフィルタリングされます。 USB ポートを有効化 オフ オン * 前面と背面の USB ドライブポートを有効にします。 メニュー USB"},{"UUID":"8a19701c-dd2e-45c1-a2d4-3099996b72f1","title":"ネットワーク/ポート","link":"network-overview-topic.html","desc":"外部ネットワークへのアクセスを制限する ［外部ネットワークアクセスを制限する］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"外部ネットワークへのアクセスを制限する ［外部ネットワークアクセスを制限する］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 外部ネットワークへのアクセスを制限する オフ ＊ オン ネットワークサイトへのアクセスを制限します。 外部ネットワークアドレス この設定はユーザーが定義します。 制限されたアクセスでのネットワークアドレスを指定します。 通知を送信する E メールアドレス この設定はユーザーが定義します。 ログに記録されたイベントの通知を送信する E メールアドレスを指定します。 Ping 頻度 1 ～ 300 （10＊） ネットワーククエリの間隔を秒単位で指定します。 件名 この設定はユーザーが定義します。 通知 E メールの件名とメッセージを指定します。 メッセージ メニュー 外部ネットワークへのアクセスを制限する"},{"UUID":"324d4d38-02ee-4f88-a5c4-d35555b86e60","title":"ログイン方式","link":"login-methods-subgroup.html","desc":"権限を管理 ［権限を管理］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"権限を管理 ［権限を管理］のメニュー項目と説明 メニュー項目 設定 説明 機能アクセス アプリ内のアドレス帳にアクセス アドレス帳を変更 ショートカット管理 プロファイルを作成 ブックマークの管理 フラッシュメモリ印刷 フラッシュドライブカラー印刷 フラッシュメモリスキャン コピー機能 カラーコピー印刷 カラー削除 E メール機能 FAX 機能 FTP 機能 保留の FAX を印刷 保留ジョブにアクセス プロファイルの使用 デバイスのジョブを中止 言語の変更 インターネットプリンティングプロトコル（IPP） リモートスキャンを開始 B/W 印刷 カラー印刷 ネットワークフォルダ - スキャン ハードディスク - 印刷 ハードディスク - カラー印刷 ハードディスク - スキャン ユーザーがアクセスできるプリンタ機能を指定します。 一部のメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 管理メニュー セキュリティメニュー ネットワーク/ポートメニュー 用紙メニュー レポートメニュー 機能設定メニュー 消耗品メニュー オプションカードメニュー SE メニュー デバイスメニュー ユーザーがアクセスできるプリンタメニューを指定します。 デバイス管理 リモート管理 ファームウェア更新 アプリ構成 操作パネルロック Embedded Web Server へのアクセス すべての設定をインポート/エクスポート 未使用時の消去 クラウドサービス登録 ユーザーがアクセスできる［ デバイス管理 ］の機能を指定します。 アプリ 新しいアプリ スライドショー 壁紙を変更 スクリーンセーバー カードコピー スキャンセンター カスタムスキャンセンター  [x] プリンタアプリへのアクセスを管理します。 メニュー 権限を管理"},{"UUID":"259b0f47-01ec-4667-b98a-8aa9977a9141","title":"ログイン方式","link":"login-methods-subgroup.html","desc":"ローカルアカウント ［ローカルアカウント］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定","descFull":"ローカルアカウント ［ローカルアカウント］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 グループ/権限を管理 グループの追加 この設定はユーザーが定義します。 プリンタ機能、管理メニュー、プリンタ管理オプション、およびアプリにアクセスできるグループを指定します。 全ユーザー アクセス制御をインポート プリンタに登録されているアカウントからアクセス制御をインポートします。 ユーザーを追加 ユーザー名/パスワード ユーザー名 パスワード PIN この設定はユーザーが定義します。 ユーザーを追加し、プリンタへのログイン方法を指定します。 メニュー ローカルアカウント"},{"UUID":"18742823-0e9a-4de9-825e-f6fd0fd6414e","title":"ログイン方式","link":"login-methods-subgroup.html","desc":"標準設定のログイン方式 このメニューは、［ ローカルアカウント ］メニューが設定されている場合にのみ表示されます。 ［標準設定のログイン方式］のメニュー項目と説明","descFull":"標準設定のログイン方式 このメニューは、［ ローカルアカウント ］メニューが設定されている場合にのみ表示されます。 ［標準設定のログイン方式］のメニュー項目と説明 メニュー項目 設定 説明 操作パネル ユーザー名/パスワード ユーザー名 パスワード PIN 操作パネルにアクセスするための初期設定のログイン方式を指定します。 ブラウザ ユーザー名/パスワード ユーザー名 パスワード PIN ブラウザにアクセスするための初期設定のログイン方式を指定します。 メニュー 標準設定のログイン方式"},{"UUID":"e7677b12-9c4e-407e-a05a-725afbe46ffd","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"USB デバイスのスケジュール ［USB デバイスのスケジュール］のメニュー項目と説明 メニュー項目","descFull":"USB デバイスのスケジュール ［USB デバイスのスケジュール］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 スケジュール 新しいスケジュールを追加 スケジュールを保存 アクション 日 時 前面 USB ポートへのアクセスをスケジュールします。 メニュー USB デバイスのスケジュール"},{"UUID":"54985ea1-9f9d-4322-b187-7fc7f91f688d","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"セキュリティ監査ログ ［セキュリティ監査ログ］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"セキュリティ監査ログ ［セキュリティ監査ログ］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 監査を有効化 オフ ＊ オン プリンタがセキュリティ監査ログとリモート Syslog にイベントを記録するように設定します。 リモート Syslog を有効化 オフ ＊ オン プリンタが監査ログをリモートサーバーに送信するように設定します。 リモート Syslog サーバー この設定はユーザーが定義します。 リモート Syslog サーバーを指定します。 リモート Syslog ポート 1 ～ 65535 （514＊） 記録したイベントをプリンタからリモートサーバーに送信するポートを指定します。 リモート Syslog 方式 標準 UDP ＊ スプリットトンネリング リモートサーバーにログイベントを送信する際に、プリンタが使用するプロトコルを指定します。 リモート Syslog ファシリティ 0 - カーネルメッセージ 1 - ユーザーレベルメッセージ 2 - メールシステム 3 - システムデーモン 4 - セキュリティ/認証メッセージ ＊ 5 - Syslog で内部的に生成されたメッセージ 6 - ラインプリンタサブシステム 7 - ネットワークニュースサブシステム 8 - UUCP サブシステム 9 - クロックデーモン 10 - セキュリティ/承認メッセージ 11 - FTP デーモン 12 - NTP サブシステム 13 - ログ監査 14 - ログアラート 15 - クロックデーモン 16 - ローカル使用 0（local0） 17 - ローカル使用 1（local1） 18 - ローカル使用 2（local2） 19 - ローカル使用 3（local3） 20 - ローカル使用 4（local4） 21 - ローカル使用 5（local5） 22 - ローカル使用 6（local6） 23 - ローカル使用 7（local7） リモート syslog サーバーにログイベントを送信する際に、プリンタが使用するファシリティの値を指定します。 ログ記録するイベントの重要度 0 - 緊急 1 - アラート 2 - クリティカル 3 - エラー 4 - 警告 ＊ 5 - 通知 6 - 情報 7 - デバッグ 各イベントの重大度の値を指定します。 ログ記録されていないイベントをリモート Syslog サーバーへ送付 オフ ＊ オン 対象となるイベントを送信するようにプリンタを設定します。 管理者の E メールアドレス この設定はユーザーが定義します。 特定のログイベントを通知するプリンタ管理者の E メールアドレスを指定します。 ログ消去アラートの E メール通知 オフ ＊ オン ログが削除されるたびに管理者に E メールを送信するようにプリンタを設定します。 ログ上書きアラートの E メール通知 オフ ＊ オン ログエントリがラップが発生した際に、管理者に E メールを送信するようにプリンタを設定します。 ログ満杯時の動作 最も古いエントリに上書き ＊ ログを E メール送信し、全エントリを削除 割り当てられたメモリがログで満杯になった場合、プリンタがログ保存の問題を解決する方法を決定します。 % フルアラート E メール オフ ＊ オン 割り当てられたメモリがログで満杯になった場合、管理者に E メールを送信するようにプリンタを設定します。 ログ容量アラートの通知レベル 1 ～ 99 （90＊） このログが占有する容量が、フルアラートレベルの値以上を占有しているかどうかを判断します。 ログエクスポートアラートの E メール通知 オフ ＊ オン ログがエクスポートされた場合、E メール通知が管理者に送信されます。 ログ設定変更アラートの E メール通知 オフ ＊ オン ［ 監査を有効化 ］メニューの値が変更されたときに、プリンタが管理者に E メールを送信するように設定します。 ログの改行コード LF（\\n） ＊ CR（\\r） CRLF（\\r\\n） ファイルを解析または表示するオペレーティングシステム（OS）に応じて、ログファイルの改行の処理方法を指定します。 エクスポートにデジタル署名を追加 オフ ＊ オン エクスポートされたセキュリティログに自動的に署名するようにプリンタを設定します。 ログをクリア この設定はユーザーが定義します。 すべての監査ログを削除します。 ログをエクスポート Syslog（RFC 5424） Syslog（RFC 3164） CSV プリンタまたはフラッシュメモリからログをエクスポートします。 メニュー セキュリティ監査ログ"},{"UUID":"af7845eb-7251-453a-aaa5-89ce9801caf6","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"ログイン制限 ［ログイン制限］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"ログイン制限 ［ログイン制限］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 ログイン失敗許容回数 1 ～ 10 （3＊） ユーザーがロックアウトされる前にログイン失敗できる回数を指定します。 ログイン失敗許容時間 1 ～ 60 分 （5＊） ユーザがロックアウトされるまでのログイン試行失敗の許容時間を指定します。 ロックアウト時間 1 ～ 60 分 （5＊） ログインが許可されない合計時間を指定します。 Web ログインのタイムアウト 1 ～ 120 分 （10＊） Web ページなどのリモートインターフェイスがどのぐらいの時間アイドル状態を維持した後に、ユーザーを自動的にログオフするかを指定します。 メニュー ログイン制限"},{"UUID":"34539cad-d5c3-4e55-b453-a3791eecb17e","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"コンフィデンシャル印刷設定 ［コンフィデンシャル印刷設定］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"コンフィデンシャル印刷設定 ［コンフィデンシャル印刷設定］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 無効 PIN の許容回数 2 ～ 10 無効な PIN の入力に関する制限を設定します。 制限回数に達すると、そのユーザー名に対する印刷ジョブが削除されます。 コンフィデンシャルジョブ期限切れ オフ ＊ 1 時間 4 時間 24 時間 72 時間 1 週間 保留ジョブのタイプごとに、プリンタがそのジョブをメモリから自動的 に削除するまでの期限を設定します。 保有ジョブのタイプには、［ コンフィデンシャル ］、［ 繰り返し ］、［ 予約 ］、［ 確認 ］があります。 コンフィデンシャル印刷ジョブがプリンタのメモリまたはプリンタのハードディスク上にある間に有効期限の設定が変更された場合、これらの印刷ジョブの有効期限は新しい標準設定値に変更されません。 プリンタの電源がオフになると、プリンタのメモリにあったコンフィデンシャルジョブはすべて削除されます。 期限切れジョブの繰り返し オフ ＊ 1 時間 4 時間 24 時間 72 時間 1 週間 繰り返す印刷ジョブの有効期限を設定します。 期限切れジョブの確認 オフ ＊ 1 時間 4 時間 24 時間 72 時間 1 週間 ジョブのコピーを印刷するにあたって有効期限を設定し、残りのコピーを印刷する前に品質を確認します。 期限切れジョブの予約 オフ ＊ 1 時間 4 時間 24 時間 72 時間 1 週間 後で印刷するために、プリンタに保存するジョブの有効期限を設定します。 すべてのジョブを保留にする オフ ＊ オン すべての印刷ジョブを保留にするようにプリンタを設定します。 重複ドキュメントを維持 オフ ＊ オン 同じファイル名を持つすべてのドキュメントを保持するようにプリンタを設定します。 メニュー コンフィデンシャル印刷設定"},{"UUID":"b61d02fe-8d6e-45b8-9324-88725a6d07a3","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"暗号化 ［暗号化］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"暗号化 ［暗号化］のメニュー項目と説明 メニュー項目 設定 説明 内部ストレージ この設定は読み取り専用の情報です。 内部ストレージの暗号化ステータスを表示します。 ハードディスク この設定は読み取り専用の情報です。 ハードディスクの暗号化ステータスを表示します。 このメニュー項目はハードディスクがある場合にのみ表示されます。 インテリジェントストレージドライブ この設定は読み取り専用の情報です。 インテリジェントストレージドライブ（ISD）の暗号化ステータスを表示します。 このメニュー項目は、ISD が取り付けられている場合にのみ表示されます。 メニュー 暗号化"},{"UUID":"e50dbb29-c684-4221-a81a-72332ad26ec2","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"一時データファイルの消去 ［一時データファイルの消去］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"一時データファイルの消去 ［一時データファイルの消去］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 オンボードメモリ内 オフ ＊ オン ジョブの完了後にジョブのすべてのデータをメモリから消去するようにプリンタを設定します。 ハードディスクに保存 1 回のパス消去 ＊ 3 回のパス消去 7 回のパス消去 ジョブの完了後にプリンタがジョブのすべてのデータをハードディスクから消去する方法を指定します。 このメニュー項目は、プリンタにハードディスクが取り付けられている場合のみ表示されます。 メニュー 一時データファイルの消去"},{"UUID":"ba2f7b96-b040-4f43-941f-bb9f2a859127","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"ソリューション LDAP 設定 ［ソリューション LDAP","descFull":"ソリューション LDAP 設定 ［ソリューション LDAP 設定］のメニュー項目と説明 メニュー項目 設定 説明 LDAP 参照を許可 オフ ＊ オン ドメイン内の異なるサーバーでログインしているユーザーアカウントを検索します。 LDAP 証明書の確認 はい いいえ * LDAP 証明書の検証を有効にします。 メニュー ソリューション LDAP 設定"},{"UUID":"adef5a0e-178c-48a8-b381-b997b9f97344","title":"セキュリティ","link":"login-methods-subgroup.html","desc":"その他 ［その他］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"その他 ［その他］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 保護された機能 表示 ＊ 非表示 ユーザーに与えられたアクセス権に関係なく、機能アクセス制御（FAC）で保護される機能をすべて表示します。 ［ 非表示 ］は、ユーザーがアクセス権を持つ保護された FAC 機能だけを表示します。 印刷許可 オフ ＊ オン 印刷する前にログインするようにユーザーに要求します。 初期設定の印刷許可ログイン ユーザー名/パスワード ＊ ユーザー名 ［ 印刷許可 ］に関する初期設定のログインを設定します。 セキュリティリセット設定 ［ 「ゲスト」アクセスを有効化 ］＊ 効果なし プリンタにユーザーアクセスを指定します。 ［ 「ゲスト」アクセスを有効化 ］を使用すると、すべてのユーザーがプリンタのあらゆる機能にアクセスできます。 ［ 効果なし ］を使用すると、必要とされるセキュリティ情報がない場合に、プリンタにアクセスできないようにすることができます。 ユーザーデータ用インテリジェントストレージドライブを使用 オフ オン * インテリジェントストレージドライブを有効にしてユーザーデータを保存します。 ハードディスクが取り付けられている場合、このメニュー項目は、無効です。 最小パスワードの長さ 0 ～ 32 （0＊） ［ パスワード ］や［ ユーザー名/パスワード ］アカウントなどの内部アカウントで使用されるパスワードの最小の長さを指定します。 パスワード/PIN 表示を有効化 オフ オン * パスワードまたは個人 ID 番号を表示します。 サービス不揮発性メモリの暗号化を許可する オフ ＊ オン デバイスのサービス不揮発性メモリの暗号化を有効にします。 この設定は、［ 暗号化サービス不揮発性メモリ ］が無効になっている場合に利用できます。 メニュー その他"},{"UUID":"87259e1d-bde7-420d-bc13-f5dbfb830fee","title":"クラウドサービス","link":"cloud-services-enrollment-topic.html","desc":"クラウドサービス登録 ［クラウドサービス登録］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"クラウドサービス登録 ［クラウドサービス登録］のメニュー項目と説明 メニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 詳細情報の表示 この設定は読み取り専用の情報です。 Lexmark クラウドサービスの使用に関する詳細情報を表示します。 Lexmark クラウドサービスとの通信を有効化 オフ ＊ オン プリンタが Lexmark クラウドサービスと通信できるようにします。 実行中ジョブの状態の表示 この設定は読み取り専用の情報です。 プリンタと Lexmark クラウドサービス間の接続状態を表示します。 メニュー クラウドサービス登録"},{"UUID":"ffaf5732-7be4-4146-b70a-6aebcf50d56a","title":"レポート","link":"menu-settings-page-topic.html","desc":"メニュー設定印刷 メニュー設定印刷 メニュー項目と説明 メニュー項目 説明","descFull":"メニュー設定印刷 メニュー設定印刷 メニュー項目と説明 メニュー項目 説明 メニュー設定印刷 プリンタメニューを含むレポートを印刷します。 メニュー メニュー設定印刷"},{"UUID":"f84d992a-1ecc-4eaa-8f41-13a54209f93d","title":"レポート","link":"menu-settings-page-topic.html","desc":"デバイス ［デバイス］のメニュー項目と説明 メニュー項目 説明 デバイス情報","descFull":"デバイス ［デバイス］のメニュー項目と説明 メニュー項目 説明 デバイス情報 プリンタに関する情報が記載されているレポートを印刷します。 デバイス統計 消耗品の状態、用紙枚数、ジョブ情報などのレポートを印刷します。 プロファイル一覧 プリンタに保存されているプロファイルの一覧を印刷します。 資産レポート 印刷に関する問題の診断ツールを印刷します。 内容がクリッピングされないようにするには、レポートをレターサイズまたは A4 サイズの用紙に印刷します。 メニュー デバイス"},{"UUID":"3f5486af-b0ef-4de5-952f-1a457701e216","title":"レポート","link":"menu-settings-page-topic.html","desc":"印刷 ［印刷］のメニュー項目と説明 メニュー項目 設定 説明","descFull":"印刷 ［印刷］のメニュー項目と説明 メニュー項目 設定 説明 フォントを印刷 PCL フォント PS フォント 各プリンタ言語で使用可能なフォントのサンプルと情報を印刷します。 デモを印刷 デモページ 印刷に関する問題の診断ツールを印刷します。 内容がクリッピングされないようにするには、レポートをレターサイズまたは A4 サイズの用紙に印刷します。 このメニュー項目は、プリンタにデモページがインストールされている場合にのみ表示されます。 ディレクトリ印刷 この設定はユーザーが定義します。 フラッシュメモリまたはプリンタのハードディスクに保存されているリソースを表示するレポートを印刷します。 メニュー 印刷"},{"UUID":"7650b55e-b95d-4ac2-aaef-8c5051f2259c","title":"レポート","link":"menu-settings-page-topic.html","desc":"ショートカット ［ショートカット］のメニュー項目と説明 メニュー項目 説明 すべてのショートカット","descFull":"ショートカット ［ショートカット］のメニュー項目と説明 メニュー項目 説明 すべてのショートカット プリンタに保存されているショートカット一覧のレポートを印刷します。 ［ FAX ショートカット ］は、 FAX  が取り付けられている場合にのみ表示されます。 FAX ショートカット コピーショートカット E メールショートカット FTP ショートカット ネットワークフォルダのショートカット メニュー ショートカット"},{"UUID":"2a8bb66a-ba03-4044-a47e-67dffa42124a","title":"レポート","link":"menu-settings-page-topic.html","desc":"Fax このメニューは、FAX が設定されていて、［ ジョブログを有効化 ］が［","descFull":"Fax このメニューは、FAX が設定されていて、［ ジョブログを有効化 ］が［ オン ］に設定されている場合にのみ表示されます。 FAX メニュー項目と説明 メニュー項目 説明 FAX ジョブログ 過去 200 件の完了した FAX ジョブに関するレポートを印刷します。 FAX 送信ログ ダイヤル、受信、ブロックされた過去 100 件の FAX に関するレポートを印刷します。 メニュー FAX"},{"UUID":"389484c4-570f-44a2-bb89-635f4bf7fdd4","title":"レポート","link":"menu-settings-page-topic.html","desc":"ネットワーク ［ネットワーク］のメニュー項目と説明 メニュー項目 説明 ネットワーク設定ページ","descFull":"ネットワーク ［ネットワーク］のメニュー項目と説明 メニュー項目 説明 ネットワーク設定ページ プリンタで設定されているネットワーク設定およびワイヤレス設定が記載されているページを印刷します。 このメニュー項目は、ネットワークプリンタ（またはプリントサーバーに接続されているプリンタ）でのみ表示されます。 Wi-Fi Direct に接続されているクライアント Wi‑Fi Directを使用してプリンタに接続されているデバイスのリストを表示するページを印刷します。 このメニュー項目は、［ Wi‑Fi Direct を有効化 ］が［ オン ］に設定されている場合にのみ表示されます。 メニュー ネットワーク"},{"UUID":"f5d7776f-5e08-473d-acea-5ed42732f489","title":"プリンタメニュー","link":"troubleshooting-menu-topic.html","desc":"トラブルシューティング ［トラブルシューティング］のメニュー項目と説明 メニュー項目 説明 印刷品質テストページ","descFull":"トラブルシューティング ［トラブルシューティング］のメニュー項目と説明 メニュー項目 説明 印刷品質テストページ サンプルページを印刷し、印刷品質の不良を特定して修正します。 スキャナを清掃する スキャナの清掃手順を印刷します。 メニュー トラブルシューティング 印刷品質テストページ スキャナを清掃する"},{"UUID":"79f6b482-0d78-44fd-b457-5b88f6e51f3f","title":"プリンタメニュー","link":"forms-merge-topic.html","desc":"Forms Merge このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ［Forms Merge］のメニュー項目と説明","descFull":"Forms Merge このメニュー項目は、ストレージドライブが取り付けられている場合にのみ表示されます。 ［Forms Merge］のメニュー項目と説明 メニュー項目 サブメニュー項目 設定 説明 値の横にあるアスタリスク（＊）は、その値が出荷時初期設定であることを示します。 マージモード 規定せず 印刷 ＊ データキャプチャ 無効 Forms Merge の動作モードを指定します。 データキャプチャターゲット 規定せず フラッシュ ＊ キャプチャしたデータの転送先を設定します。 このメニュー項目は、［ マージモード ］が［ データキャプチャ ］に設定されている場合にのみ表示されます。 印刷ポートとフィルタの設定 ネットワークポート オン * オフ ネットワークポートに送信されたすべてのデータを Forms Merge が処理できるようにします。 ネットワークフィルタ 無効 ＊ NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF プリンタに送信されるすべてのデータのネットワークフィルタを指定します。 USB ポート オン * オフ USB ポートに送信されたすべてのデータを Forms Merge が処理できるようにします。 USB フィルタ 無効 ＊ NULL OFIS OFIS+NULL OFIS+AS400 AS400 PCL ZPL ZPLF プリンタに送信されるすべてのデータの USB フィルタを指定します。 ローカルポートタイムアウト 1 ～ 100 （10＊） ローカルポートに送信される Forms Merge ジョブのタイムアウト値を指定します。 その他 すべてのフォームを印刷 開始 インテリジェントストレージドライブ（ISD）またはハードディスクに保存されたすべてのフォームセットを印刷します。 エラーページの印刷 オン * オフ Forms Merge ジョブでエラーが発生した場合にエラーページの印刷を有効にします。 メニュー Forms Merge"},{"UUID":"5f9a208a-18ea-4e1a-971a-5804db88e0c5","title":"プリンタメニュー","link":"printing-menu-settings-page-topic.html","desc":"［ メニュー設定ページ ］を印刷する 操作パネルで、［ 設定","descFull":"［ メニュー設定ページ ］を印刷する 操作パネルで、［ 設定 ］ ［ レポート ］の順に移動します。 ［ メニュー設定ページ ］を選択します。 印刷 メニュー設定ページ メニュー設定ページ 印刷 プリンタメニュー"},{"UUID":"6d060b07-e0bf-4a0b-9045-0b7229b8e6e7","title":"プリンタフィニッシャオプション","link":"using-staple-finisher-topic.html","desc":"ホチキスフィニッシャを使用する プリントドライバを使用してホチキスで綴じる Windows の場合 ドキュメントを開いている状態で、［","descFull":"ホチキスフィニッシャを使用する プリントドライバを使用してホチキスで綴じる Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 用紙/仕上げ ］をクリックし、［ 用紙 ］の設定を行います。 ［ ホチキス ］メニューから、設定を選択します。 ［ OK ］、［ 印刷 ］の順にクリックします。 Macintosh の場合 ドキュメントが開いている状態で、［ ファイル ］ ［ 印刷 ］の順に選択します。 プリンタを選択します。 ［ 仕上げオプション ］メニューから、［ 仕上げの適用 ］ ［ プリンタオプション ］を選択します。 ［ ホチキス ］をクリックし、設定を選択します。 ［ 印刷 ］をクリックします。 操作パネルを使用してホチキスで綴じる 操作パネルから［ 印刷 ］を選択して、印刷ジョブのソースを選択します。 原稿を選択します。 ［ その他の設定 ]を選択し、［ 仕上げオプション ］を選択します。 ［ ホチキス ］を選択し、設定を選択します。 ドキュメントを印刷します。 ホチキスフィニッシャ 使用する ホチキスで綴じる 印刷枚数 ホチキスで綴じる コピー文書"},{"UUID":"470adce4-f05a-4d8d-9e61-58ff993eac3c","title":"プリンタフィニッシャオプション","link":"using-staple-hole-punch-finisher-topic.html","desc":"ホチキス、穴パンチフィニッシャを使用する ホチキス、穴パンチフィニッシャを使用する プリントドライバを使用してホチキス綴じまたは穴パンチを行う Windows の場合","descFull":"ホチキス、穴パンチフィニッシャを使用する ホチキス、穴パンチフィニッシャを使用する プリントドライバを使用してホチキス綴じまたは穴パンチを行う Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 用紙/仕上げ ］をクリックし、［ 用紙 ］の設定を行います。 希望する仕上げによって、［ ホチキス ］または［ 穴パンチ ］の設定を選択します。 印刷物でホチキス綴じと穴パンチの両方を行う場合、両方の設定を選択できます。 ［ OK ］、［ 印刷 ］の順にクリックします。 Macintosh の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択します。 ［ 仕上げオプション ］メニューから、［ 仕上げの適用 ］ ［ プリンタオプション ］を選択します。 ［ ホチキス ］または［ パンチ ］をクリックし、設定を選択します。 ［ 印刷 ］をクリックします。 操作パネルを使用してホチキス留めまたは穴パンチを行う 操作パネルから［ 印刷 ］を選択して、印刷ジョブのソースを選択します。 原稿を選択します。 ［ その他の設定 ]を選択し、［ 仕上げオプション ］を選択します。 希望する仕上げによって、［ ホチキス ］または［ 穴パンチ ］の設定を選択します。 印刷物でホチキス綴じと穴パンチの両方を行う場合、両方の設定を選択できます。 ドキュメントを印刷します。 印刷された用紙をホチキスで綴じる 穴あけ 印刷した用紙 ホチキス、穴パンチフィニッシャ 使用する"},{"UUID":"a53fe89a-5f0e-40c3-b4b7-fbbd3df13811","title":"プリンタフィニッシャオプション","link":"using-offset-stacker-topic.html","desc":"オフセットスタッカを使用する プリントドライバを使用したオフセットスタック Windows の場合 ドキュメントを開いている状態で、［","descFull":"オフセットスタッカを使用する プリントドライバを使用したオフセットスタック Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 用紙/仕上げ ］をクリックし、［ 用紙 ］の設定を行います。 ［ オフセット ］メニューから、設定を選択します。 ［ OK ］、［ 印刷 ］の順にクリックします。 Macintosh の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択します。 ［ 仕上げオプション ］メニューから、［ 仕上げの適用 ］ ［ プリンタオプション ］を選択します。 ［ オフセット ］をクリックし、設定を選択します。 ［ 印刷 ］をクリックします。 操作パネルを使用したオフセットスタック 原稿を ADF トレイまたは原稿台にセットします。 画面が途切れることを防止するには、原稿と印刷物の用紙サイズが同じであることを確認してください。 操作パネルから［ コピー ］を選択して、コピー部数を指定します。 ［ その他の設定 ]を選択し、［ オフセットページ ］を選択します。 このメニューを有効にして、設定を選択します。 ドキュメントを印刷します。 オフセットスタッカ 使用する オフセットスタック"},{"UUID":"1da1be93-d660-4937-a962-d21bc09a36aa","title":"プリンタフィニッシャオプション","link":"using-booklet-finisher-topic.html","desc":"小冊子フィニッシャを使用する 小冊子を作成する前に、用紙の短辺をトレイの右側に向けてセットします。 プリントドライバを使用して小冊子を作成する Windows の場合","descFull":"小冊子フィニッシャを使用する 小冊子を作成する前に、用紙の短辺をトレイの右側に向けてセットします。 プリントドライバを使用して小冊子を作成する Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 小冊子 ］を選択します。 ［ 用紙/仕上げ ］タブをクリックし、用紙の設定を行います。 ［ 中折り ］メニューから、設定を選択します。 ［ OK ］、［ 印刷 ］の順にクリックします。 Macintosh の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択します。 ［ 仕上げオプション ］メニューから、［ 仕上げの適用 ］ ［ プリンタオプション ］を選択します。 ［ 小冊子 ］を選択して、［ 折り ］設定を選択します。 ［ OK ］をクリックします。 操作パネルを使用して小冊子を作成する 原稿を ADF トレイまたは原稿台にセットします。 画面が途切れることを防止するには、原稿と印刷物の用紙サイズが同じであることを確認してください。 操作パネルから［ コピー ］を選択して、設定を行います。 ［ その他の設定 ]を選択し、［ 小冊子の作成 ］を選択します。 ［ 小冊子仕上げ ］を有効にして、設定を選択します。 ドキュメントをコピーします。 小冊子を作成する 小冊子を作成する 小冊子フィニッシャ 使用する"},{"UUID":"31a0cabc-56a1-45f2-8f3b-e3717f947d5a","title":"プリンタフィニッシャオプション","link":"using-hptfu-topic.html","desc":"折り畳みオプション付きの用紙搬送ユニットを使用する プリントドライバを使用して用紙を折り畳む Windows の場合 ドキュメントを開いている状態で、［","descFull":"折り畳みオプション付きの用紙搬送ユニットを使用する プリントドライバを使用して用紙を折り畳む Windows の場合 ドキュメントを開いている状態で、［ ファイル ］ ［ 印刷 ］をクリックします。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ 用紙/仕上げ ］をクリックし、用紙の設定を行います。 ［ 中折り ］メニューから、設定を選択します。 ［ OK ］、［ 印刷 ］の順にクリックします。 Macintosh の場合 ドキュメントが開いている状態で、［ ファイル ］ ［ 印刷 ］の順に選択します。 プリンタを選択します。 ［ 仕上げオプション ］メニューから、［ 仕上げの適用 ］ ［ プリンタオプション ］を選択します。 ［ 中折り ］をクリックし、設定を選択します。 ［ 印刷 ］をクリックします。 操作パネルを使用して用紙を折り畳む 原稿を ADF トレイまたは原稿台にセットします。 画面が途切れることを防止するには、原稿と印刷物の用紙サイズが同じであることを確認してください。 操作パネルから［ コピー ］を選択して、コピー部数を指定します。 ［ その他の設定 ]を選択し、［ 仕上げオプション ］を選択します。 ［ 中折り ］を選択して、設定を選択します。 ドキュメントをコピーします。 折り畳みオプション付き用紙搬送ユニット 使用する 印刷物を折り畳む コピーした文書を折り畳む"},{"UUID":"387a9681-bd63-4798-b82d-aae24a327b5f","title":"プリンタのメンテナンス","link":"checking-supplies-status-topic.html","desc":"部品と消耗品の状況を確認する 部品と消耗品の状況を確認する 操作パネルの右上隅で、 を選択します。 プリンタの部品と消耗品の状態を確認します。","descFull":"部品と消耗品の状況を確認する 部品と消耗品の状況を確認する 操作パネルの右上隅で、 を選択します。 プリンタの部品と消耗品の状態を確認します。 また、  を選択して、ユーザーの操作が必要となる通知を確認できます。 確認する、消耗品の状態 消耗品の状態 確認する プリンタの部品の状態 確認する"},{"UUID":"f656eb0f-8fe2-4938-9dd2-41ae5137132b","title":"プリンタのメンテナンス","link":"configuring-supply-notifications-topic.html","desc":"消耗品通知を設定する 消耗品通知を設定する Web ブラウザを開き、アドレスフィールドにプリンタの IP","descFull":"消耗品通知を設定する 消耗品通知を設定する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ 設定 ］ ［ デバイス ］ ［ 通知 ］をクリックします。 ［ 消耗品のカスタム通知 ］をクリックします。 各消耗品の通知を選択します。 変更を適用します。 消耗品通知 設定 消耗品通知を設定する"},{"UUID":"49768ad4-889a-46c6-a83e-1a1700e17f16","title":"プリンタのメンテナンス","link":"setting-up-email-alert-topic.html","desc":"E メールアラートを設定する E メールアラートを設定する Web","descFull":"E メールアラートを設定する E メールアラートを設定する Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ 設定 ］ ［ デバイス ］ ［ 通知 ］をクリックします。 ［ E メール警報の設定 ］をクリックし、設定を行います。 SMTP 設定の詳細については、E メールプロバイダにお問い合わせください。 変更を適用します。 ［ E メールリストおよびアラートの設定 ］をクリックし、設定を行います。 変更を適用します。 E メール警告 設定する E メールアラートを設定する"},{"UUID":"67fdc95e-99d6-41e6-8622-b17cc956d936","title":"プリンタのメンテナンス","link":"generating-reports-and-logs-topic.html","desc":"レポートとログを生成する レポートとログを生成する 操作パネルで、［ 設定 ］","descFull":"レポートとログを生成する レポートとログを生成する 操作パネルで、［ 設定 ］ ［ レポート ］の順に移動します。 印刷するレポートまたはログを選択します。 メニュー設定ページ-  — 現在のプリンタの環境設定、印刷設定および構成を表示します。 デバイス デバイス情報  — プリンタのシリアル番号、インストールされているソリューション、FAX を表示します。 デバイス統計  — 消耗品の状態、総印刷枚数、プリンタジョブ情報を表示します。 プロファイル一覧  — プリンタに保存されているプロファイルまたはショートカットの一覧を表示します。 資産レポート  — シリアル番号や機種名などのプリンタ資産情報を含むレポートを表示します。 印刷 フォントを印刷  — 各プリンタ言語で使用可能なフォントを表示します。 デモを印刷  — ファームウェア、フラッシュオプション、およびディスクオプションで使用可能なデモファイルを表示します。 ディレクトリ印刷  — フラッシュメモリ、ハードディスク、インテリジェントストレージドライブ（ISD）に保存されているリソースを表示します。 このレポートは、フラッシュメモリ、ハードディスク、ISD が取り付けられている場合にのみ表示されます。 ショートカット すべてのショートカット  — プリンタに保存されているすべてのショートカットの一覧を表示します。 FAX ショートカット  — プリンタに保存されている FAX ショートカットの一覧を表示します。 コピーショートカット  — プリンタに保存されているコピーショートカットの一覧を表示します。 E メールショートカット  — プリンタに保存されている E メールショートカットの一覧を表示します。 FTP ショートカット  — プリンタに保存されているファイル転送プロトコル（FTP）ショートカットの一覧を表示します。 ネットワークフォルダのショートカット  — プリンタに保存されているネットワークフォルダのショートカットの一覧を表示します。 Fax FAX ジョブログ  — 過去 200 件の完了した FAX ジョブの一覧を表示します。 このレポートは、［ ジョブログを有効化 ］が有効な場合にのみ表示されます。 FAX 送信ログ  — フラッシュメモリやストレージドライブに保存されているリソースを表示します。 このレポートは、フラッシュメモリまたはストレージドライブが取り付けられている場合にのみ表示されます。 ネットワーク ネットワーク設定ページ  — プリンタのネットワーク設定およびワイヤレス設定を表示します。 このレポートは、ネットワークプリンタ、またはプリントサーバーに接続されているプリンタでのみ表示されます。 Wi-Fi Direct に接続されているクライアント  — Wi-Fi Direct を使用してプリンタに接続されているデバイスの一覧を表示します。 このレポートは、［ Wi‑Fi Direct を有効化 ］が［ オン ］に設定されている場合にのみ表示されます。 レポートを印刷する ログを印刷する レポートとログを表示する メーター示度、表示する 印刷枚数、表示する"},{"UUID":"bef55607-a725-4732-8bca-69437a739444","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"米国で消耗品を注文するには、お住まいの地域の Lexmark 認定消耗品販売店について、1-800-539-6275 までお電話でお問い合わせください。他の国または地域については、 www.lexmark.com","descFull":"米国で消耗品を注文するには、お住まいの地域の Lexmark 認定消耗品販売店について、1-800-539-6275 までお電話でお問い合わせください。他の国または地域については、 www.lexmark.com  をご覧いただくか、プリンタの販売店までお問い合わせください。 消耗品を注文するには、プリンタの販売店までお問い合わせください。 プリンタの消耗品の耐用期間見積もりは、レターまたは A4 サイズの普通紙を想定しています。 最適なプリンタのパフォーマンスを維持できない場合や、部品や消耗品を交換できない場合は、プリンタの損傷が生じるおそれがあります。 純正の部品と消耗品"},{"UUID":"8ce5c041-19c5-47e9-8bf0-4982be13e089","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"Lexmark の純正部品と純正消耗品を使用する Lexmark プリンタは Lexmark","descFull":"Lexmark の純正部品と純正消耗品を使用する Lexmark プリンタは Lexmark の純正部品および純正消耗品を使用して最高の機能を発揮するように設計されています。サードパーティ製の消耗品や部品を使用すると、パフォーマンス、信頼性、プリンタの寿命およびイメージングコンポーネントに影響する場合があります。保証の対象にも影響します。サードパーティ製の部品や消耗品の使用による損傷は、保証の対象外となります。すべての寿命インジケータは、純正の部品および消耗品を使用して機能するように設計されており、サードパーティ製の部品や消耗品を使用すると、予期せぬ結果になることがあります。想定された寿命を超えてイメージングコンポーネントを使用すると、Lexmark プリンタや関連するコンポーネントが損傷する可能性があります。 返却プログラムの契約条項のない消耗品および部品は、リセットして再製造することができます。ただし、純正以外の消耗品または部品を使用したために発生した損傷については、製造元の保証は適用されません。適切に再生されていない消耗品および部品のカウンタをリセットするとプリンタが損傷する可能性があります。消耗品および部品のカウンタをリセットした後で、プリンタにリセットアイテムが存在することを示すエラーが表示される場合があります。 Lexmark の純正部品と純正消耗品を使用する Lexmark の純正部品と純正消耗品"},{"UUID":"74b99a4f-1054-482a-b332-2cddc27d48d8","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"トナーカートリッジを注文する トナーカートリッジを注文する 推定カートリッジ歩留まりは、ISO/IEC 19798 規格に基づいています。","descFull":"トナーカートリッジを注文する トナーカートリッジを注文する 推定カートリッジ歩留まりは、ISO/IEC 19798 規格に基づいています。 印刷部分が極端に少ない状態で長期間印刷すると、実際の印刷数に悪影響を与える可能性があります。 トナーカートリッジを注文するには、プリンタの販売店までお問い合わせください。 返却プログラムトナーカートリッジ Lexmark CX833、CX961、CX962、CX963 項目 米国、カナダ、オーストラリア、ニュージーランド 欧州連合、欧州経済領域、アイスランド、リヒテンシュタイン、ノルウェー、スイス 他のアジア太平洋地域 中南米、プエルトリコ、およびメキシコ その他の欧州、中東、アフリカ、欧州中東部、独立国家共同体 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 77L10C0 77L20C0 77L30C0 77L40C0 77L50C0 マゼンタ 77L10M0 77L20M0 77L30M0 77L40M0 77L50M0 イエロー 77L10Y0 77L20Y0 77L30Y0 77L40Y0 77L50Y0 ブラック 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 高出力回収プログラムトナーカートリッジ Lexmark CX833 項目 米国、カナダ、オーストラリア、ニュージーランド 欧州連合、欧州経済領域、アイスランド、リヒテンシュタイン、ノルウェー、スイス 他のアジア太平洋地域 中南米、プエルトリコ、およびメキシコ その他の欧州、中東、アフリカ、欧州中東部、独立国家共同体 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 79L10K0 79L20K0 79L30K0 79L40K0 79L50K0 マゼンタ 79L1HM0 79L2HM0 79L3HM0 79L4HM0 79L5HM0 イエロー 79L1HY0 79L2HY0 79L3HY0 79L4HY0 79L5HY0 ブラック 79L1HK0 79L2HK0 79L3HK0 79L4HK0 79L5HK0 Lexmark CX961、CX962、CX963 項目 米国、カナダ、オーストラリア、ニュージーランド 欧州連合、欧州経済領域、アイスランド、リヒテンシュタイン、ノルウェー、スイス 他のアジア太平洋地域 中南米、プエルトリコ、およびメキシコ その他の欧州、中東、アフリカ、欧州中東部、独立国家共同体 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 77L10K0 77L20K0 77L30K0 77L40K0 77L50K0 マゼンタ 77L1HM0 77L2HM0 77L3HM0 77L4HM0 77L5HM0 イエロー 77L1HY0 77L2HY0 77L3HY0 77L4HY0 77L5HY0 ブラック 77L1HK0 77L2HK0 77L3HK0 77L4HK0 77L5HK0 Lexmark XC8355 項目 米国、カナダ、オーストラリア、ニュージーランド 他の欧州諸国、中東、アフリカ 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 24B7574 24B7582 マゼンタ 24B7575 24B7583 イエロー 24B7576 24B7584 ブラック 24B7577 24B7585 Lexmark XC9635、XC9645、XC9655 項目 米国、カナダ、オーストラリア、ニュージーランド 他の欧州諸国、中東、アフリカ 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 24B7570 24B7578 マゼンタ 24B7571 24B7579 イエロー 24B7572 24B7580 ブラック 24B7573 24B7581 大容量標準トナーカートリッジ Lexmark CX833 項目 グローバル 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 77L0H20 マゼンタ 77L0H30 イエロー 77L0H40 ブラック 77L0H10 Lexmark CX961、CX962、CX963 項目 グローバル 各地域の国の情報については、 www.lexmark.com/regions  をご覧ください。 シアン 79L0H20 マゼンタ 79L0H30 イエロー 79L0H40 ブラック 79L0H10 消耗品を注文する トナーカートリッジ トナーカートリッジ 注文する"},{"UUID":"97287031-065a-425b-b8df-752ad9a16161","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"ブラックイメージングユニットを注文する ブラックイメージングユニットを注文する ブラックイメージングユニットを注文するには、プリンタの販売店までお問い合わせください。 ブラックイメージングユニットと部品番号 項目","descFull":"ブラックイメージングユニットを注文する ブラックイメージングユニットを注文する ブラックイメージングユニットを注文するには、プリンタの販売店までお問い合わせください。 ブラックイメージングユニットと部品番号 項目 部品番号 ブラックイメージングユニットの返却プログラム 77L0ZK0 ブラックイメージングユニット 77L0Z10 ブラックイメージングユニット 注文する 消耗品を注文する ブラックイメージングユニット"},{"UUID":"04669078-ee1d-4a72-aa90-41b8a53f4aaf","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"カラーイメージングキットを注文する カラーイメージングキットを注文するには、プリンタの販売店までお問い合わせください。 項目 部品番号 カラーイメージングキット返却プログラム","descFull":"カラーイメージングキットを注文する カラーイメージングキットを注文するには、プリンタの販売店までお問い合わせください。 項目 部品番号 カラーイメージングキット返却プログラム 77L0ZV0 正規のカラーイメージングキット 77L0Z50 カラーイメージングキット 注文する 消耗品を注文する カラーイメージングキット"},{"UUID":"5539b857-8ba5-4d4c-9bc6-4cd5fc7a0e4e","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"廃トナーボトルを注文する 廃トナーボトルを注文する 廃トナーボトルを注文するには、プリンタの販売店までお問い合わせください。 廃トナーボトルの部品番号 項目","descFull":"廃トナーボトルを注文する 廃トナーボトルを注文する 廃トナーボトルを注文するには、プリンタの販売店までお問い合わせください。 廃トナーボトルの部品番号 項目 部品番号 廃トナーボトル 77L0W00 消耗品を注文する 廃トナーボトル 廃トナーボトル 注文する"},{"UUID":"12d745bd-e4d5-4595-b890-867fb47865e5","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"ホチキスカートリッジを注文する ホチキスカートリッジを注文するには、プリンタの販売店までお問い合わせください。 ホチキスカートリッジと部品番号 項目 部品番号","descFull":"ホチキスカートリッジを注文する ホチキスカートリッジを注文するには、プリンタの販売店までお問い合わせください。 ホチキスカートリッジと部品番号 項目 部品番号 1  冊子メーカーでのみ使用可能。 2  冊子フィニッシャ、ホチキスフィニッシャ、およびホチキス、穴パンチフィニッシャでのみ使用可能。 ホチキスカートリッジ（4 パック） 1 20L7500 ホチキスカートリッジ（3 パック） 2 25A0013 ホチキスカートリッジ 注文する 消耗品を注文する ホチキスカートリッジ"},{"UUID":"dbf2f9be-a7da-492a-af55-f151e89b048d","title":"部品と消耗品を注文する","link":"ordering-parts-and-supplies-group.html","desc":"メンテナンスキットを注文する メンテナンスキットを注文する メンテナンスキットを注文するには、プリンタの販売店までお問い合わせください。 メンテナンスキットをプリンタの電圧と合わせます。 特定のタイプの用紙を使用するには、メンテナンスキットをより頻繁に交換しなければならない場合があります。","descFull":"メンテナンスキットを注文する メンテナンスキットを注文する メンテナンスキットを注文するには、プリンタの販売店までお問い合わせください。 メンテナンスキットをプリンタの電圧と合わせます。 特定のタイプの用紙を使用するには、メンテナンスキットをより頻繁に交換しなければならない場合があります。 メンテナンスキットには、フューザーとピックタイヤが含まれます。必要に応じて、これらの部品は個別に注文して交換することができます。 推奨メンテナンスキットと部品番号 項目 部品番号 認定サービス技術者のみがメンテナンスキットを交換できます。サービスプロバイダにお問い合わせください。 100 V 回収プログラムフューザーメンテナンスキット、タイプ 02 41X5654 110-120 V 回収プログラムフューザーメンテナンスキット、タイプ 00 41X5655 220-240 V 回収プログラムフューザーメンテナンスキット、タイプ 01 41X5656 100 V 標準フューザーメンテナンスキット、タイプ 12 41X6053 110-120 V フューザーメンテナンスキット、タイプ 10 41X6051 220-240 V フューザーメンテナンスキット、タイプ 11 41X6052 消耗品を注文する フューザーメンテナンスキット フューザーメンテナンスキット 注文する"},{"UUID":"d1c6d1d8-2188-4b4e-a13c-8f7744643bd7","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"トナーカートリッジを交換する トナーカートリッジを交換する 前面ドアを開きます。 使用済みトナーカートリッジを取り外します。 新しいトナーカートリッジを包装から取り出します。","descFull":"トナーカートリッジを交換する トナーカートリッジを交換する 前面ドアを開きます。 使用済みトナーカートリッジを取り外します。 新しいトナーカートリッジを包装から取り出します。 新しいトナーカートリッジを挿入し、 カチッ と音がすることを確認します。 ドアを閉じます。 トナーカートリッジ 交換する 消耗品を交換する トナーカートリッジ"},{"UUID":"339820a3-7674-41ef-90b8-83a998976a8d","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"ブラックイメージングユニットを交換する 前面ドアを開きます。 トナーカートリッジを取り外します。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。","descFull":"ブラックイメージングユニットを交換する 前面ドアを開きます。 トナーカートリッジを取り外します。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。 イメージングキットを取り外します。 イメージングキットを直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 フォトコンダクタードラムには触らないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 フォトコンダクタードラムに傷や損傷を与えないように、イメージングキットを清潔で平らな場所に、垂直に置きます。 使用済みのブラックイメージングユニットのロックを解除します。 使用済みのブラックイメージングユニットを取り外します。 新しいブラックイメージングユニットの梱包を取り外します。 新しいブラックイメージングユニットを挿入します。 新しいブラックイメージングユニットをロックします。 イメージングキットがしっかりと装着されるまで挿入します。 廃トナーボトルを挿入し、 カチッ と音がすることを確認します。 プリントヘッドワイパーをゆっくりと引き出し、プリントヘッドレンズを清掃します。 プリントヘッドレンズの清掃の詳細については、 を参照してください。 トナーカートリッジを挿入します。 ドアを閉じます。 ブラックイメージングユニット 交換する 消耗品を交換する ブラックイメージングユニット"},{"UUID":"d87b6edd-6ff6-4690-9bfe-cdddd02240f8","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"カラーイメージングキットを交換する 前面ドアを開きます。 トナーカートリッジを取り外します。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。","descFull":"カラーイメージングキットを交換する 前面ドアを開きます。 トナーカートリッジを取り外します。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。 使用済みイメージングキットを取り外します。 フォトコンダクタードラムに傷や損傷を与えないように、イメージングキットを清潔で平らな場所に、垂直に置きます。 ブラックイメージングユニットのロックを解除します。 ブラックイメージングユニットを取り外します。 このブラックイメージングユニットは捨てないでください。これは、新しいイメージングキットに取り付けます。 新しいイメージングキットを包装から取り出します。 イメージングキットには、イメージングバスケットとシアン、マゼンタ、およびイエローの現像体ユニットがあります。 イメージングキットを直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 フォトコンダクタードラムには触らないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニットを新しいイメージングキットに挿入します。 ブラックイメージングユニットをロックします。 新しいイメージングキットを挿入し、しっかりと装着します。 廃トナーボトルを挿入し、 カチッ と音がすることを確認します。 プリントヘッドワイパーをゆっくりと引き出し、プリントヘッドレンズを清掃します。 プリントヘッドレンズの清掃の詳細については、 を参照してください。 トナーカートリッジを挿入します。 ドアを閉じます。 カラーイメージングキット 交換する 消耗品を交換する カラーイメージングキット"},{"UUID":"2416a758-ea2a-4fa6-960a-444a7ec88c96","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"廃トナーボトルを交換する 廃トナーボトルを交換する 前面ドアを開きます。 使用済の廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。","descFull":"廃トナーボトルを交換する 廃トナーボトルを交換する 前面ドアを開きます。 使用済の廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。 新しい廃トナーボトルの梱包を取り外します。 廃トナー転送ボックスを挿入し、 カチッ と音がすることを確認してから、ドアを閉じます。 消耗品を交換する 廃トナーボトル 廃トナーボトル 交換する"},{"UUID":"92edb087-b5b7-4fc7-93b9-bd13f08f51de","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"フューザーを交換する フューザーを交換する プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 ドア","descFull":"フューザーを交換する フューザーを交換する プリンタの電源を切ります。 電源コードをコンセントから抜き、次にプリンタから抜きます。 ドア B を開きます。 プリンタの内部が高温になっている場合があります。高温のコンポーネントによる負傷の危険を減らすために、コンポーネントの表面が冷えるのを待ってから触れてください。 使用済みのフューザーのロックを解除してから、取り外します。 新しいフューザーを梱包から取り出します。 新しいフューザーを挿入して、 カチッ と音がすることを確認してから、ロックします。 ドア B を閉じます。 電源コードの一方の端をプリンタに接続してから、もう一方の端をコンセントに差し込みます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源を入れます。 フューザー 交換する 部品を交換する フューザー"},{"UUID":"99cfb964-84bc-410d-950a-2e728e9cd719","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"トレイの引き出し部を交換する トレイの引き出し部を交換する 使用済みのトレイの引き出し部を引き出します。 新しいトレイの引き出し部を梱包から取り出します。 新しいトレイの引き出し部を挿入します。","descFull":"トレイの引き出し部を交換する トレイの引き出し部を交換する 使用済みのトレイの引き出し部を引き出します。 新しいトレイの引き出し部を梱包から取り出します。 新しいトレイの引き出し部を挿入します。 トレイの引き出し部 交換する 部品を交換する トレイの引き出し部"},{"UUID":"a70ae2c3-492b-41bd-936c-14168a181ea6","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"オプションの 550 枚給紙トレイでガイドを交換する オプションの 550","descFull":"オプションの 550 枚給紙トレイでガイドを交換する オプションの 550 枚給紙トレイでガイドを交換する トレイを引き出します。 使用済みのサイズガイドを取り外します。 新しいサイズガイドを梱包から取り出します。 新しいサイズガイドを挿入し、 カチッ と音がすることを確認します。 トレイを挿入します。 サイズガイド 交換する 部品を交換する サイズガイド"},{"UUID":"1ca1c102-7eda-4dd6-ad11-bf6d13ca9d5b","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"オプションの 550 枚給紙トレイのカバーを交換する オプションの 550","descFull":"オプションの 550 枚給紙トレイのカバーを交換する オプションの 550 枚給紙トレイのカバーを交換する 使用済みのトレイカバーを取り外します。 新しいトレイカバーを梱包から取り出します。 新しいトレイカバーを挿入し、カチッという音がすることを確認します。 部品を交換する トレイカバー トレイカバー 交換する 550 枚トレイカバー"},{"UUID":"f6924c03-45b6-47e0-b7e1-febc139444c4","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"小冊子フィニッシャ上部排紙トレイ拡張機能を交換する 使用済みの上部排紙トレイ拡張機能を取り外します。 新しいアクセス上部排紙トレイ拡張機能を梱包から取り出します。 新しい上部排紙トレイ拡張機能を挿入します。 部品を交換する","descFull":"小冊子フィニッシャ上部排紙トレイ拡張機能を交換する 使用済みの上部排紙トレイ拡張機能を取り外します。 新しいアクセス上部排紙トレイ拡張機能を梱包から取り出します。 新しい上部排紙トレイ拡張機能を挿入します。 部品を交換する 小冊子フィニッシャ上部排紙トレイ拡張機能 小冊子フィニッシャ上部排紙トレイ拡張機能 交換する"},{"UUID":"1924204f-ad7d-4320-b775-acefa7954269","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"穴パンチボックスを交換する 取り付けているフィニッシャによって、穴パンチボックスの外観は異なる場合があります。 フィニッシャのドアを開きます。 使用済みのホールパンチボックスを取り外します。 新しい穴パンチボックスを取り出します。","descFull":"穴パンチボックスを交換する 取り付けているフィニッシャによって、穴パンチボックスの外観は異なる場合があります。 フィニッシャのドアを開きます。 使用済みのホールパンチボックスを取り外します。 新しい穴パンチボックスを取り出します。 新しい穴パンチボックスを挿入します。 フィニッシャのドアを閉じます。 部品を交換する 穴パンチボックス 穴パンチボックス 交換する"},{"UUID":"f0701617-906c-4080-8c3b-80342ef655fd","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"標準排紙トレイを交換する 標準排紙トレイを交換する 使用済みの標準排紙トレイを取り外します。 新しい標準排紙トレイを梱包から取り出します。 新しい標準排紙トレイを取り付けます。","descFull":"標準排紙トレイを交換する 標準排紙トレイを交換する 使用済みの標準排紙トレイを取り外します。 新しい標準排紙トレイを梱包から取り出します。 新しい標準排紙トレイを取り付けます。 部品を交換する 標準排紙トレイ 標準排紙トレイ 交換する"},{"UUID":"3ffe2130-c81c-4031-a62e-35c5123009e9","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"ファンカバーを交換する 使用済みのファンカバーを取り外します。 新しいカバーを梱包から取り出します。 新しいカバーを挿入し、 カチッ","descFull":"ファンカバーを交換する 使用済みのファンカバーを取り外します。 新しいカバーを梱包から取り出します。 新しいカバーを挿入し、 カチッ という音がすることを確認します。 部品を交換する ファンカバー ファンカバー 交換する"},{"UUID":"69c61e91-62d3-485f-abd0-e5eb521e173d","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"右側カバーを交換する 使用中の右側カバーを取り外します。 新しいカバーを梱包から取り出します。 新しいカバーを挿入し、 カチッ","descFull":"右側カバーを交換する 使用中の右側カバーを取り外します。 新しいカバーを梱包から取り出します。 新しいカバーを挿入し、 カチッ という音がすることを確認します。 部品を交換する 右側カバー 右側カバー 交換する"},{"UUID":"2d47bd4b-9ba8-4f60-bcaa-92a0281e8941","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"ガラスクリーナーツールを交換する スキャナカバーを開きます。 使用済みのガラスクリーナーツールを取り外します。 新しいガラスクリーナーツールを梱包から取り出します。 新しいガラスクリーナーツールを挿入します。","descFull":"ガラスクリーナーツールを交換する スキャナカバーを開きます。 使用済みのガラスクリーナーツールを取り外します。 新しいガラスクリーナーツールを梱包から取り出します。 新しいガラスクリーナーツールを挿入します。 スキャナカバーを閉じます。 部品を交換する ガラスクリーナーツール ガラスクリーナーツール 交換する"},{"UUID":"c70ef733-9320-4892-b614-505b98bbc7a4","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"用紙搬送ユニットのコネクタカバーを交換する 用紙搬送ユニットのコネクタカバーを交換する 標準排紙トレイを取り外します。 使用済みの用紙搬送ユニットのコネクタカバーを取り外します。 新しいコネクタカバーを梱包から取り出します。","descFull":"用紙搬送ユニットのコネクタカバーを交換する 用紙搬送ユニットのコネクタカバーを交換する 標準排紙トレイを取り外します。 使用済みの用紙搬送ユニットのコネクタカバーを取り外します。 新しいコネクタカバーを梱包から取り出します。 新しいコネクタカバーを取り付け、 カチッ と音がすることを確認します。 標準排紙トレイを取り付けます。 部品を交換する 用紙搬送ユニットのコネクタカバー 用紙搬送ユニットのコネクタカバー 交換する"},{"UUID":"e307a5fc-d204-4202-8f07-f03bc0ceaf8f","title":"ホチキスカートリッジユニットを交換する","link":"replacing-toner-cartridge-topic.html","desc":"ホチキスフィニッシャのホチキスカートリッジを交換する ハンドル F をつかんで、ホチキスフィニッシャを左にスライドします。 ホチキスカートリッジホルダーを取り外します。","descFull":"ホチキスフィニッシャのホチキスカートリッジを交換する ハンドル F をつかんで、ホチキスフィニッシャを左にスライドします。 ホチキスカートリッジホルダーを取り外します。 空のホチキスカートリッジを取り外します。 新しいホチキスカートリッジを、所定の位置で カチッ という音がするまで挿入します。 カチッ と音がするまで、ホチキスカートリッジホルダーを挿入します。 ホチキスフィニッシャを右にスライドします。 消耗品を交換する ホチキスカートリッジ ホチキスカートリッジ 交換する"},{"UUID":"4ea54481-03d2-42c0-8e75-8e053a16a11b","title":"ホチキスカートリッジユニットを交換する","link":"replacing-toner-cartridge-topic.html","desc":"ホチキス、穴パンチフィニッシャのホチキスカートリッジを交換する ドア H を開きます。 緑色のハンドルを引き抜き、ホチキスカートリッジホルダーを取り外します。","descFull":"ホチキス、穴パンチフィニッシャのホチキスカートリッジを交換する ドア H を開きます。 緑色のハンドルを引き抜き、ホチキスカートリッジホルダーを取り外します。 空のホチキスカートリッジを取り外します。 新しいホチキスカートリッジを包装から取り出します。 新しいホチキスカートリッジを、所定の位置で カチッ という音がするまで挿入します。 カチッ と音がするまで、ホチキスカートリッジホルダーを挿入します。 ドア H を閉じます。 消耗品を交換する ホチキスカートリッジ ホチキスカートリッジ 交換する"},{"UUID":"d11a6221-1017-4a79-8b08-b6fa27424e4f","title":"ホチキスカートリッジユニットを交換する","link":"replacing-toner-cartridge-topic.html","desc":"冊子フィニッシャのホチキスカートリッジを交換する ドア H を開きます。 緑色のハンドルを引き抜き、ホチキスカートリッジホルダーを取り外します。","descFull":"冊子フィニッシャのホチキスカートリッジを交換する ドア H を開きます。 緑色のハンドルを引き抜き、ホチキスカートリッジホルダーを取り外します。 空のホチキスカートリッジを取り外します。 新しいホチキスカートリッジを包装から取り出します。 新しいホチキスカートリッジを、所定の位置で カチッ という音がするまで挿入します。 カチッ と音がするまで、ホチキスカートリッジホルダーを挿入します。 ドア H を閉じます。 消耗品を交換する ホチキスカートリッジ ホチキスカートリッジ 交換する"},{"UUID":"0157ab8f-0237-4451-b568-7273861fb822","title":"ホチキスカートリッジユニットを交換する","link":"replacing-toner-cartridge-topic.html","desc":"冊子フィニッシャのホチキスカートリッジホルダーの交換 フィニッシャのドアを開きます。 冊子メーカーを引き出し、使用済みホチキスカートリッジホルダーを取り外します。 新しいホチキスカートリッジを梱包から取り出します。 新しいホチキスカートリッジホルダーを挿入します。","descFull":"冊子フィニッシャのホチキスカートリッジホルダーの交換 フィニッシャのドアを開きます。 冊子メーカーを引き出し、使用済みホチキスカートリッジホルダーを取り外します。 新しいホチキスカートリッジを梱包から取り出します。 新しいホチキスカートリッジホルダーを挿入します。 冊子メーカーを挿入し、フィニッシャのドアを閉じます。 部品を交換する ホチキスカートリッジホルダー ホチキスカートリッジホルダー 交換する"},{"UUID":"c499b077-49fd-4581-bd4d-39962576ae9f","title":"部品と消耗品を交換する","link":"replacing-toner-cartridge-topic.html","desc":"消耗品使用量カウンタをリセットする 消耗品使用量カウンタをリセットする 操作パネルで、［ 設定 ］","descFull":"消耗品使用量カウンタをリセットする 消耗品使用量カウンタをリセットする 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 設定メニュー ］ ［ 消耗品使用量とカウンタ ］の順に移動します。 リセットするカウンタを選択します。 返却プログラムの契約条項のない消耗品および部品は、リセットして再製造することができます。ただし、純正以外の消耗品または部品を使用したために発生した損傷については、製造元の保証は適用されません。適切に再生されていない消耗品および部品のカウンタをリセットするとプリンタが損傷する可能性があります。消耗品および部品のカウンタをリセットした後で、プリンタにリセットアイテムが存在することを示すエラーが表示される場合があります。 使用後返却プログラムの契約条項のない消耗品および部品は、リセットして再製造することができます。ただし、純正以外の消耗品または部品を使用したために発生した損傷については、製造元の保証は適用されません。適切に再生されていない消耗品および部品のカウンタをリセットするとプリンタが損傷する可能性があります。消耗品および部品のカウンタをリセットした後で、プリンタにリセットアイテムが存在することを示すエラーが表示される場合があります。 消耗品使用量カウンタ リセット 消耗品使用量カウンタをリセットする"},{"UUID":"468f9017-dbb6-4fb9-815a-dbfe6a914984","title":"プリンタ部品を清掃する","link":"cleaning-printer-topic.html","desc":"プリンタを清掃する プリンタを清掃する プリンタの外部を清掃する際には、感電のリスクを避けるため、コンセントから電源コードを抜き、プリンタに接続されているすべてのケーブルを外してから作業を行ってください。 数か月に 1","descFull":"プリンタを清掃する プリンタを清掃する プリンタの外部を清掃する際には、感電のリスクを避けるため、コンセントから電源コードを抜き、プリンタに接続されているすべてのケーブルを外してから作業を行ってください。 数か月に 1 回この作業を実施します。 不適切な取り扱いにより生じたプリンタの損傷は、保証の対象にはなりません。 プリンタの電源を切り、電源コードをコンセントから抜きます。 標準排紙トレイと多目的フィーダから用紙を取り除きます。 柔らかいブラシや掃除機で、プリンタ周辺のほこり、糸くず、紙片を取り除きます。 プリンタの外側を、水で湿らせた柔らかい糸くずの出ない布で拭きます。 家庭用クリーナーや洗剤を使用しないでください。プリンタ表面の仕上げを傷つけることがあります。 清掃後にプリンタのすべてのエリアが乾いていることを確認してください。 電源コードをコンセントに接続し、プリンタの電源を入れます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタを清掃する プリンタ、清掃する"},{"UUID":"cb1d92ce-931e-4872-8a71-85559f8b9b96","title":"プリンタ部品を清掃する","link":"cleaning-printer-topic.html","desc":"タッチ画面を清掃する タッチ画面を清掃する プリンタの外部を清掃する際には、感電のリスクを避けるため、コンセントから電源コードを抜き、プリンタに接続されているすべてのケーブルを外してから作業を行ってください。 プリンタの電源を切り、電源コードをコンセントから抜きます。 タッチ画面を、水で湿らせた柔らかい糸くずの出ない布で拭きます。","descFull":"タッチ画面を清掃する タッチ画面を清掃する プリンタの外部を清掃する際には、感電のリスクを避けるため、コンセントから電源コードを抜き、プリンタに接続されているすべてのケーブルを外してから作業を行ってください。 プリンタの電源を切り、電源コードをコンセントから抜きます。 タッチ画面を、水で湿らせた柔らかい糸くずの出ない布で拭きます。 タッチ画面を傷める可能性がありますので、家庭用クリーナーや洗剤は使用しないでください。 清掃後は、タッチ画面が乾燥していることを確認してください。 電源コードをコンセントに接続し、プリンタの電源を入れます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 タッチ画面、清掃する タッチ画面を清掃する"},{"UUID":"64f8a3d6-6a39-4571-a2b9-61fde161c158","title":"プリンタ部品を清掃する","link":"cleaning-printer-topic.html","desc":"スキャナを清掃する スキャナカバーを開きます。 ガラスクリーナーツールを取り外します。 ドア A1","descFull":"スキャナを清掃する スキャナカバーを開きます。 ガラスクリーナーツールを取り外します。 ドア A1 を開きます。 このクリーナーツールで ADF のガラスを拭きます。 ドア A1 を閉じます。 下に示した領域を、水で湿らせた柔らかい糸くずの出ない布で拭きます。 ADF ガラスパッド スキャナガラスパッド 原稿台 このクリーナーツールで ADF のガラスを拭きます。 ツールを元の場所に戻します。 スキャナカバーを閉じます。 スキャナ 清掃する 印刷品質 スキャナを清掃する スキャナを清掃する"},{"UUID":"1158f777-f706-4042-8fce-806110d7d8d7","title":"プリンタ部品を清掃する","link":"cleaning-printer-topic.html","desc":"プリントヘッドレンズの清掃 前面ドアを開きます。 トナーカートリッジを取り外します。 ワイパーが止まるまでゆっくりと引き出します。 ワイパーはプリンタからは外れません。","descFull":"プリントヘッドレンズの清掃 前面ドアを開きます。 トナーカートリッジを取り外します。 ワイパーが止まるまでゆっくりと引き出します。 ワイパーはプリンタからは外れません。 ワイパーが止まるまでプリントヘッドに押し戻します。 各プリントヘッドについて、 ステップ 3  と  ステップ 4  を 3 回繰り返します。 トナーカートリッジを挿入します。 前面ドアを閉じます。 プリントヘッドレンズ 清掃する プリントヘッドレンズの清掃"},{"UUID":"45c6731a-2e7c-4fc5-a425-e2a6a7a0778f","title":"プリンタ部品を清掃する","link":"cleaning-printer-topic.html","desc":"ホールパンチボックスを空にする 取り付けているフィニッシャによって、ホールパンチボックスの外観は異なる場合があります。 フィニッシャのドアを開きます。 ホールパンチボックスを取り外して空にします。 ホールパンチボックスを挿入します。","descFull":"ホールパンチボックスを空にする 取り付けているフィニッシャによって、ホールパンチボックスの外観は異なる場合があります。 フィニッシャのドアを開きます。 ホールパンチボックスを取り外して空にします。 ホールパンチボックスを挿入します。 フィニッシャのドアを閉じます。 ホールパンチボックス 空にする ホールパンチボックスを空にする"},{"UUID":"7d9f0945-8371-4f33-88c7-507e2d4ea7db","title":"電力と用紙を節約する","link":"configuring-power-save-mode-settings-topic.html","desc":"節電モードを設定する 節電モードを設定する スリープモード 操作パネルで、［ 設定","descFull":"節電モードを設定する 節電モードを設定する スリープモード 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 電源管理 ］ ［ タイムアウト ］ ［ スリープモード ］の順に移動します。 プリンタが スリープモード に移行するまでのアイドル時間を設定します。 休止モード 操作パネルから、［ 設定 ］ ［ デバイス ］ ［ 電源管理 ］ ［ タイムアウト ］ ［ 休止時間 ］の順に移動します。 プリンタが休止モードに移行するまでのアイドル時間を設定します。 ［ 休止時間 ］を作動させるには、［ ネットワーク接続時の休止時間 ］を［ 休止モードにする ］に設定します。 プリンタがハイバネートモードの場合、内蔵 Web サーバーは無効です。 スリープモード 設定 休止モード 設定 節電モード 設定"},{"UUID":"32972de1-c9c3-435a-a479-01a32da12671","title":"電力と用紙を節約する","link":"configuring-power-save-mode-settings-topic.html","desc":"ディスプレイの明るさを調整する ディスプレイの明るさを調整する 操作パネルで、［ 設定 ］","descFull":"ディスプレイの明るさを調整する ディスプレイの明るさを調整する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 基本設定 ］の順に移動します。 ［ 画面の明るさ ］メニューで、設定を調整します。 ディスプレイの明るさ 調整 明るさを調整する"},{"UUID":"20ad2edc-2d83-4b80-9f8b-53db8e55a411","title":"電力と用紙を節約する","link":"configuring-power-save-mode-settings-topic.html","desc":"消耗品を節約する 用紙の両面に印刷します。 両面印刷は、プリンタの標準設定です。 1 枚の用紙に複数のページを割り付けて印刷します。","descFull":"消耗品を節約する 用紙の両面に印刷します。 両面印刷は、プリンタの標準設定です。 1 枚の用紙に複数のページを割り付けて印刷します。 プレビュー機能を使用して、印刷前にドキュメントがどのように印刷されるか確認します。 ドキュメントを 1 部だけ印刷し、内容と形式に間違いがないかどうかを確認します。 消耗品を節約する 消耗品、節約する"},{"UUID":"fdcd425b-00e5-4736-8370-c223e85f98e5","title":"プリンタのメンテナンス","link":"moving-printer-topic.html","desc":"プリンタを別の場所に移動する プリンタを別の場所に移動する プリンタの重量が 20 kg（44","descFull":"プリンタを別の場所に移動する プリンタを別の場所に移動する プリンタの重量が 20 kg（44 ポンド）以上ある場合、安全に持ち上げるには 2 名以上の人が必要になることがあります。 火災や感電の危険を避けるため、製品に同梱されている電源コード、または製造元が代替品として認可した電源コードのみを使用してください。 プリンタを移動する場合は、けがやプリンタの破損を避けるため、以下のガイドラインに従ってください。 すべてのドアとトレイが閉じられていることを確認します。 プリンタの電源を切り、電源コードをコンセントから抜きます。 プリンタからコードやケーブル類をすべて取り外します。 プリンタに別途フロアスタンド型オプショントレイまたは排紙オプションが取り付けられている場合は、それらを取り外してからプリンタを移動します。 プリンタにキャスターベースがある場合は、慎重に新しい場所に移動します。しきいや床の割れ目を通るときは注意してください。 プリンタにキャスターベースがなく、オプションのトレイまたは排紙オプションで構成されている場合は、排紙オプションを取り外してからプリンタをトレイから取り外します。どのオプションの場合も、プリンタと同時に持ち上げないでください。 必ずプリンタの持ち手を使用してプリンタを持ち上げます。 プリンタの移動に台車を使用する場合は、プリンタの底面全体を載せられる台車を使用してください。 ハードウェアオプションの移動に台車を使用する場合は、オプション全体を載せられる台車を使用してください。 プリンタは直立状態に保ってください。 急激な動きは避けてください。 下に置くときにプリンタの下に指が入らないようにしてください。 プリンタの周囲に十分なスペースがあることを確認します。 不適切な移動により生じたプリンタの損傷は、保証の対象にはなりません。 プリンタを移動する"},{"UUID":"1d26dd35-2464-4e4f-90cb-f3343d1ca467","title":"問題をトラブルシューティングする","link":"print-quality-problems-topic.html","desc":"","descFull":"印刷品質の問題 現在発生している印刷品質問題に似ている画像を探して、その下のリンクをクリックして、問題を解決する手順を確認してください。"},{"UUID":"5e0f3590-2791-4b2f-b204-b262bd249388","title":"問題をトラブルシューティングする","link":"printer-error-codes-topic.html","desc":"プリンタのエラーコード エラーコードとその解決方法 エラーコード エラーメッセージ ソリューション","descFull":"プリンタのエラーコード エラーコードとその解決方法 エラーコード エラーメッセージ ソリューション 2.01 消耗品が必要です。 ［ ジョブをキャンセル ］を選択して、必要な消耗品を注文します。詳細については、 を参照してください。 3.01 標準排紙トレイが満杯になっています。 標準排紙トレイから用紙を取り除いてから、［ 続行 ］を選択します。 3.02、3.03、3.04 排紙トレイ［x］から用紙を取り除いてください。 標準排紙トレイから用紙を取り除いてから、［ 続行 ］を選択します。 7.13、7.23、7.33、7.43 トレイ［x］を挿入してください。 表示されているトレイを挿入します。 8.01 前面ドアを閉じます。 メンテナンスを実行する場合以外、前面ドアは閉じておいてください。 8.02、8.03、8.04、8.05、8.08、 8.10、8.11 ドア［x］を閉じてください。 メンテナンスを実行する場合以外、表示されたドアは閉じておいてください。 8.06 1500 枚トレイを再び取り付けます。 トレイがプリンタに正しく接続されていることを確認します。 8.07 ホチキスフィニッシャを再び取り付けます。 フィニッシャがプリンタに正しく接続されていることを確認します。 8.08 用紙搬送ユニットのカバー F を閉じてくさい。 メンテナンスを実行する場合以外、カバーは閉じておいてください。 8.09 用紙搬送ユニットのカバー G を閉じてくさい。 9 プリンタを再起動する必要があります。最後のジョブが完了していない可能性があります。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 11.11、11.21、11.31、11.41、11.51、 11.81、11.91 <source/> に <type/> <size/> をセットしてください。 指定されたトレイに用紙をセットします。詳細については、 を参照してください。 11.12、11.22、11.32、11.42、11.82、11.92 <source/> に <type/> <size/> <orientation/> をセットしてください。 12.11、12.21、12.31、12.41、12.51、12.91 <source/> を <type/> <size/> に変更してください。 表示されたトレイを引き出し、用紙を取り除き、正しい種類とサイズの用紙をセットします。詳細については、 を参照してください。 12.12、12.22、12.32、12.4212.92 <source/> を <type/> <size/> <orientation/> に変更してください。 31.00 穴パンチボックスが見つからないか満杯です。 ドア H を開きます。 穴パンチボックスを取り外します。 穴パンチボックスが満杯の場合は、空にします。 穴パンチボックスを挿入します。 ドア H を閉じます。 31.35、31.35A、31.35B 廃トナーボトルが見つからない、または反応がありません。取り付けなおしてください。 前面ドアを開きます。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。 廃トナーボトルを挿入します。 前面ドアを閉じます。 31.40z、31.41z、31.42z、31.43z ［カラー］トナーカートリッジが見つからない、または反応がありません。取り付けなおしてください。 前面ドアを開きます。 カートリッジを取り外します。 カートリッジを差し込みます。 前面ドアを閉じます。 31.60z 見つからないか応答しないブラックイメージングユニットを取り付け直してください。 前面ドアを開きます。 トナーカートリッジを取り外します。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。 イメージングキットを取り外します。 イメージングキットを直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 フォトコンダクタードラムには触らないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニットをロック解除してから取り外します。 ブラックイメージングユニットを挿入し、所定の位置にロックします。 イメージングキットがしっかりと装着されるまで挿入します。 廃トナーボトルを挿入します。 トナーカートリッジを挿入します。 前面ドアを閉じます。 31.64z 取り付けられていない、外れている、または応答しないカラーイメージングキットを取り付けなおしてください。 前面ドアを開きます。 トナーカートリッジを取り外します。 廃トナーボトルを取り外します。 トナーがこぼれるのを避けるため、ボトルは縦にして扱います。 イメージングキットを取り外します。 イメージングキットを直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 フォトコンダクタードラムには触らないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 イメージングキットがしっかりと装着されるまで挿入します。 廃トナーボトルを挿入します。 トナーカートリッジを挿入します。 前面ドアを閉じます。 31.80z 取り付けられていない、または応答しないフューザーを取り付けなおしてください。 ドア B を開きます。 プリンタの内部が高温になっている場合があります。高温のコンポーネントによる負傷の危険を減らすために、コンポーネントの表面が冷えるのを待ってから触れてください。 フューザーのロックを解除してから、取り外します。 フューザーを挿入し、所定の位置にロックします。 ドア B を閉じます。 32.40z、32.41z、32.42z、32.43z ［カラー］トナーカートリッジがサポートされていません。交換してください。 詳細については、 を参照してください。 32.60z サポートされていないブラックイメージングユニットを交換してください。 詳細については、 を参照してください。 32.65z サポートされていないカラーイメージングキットを交換してください。 詳細については、 を参照してください。 33.40z、33.41z、33.42z、33.43z 補充された標準[カラー]カートリッジ 詳細については、 を参照してください。 33.60z Lexmark の純正品ではないブラックイメージングユニットです。『ユーザーズガイド』を参照してください。 詳細については、 を参照してください。 33.64z Lexmark の純正品ではないカラーイメージングキットです。『ユーザーズガイド』を参照してください。 34.00 用紙が短すぎます。 トレイにセットされている用紙に合わせて、用紙サイズを設定します。操作パネルで、［ 設定 ］ ［ 用紙 ］ ［ トレイ ］ ［ 設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 34.10、34.20、34.30、34.40、34.50 ［給紙源］を確認し、ガイドと原稿の向きを調節してください。 表示されたトレイを引き出し、用紙が正しくセットされていることを確認します。詳細については、 を参照してください。 34.90 多目的フィーダを確認し、ガイドと原稿の向きを調節してください。 用紙が正しくセットされていることを確認します。詳細については、 を参照してください。 37.1 部単位印刷を行うのに十分なメモリがありません。 次のいずれかを実行します。 ［ 続行 ］を選択し、保存済みの一部のジョブの印刷を行って、残りの印刷ジョブの部単位印刷を開始します。 現在の印刷ジョブをキャンセルします。 37.3 メモリ不足です。保留ジョブが一部削除されました。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 38.1 メモリが満杯です。 次の手順を 1 つ以上実行します。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 現在の印刷ジョブをキャンセルします。 プリンタメモリを増設します。 印刷ジョブの部数を減らします。 39.1 複雑なページです。データが一部印刷されていない可能性があります。 次の手順を 1 つ以上実行します。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 現在の印刷ジョブをキャンセルします。 プリンタメモリを増設します。 印刷ジョブを再度送信する前に、印刷ジョブの複雑さを軽減し、サイズを小さくします。 印刷ジョブの部数を減らします。 ダウンロードしたフォントの数とサイズを減らします。 不要なフォントやマクロを印刷ジョブから削除します。 印刷ジョブ内のグラフィックスの数を減らします。 42.yyC、42.yyK、42.yyM、42.yyY ［カラー］トナーカートリッジを交換してください。プリンタの地域設定が一致しません。 詳細については、 を参照してください。 43.40Y、43.41Y、43.42Y、43.43Y ［カラー］トナーカートリッジをもう一度取り付けます。 前面ドアを開きます。 カートリッジを取り外します。 カートリッジを差し込みます。 前面ドアを閉じます。 43.40Z、43.41Z、43.42Z、43.43Z ［カラー］トナーカートリッジを交換してください。 詳細については、 を参照してください。 50 PPDS フォントエラー。 印刷ジョブで指定された PPDS フォントをインストールし、 ［続行］ を選択してプリンタで代替フォントを検索します。 51 フラッシュメモリ不良が検出されました。 次の手順を 1 つ以上実行します。 フラッシュメモリを交換します。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 現在の印刷ジョブをキャンセルします。 52 フラッシュメモリにリソースの空き容量が足りません。 次の手順を 1 つ以上実行します。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 フラッシュメモリに保存されているフォント、マクロ、その他のデータを削除します。 ストレージドライブを取り付けます。 フラッシュメモリに保存されていないダウンロード済みのフォントおよびマクロは削除されます。 58.4 排紙オプションの設定が不正です。 プリンタの電源を切り、正しい排紙トレイまたはフィニッシャを取り付けます。 61 ディスクが故障しています。取り外してください。 故障したストレージドライブを交換します。 62 ディスクがフルです。 次の手順を 1 つ以上実行します。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 ストレージドライブに保存されているフォントやマクロなどのデータを削除します。 ストレージドライブを取り付けます。 63 ディスクをフォーマットしてください。 フォーマットすると、ストレージドライブのすべての情報が消去されます。 ディスクをフォーマットするには、次の手順を実行します。 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 未使用時の消去 ］の順に移動します。 ［ ハードディスクのすべての情報を消去 ］を選択し、［ 消去 ］を選択します。 71.01 FAX ステーション名が設定されていません。システム管理者に連絡してください。 詳細については、 を参照してください。 71.02 FAX ステーション番号が設定されていません。システム管理者に連絡してください。 71.03 アナログ電話回線がモデムに接続されていません。FAX が無効です。 接続および回線を点検して信号を調べてください。詳細については、 を参照してください。 71.04 アナログ電話回線が間違ったポートに接続されています。 電話線を抜いて、LINE ポートに接続します。 71.06 HTTPS FAX サーバーに接続できません。 HTTPS FAX サーバーへの接続が切断されました。プリンタのインターネット接続を確認します。 71.07 HTTPS FAX サーバーにプリンタが登録されていません。 HTTPS FAX サーバーポータルのデバイスリストに、プリンタが追加されていることを確認してください。システム管理者に問い合わせてください。 71.11 FAX パーティション。 FAX パーティションが機能しません。システム管理者に問い合わせてください。 71.12 メモリがフルです。FAX を印刷できません。 [ すべて印刷 ]を選択すると、保存されている FAX の数だけ印刷されます。 71.13 メモリが満杯です。FAX を送信できません。 次のいずれかを実行します。 続行してもう一度 FAX を送信してみてください。 原稿を一度に 1 ページずつスキャンし、FAX 番号をダイヤルしてから、原稿を FAX します。 71.4 プリンタの時刻が正しくありません。 プリンタ時刻を設定します。操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 基本設定 ］ ［ 日付/時刻 ］ ［ 設定 ］の順に移動します。 72.01 E メール SMTP サーバーが設定されていません。システム管理者に連絡してください。 次のいずれかを実行します。 E メール機能を設定します。詳細については、 を参照してください。 エラーメッセージを無効にします。詳細については、 を参照してください。 72.02 Web リンクサーバーが設定されていません。システム管理者に連絡してください。 システム管理者に問い合わせてください。 72.04 FAX サーバーの送信先形式が設定されていません。システム管理者に連絡してください。 次のいずれかを実行します。 ［ 送信先形式 ］を設定します。操作パネルで、［ 設定 ］ ［ Fax ］ ［ Fax サーバー設定 ］ ［ 一般 Fax 設定 ］の順に移動します。 システム管理者に問い合わせてください。 75.01 セキュアエレメントが検出されました。 次のいずれかを実行します。 インストールされているセキュアエレメントを使用します。 プリンタは、既存の証明書をすべて消去します。また、ストレージドライブを消去して再フォーマットする場合もあります。 プリンタの電源を切り、セキュアエレメントを取り外します。 75.02 セキュアエレメントが認識されません。 75.03 セキュアエレメントとの通信中にエラーが発生しました。 次のいずれかを実行します。 セキュアエレメントの使用を中止します。 プリンタは、既存の証明書をすべて消去します。また、ストレージドライブを消去して再フォーマットする場合もあります。 プリンタの電源を切り、セキュアエレメントを取り外してから、再度取り付けます。 75.11 セキュアエレメントのアップデートに失敗しました。 次のいずれかを実行します。 アップデートを再試行します。 アップデートをキャンセルします。 プリンタは、既存の全ての証明書とストレージドライブの内容を消去する場合があります。 75.12 セキュアエレメントのアップデートが完了しませんでした。 次のいずれかを実行します。 プリンタを再起動します。 アップデートが完了するまで 10 秒間待ちます。 アップデートをキャンセルします。 プリンタは、既存の全ての証明書とストレージドライブの内容を消去する場合があります。 80.01、80.09 メンテナンスキットの残量がやや少なくなっています。 ［ 続行 ］を選択して、メッセージを消去します。 80.11、80.19 メンテナンスキットの残量が少なくなっています。 80.21、80.29 メンテナンスキットの残量が非常に少なくなっています。 80.31 メンテナンスキットを交換して印刷を続行してください。 詳細については、 を参照してください。 80.31 メンテナンスキットを交換してください。標準寿命を超過しています。 81.11 1500 枚トレイローラーキットの残量が少なくなっています。 ［ 続行 ］を選択して、メッセージを消去します。 81.31 1500 枚トレイローラーキットを交換してください。標準寿命を超過しています。 詳細については、 カスタマサポート に問い合わせてください。 82.00、82.02、82.09 廃トナーボトルがほぼ満杯です。 詳細については、 を参照してください。 82.3、82.32、82.33、82.39 廃トナーボトルを交換します。 83.1y 転写モジュールの残量が少なくなっています。 ［ 続行 ］を選択して、メッセージを消去します。 83.3y 転写モジュールを交換してください。標準寿命を超過しています。 詳細については、 カスタマサポート に問い合わせてください。 83.4y 転写モジュールを交換してください。 83.20 ホチキスカートリッジの残量が少なくなっています。 ［ 続行 ］を選択して、メッセージを消去します。 83.20 内部ステープル S2 の残量が少なくなっています。 83.20 外部ステープル S2 の残量が少なくなっています。 83.30 ホチキスカートリッジが空か、見つかりません。 次のいずれかを実行します。 ホチキスカートリッジを取り外してから挿入します。 ホチキスカートリッジを交換します。詳細については、  または を参照してください。 83.30 ホチキスカートリッジ S1 が空か、見つかりません。 次のいずれかを実行します。 ホチキスカートリッジを取り外してから挿入します。 ホチキスカートリッジを交換します。詳細については、 を参照してください。 83.30 内部ホチキスカートリッジ S2 が空か、見つかりません。 次のいずれかを実行します。 ホチキスカートリッジを取り外してから挿入します。 ホチキスカートリッジを交換します。詳細については、 を参照してください。 83.30 外部ステープルカートリッジ S2 が空か、見つかりません。 84.01K、84.03K、84.09K ブラックイメージングユニットの残量がやや少なくなっています。 ［ 続行 ］を選択して、メッセージを消去します。 84.11K、84.13K、84.19K ブラックイメージングユニットの残量が少なくなっています。 84.21C、84.03C、84.09C ブラックイメージングユニットの残量が非常に少なくなっています 。 84.01C、84.03C、84.09C カラーイメージングキットの残量がやや少なくなっています。 84.11C、84.13C、84.19C カラーイメージングキットの残量が少なくなっています。 84.21C、84.23C、84.29C カラーイメージングキットの残量が非常に少なくなっています。 84.31、84.33 ブラックイメージングユニットを交換してください。標準寿命を超過しています。 詳細については、 を参照してください。 84.31、84.33 カラーイメージングキットが標準寿命を超過しています。交換してください。 詳細については、 を参照してください。 84.41、84.43、84.48 印刷を続けるには、ブラックイメージングユニットを交換してください。 詳細については、 を参照してください。 84.41、84.43、84.48 印刷を続けるには、カラーイメージングキットを交換してください。 詳細については、 を参照してください。 86.23 まもなくスキャナメンテナンスが必要です。 ［ 続行 ］を選択して、メッセージを消去します。 86.33 ADF キットを交換してください。標準寿命を超過しています。 詳細については、 カスタマサポート に問い合わせてください。 88.00[x]、88.07[x]、88.08[x]、88.09[x] ［カラー］トナーカートリッジの残量がやや少なくなっています。 ［ 続行 ］を選択して、メッセージを消去します。 88.10[x]、88.17[x]、88.18[x]、88.19[x] ［カラー］トナーカートリッジの残量が少なくなっています。 88.20[x]、88.27[x]、88.28[x]、88.29[x] ［カラー］トナーカートリッジの残量が非常に少なくなっています。 88.30[x]、88.37[x]、88.38[x] ［カラー］トナーカートリッジを交換してください。推定残り <NUM/> ページです。 詳細については、 を参照してください。 88.30[x]、88.37[x]、88.38[x] ［カラー］トナーカートリッジを交換してください。 88.40[x]、88.47[x]、88.48[x] ［カラー］トナーカートリッジを交換してください。残り 0 ページです。 88.40[x]、88.47[x]、88.48[x] ［カラー］トナーカートリッジを交換してください。 200.03、200.05、200.12、200.13、200.14、200.15、200.22、200.23、200.24、200.25、200.26、200.32、200.33、200.34、200.35、200.36、200.42、200.43、200.44、200.45、200.46、200.52、200.53、200.54、200.55、200.56、200.91、201.91、202.02、202.03、202.04、202.05、202.12、202.13、202.14、202.15、202.22、202.23、202.24、202.25、202.32、202.33、202.34、202.35、202.42、202.43、202.44、202.45、202.52、202.53、202.54、202.55、202.91、202.93、202.95、231.03、231.05、231.13、231.15、231.23、231.25、231.33、231.35、231.43、231.45、231.53、231.55、231.91、232.03、232.05、232.13、232.15、232.23、232.25、232.33、232.35、232.43、232.45、232.53、232.55、232.93、232.94、232.95、240.05、240.25、240.35、240.45、240.55、240.91、240.95、241.12、241.14、241.15、241.91 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 240.06 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 241.16、241.82、241.83、241.84、661.13、661.84 [LOCATION/]の用紙のセットエラーです。 トレイ 1 を開きます。 用紙を取り除いてから、用紙の束を再調整します。 必要に応じて用紙ガイドを調整します。 トレイ 1 に用紙を再セットします。 カセット 1 を閉じます。 242.23、242.25、242.35、242.45、242.55、242.91 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 242.33、242.43、243.33、243.35、243.36、243.43、243.35、243.45、243.45、243.55、243.91、244.43、244.45、244.91 [LOCATION/]の紙詰り。 詳細については、次のいずれかを参照してください。 243.43、243.53、244.43、244.45、244.46、244.91、245.53、245.56、245.55、245.91、602.59、664.43、665.53 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 28X.13K、28X.93K、28X.15K、28X.95K、281.16K、281.96K、680.20K、680.40K ジョブを再開する場合は、すべての原稿を交換してください。 次のいずれかを実行します。 ジョブを再開します。 ジョブをキャンセルします。 28X.13Q、28X.93Q、28X.15Q、28X.95Q、281.16Q、281.96Q、680.20Q ジョブを続行する場合は、詰まっている原稿を交換してください。 以下のいずれかの手順に従います。 原稿台からスキャンします。 自動原稿フィーダーからスキャンします。 スキャンを中止してジョブを終了します。 ジョブをキャンセルします。 280.06 ADF に原稿を再セットし、ジョブを再開してください。 280.06、280.11、280.13、280.15、280.91、280.93、280.95、281.11、281.15、281.16、281.91、281.95、281.96、282.11、282.13、282.15、282.91、282.93、282.95、283.11、283.13、283.91、283.15、283.93、284.11、284.13、284.15、284.91、284.93、284.95、295.01 スキャナの紙詰まりです。 詳細については、 を参照してください。 291.06 ジョブを再開する場合は原稿台のカバーを閉じ、原稿をセットしてください 。 次のいずれかを実行します。 原稿台からスキャンします。 自動原稿フィーダーからスキャンします。 スキャンを中止してジョブを終了します。 ジョブをキャンセルします。 400.11、400.13、400.15、401.11、401.13、401.15、404.19、438.11、438.21、444.66、450.21、450.23、450.25、450.98、450.99、451.21、451.23、451.25、452.66、453.21、453.23、454.21、454.23、454.25、457.21、457.23、457.25、460.66、461.66、464.66、465.66、466.66、467.66、468.66、469.66、472.66、477.66、480.66、483.66、486.29、504.11、504.15、505.11、505.15、514.19、698.29 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 400.11、400.13、400.15、401.11、401.13、401.15、404.19、438.11、438.21、442.66、444.66、445.66、450.21、450.23、450.25、451.21、451.23、451.25、451.98、451.99、452.66、453.21、453.23、453.25、454.21、454.23、454.25、457.21、457.23、457.25、459.66、460.66、461.66、462.66、463.66、464.66、465.66、466.66、467.66、468.66、469.66、470.66、472.66、473.66、476.66、477.66、480.66、483.66、486.29、490.66、491.21、491.25、491.66、493.21、494.21、492.66、494.66、495.66、496.66、497.66、504.11、504.15、505.11、505.15、514.19、698.29 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 420.11、420.13、420.15、420.99、421.56、422.56、423.56、424.56、425.13、425.15、425.11、426.11、426.15、428.56A、428.56B、431.56、435.56、438.11、439.19、461.56、698.19 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 438.11、500.11、500.13、500.15、500.99、502.11、502.13、502.15、504.11、504.13、504.15、505.13、506.11、506.13、506.15、507.11、507.13、507.15、508.56、509.56、510.56、511.56、512.56、513.56、514.19、698.19、698.29 [LOCATION/]の紙詰り。 詳細については、 を参照してください。 602.29、662.23 トレイ 2 の用紙のセットエラーです。 詳細については、 を参照してください。 602.39、663.33 トレイ 3 の用紙のセットエラーです。 詳細については、次のいずれかを参照してください。 602.49、664.43 トレイ 4 の用紙のセットエラーです。 詳細については、 を参照してください。 プリンタのエラーコード エラーコード プリンタメッセージ エラーメッセージ"},{"UUID":"86daf1e4-9d47-4c5f-9d38-48e302abeb5b","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"空白または白のページ 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"空白または白のページ 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 イメージングキット、イメージングユニット、トナーカートリッジから梱包材がすべて取り除かれていることを確認します。 プリンタに使用しているトナーカートリッジが、対応する Lexmark 純正品であるかを確認します。 プリンタに使用しているトナーカートリッジが、対応する純正品であるかを確認します。 対応するカートリッジではない場合は、対応するカートリッジを取り付けます。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 白のページ 印刷品質の問題 空白ページ 空白ページ 白のページ"},{"UUID":"c8fc1234-cd9f-442a-a810-0cdd8b68f44e","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"印刷が濃い 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"印刷が濃い 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］の順に移動して、［ カラー調整 ］を選択します。 オペレーティングシステム（OS）によって、［印刷設定］または［印刷］ダイアログからトナー濃度を薄くします。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ トナーの濃さ ］の順に移動します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。設定がトレイにセットされた用紙と一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 用紙の表面が粗くないことを確認します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 印刷が濃い 印刷が濃い"},{"UUID":"4780c54d-0458-4359-9173-82abfbaf3984","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"ゴーストイメージ 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"ゴーストイメージ 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 トレイに、適切なタイプおよび重さの用紙をセットします。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。設定がトレイにセットされた用紙と一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］の順に移動して、［ カラー調整 ］を選択します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 ゴーストイメージ ゴーストイメージ"},{"UUID":"1bd87748-aff5-4c05-b26c-334bb8729088","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"グレースケールまたはカラーの背景 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"グレースケールまたはカラーの背景 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログからトナー濃度を濃くします。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ トナーの濃さ ］の順に移動します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］の順に移動して、［ カラー調整 ］を選択します。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 グレースケールまたはカラーの背景 印刷後の背景がグレーになる 印刷後の背景がカラーになる"},{"UUID":"eeb711bd-5271-42f3-ae24-94442b9964a0","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"余白が正しくない 次の手順を 1 つ以上実行します。 トレイの用紙ガイドを、セットされている用紙のサイズに合う正しい位置に調整します。","descFull":"余白が正しくない 次の手順を 1 つ以上実行します。 トレイの用紙ガイドを、セットされている用紙のサイズに合う正しい位置に調整します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙のサイズを指定します。トレイにセットされた用紙と設定が一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 余白が正しくない 余白が正しくない"},{"UUID":"fa4e02e9-d808-40d6-bdf7-6d53fecb4343","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"印刷が薄い 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"印刷が薄い 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 イメージングキット、イメージングユニット、トナーカートリッジから梱包材がすべて取り除かれていることを確認します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］の順に移動して、［ カラー調整 ］を選択します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログからトナー濃度を濃くします。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ トナーの濃さ ］の順に移動します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］の順に移動し、［ カラートナー節約 ］をオフにします。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。トレイにセットされた用紙と設定が一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 用紙の表面が粗くないことを確認します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 印刷が薄い 印刷が薄い"},{"UUID":"a085051b-8706-44fa-a8d2-7ce984f32a4e","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"色抜け 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"色抜け 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 イメージングキット、イメージングユニット、トナーカートリッジから梱包材がすべて取り除かれていることを確認します。 印刷されない色の現像体ユニットを取り外します。 イメージングキットを取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 色抜けしている色の現像体ユニットを取り外してから、挿入します。 イメージングキットを挿入します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 色抜け 色抜け"},{"UUID":"6c6246ce-aa8c-448f-b0da-032a8f8e249f","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"まだらな印刷やドット まだらな印刷やドット 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］","descFull":"まだらな印刷やドット まだらな印刷やドット 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 トナー漏れの汚れがないか、プリンタをチェックします。 用紙サイズと用紙タイプがセットした用紙と一致していることを確認します。操作パネルから、［ 設定 ］ ［ 用紙 ］ ［ トレイ設定 ］ ［ 用紙サイズ/タイプ］ の順に移動します。 用紙の表面が粗くないことを確認します。 オペレーティングシステム（OS）に応じて、［印刷設定］または［印刷］ダイアログから用紙サイズと用紙タイプを指定します。設定がトレイにセットされた用紙と一致していることを確認します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 まだらな印刷やドット まだらな印刷やドット 印刷されたページ上のドット"},{"UUID":"37495bf2-7686-46d7-9eb7-8c61737c4692","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"印刷が歪むまたは傾く 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"印刷が歪むまたは傾く 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 新しいパッケージの用紙をセットします。 トレイを開き、用紙を取り出します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 トレイの用紙ガイドを、セットされている用紙のサイズに合う正しい位置に調整します。 サポートされている用紙に印刷していることを確認します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 歪んだ印刷 印刷品質の問題 印刷が歪む 印刷が歪む 歪んだ印刷"},{"UUID":"9dec249d-75b3-4544-ab23-4d6c75f154a1","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"単色または黒の画像 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"単色または黒の画像 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 単色または黒の画像 単色 ブラックイメージ"},{"UUID":"27f41c57-fa14-4a23-8e33-4715cbd3cac0","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"文字または画像が切り取られる 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"文字または画像が切り取られる 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 イメージングキット、イメージングユニット、トナーカートリッジから梱包材がすべて取り除かれていることを確認します。 トレイの用紙ガイドを、セットされている用紙のサイズに合う正しい位置に調整します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙のサイズを指定します。設定がトレイにセットされた用紙と一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 文字または画像が切り取られる テキストが切り取られる 画像が切り取られる"},{"UUID":"ded4f587-9d72-4476-997b-618ba3418848","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"トナーが簡単にはがれ落ちる 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"トナーが簡単にはがれ落ちる 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 以下のいずれかの手順を実行します。 プリンタの電源コードが、正しい定格で正しく接地されたコンセントに接続されていることを確認します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。トレイにセットされた用紙と設定が一致していることを確認します。 操作パネルから用紙の種類を設定します。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 トナーが簡単にはがれ落ちる トナーが簡単にはがれ落ちる"},{"UUID":"028beab5-a222-4083-8b35-b9ae380ca543","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"印刷の濃さが均一ではない 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"印刷の濃さが均一ではない 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 ドア B を開いて、セカンド転写ローラーが所定の位置でロックされていることを確認します。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 印刷の濃さが均一ではない 印刷の濃さが均一ではない"},{"UUID":"96fe5f85-12a3-4285-bef0-bff7edd8b35f","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"横方向の黒い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"横方向の黒い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、この用紙が縦向きにセットされていることを確認します。 印刷に横方向の黒い線が表示され続ける場合は、 を参照してください。 次の手順を 1 つ以上実行します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。トレイにセットされた用紙と設定が一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 用紙の表面が粗くないことを確認します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 横方向の黒い線 横方向の黒い線"},{"UUID":"072ed26e-2e87-4f2e-b1a9-73b6fa49fb08","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"縦方向の黒い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"縦方向の黒い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。設定がトレイにセットされた用紙と一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 用紙の表面が粗くないことを確認します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 印刷に縦方向の黒い線が表示される 印刷物に縦の濃い線が出力される"},{"UUID":"503943c8-a6fa-4fc2-90b9-e064744e53a0","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"横方向の白い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"横方向の白い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、用紙が縦向きにセットされていることを確認します。 印刷に横方向の白い線が表示され続ける場合は、 を参照してください。 次の手順を 1 つ以上実行します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。設定がトレイにセットされた用紙と一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 推奨されるタイプの用紙の指定された給紙源をセットします。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 フォトコンダクタードラムを直射光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 フォトコンダクタードラムに触らないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 横方向の白い線 横方向の白い線"},{"UUID":"c61b9bb4-29ba-4c3d-920c-9e647194edee","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"縦方向の白い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"縦方向の白い線 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、用紙が縦向きにセットされていることを確認します。 次の手順を 1 つ以上実行します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。設定がトレイにセットされた用紙と一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 推奨されるタイプの用紙を使用しているか確認します。 推奨されるタイプの用紙の指定された給紙源をセットしていることを確認します。 イメージングキットとブラックイメージグユニットが正しく取り付けられていることを確認します。 イメージングキット、ブラックイメージングユニットの順に取り外します。 イメージングキットまたはブラックイメージングユニットは、10 分間以上直射日光にさらさないでください。長時間直射日光にさらすと、印刷品質の問題が生じる可能性があります。 イメージングキットおよびブラックイメージングユニットの下のフォトコンダクタードラムに触れないでください。触れると、今後の印刷ジョブの印刷品質に影響する可能性があります。 ブラックイメージングユニット、イメージングキットの順に取り付けます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 縦方向の白い線 縦方向の白い線"},{"UUID":"bf713067-c461-42bf-8c11-c54e09dadda6","title":"印刷品質が悪い","link":"solving-printing-problems.html","desc":"印刷不良が繰り返し発生する 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング","descFull":"印刷不良が繰り返し発生する 問題を解決する前に、印刷品質テストページを印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 トレイ 1 を使用してサンプルページを印刷し、用紙が縦向きにセットされていることを確認します。 不良が発生している色数を確認します。 影響を受けているカラーページに繰り返し現れる印刷不良の間隔を測定します。［メンテナンス不良ルーラー］を使って、影響を受けるカラーページに繰り返し現れる異常の間隔を測定します。 影響を受けるカラーページの測定結果と一致する消耗品または部品を交換します。 カラーイメージングキットまたはブラックイメージングユニット 94.5 mm（3.72 インチ） 19.9 mm（1.18 インチ） 23.2 mm（0.19 インチ） 現像体ユニット 43.6 mm（1.72 インチ） 45.0 mm（1.77 インチ） フューザー 95 mm（3.74 インチ） 110 mm（4.33 インチ） 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 印刷の問題を繰り返す 印刷の問題を繰り返す"},{"UUID":"31cb2e30-4293-4851-ac1b-c7c4e81451d9","title":"印刷の問題","link":"solving-printing-problems.html","desc":"印刷ジョブが印刷されない 次の手順を 1 つ以上実行します。 印刷するドキュメントで、［印刷設定］または［印刷］ダイアログボックスを開いて、正しいプリンタが選択されているかどうかを確認します。","descFull":"印刷ジョブが印刷されない 次の手順を 1 つ以上実行します。 印刷するドキュメントで、［印刷設定］または［印刷］ダイアログボックスを開いて、正しいプリンタが選択されているかどうかを確認します。 プリンタの電源が入っているか確認し、ディスプレイに表示されたエラーメッセージを解決します。 ポートが動作し、ケーブルがコンピュータとプリンタにしっかりと接続されていることを確認します。詳細については、プリンタに同梱されているセットアップマニュアルを参照してください。 プリンタの電源を切って約 10 秒間待ってから、再び電源を入れます。 印刷ドライバを削除してから、再インストールします。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷の問題 印刷ジョブが印刷されない 印刷ジョブが印刷されない 印刷ジョブが印刷されない"},{"UUID":"4fd156fe-0fbd-47d0-9d9e-35fe736dbac7","title":"印刷の問題","link":"solving-printing-problems.html","desc":"コンフィデンシャルドキュメントおよびその他の保留ドキュメントが印刷されない 次の手順を 1 つ以上実行します。 操作パネルから、［","descFull":"コンフィデンシャルドキュメントおよびその他の保留ドキュメントが印刷されない 次の手順を 1 つ以上実行します。 操作パネルから、［ 保留ジョブ ］のリストにドキュメントが表示されるかを確認します。 ドキュメントが一覧表示されない場合、［印刷して保持］オプションを使用してドキュメントを印刷します。 印刷ジョブに含まれている可能性があるフォーマットエラーや無効なデータを解決します。 印刷ジョブを削除し、もう一度送信します。 PDF ファイルの場合、新しいファイルを生成してから、ドキュメントを印刷します。 インターネットから印刷する場合、プリンタは重複している複数のジョブタイトルを読み取る可能性があります。 Windows ユーザーの場合は、［印刷設定］または［印刷］ダイアログで、必ず［ 重複ドキュメントを維持 ］を選択してください。 Macintosh ユーザーの場合は、各ジョブに異なる名前を付けてください。 一部の保留ジョブを削除して、プリンタメモリの空き容量を増やします。 プリンタメモリを増設します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 コンフィデンシャルドキュメントおよびその他の保留ドキュメントが印刷されない コンフィデンシャルドキュメントが印刷されない 保留ドキュメントが印刷されない"},{"UUID":"8741f894-7117-4087-988f-53e45d2e0d4f","title":"印刷の問題","link":"solving-printing-problems.html","desc":"ジョブが誤ったトレイまたは用紙で印刷される 次の手順を 1 つ以上実行します。 正しい用紙に印刷していることを確認します。","descFull":"ジョブが誤ったトレイまたは用紙で印刷される 次の手順を 1 つ以上実行します。 正しい用紙に印刷していることを確認します。 オペレーティングシステム（OS）に応じて、［印刷設定］または［印刷］ダイアログから用紙サイズと用紙タイプを指定します。セットした用紙と設定が一致していることを確認します。 プリンタ操作パネルでも、設定を変更できます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 トレイがリンクされていることを確認します。詳細については、 を参照してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷の問題 ジョブが正しくないトレイから印刷される 印刷の問題 ジョブが正しくない用紙で印刷される ジョブが正しくないトレイから印刷される ジョブが正しくない用紙で印刷される"},{"UUID":"13b65548-3d33-4bc1-87fb-a813440c2133","title":"印刷の問題","link":"solving-printing-problems.html","desc":"印刷が遅い 次の手順を 1 つ以上実行します。 プリンタケーブルがプリンタ、コンピュータ、プリントサーバー、オプション、またはその他のネットワークデバイスにしっかりと接続されていることを確認します。","descFull":"印刷が遅い 次の手順を 1 つ以上実行します。 プリンタケーブルがプリンタ、コンピュータ、プリントサーバー、オプション、またはその他のネットワークデバイスにしっかりと接続されていることを確認します。 プリンタが［ 静音モード ］になっていないことを確認します。 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 構成設定メニュー ］ ［ デバイスの操作 ］ ［ ［静音モード ］の順に移動します。 印刷するドキュメントの解像度を指定します。 オペレーティングシステム（OS）に応じて、［印刷設定］または［印刷］ダイアログにアクセスします。 解像度を［ 4800 CQ ］に設定します。 操作パネルで設定を変更することもできます。［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ 印刷解像度 ］の順に選択します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。 操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 用紙が重くなるほど、印刷に時間がかかります。 レターサイズ、A4、リーガルよりも幅の狭い用紙は、印刷に時間がかかることがあります。 ［表面の粗さ］と［重さ］のプリンタ設定がセットされている用紙と一致していることを確認します。 操作パネルで、［ 設定 ］ ［ 用紙 ］ 用紙構成 ］ ［用紙の種類 ］の順に移動します。 粗い用紙および重い用紙は、印刷に時間がかかることがあります。 保留ジョブを削除します。 プリンタが過熱していないことを確認します。 長い印刷ジョブの後には、プリンタを十分に冷まします。 プリンタの推奨周囲温度を守ってください。詳細については、 を参照してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷の問題 印刷が遅い 印刷が遅い"},{"UUID":"8dbf0cca-b750-4a39-959d-fba8802d12ab","title":"問題をトラブルシューティングする","link":"trb-printer-not-responding-topic.html","desc":"プリンタが応答していない 次の手順を 1 つ以上実行します。 電源コードが電源コンセントに接続されていることを確認します。","descFull":"プリンタが応答していない 次の手順を 1 つ以上実行します。 電源コードが電源コンセントに接続されていることを確認します。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 コンセントがスイッチやブレーカーなどでオフになっていないことを確認します。 プリンタの電源が入っているかどうかを確認します。 プリンタがスリープモードまたは休止モードになっていないことを確認します。 プリンタとコンピュータをつなぐケーブルが正しいポートに接続されているかどうかを確認します。 プリンタの電源を切ってハードウェアオプションを取り付けてから、プリンタの電源を入れます。詳細については、オプションに同梱されているマニュアルを参照してください。 正しいプリントドライバをインストールします。 プリンタの電源を切って約 10 秒間待ってから、再び電源を入れます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷の問題 プリンタが応答していない プリンタが応答していない"},{"UUID":"640c182a-c155-461b-bd39-4669a2bd085c","title":"問題をトラブルシューティングする","link":"trb-unable-to-read-flash-drive-topic.html","desc":"フラッシュメモリを読み取れない 次の手順を 1 つ以上実行します。 プリンタが複数のジョブを処理しておりビジーになっていないか確認します。","descFull":"フラッシュメモリを読み取れない 次の手順を 1 つ以上実行します。 プリンタが複数のジョブを処理しておりビジーになっていないか確認します。 フラッシュメモリが正面の USB ポートに挿入されていることを確認します。 背面の USB ポートに挿入されている場合、フラッシュメモリは動作しません。 フラッシュメモリがサポートされていることを確認します。詳細については、 を参照してください。 フラッシュメモリを取り外してから、挿入します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 フラッシュメモリを読み取れない 印刷の問題 フラッシュメモリを読み取れない"},{"UUID":"7c94d11f-378e-4598-a4af-91f0697ee3f5","title":"問題をトラブルシューティングする","link":"enabling-usb-port-topic.html","desc":"USB ポートの有効化 操作パネルで、［ 設定 ］","descFull":"USB ポートの有効化 操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ USB ］の順に移動します。 ［ USB ポートを有効化 ］を選択します。 USB ポート 有効にする USB ポートを有効にする USB ポートを設定する"},{"UUID":"f32634b3-95c0-4373-bdef-0de3a04751d7","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"紙詰まりを防止する 用紙を正しくセットする 用紙はトレイに平らに置いてください。 正しい用紙のセット方法と誤った用紙のセット方法 正しい用紙のセット方法","descFull":"紙詰まりを防止する 用紙を正しくセットする 用紙はトレイに平らに置いてください。 正しい用紙のセット方法と誤った用紙のセット方法 正しい用紙のセット方法 誤った用紙のセット方法 印刷中は、トレイに用紙をセットしたり、トレイを取り外したりしないでください。 過剰な量の用紙をセットしないでください。重ねた用紙の高さが、給紙上限マークを超えないようにします。 トレイに用紙を滑らせて入れないでください。図のように用紙をセットします。 用紙ガイドが正しい位置にあり、用紙や封筒をきつく挟みすぎていないことを確認します。 用紙をセットしたらトレイをしっかりと押し込みます。 推奨用紙を使用する 推奨される用紙や普通紙以外の用紙のみを使用します。 しわ、折り目のある用紙、湿っている用紙、曲がっている用紙、丸まっている用紙をセットしないでください。 用紙をほぐし、パラパラとめくってから端をそろえ、用紙をセットします。 手で切った、またはちぎった用紙は使用しないでください。 用紙のサイズ、重さ、タイプが異なる用紙を混在させてセットしないでください。 コンピュータまたはプリンタ操作パネルで、用紙のサイズおよびタイプが適切に設定されていることを確認します。 用紙はメーカーの推奨事項に従って保管します。 紙詰まり 防止 詰まり、用紙 防止 紙詰まりを防止する"},{"UUID":"b11fef18-53fe-4038-952b-2752a67ddd1f","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"紙詰まりの場所を特定する ［ 紙づまりアシスト ］が［ オン","descFull":"紙詰まりの場所を特定する ［ 紙づまりアシスト ］が［ オン ］に設定されている場合、紙詰まりを起こしたページが取り除かれた後、プリンタは空白ページまたは一部印刷されたページを排出します。空白ページがあるかどうか、印刷済み出力用紙を確認します。 ［ 紙づまり回復 ］が［ オン ］または［ 自動 ］に設定されている場合、プリンタは紙づまりが発生したページを再印刷します。 紙詰まりの場所 紙詰まりの場所 1 ドア B 2 多目的フィーダ 3 標準トレイ 4 標準排紙トレイ 5 自動原稿フィーダ 6 ホチキスフィニッシャ 7 オプションの 550 枚トレイ 8 2 x 550 枚トレイ 9 1500 枚トレイ 10 ホチキス、ホールパンチフィニッシャ 11 折り畳みオプション付き用紙搬送ユニット 12 2000 枚デュアル給紙 13 冊子フィニッシャ 紙詰まり 場所を特定する 紙詰まりの場所 特定する"},{"UUID":"9f13acdb-f963-4191-adc8-2c0a12291042","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"標準カセットの紙づまり 標準カセットの紙づまり 標準トレイを引き出します。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。","descFull":"標準カセットの紙づまり 標準カセットの紙づまり 標準トレイを引き出します。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 トレイを挿入します。 紙詰まりを取り除く 標準トレイ 紙詰まりを取り除く 標準トレイ 標準トレイの紙詰まり"},{"UUID":"2761bd11-b63b-4629-87c1-c3b7b7cacacc","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"オプションの 550 枚トレイの紙詰まり ドア D","descFull":"オプションの 550 枚トレイの紙詰まり ドア D を開きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドアを閉じます。 オプションの 550 枚トレイを引き出します。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 トレイを挿入します。 紙詰まりを取り除く 550 枚トレイ 紙詰まりを取り除く 550 枚トレイ 550 枚トレイの紙詰まり"},{"UUID":"af91d946-faf7-4ebb-ac58-0461a9b6ceb3","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"ADF（自動原稿フィーダ）内の紙詰まり ドア A 内の紙詰まり ドア","descFull":"ADF（自動原稿フィーダ）内の紙詰まり ドア A 内の紙詰まり ドア A を開きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア A を閉じます。 ドア A1 内の紙詰まり スキャナカバーを開きます。 緑のラッチを押して、ドア A1 を開きます。 ハンドル A1 の近くの緑のノブを右に回し、詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア A1 を閉じてから、スキャナカバーを閉じます。 ADF（自動原稿フィーダ）排紙トレイの紙詰まり 自動原稿フィーダ排紙トレイからすべての用紙を取り除きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 紙詰まりを取り除く ADF（自動原稿フィーダー）内 紙詰まり ADF（自動原稿フィーダー）内 紙詰まりを取り除く ADF（自動原稿フィーダー）内"},{"UUID":"27e4d59e-7091-40e2-9baa-ad1d3ed480bf","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"多目的フィーダの紙詰まり 多目的フィーダからすべての用紙を取り除きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 紙詰まりを取り除く","descFull":"多目的フィーダの紙詰まり 多目的フィーダからすべての用紙を取り除きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 紙詰まりを取り除く 多目的フィーダ 紙詰まりを取り除く 多目的フィーダ 多目的フィーダ内の紙詰まり"},{"UUID":"187e1121-92e6-4019-b449-1e5669cd7bc5","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"2 x 550 枚トレイの紙詰まり ドア","descFull":"2 x 550 枚トレイの紙詰まり ドア E を開きます。 ドア E の内側につまった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア E を閉じます。 トレイ 3 を取り外します。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 トレイ 3 を挿入します。 トレイ 4 についても、 手順 4  から  手順 6  を繰り返します。 紙詰まりを取り除く 2 x 550 枚トレイ 紙詰まりを取り除く 2 x 550 枚トレイ 紙詰まり 2 x 550 枚トレイ"},{"UUID":"48406bc4-6d2c-4227-b223-56f9751643b7","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"2000 枚デュアル給紙の紙詰まり ドア E を開きます。","descFull":"2000 枚デュアル給紙の紙詰まり ドア E を開きます。 ドア E の内側につまった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア E を閉じます。 紙詰まりを取り除く 2000 枚デュアル給紙 紙詰まりを取り除く 2000 枚デュアル給紙 紙詰まり 2000 枚トレイ"},{"UUID":"d4533a9d-8e86-4ffa-a719-b56e12cb84a5","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"1500 枚トレイの紙詰まり ドア K を開きます。","descFull":"1500 枚トレイの紙詰まり ドア K を開きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア K を閉じます。 ハンドル J をつかんで、トレイを右にスライドします。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 トレイをスライドさせ、元の位置に戻します。 紙詰まりを取り除く 1500 枚トレイ 紙詰まりを取り除く 1500 枚トレイ 紙詰まり 1500 枚トレイ"},{"UUID":"a39c3caf-fdf3-42fd-9515-5f5e93a0d58a","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"ドア B 内の紙詰まり ドア B","descFull":"ドア B 内の紙詰まり ドア B を開きます。 プリンタの内部が高温になっている場合があります。高温のコンポーネントによる負傷の危険を減らすために、コンポーネントの表面が冷えるのを待ってから触れてください。 静電気放電による損傷を防ぐため、プリンタ内部に手を入れたり触れたりする前に、プリンタの露出している金属製フレームに触れてください。 詰まっている用紙を次の場所から取り除きます。 必ずすべての紙片を取り除いてください。 フューザーの上 フューザー内 フューザーの下 標準排紙トレイの排紙ローラーの下 両面印刷ユニット内 ドア B を閉じます。 ドア B 内の紙詰まり フューザーの紙詰まり 両面印刷ユニット内の紙づまり 紙詰まりを取り除く フューザー 紙詰まりを取り除く 両面印刷ユニット内 紙詰まりを取り除く フューザー 紙詰まりを取り除く 両面印刷ユニット内"},{"UUID":"0ccd80bc-79e8-4e82-81c6-63bfcbb85bd4","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"標準排紙トレイの紙詰まり 標準排紙トレイから用紙を取り除きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 紙詰まりを取り除く","descFull":"標準排紙トレイの紙詰まり 標準排紙トレイから用紙を取り除きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 紙詰まりを取り除く 標準排紙トレイ 紙詰まりを取り除く 標準排紙トレイ 標準排紙トレイの紙詰まり"},{"UUID":"fdd56171-c080-4c23-a777-12a4fe5b7556","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"ホチキスフィニッシャの紙詰まり ホチキスフィニッシャ排紙トレイから詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ハンドル F","descFull":"ホチキスフィニッシャの紙詰まり ホチキスフィニッシャ排紙トレイから詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ハンドル F をつかんで、ホチキスフィニッシャを左にスライドします。 ドア R1 を開いて、ノブ R2 を時計回りに回します。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア R1 を閉じます。 標準排紙トレイの排紙ローラーから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ホチキスフィニッシャを元の位置にスライドさせます。 紙詰まりを取り除く ホチキスフィニッシャ 紙詰まりを取り除く ホチキスフィニッシャ 紙詰まり ホチキスフィニッシャ"},{"UUID":"5d791b15-0ebf-45e3-8b29-4f822801f9ca","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"折り畳みオプション付き用紙搬送ユニットの紙づまり 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア F","descFull":"折り畳みオプション付き用紙搬送ユニットの紙づまり 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア F を開きます。 ハンドル N4 を持ち上げます。 ハンドル N5 を持ち上げます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ハンドル N5 を閉じ、次にハンドル N4 を閉じます。 ハンドル N1 を押し下げます。 ノブ N2 を反時計方向に回します。 詰まっている用紙を取り除きます。 プリンタの損傷を防ぐため、詰まった用紙を取り除く前に、身に付けているアクセサリはすべて外してください。 必ずすべての紙片を取り除いてください。 ハンドル N1 を元の位置に戻します。 ドア F を閉じます。 紙詰まりを取り除く 折り畳みオプション付き用紙搬送ユニット 紙詰まりを取り除く 折り畳みオプション付き用紙搬送ユニット 紙詰まり 折り畳みオプション付き用紙搬送ユニット"},{"UUID":"452f3f3d-c106-4728-90f6-28f2fe96c805","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"ホチキスパンチフィニッシャの紙詰まり お使いのプリンタで用紙搬送ユニットが設定されている場合は、以下の手順に従います。 排紙トレイ 1 で詰まっている用紙を取り除きます。","descFull":"ホチキスパンチフィニッシャの紙詰まり お使いのプリンタで用紙搬送ユニットが設定されている場合は、以下の手順に従います。 排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ページの欠落を防ぐため、ホチキスコンパイラにある印刷済みのページは取り出さないでください。 フィニッシャ標準排紙トレイから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ 2 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 用紙搬送ユニットのカバー G を開き、詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 用紙搬送ユニットのカバー G を閉じます。 ドア I と ドア R1 を開いて、詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア R1 を閉じ、次にドア I を閉じます。 用紙搬送ユニットのカバー F を閉じます。 ドア H を開きます。 ハンドル R4 を持ち上げます。 ノブ R3 を反時計回りに回し、排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ノブ R2 を反時計回りに回し、用紙搬送ユニットのカバー F から詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 用紙搬送ユニットのカバー F を閉じます。 ハンドル R4 を元の位置に戻します。 ドア H を閉じます。 お使いのプリンタで折り畳みオプション付きの用紙搬送ユニットが設定されている場合は、以下の手順に従います。 排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ページの欠落を防ぐため、ホチキスコンパイラにある印刷済みのページは取り出さないでください。 フィニッシャ標準排紙トレイから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ 2 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア F を開きます。 ドア N4 を開きます。 ドア N5 を開きます。 ドア H を開きます。 ハンドル R4 を持ち上げます。 ノブ R3 を反時計回りに回し、排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ノブ R2 を反時計回りに回し、ドア N4 と N5 の間で詰まった用紙があれば取り除きます。 必ずすべての紙片を取り除いてください。 ドア B を開きます。 プリンタの内部が高温になっている場合があります。高温のコンポーネントによる負傷の危険を減らすために、コンポーネントの表面が冷えるのを待ってから触れてください。 静電気放電による損傷を防ぐため、プリンタ内部に手を入れたり触れたりする前に、プリンタの露出している金属製フレームに触れてください。 標準排紙トレイの排紙ローラーから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア B を閉じます。 ハンドル N1 を押し下げます。 ノブ N2 を反時計方向に回します。 詰まっている用紙を取り除きます。 プリンタの損傷を防ぐため、詰まった用紙を取り除く前に、身に付けているアクセサリはすべて外してください。 必ずすべての紙片を取り除いてください。 ハンドル N1 を元の位置に戻します。 ハンドル N5 を閉じ、次にハンドル N4 を閉じます。 ドア F を閉じます。 ハンドル R4 を元の位置に戻します。 ドア H を閉じます。 紙詰まりを取り除く ホチキスパンチフィニッシャ 紙詰まりを取り除く ホチキスパンチフィニッシャ ホチキスパンチフィニッシャの紙詰まり"},{"UUID":"88734a33-76e7-4b07-9ba5-91abbd27b964","title":"紙詰まりを取り除く","link":"clearing-jams.html","desc":"冊子フィニッシャの紙詰まり お使いのプリンタで用紙搬送ユニットが設定されている場合は、以下の手順に従います。 フィニッシャ標準排紙トレイから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ","descFull":"冊子フィニッシャの紙詰まり お使いのプリンタで用紙搬送ユニットが設定されている場合は、以下の手順に従います。 フィニッシャ標準排紙トレイから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ページの欠落を防ぐため、ホチキスコンパイラにある印刷済みのページは取り出さないでください。 排紙トレイ 3 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 用紙搬送ユニットのカバー G を開き、詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 用紙搬送ユニットのカバー G を閉じます。 用紙搬送ユニットのカバー F を閉じます。 ドア H を開きます。 ハンドル R3 を右に移動し、つまった用紙があれば取り除きます。 必ずすべての紙片を取り除いてください。 ハンドル R1 を左に移動し、ノブ R2 を反時計回りに回し、詰まった用紙があれば取り除きます。 必ずすべての紙片を取り除いてください。 ノブ R5 を反時計回りに回し、フィニッシャ標準排紙トレイから詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ハンドル R4 を持ち上げ、ノブ R2 を時計回りに回し、詰まった用紙があれば取り除きます。 必ずすべての紙片を取り除いてください。 用紙搬送ユニットのカバー F を閉じます。 ハンドル R1、R3、R4 を元の位置に戻します。 ドア H を閉じます。 お使いのプリンタで折り畳みオプション付きの用紙搬送ユニットが設定されている場合は、以下の手順に従います。 フィニッシャ標準排紙トレイから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 排紙トレイ 1 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ページの欠落を防ぐため、ホチキスコンパイラにある印刷済みのページは取り出さないでください。 排紙トレイ 3 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア F を開きます。 ドア H を開きます。 ドア N4 を開きます。 ドア N5 を開きます。 ハンドル R4 を持ち上げます。 ノブ R2 を時計回りに回し、ハンドル R4 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ハンドル R1 を左に移動し、ノブ R2 を反時計回りに回し、ドア N4 と N5 の間で詰まった用紙があれば取り除きます。 必ずすべての紙片を取り除いてください。 ドア B を開きます。 プリンタの内部が高温になっている場合があります。高温のコンポーネントによる負傷の危険を減らすために、コンポーネントの表面が冷えるのを待ってから触れてください。 静電気放電による損傷を防ぐため、プリンタ内部に手を入れたり触れたりする前に、プリンタの露出している金属製フレームに触れてください。 標準排紙トレイの排紙ローラーから詰まった用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア B を閉じます。 ハンドル N1 を押し下げます。 ノブ N2 を反時計方向に回します。 詰まっている用紙を取り除きます。 プリンタの損傷を防ぐため、詰まった用紙を取り除く前に、身に付けているアクセサリはすべて外してください。 必ずすべての紙片を取り除いてください。 ハンドル N1 を元の位置に戻します。 ドア N5 を閉じ、次にドア N4 を閉じます。 ドア F を閉じます。 ハンドル R1 と R4 を元の位置に戻します。 ドア H を閉じます。 冊子メーカーの紙詰まり 排紙トレイ 2 で詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア H を開きます。 ノブ R6、R11、R10 を時計回りに回します。 冊子メーカーを引き出します。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ノブ R9 が止まるまで、反時計回りに回します。 ドア R8 を開きます。 詰まっている用紙を取り除きます。 必ずすべての紙片を取り除いてください。 ドア R8 を閉じます。 冊子メーカーを冊子フィニッシャに戻します。 ドア H を閉じます。 紙詰まりを取り除く 冊子フィニッシャ 紙詰まりを取り除く 冊子フィニッシャ 冊子フィニッシャの紙詰まり"},{"UUID":"4dcb65a9-dbd7-4138-8621-2c5ca303ab2c","title":"ネットワーク接続の問題","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"EWS を開けない EWS を開けない 次の手順を","descFull":"EWS を開けない EWS を開けない 次の手順を 1 つ以上実行します。 プリンタの電源がオンになっていることを確認します。 プリンタの IP アドレスが正しいかどうかを確認します。 操作パネルで IP アドレスを確認します。 IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 サポートされているブラウザがインストールされていることを確認します。 Internet Explorer バージョン 11 以降 Microsoft Edge Safari バージョン 6 以降 Google Chrome  バージョン 32 以降 Mozilla Firefox バージョン 24 以降 ネットワーク接続が動作しているかどうかを確認します。 接続が機能していない場合は、管理者に問い合わせてください。 プリンタおよびプリントサーバーへのケーブルの接続をチェックし、しっかり固定されているか確認します。詳細については、プリントサーバーに付属のマニュアルを参照してください。 Web プロキシサーバーが無効か確認します。 サーバーが無効になっている場合は、管理者に問い合わせてください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 EWS を開けない トラブルシューティング EWS を開けない"},{"UUID":"acfb9f9f-3128-4732-af2e-1f6911e8d144","title":"ネットワーク接続の問題","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"プリンタを Wi-Fi ネットワークに接続できません プリンタを Wi-Fi","descFull":"プリンタを Wi-Fi ネットワークに接続できません プリンタを Wi-Fi ネットワークに接続できません 次の手順を 1 つ以上実行します。 操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ネットワークの概要 ］ ［ アクティブアダプタ ］の順に移動して、［ 自動 ］を選択します。 コンピュータが正しい Wi-Fi ネットワークに接続されていることを確認します。詳細については、 を参照してください。 一部のルーターは初期設定の Wi-Fi 名を共有する場合があります。 ネットワークパスワードを正しく入力したことを確認します。 パスワード内のスペース、数字、大文字小文字の区別に注意してください。 正しいワイヤレスセキュリティモードが選択されていることを確認します。操作パネルで、［ 設定 ］ ［ ネットワーク/ポート ］ ［ ワイヤレス ］ ［ ワイヤレスセキュリティモード ］の順に移動します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 プリンタを Wi-Fi に接続できない トラブルシューティング プリンタを Wi-Fi に接続できない"},{"UUID":"bc271373-21d9-4e3a-a308-4cd3b88a4886","title":"ハードウェアオプションの問題","link":"trb-cannot-detect-internal-option-topic.html","desc":"内蔵オプションが検出されない 内蔵オプションが検出されない 次の手順を 1 つ以上実行します。","descFull":"内蔵オプションが検出されない 内蔵オプションが検出されない 次の手順を 1 つ以上実行します。 プリンタの電源を切って約 10 秒間待ってから、再び電源を入れます。 ［ メニュー設定ページ ］を印刷し、［インストール済みの機能］リストに内蔵オプションがあるかどうかを確認します。操作パネルで、［ 設定 ］ ［ レポート ］ ［ メニュー設定ページ ］の順に移動します。 内蔵オプションがコントローラボードに正しく取り付けられていることを確認します。 プリンタの電源を切り、電源コードをコンセントから抜きます。 内蔵オプションがコントローラボードの適切なコネクタに取り付けられていることを確認します。 電源コードをコンセントに接続し、プリンタの電源を入れます。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 内蔵オプションがプリンタドライバで使用可能かどうか確認します。 必要に応じて、プリンタドライバで内蔵オプションを手動で追加し、印刷ジョブで使用できるようにします。詳細については、 を参照してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 ハードウェアオプションの問題 内蔵オプションが検出されない 内部オプションが検出されない 内蔵オプションが検出されない"},{"UUID":"f13bb8c6-b943-4f89-b572-1b7d3a5675c8","title":"ハードウェアオプションの問題","link":"trb-cannot-detect-internal-option-topic.html","desc":"内蔵ソリューションポートが正しく動作しない 内蔵ソリューションポートが正しく動作しない 次の手順を 1 つ以上実行します。","descFull":"内蔵ソリューションポートが正しく動作しない 内蔵ソリューションポートが正しく動作しない 次の手順を 1 つ以上実行します。 ［ メニュー設定ページ ］を印刷し、［インストール済みの機能］リストに内部ソリューションポートがあるかどうかを確認します。操作パネルで、［ 設定 ］ ［ レポート ］ ［ メニュー設定ページ ］の順に移動します。 ISP を取り外してから再度取り付けます。詳細については、 を参照してください。 ケーブルと ISP の接続を確認します。 正しいケーブルを使用し、ISP にしっかりと接続していることを確認します。 ISP ソリューションインターフェイスケーブルがコントローラボードのスロットにしっかりと接続していることを確認します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 トラブルシューティング 内蔵ソリューションポート プリンタオプションの問題 内蔵ソリューションポート 内蔵ソリューションポートが正しく動作しない"},{"UUID":"22aaf028-bdff-4a66-b467-e08a21432a42","title":"ハードウェアオプションの問題","link":"trb-cannot-detect-internal-option-topic.html","desc":"パラレルまたはシリアルインターフェイスカードが正しく動作しない パラレルまたはシリアルインターフェイスカードが正しく動作しない 次の手順を 1 つ以上実行します。","descFull":"パラレルまたはシリアルインターフェイスカードが正しく動作しない パラレルまたはシリアルインターフェイスカードが正しく動作しない 次の手順を 1 つ以上実行します。 ［ メニュー設定ページ ］を印刷し、［インストール済みの機能］リストにパラレルまたはシリアルインターフェイスカードがあるかどうかを確認します。操作パネルで、［ 設定 ］ ［ レポート ］ ［ メニュー設定ページ ］の順に移動します。 パラレルまたはシリアルインターフェイスカードを、取り外してから再度取り付けます。詳細については、 を参照してください。 ケーブルとパラレルまたはシリアルインターフェイスカードの接続を確認します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 プリンタオプションの問題 パラレルインターフェイスカード プリンタオプションの問題 シリアルインターフェイスカード トラブルシューティング パラレルインターフェイスカード トラブルシューティング シリアルインターフェイスカード"},{"UUID":"2a12551e-1ad0-4689-91be-40a83f7be0c4","title":"ハードウェアオプションの問題","link":"trb-cannot-detect-internal-option-topic.html","desc":"フラッシュメモリ不良 フラッシュメモリ不良 次の手順を 1 つ以上実行します。","descFull":"フラッシュメモリ不良 フラッシュメモリ不良 次の手順を 1 つ以上実行します。 不良のフラッシュメモリを交換します。 ［ 続行 ］を選択し、メッセージを無視して印刷を続行します。 現在の印刷ジョブをキャンセルします。 プリンタメッセージ フラッシュメモリ不良 フラッシュメモリが不良 トラブルシューティング フラッシュメモリが不良"},{"UUID":"8691291e-cc27-4fd3-9286-40f9650cf22a","title":"ハードウェアオプションの問題","link":"trb-cannot-detect-internal-option-topic.html","desc":"フラッシュメモリにリソースの空き容量が足りません フラッシュメモリにリソースの空き容量が足りません 次の手順を 1 つ以上実行します。","descFull":"フラッシュメモリにリソースの空き容量が足りません フラッシュメモリにリソースの空き容量が足りません 次の手順を 1 つ以上実行します。 ［ 続行 ］を選択し、メッセージを消去して印刷を続行します。 フラッシュメモリに保存されているフォント、マクロ、その他のデータを削除します。 ストレージドライブを取り付けます。 フラッシュメモリに保存されていないダウンロード済みのフォントおよびマクロは削除されます。 プリンタメッセージ フラッシュメモリにリソースの空き容量が足りません フラッシュメモリにリソースの空き容量が足りません"},{"UUID":"c121288a-6d4e-4f59-b685-e9ec6da7394b","title":"消耗品の問題","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"カートリッジを交換してください。プリンタの地域設定が一致しません この問題を解決するには、プリンタの地域に一致する正しい地域でカートリッジを購入するか、世界標準のカートリッジを購入します。 42 の後ろに続くメッセージの最初の番号は、プリンタの地域を示します。 42","descFull":"カートリッジを交換してください。プリンタの地域設定が一致しません この問題を解決するには、プリンタの地域に一致する正しい地域でカートリッジを購入するか、世界標準のカートリッジを購入します。 42 の後ろに続くメッセージの最初の番号は、プリンタの地域を示します。 42 の後ろに続くメッセージの 2 番目の番号は、カートリッジの地域を示します。 正しいトナーカートリッジを取り付けます。 プリンタおよびトナーカートリッジの地域 地域 数値コード 世界標準または未定義の地域 0 北米（米国、カナダ） 1 欧州経済領域、西ヨーロッパ、北欧諸国、スイス 2 アジア太平洋 3 中南米 4 その他の欧州諸国、中東、アフリカ 5 オーストラリア、ニュージーランド 6 無効な地域 9 プリンタとトナーカートリッジの地域設定を検索するには、［ 印刷品質テストページ ］を印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 プリンタメッセージ カートリッジを交換してください。プリンタの地域設定が一致しません カートリッジを交換してください。プリンタの地域設定が一致しません カートリッジ、プリンタの地域設定の不一致"},{"UUID":"5fce1a90-c3d8-4b06-bfd8-e6674365f3ba","title":"消耗品の問題","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"補充された標準[カラー]カートリッジ Lexmark 以外のサードパーティー製の純正以外のトナーが Lexmark 標準カートリッジに補充されたことを、プリンタが検出しました。","descFull":"補充された標準[カラー]カートリッジ Lexmark 以外のサードパーティー製の純正以外のトナーが Lexmark 標準カートリッジに補充されたことを、プリンタが検出しました。 プリンタメーカー以外のサードパーティー製の純正以外のトナーがトナーがカートリッジに補充されたことを、プリンタが検出しました。 ［ OK ］を選択して続行します。 すべてのプリンタ部品の寿命インジケータは、Lexmark の消耗品および部品を使用して機能するように設計されており、Lexmark 以外のサードパーティー製の消耗品または部品を Lexmark プリンタで使用すると、予測せぬ結果になることがあります。 すべてのプリンタ部品の寿命インジケータは、メーカーの消耗品および部品を使用して機能するように設計されており、プリンタメーカー以外のサードパーティー製の消耗品または部品を Lexmark プリンタで使用すると、予測せぬ結果になることがあります。 詳細については、プリンタの限定保証規定を参照してください。 プリンタメッセージ 補充された標準カートリッジ 純正以外のトナー サードパーティ製の消耗品"},{"UUID":"205362d3-050f-4a79-800d-d0fbfe0348ba","title":"消耗品の問題","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Lexmark 以外の消耗品 Dell 以外の消耗品 プリンタメーカー以外の消耗品","descFull":"Lexmark 以外の消耗品 Dell 以外の消耗品 プリンタメーカー以外の消耗品 プリンタに Lexmark 以外の消耗品または部品が取り付けられています。 プリンタに Dell 以外の消耗品または部品が取り付けられています。 プリンタに認識できない消耗品または部品が取り付けられていることが検出されました。 お使いの Lexmark プリンタは、Lexmark 純正の消耗品および部品を使用して最適に動作するように設計されています。サードパーティ製の消耗品や部品を使用すると、パフォーマンス、信頼性、プリンタの寿命およびイメージングコンポーネントに影響する場合があります。 お使いの Dell プリンタは、Dell 純正の消耗品および部品を使用して最適に動作するように設計されています。サードパーティ製の消耗品や部品を使用すると、パフォーマンス、信頼性、プリンタの寿命およびイメージングコンポーネントに影響する場合があります。 お使いのプリンタは、プリンタメーカーによる純正の消耗品および部品を使用して最適に動作するように設計されています。サードパーティ製の消耗品や部品を使用すると、パフォーマンス、信頼性、プリンタの寿命およびイメージングコンポーネントに影響する場合があります。 すべての寿命インジケータは、Lexmark の消耗品および部品を使用して機能するように設計されており、サードパーティ製の消耗品や部品を使用すると、予期せぬ結果になることがあります。想定された寿命を超えてイメージングコンポーネントを使用すると、Lexmark プリンタや関連するコンポーネントが損傷する可能性があります。 すべての寿命インジケータは、Dell の消耗品および部品を使用して機能するように設計されており、サードパーティ製の消耗品や部品を使用すると、予期せぬ結果になることがあります。想定された寿命を超えてイメージングコンポーネントを使用すると、Dell プリンタや関連するコンポーネントが損傷する可能性があります。 すべての寿命インジケータは、プリンタメーカーの消耗品および部品を使用して機能するように設計されており、サードパーティ製の消耗品や部品を使用すると、予期せぬ結果になることがあります。想定された寿命を超えてイメージングコンポーネントを使用すると、プリンタや関連するコンポーネントが損傷する可能性があります。 サードパーティ製の消耗品や部品の使用は、保証の対象に影響します。サードパーティ製の消耗品や部品の使用による損傷は、保証の対象外となる可能性があります。 これらのリスクをすべて許容し、プリンタで純正でない消耗品や部品の使用を続行するには、ディスプレイのエラーメッセージを 2 本の指でタッチして 15 秒間押し続けます。確認のダイアログボックスが表示されたら、［ 続行 ］をタッチします。 これらのリスクを許容しない場合は、サードパーティ製の消耗品や部品をプリンタから取り外し、Lexmark 純正の消耗品や部品を取り付けます。詳細については、 を参照してください。 これらのリスクを許容しない場合は、サードパーティ製の消耗品や部品をプリンタから取り外し、Dell 純正の消耗品や部品を取り付けます。 これらのリスクを許容しない場合は、サードパーティ製の消耗品や部品をプリンタから取り外し、プリンタメーカー純正の消耗品や部品を取り付けます。 エラーメッセージを消去してもプリンタで印刷できない場合は、消耗品使用量カウンタをリセットします。 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 設定メニュー ］ ［ 消耗品使用量とカウンタ ］の順に移動します。 リセットする部品または消耗品を選択して、［ 開始 ］を選択します。 警告メッセージを確認して［ 続行 ］を選択します。 2 本の指でディスプレイを 15 秒間タッチしてメッセージを消去します。 消耗品使用量カウンタをリセットできない場合は、購入先に消耗品を返品します。 プリンタメッセージ Lexmark 以外の消耗品 Lexmark 以外の消耗品 プリンタメッセージ Dell 以外の消耗品 Dell 以外の消耗品 プリンタメッセージ プリンタメーカー以外の消耗品 プリンタメーカー以外の消耗品 リセット 消耗品使用量カウンタ 消耗品使用量カウンタ リセット 消耗品使用量カウンタをリセットする"},{"UUID":"e10486e4-a715-4db0-9f81-b52d4f2c5f7b","title":"給紙の問題","link":"trb-paper-curl-topic.html","desc":"用紙のカール 次の手順を 1 つ以上実行します。 トレイのガイドを、セットされている用紙のサイズに合う正しい位置に調整します。","descFull":"用紙のカール 次の手順を 1 つ以上実行します。 トレイのガイドを、セットされている用紙のサイズに合う正しい位置に調整します。 オペレーティングシステム（OS）に応じて、［印刷基本設定］または［印刷］ダイアログから用紙の種類を指定します。トレイにセットされた用紙と設定が一致していることを確認します。 プリンタ操作パネルで設定を変更することもできます。［ 設定 ］ ［ 用紙 ］ ［ トレイ構成設定 ］ ［ 用紙サイズ/タイプ ］の順に移動します。 用紙を取り出して裏返し、セットし直します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷品質の問題 用紙のカール 用紙のカール"},{"UUID":"edd0adb5-929b-471f-81b1-17f53d1da669","title":"給紙の問題","link":"trb-paper-curl-topic.html","desc":"印刷時に封筒の封が閉じられる 次の手順を 1 つ以上実行します。 乾燥した場所に保管されている封筒を使用してください。","descFull":"印刷時に封筒の封が閉じられる 次の手順を 1 つ以上実行します。 乾燥した場所に保管されている封筒を使用してください。 湿気を帯びた封筒に印刷すると、封の部分が閉じられる可能性があります。 この用紙タイプが［ 封筒 ］に設定されていることを確認します。操作パネルから、［ 設定 ］ ［ 用紙 ］ ［ トレイ設定 ］ ［ 用紙サイズ/タイプ］ の順に移動します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 給紙の問題 印刷時に封筒の封が閉じられる 印刷時に封筒の封が閉じられる"},{"UUID":"237a972a-ee5c-412d-8b66-467740d8b37c","title":"給紙の問題","link":"trb-paper-curl-topic.html","desc":"部単位印刷が動作しない 次の手順を 1 つ以上実行します。 操作パネルで、［","descFull":"部単位印刷が動作しない 次の手順を 1 つ以上実行します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ レイアウト ］ ［ 部単位印刷 ］に順に移動し、［ オン[1,2,1,2,1,2] ］を選択します。 印刷するドキュメントで、［印刷設定］ダイアログボックスを開いて［ 部単位印刷 ］を選択します。 印刷するページ数を減らします。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 給紙の問題 部単位印刷が動作しない 部単位印刷が動作しない"},{"UUID":"9d6ab501-a8b3-409a-84dc-afa133c0c58d","title":"給紙の問題","link":"trb-paper-curl-topic.html","desc":"トレイのリンクが動作しない 次の手順を 1 つ以上実行します。 リンクされているトレイに同じサイズ、向き、およびタイプの用紙がセットされていることを確認します。","descFull":"トレイのリンクが動作しない 次の手順を 1 つ以上実行します。 リンクされているトレイに同じサイズ、向き、およびタイプの用紙がセットされていることを確認します。 用紙ガイドが正しい位置にあることを確認します。 接続されているトレイにセットされた用紙に合った用紙サイズと用紙のタイプを設定します。操作パネルから、［ 設定 ］ ［ 用紙 ］ ［ トレイ設定 ］ ［ 用紙サイズ/タイプ］ の順に移動します。 ［ 同一用紙サイズのトレイのリンク ］が［ 自動 ］に設定されていることを確認します詳細については、 を参照してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 給紙の問題 トレイのリンクが動作しない トレイのリンクが動作しない"},{"UUID":"ed42999b-38bf-4ccf-8172-6611b2ae4d12","title":"給紙の問題","link":"trb-paper-curl-topic.html","desc":"紙詰まりが頻繁に発生する 次の手順を 1 つ以上実行します。 用紙が正しくセットされていることを確認します。","descFull":"紙詰まりが頻繁に発生する 次の手順を 1 つ以上実行します。 用紙が正しくセットされていることを確認します。 用紙ガイドが正しい位置にあることを確認します。 重ねた用紙の高さが、給紙上限マークを超えないようにします。 必ずこの推奨される用紙サイズと用紙タイプで印刷してください。 正しい用紙サイズと用紙タイプをセットします。操作パネルから、［ 設定 ］ ［ 用紙 ］ ［ トレイ設定 ］ ［ 用紙サイズ/タイプ］ の順に移動します。 新しいパッケージの用紙をセットします。 高湿度の場合、用紙は水分を吸収します。この用紙は、使用するときまで包装を開けずに保管してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 給紙の問題 紙詰まりが頻繁に発生する 紙詰まりが頻繁に発生する"},{"UUID":"1344a086-78d7-47cf-859b-9b5f6ecda593","title":"給紙の問題","link":"trb-paper-curl-topic.html","desc":"紙詰まりが発生したページが再印刷されない 操作パネルで、［ 設定 ］ ［","descFull":"紙詰まりが発生したページが再印刷されない 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ 通知 ］ ［ 紙詰まりしたページの再印刷 ］の順に移動します。 ［ 紙づまり回復 ］メニューで［ オン ］または［ 自動 ］を選択します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 印刷の問題 紙詰まりが発生したページが再印刷されない 紙詰まりが発生したページが再印刷されない"},{"UUID":"7d1a2da8-8c5d-498d-9f3f-7ddcbfdf5e11","title":"E メールの問題","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"［SMTP サーバーが設定されていません］エラーメッセージを無効にする 操作パネルで、［ 設定 ］","descFull":"［SMTP サーバーが設定されていません］エラーメッセージを無効にする 操作パネルで、［ 設定 ］ ［ E メール ］ ［ E メール設定 ］の順に移動します。 ［ ［SMTP サーバーが設定されていません］エラーを無効にする ］を［ オン ］に設定します。 エラーの再発を防止するには、次の操作を 1 つ以上実行します。 プリンタのファームウェアを更新します詳細については、「ファームウェアを更新する」セクションを参照してください。 E メールの SMTP 設定を行います。詳細については、 を参照してください。 ［SMTP サーバーが設定されていません］エラー 無効にする トラブルシューティング ［SMTP サーバーが設定されていません］エラー ［SMTP サーバーが設定されていません］エラーを無効にする"},{"UUID":"5c0a04ba-da42-4dcb-b88a-4b3032e6ed92","title":"E メールの問題","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"E メールを送信できない 次の手順を 1 つ以上実行します。","descFull":"E メールを送信できない 次の手順を 1 つ以上実行します。 プリンタの E メール SMTP 設定が正しいことを確認してください。詳細については、 を参照してください。 プリンタがネットワークに接続されていること、ネットワークがインターネットに接続されていることを確認してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 E メールの問題 E メールを送信できない E メールを送信できない"},{"UUID":"59ae17b7-0b76-42a5-88f9-21972d5ab2b9","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"発信者 ID が表示されない 発信者 ID","descFull":"発信者 ID が表示されない 発信者 ID が表示されない これらの手順は、FAX カードが取り付けられているプリンタにのみ適用されます。 操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ 管理者用設定 ］の順に移動します。 ［ 発信者 ID 表示を有効化 ］を［ オン ］に設定します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル 発信者 ID が表示されない 発信者 ID が表示されない"},{"UUID":"e87ae9fb-b20b-4ba6-8df8-1bb0b5558608","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"アナログ FAX を使用して FAX を送受信できない","descFull":"アナログ FAX を使用して FAX を送受信できない アナログ FAX を使用して FAX を送受信できない 次の手順を 1 つ以上実行します。 ディスプレイに表示されるエラーメッセージを解決します。 電話器、受話器、留守番電話のケーブルがしっかりと接続されていることを確認します。 発信音を確認します。 FAX 番号に電話をかけて、正しく機能していることを確認します。 オンフックダイヤル機能をご使用の場合は、ボリュームを上げて発信音が聞こえるかどうかを確認してください。 電話の差し込み口を確認します。 差し込み口に直接アナログ電話を接続します。 発信音を聞いてください。 発信音が聞こえない場合は、別の電話ケーブルをご利用ください。 やはり発信音が聞こえない場合は、アナログ電話を別の差し込み口に差し込んでください。 発信音が聞こえたら、その差し込み口にプリンタを接続してください。 プリンタがアナログ電話サービスまたは正しいデジタルコネクタに接続されていることを確認します。 統合サービスデジタル通信網（ISDN）電話サービスを使用している場合、ISDN ターミナルアダプタのアナログ電話ポートに接続します。詳細については、ISDNプロバイダにお問い合わせください。 DSL を使用している場合、アナログでの使用をサポートしている DSL フィルタまたはルーターに接続します。詳細については、DSLプロバイダにお問い合わせください。 構内交換機（PBX）電話サービスをご使用の場合は、PBX のアナログ接続部に接続しているか確認してください。アナログ接続部がない場合は、FAX 機用アナログ電話回線の設置をご検討ください。 一時的に他の機器の接続を切断して、他の電話サービスを無効にします。 プリンタと電話回線間の他の機器（留守番電話、コンピュータ、モデムまたは電話回線スプリッタなど）を切断します。 割込通話およびボイスメールを無効にします。詳細については、電話会社にお問い合わせください。 原稿を一度に 1 ページスキャンしてください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル アナログ FAX を使用して FAX を送受信できない アナログ FAX を使用して FAX を送受信できない"},{"UUID":"64f942de-920e-43fd-a2a1-6b5abe1f6fba","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"アナログ FAX を使用して FAX を受信できるが送信できない","descFull":"アナログ FAX を使用して FAX を受信できるが送信できない アナログ FAX を使用して FAX を受信できるが送信できない 次の手順を 1 つ以上実行します。 原稿を ADF トレイまたは原稿台にセットします。 ショートカット番号を正しく設定します。 ショートカット番号がダイヤルしたい電話番号に設定されていることを確認してください。 電話番号を手動でダイヤルします。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル アナログ FAX を使用して FAX を送信できない アナログ FAX を使用して FAX を送信できない"},{"UUID":"fcf76f69-8f26-4bab-a335-865b2152580e","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"アナログ FAX を使用して FAX を送信できるが受信できない","descFull":"アナログ FAX を使用して FAX を送信できるが受信できない アナログ FAX を使用して FAX を送信できるが受信できない 次の手順を 1 つ以上実行します。 給紙源が空でないことを確認します。 着信音待機回数の設定をチェックします。操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ 呼び出し回数 ］の順に移動します。 プリンタで空白のページが印刷される場合は、 を参照してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル アナログ FAX を使用して FAX を送信できるが受信できない アナログ FAX を使用して FAX を受信できない"},{"UUID":"465bddf1-985c-40d5-808f-7b901c8c7fe4","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"etherFAX を設定できない etherFAX を設定できない 次の手順を","descFull":"etherFAX を設定できない etherFAX を設定できない 次の手順を 1 つ以上実行します。 プリンタの接続を確認します。 操作パネルで、［ 設定 ］ ［ レポート ］ ［ ネットワーク ］ ［ ネットワーク設定ページ ］の順に移動します。 印刷されたページでネットワークの状態を確認します。 プリンタがネットワークに接続されていること、ネットワークがインターネットに接続されていることを確認してください。 etherFAX が正しく設定されていることを確認します。詳細については、 を参照してください。 問題が解決しない場合は、 https://www.etherfax.net/lexmark  にアクセスします。 FAX に関するトラブル etherFAX を設定できない etherFAX を設定できない"},{"UUID":"b108b563-f289-4f21-b816-83a2992764fe","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"etherFAX を使用して FAX を送受信できない etherFAX","descFull":"etherFAX を使用して FAX を送受信できない etherFAX を使用して FAX を送受信できない 次の手順を 1 つ以上実行します。 プリンタがネットワークに接続されていること、ネットワークがインターネットに接続されていることを確認してください。 etherFAX が正しく設定されていることを確認します。詳細については、 を参照してください。 大きいドキュメントを小さいファイルサイズに分割します。 問題が解決しない場合は、 https://www.etherfax.net/lexmark  にアクセスします。 FAX に関するトラブル etherFAX を使用して FAX を送受信できない etherFAX を使用して FAX を送受信できない"},{"UUID":"2b42b0e0-be8b-4ca6-82cb-a248e576663b","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"FAX の印刷品質が悪い FAX の印刷品質が悪い 次の手順を","descFull":"FAX の印刷品質が悪い FAX の印刷品質が悪い 次の手順を 1 つ以上実行します。 印刷品質の問題があれば解決します。 ［ 品質テストページ ］を印刷します。操作パネルで、［ 設定 ］ ［トラブルシューティング ］ ［ 印刷品質テストページ ］の順に移動します。 印刷品質の問題があれば修正します。詳細については、 を参照してください。 アナログ FAX を使用している場合は、FAX の受信速度を下げます。 操作パネルで、［ 設定 ］ ［ FAX ］ ［ FAX 設定 ］ ［ FAX 受信設定 ］ ［ 管理者用設定 ］の順に移動します。 ［ 最高印刷速度 ］メニューで、遅い送信速度を選択します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル 印刷品質が良くない FAX の印刷品質が悪い"},{"UUID":"31c66e5a-81b8-4976-ad52-10c47e85b736","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"FAX 送付状ページに情報がない FAX 送付状ページに情報がない プリンタの電源を切って約","descFull":"FAX 送付状ページに情報がない FAX 送付状ページに情報がない プリンタの電源を切って約 10 秒間待ってから、再び電源を入れます。 FAX を送信または取得します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル FAX 送付状ページに情報がない FAX 送付状ページに情報がない"},{"UUID":"16d5e468-e8d2-46d8-a922-7be680846a6d","title":"FAX の問題","link":"trb-caller-id-not-shown-topic.html","desc":"コンピュータから FAX 送付状ページを送信できない コンピュータから FAX","descFull":"コンピュータから FAX 送付状ページを送信できない コンピュータから FAX 送付状ページを送信できない 次の手順を 1 つ以上実行します。 プリンタドライバが更新されていることを確認します。詳細については、 www.lexmark.com/downloads  を参照してください。 プリンタドライバが更新されていることを確認します。詳細については、プリンタの購入先に問い合わせてください。 プリントドライバが更新されていることを確認してから、ファクスを送信します。詳細については、 営業担当者 に問い合わせてください。 ［ FAX を送信する前に設定を常に表示 ］設定をオフにします。 FAX するドキュメントで、［ 印刷 ］ダイアログを開きます。 プリンタを選択し、［ プロパティ ］、［ 基本設定 ］、［ オプション ］、または［ 設定 ］をクリックします。 ［ FAX ］をクリックし、［ FAX を送信する前に設定を常に表示 ］設定をオフにします。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 FAX に関するトラブル コンピュータから FAX 送付状ページを送信できない コンピュータから FAX 送付状ページを送信できない"},{"UUID":"39ba7283-37e8-4558-98e8-e2f008f12bcb","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャンしてコンピュータに保存できない 次の手順を 1 つ以上実行します。 コピージョブを実行します。ジョブが失敗した場合、プリンタの電源を切って約","descFull":"スキャンしてコンピュータに保存できない 次の手順を 1 つ以上実行します。 コピージョブを実行します。ジョブが失敗した場合、プリンタの電源を切って約 10 秒間待ってから、再び電源を入れます。 プリンタの接続を確認します。 ［ ネットワーク設定ページ ］を印刷します。操作パネルで、［ 設定 ］ ［ レポート ］ ［ ネットワーク ］の順に移動し、［ ネットワーク設定ページ ］を選択します。 ページの最初のセクションを確認し、状態が［接続済み］であることを確認します。 プリンタとコンピュータが同じネットワークに接続していることを確認します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンの問題 スキャンしてコンピュータに保存できない スキャンしてコンピュータに保存できない"},{"UUID":"6a9b52d0-35e4-46b8-bbea-57ca8fba9b6e","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャンしてネットワークフォルダに保存できない 次の手順を 1 つ以上実行します。 ネットワークフォルダのショートカットを作成し、ショートカットを使ってドキュメントをスキャンします。詳細については、","descFull":"スキャンしてネットワークフォルダに保存できない 次の手順を 1 つ以上実行します。 ネットワークフォルダのショートカットを作成し、ショートカットを使ってドキュメントをスキャンします。詳細については、 を参照してください。 ネットワークフォルダのパスと形式が正しいことを確認します。例えば、 // server_hostname /foldername/path  の場合、 server_hostname  は、完全修飾ドメイン（FQDN）または IP アドレスです。 ネットワークフォルダへの書き込みアクセス権限があることを確認します。 ネットワークフォルダのショートカットを更新します。 Web ブラウザを開き、アドレスフィールドにプリンタの IP アドレスを入力します。 プリンタのホーム画面で、プリンタの IP アドレスを表示します。IP アドレスは、123.123.123.123 のように、ピリオドで区切られた 4 組の数字で表示されます。 プロキシサーバーを使用している場合は、一時的に無効にし、Web ページを正しく読み込んでください。 ［ ショートカット ］をクリックして、ショートカットを選択します。 複数のショートカットタイプがある場合は、［ ネットワークフォルダ .］を選択します。 ［共有パス］フィールドに、ネットワークフォルダのパスを入力します。例えば、「 \\server_hostname_foldernamepath 」のように入力します。 共有パスを入力するときは、常にフォワードスラッシュを使用してください。 ［ 認証 ］メニューから、認証方法を選択します。 ［ 認証 ］が［ 割り当て済みのユーザー名とパスワードを使用 ］に設定されている場合は、［ユーザー名］フィールドと［パスワード］フィールドに資格情報を入力します。 ［ 保存 ］をクリックします。 プリンタとネットワークフォルダが同じネットワークに接続していることを確認します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンしてネットワークフォルダに保存できない スキャンの問題 スキャンしてネットワークフォルダに保存できない"},{"UUID":"3518d2e8-44ea-4efc-8f66-bbef8a48c814","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"文書や写真の一部しかコピーされない 次の手順を 1 つ以上実行します。 ドキュメントまたは写真が原稿台ガラスの左上の角に表を下にしてセットされているか確認してください。","descFull":"文書や写真の一部しかコピーされない 次の手順を 1 つ以上実行します。 ドキュメントまたは写真が原稿台ガラスの左上の角に表を下にしてセットされているか確認してください。 用紙サイズの設定がトレイにセットした用紙と合っているか確認してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 コピーの問題 文書の一部分しかコピーされない コピーの問題 写真の一部分しかコピーされない 文書や写真の一部分しかコピーされない スキャンの問題 文書の一部分しかコピーされない スキャンの問題 写真の一部分しかコピーされない"},{"UUID":"d9591aaf-5675-4df2-8be2-7c6b96456fd6","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"コピー品質が悪い 次の手順を 1 つ以上実行します。 水で湿らせた柔らかい糸くずの出ない布で、スキャナ原稿台ガラスと","descFull":"コピー品質が悪い 次の手順を 1 つ以上実行します。 水で湿らせた柔らかい糸くずの出ない布で、スキャナ原稿台ガラスと ADF 原稿台ガラスを清掃してください。 お使いのプリンタで、ADF 内部に 2 枚目の ADF 原稿台ガラスがある場合は、そのガラスも清掃してください。詳細については、 を参照してください。 ドキュメントまたは写真が原稿台ガラスの左上の角に表を下にしてセットされているか確認してください。 元のドキュメントや写真の画質を確認し、その画質に応じてスキャン品質の設定を調整します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 コピーの問題 コピー品質が悪い コピー品質が悪い スキャンの問題 コピー品質が悪い スキャン品質が悪い"},{"UUID":"facdf28b-cf66-4e40-8368-02eb3082318d","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"ADF からスキャンした場合に発生する縦方向の黒い縞 スキャナカバーを持ち上げ、ガラスクリーナツールを取り外します。 スキャナガラスの横にある ADF","descFull":"ADF からスキャンした場合に発生する縦方向の黒い縞 スキャナカバーを持ち上げ、ガラスクリーナツールを取り外します。 スキャナガラスの横にある ADF ガラスを拭きます。 ドア A1 を開き、ADF ガラスを清掃します。 ツールを元の場所に戻します。 スキャナカバーを閉じます。 スキャナの清掃の詳細については、 を参照してください。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンの問題 ADF からスキャンしたときに出力に縦方向の濃い縞が入る ADF からスキャンしたときに出力に縦方向の濃い縞が入る スキャンの品質問題"},{"UUID":"6606eaf1-dabb-4537-ba43-04b354cea640","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"ADF からスキャンするときに画像または文字がぎざぎざになる ADF からスキャンするときに画像または文字がぎざぎざになる 50","descFull":"ADF からスキャンするときに画像または文字がぎざぎざになる ADF からスキャンするときに画像または文字がぎざぎざになる 50 枚のきれいな普通紙を ADF にセットします。 普通紙を使用すると、ADF 給紙ローラーの汚れやその他のコーティングを除去できます。 操作パネルで、右にスワイプしてコントロールセンターに移動し、  を選択します。 ADF に原稿をセットします。 ドキュメントをスキャンします。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンの問題 ぎざぎざの画像 スキャンの問題 ぎざぎざの文字 トラブルシューティング ADF スキャンで画像がぎざぎざになる トラブルシューティング ADF スキャンでテキストがぎざぎざになる ADF スキャンで画像がぎざぎざになる ADF スキャンでテキストがぎざぎざになる"},{"UUID":"ffa3995f-ea11-4d99-a709-174d7f046496","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャンジョブが失敗した スキャンジョブが失敗した 次の手順を 1 つ以上実行します。","descFull":"スキャンジョブが失敗した スキャンジョブが失敗した 次の手順を 1 つ以上実行します。 イーサネットまたは USB ケーブルがコンピュータおよびプリンタにしっかりと接続されていることを確認してください。 スキャンするファイルについて、次の点を確認します。 ファイル名が保存先フォルダで既に使用されていないこと。 スキャンするドキュメントまたは写真が他のアプリケーションで開かれていないこと。 保存先の設定で［ タイムスタンプを追加 ］または［ 既存ファイルを上書き ］チェックボックスが選択されていることを確認します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンの問題 スキャンジョブが失敗した スキャンジョブが失敗した トラブルシューティング スキャンジョブが失敗した"},{"UUID":"b0d45f2c-7597-4f08-a47c-f5340ffe102b","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャナが閉じない スキャナが閉じない スキャナカバーが閉じない原因となっている障害物を取り除きます。 スキャナを閉じます。 問題が解決されない場合は、","descFull":"スキャナが閉じない スキャナが閉じない スキャナカバーが閉じない原因となっている障害物を取り除きます。 スキャナを閉じます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンの問題 スキャナが閉じない スキャナが閉じない"},{"UUID":"b5abaa0a-7a00-412b-a283-89aee4b9254f","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャンに時間がかかり過ぎる、またはコンピュータがフリーズする スキャンに時間がかかり過ぎる、またはコンピュータがフリーズする スキャンを妨害しているすべてのアプリケーションを閉じます。 原稿をもう一度スキャンします。 問題が解決されない場合は、","descFull":"スキャンに時間がかかり過ぎる、またはコンピュータがフリーズする スキャンに時間がかかり過ぎる、またはコンピュータがフリーズする スキャンを妨害しているすべてのアプリケーションを閉じます。 原稿をもう一度スキャンします。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 スキャンの問題 スキャンに時間がかかりすぎる スキャンの問題 スキャンによってコンピュータがフリーズする スキャンに時間がかかり過ぎる、またはコンピュータがフリーズする"},{"UUID":"453a8255-fbb1-401a-bdd7-c3295d8e5f4d","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャナが反応しない スキャナが反応しない 次の手順を 1 つ以上実行します。","descFull":"スキャナが反応しない スキャナが反応しない 次の手順を 1 つ以上実行します。 電源コードがプリンタと電源コンセントに接続されていることを確認します。 火災や感電の危険を避けるため、電源コードを接続するコンセントが、製品の設置場所の近くにあること、アクセスしやすいこと、正しく接地されていること、適切な定格であることを確認してください。 プリンタの電源が入っているか確認し、ディスプレイに表示されたエラーメッセージを解決します。 プリンタの電源を切って約 10 秒間待ってから、再び電源を入れます。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 コピーの問題 スキャナが反応しない スキャンの問題 スキャナが反応しない スキャナが反応しない"},{"UUID":"422c7486-95c1-4cc1-baeb-6c64a383223c","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"スキャナ登録を調整する スキャナ登録を調整する 操作パネルで、［ 設定 ］","descFull":"スキャナ登録を調整する スキャナ登録を調整する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 構成設定メニュー ］ ［ ［スキャナ設定 ］ ［ ［スキャナ手動登録 ］の順に移動します。 ［ 印刷簡易テスト ］メニューで［ 開始 ］を選択します。 原稿台にテストページをセットし、［ フラットベッド登録 ］を選択します。 ［ コピー簡易テスト ］メニューで［ 開始 ］を選択します。 テストページを原稿と比較します。 テストページの余白が原稿と異なる場合は、［ 左余白 ］と［ 上部余白 ］設定を調整します。 ［ コピー簡易テスト ］ページの余白が原稿と一致するまで、 および を繰り返します。 調整 スキャナ登録"},{"UUID":"50847416-d295-439b-9630-bd468dd7a4cf","title":"スキャンの問題","link":"trb-cannot-scan-to-computer-topic.html","desc":"ADF 登録を調整する 操作パネルで、［ 設定 ］","descFull":"ADF 登録を調整する 操作パネルで、［ 設定 ］ ［ デバイス ］ ［ メンテナンス ］ ［ 構成設定メニュー ］ ［ ［スキャナ設定 ］ ［ ［スキャナ手動登録 ］の順に移動します。 ［ 印刷簡易テスト ］メニューで［ 開始 ］を選択します。 ADF トレイにテストページをセットします。 ［ 正面 ADF 登録 ］または［ 背面 ADF 登録 ］を選択します。 ［ 正面 ADF 登録 ］を調整するには、短辺方向から ADF へテストページ面を上にしてセットします。 ［ 背面 ADF 登録 ］を調整するには、短辺方向から ADF へテストページ面を下にしてセットします。 ［ コピー簡易テスト ］メニューで［ 開始 ］を選択します。 テストページを原稿と比較します。 テストページの余白が原稿と異なる場合は、［ 横方向の調整 ］と［ 上部余白 ］設定を調整します。 ［ コピー簡易テスト ］ページの余白が原稿と一致するまで、 および を繰り返します。 ADF 登録 調整 ADF 登録を調整する"},{"UUID":"603ba008-356a-4fe9-8635-fed6e6750570","title":"色品質の問題","link":"modifying-colors-in-printed-output-topic.html","desc":"印刷出力で色を変更する 操作パネルで、［ 設定 ］ ［","descFull":"印刷出力で色を変更する 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］ ［ カラー補正 ］の順に移動します。 ［ カラー補正 ］メニューから、［ 手動 ］を選択します。 ［ カラー補正の内容 ］メニューで、適切なカラー変換設定を選択します。 ［手動カラー］メニューオブジェクトタイプとカラー変換表 オブジェクトタイプ カラー変換表 RGB イメージ RGB 文字 RGB グラフィックス ビビッド  — より明るい彩度の色を生成し、すべての受信するカラー形式に適用できます。 sRGB 表示  — コンピュータ画面の表示に近い色で印刷します。写真印刷のブラックトナーの使用が最適化されます。 画面-トゥルーブラック —コンピュータ画面の表示に近い色で印刷します。この設定では、中間色のグレーにはすべてのレベルでブラックトナーのみが使用されます。 sRGB ビビッド  — ［ sRGB 表示 ］カラー補正の高い彩度の色を生成します。ビジネスグラフィックスの印刷の場合に、ブラックトナーの使用が最適化されます。 オフ CMYK イメージ CMYK 文字 CMYK グラフィックス 米国 CMYK  — SWOP（米国のオフセット印刷標準規格）色出力の近似値に補正します。 ユーロ CMYK  — EuroScale 色出力の近似値に補正します。 鮮明 CMYK  — ［ 米国 CMYK ］より彩度の高いカラー補正設定が適用されます。 オフ カラー出力を変更する 手動カラー補正 カラー補正"},{"UUID":"05b263f6-295c-43d6-b0ee-cbc298b99797","title":"色品質の問題","link":"modifying-colors-in-printed-output-topic.html","desc":"カラー印刷についてのよくある質問 RGB カラーとは？ RGB カラーは、ある色を作るのに使用する赤、緑、青色の割合を示すことによって色を表現する方法です。赤、緑、青の光は、さまざまな割合で重ねると自然界で見られる幅広い色を作ることができます。コンピュータ画面、スキャナ、デジタルカメラは、この方法を使用してカラーを表示します。","descFull":"カラー印刷についてのよくある質問 RGB カラーとは？ RGB カラーは、ある色を作るのに使用する赤、緑、青色の割合を示すことによって色を表現する方法です。赤、緑、青の光は、さまざまな割合で重ねると自然界で見られる幅広い色を作ることができます。コンピュータ画面、スキャナ、デジタルカメラは、この方法を使用してカラーを表示します。 CMYK カラーとは？ CMYK カラーは、特定の色を再現するのに使用するシアン、マゼンタ、イエロー、ブラックの割合を示すことによって色を表現する方法です。CMYK のインクまたはトナーは、さまざまな割合で印刷すると自然界で見られる幅広い色を作ることができます。印刷機、インクジェットプリンタ、カラーレーザー/LED プリンタの色はこのように作ります。 印刷される文書の色はどのように指定されるのですか？ RGB または CMYK カラーの組み合わせを使用してドキュメントでカラーを指定および変更するには、ソフトウェアプログラムが使用されます。詳細については、ソフトウェアアプリケーションのヘルプの項をご参照ください。 プリンタは印刷する色をどのように認識するのですか？ ドキュメントを印刷するときに、各オブジェクトの種類とカラーを示す情報がプリンタに送信されます。次に、これらの情報はカラー変換テーブルに渡されます。カラーは、希望する色を作るのに使用する CMYK のトナー量に換算されます。オブジェクトタイプの情報に従い、オブジェクトのタイプごとに異なる色変換表を使用します。例えば、文字にはあるタイプのカラー変換テーブルを適用し、写真には別のカラー変換テーブルを適用することができます。 手動カラー補正とは？ 手動カラー補正が有効である場合、ユーザーが選択したカラー変換テーブルを使用し、オブジェクトを処理します。手動カラー補正の設定は、印刷するオブジェクトのタイプ（文字、グラフィックス、イメージ）によって異なります。また、ソフトウェアプログラムでオブジェクトのカラーを指定する方法（RGB または CMYK の組み合わせ）によっても異なります。異なるカラー変換テーブルを手動で適用する方法については、 を参照してください。 ソフトウェアプログラムが RGB または CMYK の組み合わせでカラーを指定しない場合、手動カラー補正は役立ちません。また、ソフトウェアプログラムやコンピュータのオペレーティングシステム（OS）がカラー調整を制御している場合も、設定が無効になります。ほとんどの場合、カラー補正を［自動］に設定すると、ドキュメントに対して適切なカラーが選択されます。 特殊な色（企業のロゴなど）はどのように合わせますか？ ［ 品質 ］メニューには、9 つの［ カラーサンプル ］値があります。これらの設定は EWS の カラーサンプル ペーからも入手できます。カラーサンプルのいずれかを選択すると、数百のカラーボックスが複数ページに印刷されます。選択したテーブルに応じて、各ボックスに CMYK または RGB の組み合わせが示されます。ボックスにラベル付けされた CMYK または RGB の組み合わせを通すと、各ボックスの実際の色が得られます。 カラーサンプル ページを確認して、対応する色に最も近い色のボックスを特定できます。ボックスラベルの色の組み合わせを使用して、ソフトウェアアプリケーションでオブジェクトの色を修正できます。詳細については、ソフトウェアアプリケーションのヘルプの項をご参照ください。［手動カラー補正］は特定オブジェクトに対してカラー変換テーブルを選択して使用する際に必要です。 特定カラーの一致の問題を解決するためにどの カラーサンプル セットを選択するかは、以下の点によって異なります。 使用する［ カラー補正 ］の設定（［ 自動 ］、［ オフ ］、［ 手動 ］）。 印刷するオブジェクトのタイプ（文字、グラフィックス、イメージ）。 ソフトウェアプログラムでオブジェクトのカラーを指定する方法（RGB または CMYK の組み合わせ）。 ソフトウェアプログラムが RGB または CMYK の組み合わせでカラーを指定しない場合、 カラーサンプル ページは役立ちません。カラー管理機能を介してプログラムで指定される RGB または CMYK の組み合わせを調整するソフトウェアプログラムもあります。そのような状況では、印刷された色が カラーサンプル ページと厳密には合わない場合があります。 色品質の問題 カラー印刷についてのよくある質問 カラー印刷 カラー補正 カラーサンプル"},{"UUID":"8160faef-23cf-4ad8-bac3-a015cada5623","title":"色品質の問題","link":"modifying-colors-in-printed-output-topic.html","desc":"印刷が薄く見える 印刷が薄く見える 次の手順を 1 つ以上実行します。","descFull":"印刷が薄く見える 印刷が薄く見える 次の手順を 1 つ以上実行します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］の順に移動して、［ カラー調整 ］を選択します。 操作パネルで、［ 設定 ］ ［ 印刷 ］ ［ 品質 ］ ［ イメージ詳細設定 ］の順に移動して、［ カラーバランス ］を選択して設定を調整します。 問題が解決されない場合は、 カスタマサポート に問い合わせてください。 問題が解決されない場合は、 営業担当者 に問い合わせてください。 色品質の問題 印刷が薄く見える 印刷が薄く見える トラブルシューティング 印刷が薄く見える"},{"UUID":"5cadd6d8-b7be-4e0e-ab0a-df7206c84fbb","title":"問題をトラブルシューティングする","link":"trb-contacting-customer-support-topic.html","desc":"カスタマサポートに問い合わせる カスタマサポートに問い合わせる カスタマサポートに連絡する前に、次の情報を確認してください。 プリンタの問題 エラーメッセージ","descFull":"カスタマサポートに問い合わせる カスタマサポートに問い合わせる カスタマサポートに連絡する前に、次の情報を確認してください。 プリンタの問題 エラーメッセージ プリンタ機種とシリアル番号 E メールまたはチャットによるサポートを受けるか、マニュアル、サポートドキュメント、ドライバ、およびその他のダウンロードのライブラリを参照するには、 https://support.lexmark.com  にアクセスしてください。 電話によるテクニカルサポートもご利用いただけます。米国またはカナダにお住まいの場合は、1‑800‑539‑6275 までお問い合わせください。その他の国または地域の場合、 国際サポート連絡先ディレクトリ を参照してください。 プリンタを購入した販売店にお問い合わせください。 カスタマサポートに問い合わせる カスタマサポート"},{"UUID":"5a2f5514-234e-4100-aeb7-4aab3de46e0a","title":"問題をトラブルシューティングする","link":"troubleshooting-chapter.html","desc":"販売店に問い合わせる 販売店に連絡する前に、次の情報を確認してください。 プリンタの問題 エラーメッセージ プリンタ機種とシリアル番号","descFull":"販売店に問い合わせる 販売店に連絡する前に、次の情報を確認してください。 プリンタの問題 エラーメッセージ プリンタ機種とシリアル番号 販売店に問い合わせる プリンタの販売店"},{"UUID":"1ceed00d-dab3-49f4-ab82-8b98e6b89599","title":"問題をトラブルシューティングする","link":"troubleshooting-chapter.html","desc":"技術サポートに問い合わせる 技術サポートへ問い合わせる場合は、問題の詳細と、プリンタディスプレイに表示されているメッセージ、すでに試みたトラブルシューティング手順について説明してください。 上部のフロントカバーの内側またはプリンタ背面のラベルを参照し、以下を確認してください。 プリンタの機種 サービスタグ番号またはエクスプレスサービスコード","descFull":"技術サポートに問い合わせる 技術サポートへ問い合わせる場合は、問題の詳細と、プリンタディスプレイに表示されているメッセージ、すでに試みたトラブルシューティング手順について説明してください。 上部のフロントカバーの内側またはプリンタ背面のラベルを参照し、以下を確認してください。 プリンタの機種 サービスタグ番号またはエクスプレスサービスコード 詳細については、 www.dell.com/support  をご確認ください。 問題に対処する 技術サポートに問い合わせる 技術サポートに問い合わせる"},{"UUID":"342356af-97ab-48c0-bc73-d4a861dce6b6","title":"リサイクルおよび廃棄","link":"recycling-lexmark-products-topic.html","desc":"Lexmark 製品のリサイクルプログラム Lexmark 製品のリサイクルプログラム www.lexmark.com/recycle","descFull":"Lexmark 製品のリサイクルプログラム Lexmark 製品のリサイクルプログラム www.lexmark.com/recycle  をご覧ください。 国または地域を選択してください。 回収プログラムを選択してください。 製品リサイクル"},{"UUID":"4a9b09d6-c78f-4003-b023-ef5c5f9ee758","title":"リサイクルおよび廃棄","link":"recycling-lexmark-packaging-topic.html","desc":"Lexmark 製品の梱包材をリサイクルする Lexmark 製品の梱包材をリサイクルする Lexmark","descFull":"Lexmark 製品の梱包材をリサイクルする Lexmark 製品の梱包材をリサイクルする Lexmark は梱包材を最小限に抑えるよう絶えず努力しています。より少ない梱包材により、Lexmark プリンタは最も効率的で、かつ環境に配慮した方法で輸送され、梱包材の廃棄量の削減に貢献しています。これらの努力は、温室効果ガスのより少ない排出、省エネルギー、天然資源の節約をもたらします。また、Lexmark では、一部の国と地域で梱包材のリサイクルも行っています。詳細については、 www.lexmark.com/recycle を参照してください。 Lexmark のダンボール箱は、再生利用する施設がある地域ではすべてリサイクル可能です。その施設は、お住まいの地域にない可能性があります。 Lexmark の梱包材に使用されている発泡スチロールは、再生利用する施設がある地域ではリサイクル可能です。その施設は、お住まいの地域にない可能性があります。 Lexmark にカートリッジを返却する際には、配達時に梱包されていたダンボール箱を再利用できます。そのダンボール箱は Lexmark がリサイクルします。 製品リサイクル 梱包材"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 MFP"}},[_vm._v("\n    CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 MFP\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_ja","title":"安全に関する情報"}},[_vm._v("\n    安全に関する情報\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"表記規則"}},[_vm._v("\n     表記規則\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e43","title":"製品ステートメント"}},[_vm._v("\n     製品ステートメント\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_ja","title":"プリンタについての確認"}},[_vm._v("\n    プリンタについての確認\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e221"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_ja","title":"プリンタに関する情報を見つける"}},[_vm._v("\n     プリンタに関する情報を見つける\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_ja","title":"プリンタのシリアル番号を確認する"}},[_vm._v("\n     プリンタのシリアル番号を確認する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_ja","title":"プリンタ構成"}},[_vm._v("\n     プリンタ構成\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_ja","title":"操作パネルを使用する"}},[_vm._v("\n     操作パネルを使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#using-home-screen_ja","title":"ホーム画面のアイコン"}},[_vm._v("\n     ホーム画面のアイコン\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"colors-of-indicator-light-topic.html#colors-of-indicator-light_ja","title":"インジケータランプの色"}},[_vm._v("\n     インジケータランプの色\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ja","title":"自動原稿フィーダーと原稿台を使用する"}},[_vm._v("\n     自動原稿フィーダーと原稿台を使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_ja","title":"セキュリティスロットの場所"}},[_vm._v("\n     セキュリティスロットの場所\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e769","title":"用紙を選択する"}},[_vm._v("\n     用紙を選択する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-applications-topic.html#d0e10635","title":"その他のプリンタ機能とサポート"}},[_vm._v("\n     その他のプリンタ機能とサポート\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ja","title":"設定、設置、構成"}},[_vm._v("\n    設定、設置、構成\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_ja","title":"プリンタの設置場所を選択する"}},[_vm._v("\n     プリンタの設置場所を選択する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-ports-topic.html#printer-ports_ja","title":"プリンタポート"}},[_vm._v("\n     プリンタポート\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-scan-center-topic.html#d0e10961","title":"アプリとソリューションを設定する"}},[_vm._v("\n     アプリとソリューションを設定する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e11138","title":"ユーザー補助機能を設定して使用する"}},[_vm._v("\n     ユーザー補助機能を設定して使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e11443","title":"プリンタを設定して FAX を送信する"}},[_vm._v("\n     プリンタを設定して FAX を送信する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#loading-trays-group_ja","title":"用紙と普通紙以外の用紙をセットする"}},[_vm._v("\n     用紙と普通紙以外の用紙をセットする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e12239","title":"ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う"}},[_vm._v("\n     ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-optional-550-sheet-tray-topic.html#d0e12565","title":"ハードウェアオプションを取り付ける"}},[_vm._v("\n     ハードウェアオプションを取り付ける\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e14096","title":"ネットワーク"}},[_vm._v("\n     ネットワーク\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_ja","title":"プリンタを保護する"}},[_vm._v("\n    プリンタを保護する\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14448"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_ja","title":"プリンタメモリを消去する"}},[_vm._v("\n     プリンタメモリを消去する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ja","title":"プリンタストレージドライブを消去する"}},[_vm._v("\n     プリンタストレージドライブを消去する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ja","title":"出荷時初期設定に復元する"}},[_vm._v("\n     出荷時初期設定に復元する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_ja","title":"揮発性に関する記述"}},[_vm._v("\n     揮発性に関する記述\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_ja","title":"印刷"}},[_vm._v("\n    印刷\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e14640"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-topic.html#printing-from-computer_ja","title":"コンピュータから印刷する"}},[_vm._v("\n     コンピュータから印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691","title":"モバイルデバイスから印刷する"}},[_vm._v("\n     モバイルデバイスから印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_ja","title":"フラッシュメモリから印刷する"}},[_vm._v("\n     フラッシュメモリから印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ja","title":"コンフィデンシャルジョブを設定する"}},[_vm._v("\n     コンフィデンシャルジョブを設定する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ja","title":"コンフィデンシャルジョブおよびその他の保留中のジョブを印刷する"}},[_vm._v("\n     コンフィデンシャルジョブおよびその他の保留中のジョブを印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-list_ja","title":"フォントサンプルリストを印刷する"}},[_vm._v("\n     フォントサンプルリストを印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-topic.html#printing-directory-list_ja","title":"ディレクトリ一覧を印刷する"}},[_vm._v("\n     ディレクトリ一覧を印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_ja","title":"印刷ジョブにセパレータ紙を配置する"}},[_vm._v("\n     印刷ジョブにセパレータ紙を配置する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_ja","title":"印刷ジョブをキャンセルする"}},[_vm._v("\n     印刷ジョブをキャンセルする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ja","title":"トナーの濃さを調整する"}},[_vm._v("\n     トナーの濃さを調整する\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_ja","title":"コピー"}},[_vm._v("\n    コピー\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15186"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_ja","title":"コピーを作成する"}},[_vm._v("\n     コピーを作成する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_ja","title":"写真をコピーする"}},[_vm._v("\n     写真をコピーする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-letterhead-topic.html#copying-on-letterhead_ja","title":"レターヘッド紙にコピーする"}},[_vm._v("\n     レターヘッド紙にコピーする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ja","title":"用紙の両面にコピーする"}},[_vm._v("\n     用紙の両面にコピーする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_ja","title":"コピーを縮小または拡大する"}},[_vm._v("\n     コピーを縮小または拡大する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_ja","title":"部単位でコピーする"}},[_vm._v("\n     部単位でコピーする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ja","title":"コピーの区切りとしてセパレータ紙を挿入する"}},[_vm._v("\n     コピーの区切りとしてセパレータ紙を挿入する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_ja","title":"1 枚の用紙に複数ページをコピーする"}},[_vm._v("\n     1 枚の用紙に複数ページをコピーする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_ja","title":"カードをコピーする"}},[_vm._v("\n     カードをコピーする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_ja","title":"ショートカットコピーを作成する"}},[_vm._v("\n     ショートカットコピーを作成する\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_ja","title":"E メール"}},[_vm._v("\n    E メール\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e15459"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-settings-topic.html#configuring-smtp-settings_ja","title":"SMTP 設定を構成する"}},[_vm._v("\n     SMTP 設定を構成する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_ja","title":"E メールを送信する"}},[_vm._v("\n     E メールを送信する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ja","title":"E メールショートカットを作成する"}},[_vm._v("\n     E メールショートカットを作成する\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_ja","title":"FAX"}},[_vm._v("\n    FAX\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16908"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_ja","title":"FAX を送信する"}},[_vm._v("\n     FAX を送信する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_ja","title":"FAX をスケジュール設定する"}},[_vm._v("\n     FAX をスケジュール設定する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ja","title":"FAX 宛先のショートカットを作成する"}},[_vm._v("\n     FAX 宛先のショートカットを作成する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_ja","title":"FAX の解像度変更"}},[_vm._v("\n     FAX の解像度変更\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ja","title":"FAX の濃度を調整する"}},[_vm._v("\n     FAX の濃度を調整する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_ja","title":"FAX ログを印刷する"}},[_vm._v("\n     FAX ログを印刷する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_ja","title":"迷惑 FAX をブロックする"}},[_vm._v("\n     迷惑 FAX をブロックする\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_ja","title":"FAX の保留"}},[_vm._v("\n     FAX の保留\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_ja","title":"FAX の転送"}},[_vm._v("\n     FAX の転送\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_ja","title":"スキャン"}},[_vm._v("\n    スキャン\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17204"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_ja","title":"コンピュータへのスキャン"}},[_vm._v("\n     コンピュータへのスキャン\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ja","title":"スキャンして FTP サーバーに送信する"}},[_vm._v("\n     スキャンして FTP サーバーに送信する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ja","title":"FTP ショートカットを作成する"}},[_vm._v("\n     FTP ショートカットを作成する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-network-folder-topic.html#scanning-to-network-folder_ja","title":"スキャンしてネットワークフォルダに送信する"}},[_vm._v("\n     スキャンしてネットワークフォルダに送信する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-network-folder-destination-topic.html#configuring-network-folder-destination_ja","title":"保存先のネットワークフォルダを設定する"}},[_vm._v("\n     保存先のネットワークフォルダを設定する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ja","title":"ネットワークフォルダのショートカットを作成する"}},[_vm._v("\n     ネットワークフォルダのショートカットを作成する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ja","title":"フラッシュメモリにスキャンする"}},[_vm._v("\n     フラッシュメモリにスキャンする\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printer-menus-chapter.html#printer-menus-chapter_ja","title":"プリンタメニュー"}},[_vm._v("\n    プリンタメニュー\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17493"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-topic.html#menu-map_ja","title":"メニューマップ"}},[_vm._v("\n     メニューマップ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e17807","title":"デバイス"}},[_vm._v("\n     デバイス\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e20041","title":"印刷"}},[_vm._v("\n     印刷\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e21323","title":"用紙"}},[_vm._v("\n     用紙\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e21655","title":"コピー"}},[_vm._v("\n     コピー\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e22214","title":"FAX"}},[_vm._v("\n     FAX\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e24081","title":"E メール"}},[_vm._v("\n     E メール\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e25178","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e25884","title":"USB ドライブ"}},[_vm._v("\n     USB ドライブ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e26730","title":"ネットワーク/ポート"}},[_vm._v("\n     ネットワーク/ポート\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e28881","title":"セキュリティ"}},[_vm._v("\n     セキュリティ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e29978","title":"クラウドサービス"}},[_vm._v("\n     クラウドサービス\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e30035","title":"レポート"}},[_vm._v("\n     レポート\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_ja","title":"トラブルシューティング"}},[_c('strong',[_vm._v("\n      トラブルシューティング\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_ja","title":"Forms Merge"}},[_c('strong',[_vm._v("\n      Forms Merge\n     ")])])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_ja","title":"［メニュー設定ページ］を印刷する"}},[_vm._v("\n     ［\n     "),_c('strong',[_vm._v("\n      メニュー設定ページ\n     ")]),_vm._v("\n     ］を印刷する\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_ja","title":"プリンタフィニッシャオプション"}},[_vm._v("\n    プリンタフィニッシャオプション\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30518"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-finisher-topic.html#using-staple-finisher_ja","title":"ホチキスフィニッシャを使用する"}},[_vm._v("\n     ホチキスフィニッシャを使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_ja","title":"ホチキス、穴パンチフィニッシャを使用する"}},[_vm._v("\n     ホチキス、穴パンチフィニッシャを使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacker-topic.html#using-offset-stacker_ja","title":"オフセットスタッカを使用する"}},[_vm._v("\n     オフセットスタッカを使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-booklet-finisher-topic.html#using-booklet-finisher_ja","title":"小冊子フィニッシャを使用する"}},[_vm._v("\n     小冊子フィニッシャを使用する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-hptfu-topic.html#using-hptfu_ja","title":"折り畳みオプション付きの用紙搬送ユニットを使用する"}},[_vm._v("\n     折り畳みオプション付きの用紙搬送ユニットを使用する\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_ja","title":"プリンタのメンテナンス"}},[_vm._v("\n    プリンタのメンテナンス\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e30928"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-supplies-status-topic.html#checking-supplies-status_ja","title":"部品と消耗品の状況を確認する"}},[_vm._v("\n     部品と消耗品の状況を確認する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_ja","title":"消耗品通知を設定する"}},[_vm._v("\n     消耗品通知を設定する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-email-alert-topic.html#setting-up-email-alert_ja","title":"E メールアラートを設定する"}},[_vm._v("\n     E メールアラートを設定する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-reports-and-logs-topic.html#generating-reports-and-logs_ja","title":"レポートとログを生成する"}},[_vm._v("\n     レポートとログを生成する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_ja","title":"部品と消耗品を注文する"}},[_vm._v("\n     部品と消耗品を注文する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e31783","title":"部品と消耗品を交換する"}},[_vm._v("\n     部品と消耗品を交換する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e32407","title":"プリンタ部品を清掃する"}},[_vm._v("\n     プリンタ部品を清掃する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e32571","title":"電力と用紙を節約する"}},[_vm._v("\n     電力と用紙を節約する\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_ja","title":"プリンタを別の場所に移動する"}},[_vm._v("\n     プリンタを別の場所に移動する\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_ja","title":"問題をトラブルシューティングする"}},[_vm._v("\n    問題をトラブルシューティングする\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32709"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_ja","title":"印刷品質の問題"}},[_vm._v("\n     印刷品質の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_ja","title":"プリンタのエラーコード"}},[_vm._v("\n     プリンタのエラーコード\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_ja","title":"印刷の問題"}},[_vm._v("\n     印刷の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_ja","title":"プリンタが応答していない"}},[_vm._v("\n     プリンタが応答していない\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ja","title":"フラッシュメモリを読み取れない"}},[_vm._v("\n     フラッシュメモリを読み取れない\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_ja","title":"USB ポートの有効化"}},[_vm._v("\n     USB ポートの有効化\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_ja","title":"紙詰まりを取り除く"}},[_vm._v("\n     紙詰まりを取り除く\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e36133","title":"ネットワーク接続の問題"}},[_vm._v("\n     ネットワーク接続の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e36226","title":"ハードウェアオプションの問題"}},[_vm._v("\n     ハードウェアオプションの問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399","title":"消耗品の問題"}},[_vm._v("\n     消耗品の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-paper-curl-topic.html#d0e36547","title":"給紙の問題"}},[_vm._v("\n     給紙の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e36741","title":"E メールの問題"}},[_vm._v("\n     E メールの問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e36796","title":"FAX の問題"}},[_vm._v("\n     FAX の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e37118","title":"スキャンの問題"}},[_vm._v("\n     スキャンの問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e37536","title":"色品質の問題"}},[_vm._v("\n     色品質の問題\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ja","title":"カスタマサポートに問い合わせる"}},[_vm._v("\n     カスタマサポートに問い合わせる\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_ja","title":"リサイクルおよび廃棄"}},[_vm._v("\n    リサイクルおよび廃棄\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37762"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_ja","title":"Lexmark 製品のリサイクルプログラム"}},[_vm._v("\n     Lexmark 製品のリサイクルプログラム\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ja","title":"Lexmark 製品の梱包材をリサイクルする"}},[_vm._v("\n     Lexmark 製品の梱包材をリサイクルする\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_ja","title":"通知事項"}},[_vm._v("\n    通知事項\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e37798"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37801","title":"製品情報"}},[_vm._v("\n     製品情報\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37818","title":"改訂通知"}},[_vm._v("\n     改訂通知\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_ja","title":"商標"}},[_vm._v("\n     商標\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_ja","title":"ライセンスに関する通知"}},[_vm._v("\n     ライセンスに関する通知\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_ja","title":"騒音レベル"}},[_vm._v("\n     騒音レベル\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e37916","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_ja","title":"製品の廃棄"}},[_vm._v("\n     製品の廃棄\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_ja","title":"静電気感知に関する通知"}},[_vm._v("\n     静電気感知に関する通知\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_ja","title":"国際エネルギースタープログラム（ENERGY STAR）"}},[_vm._v("\n     国際エネルギースタープログラム（ENERGY STAR）\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_ja","title":"温度に関する情報"}},[_vm._v("\n     温度に関する情報\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_ja","title":"レーザーについて"}},[_vm._v("\n     レーザーについて\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_ja","title":"電力消費量"}},[_vm._v("\n     電力消費量\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e38159","title":"ワイヤレス製品に関する規制通知"}},[_vm._v("\n     ワイヤレス製品に関する規制通知\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_ja","title":"モジュールコンポーネントに関する通知事項"}},[_vm._v("\n     モジュールコンポーネントに関する通知事項\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_ja","title":"高周波エネルギーの放射に対する被爆"}},[_vm._v("\n     高周波エネルギーの放射に対する被爆\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#japanese-vcci-notice_ja","title":"日本の VCCI 規定"}},[_vm._v("\n     日本の VCCI 規定\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_ja","title":"電波障害について"}},[_vm._v("\n     電波障害について\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js